(function(t) {
    var e = {};
    function n(r) {
        if (e[r])
            return e[r].exports;
        var i = e[r] = {
            i: r,
            l: !1,
            exports: {}
        };
        return t[r].call(i.exports, i, i.exports, n),
        i.l = !0,
        i.exports
    }
    n.m = t,
    n.c = e,
    n.d = function(t2, e2, r) {
        n.o(t2, e2) || Object.defineProperty(t2, e2, {
            enumerable: !0,
            get: r
        })
    }
    ,
    n.r = function(t2) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(t2, Symbol.toStringTag, {
            value: "Module"
        }),
        Object.defineProperty(t2, "__esModule", {
            value: !0
        })
    }
    ,
    n.t = function(t2, e2) {
        if (1 & e2 && (t2 = n(t2)),
        8 & e2 || 4 & e2 && typeof t2 == "object" && t2 && t2.__esModule)
            return t2;
        var r = Object.create(null);
        if (n.r(r),
        Object.defineProperty(r, "default", {
            enumerable: !0,
            value: t2
        }),
        2 & e2 && typeof t2 != "string")
            for (var i in t2)
                n.d(r, i, function(e3) {
                    return t2[e3]
                }
                .bind(null, i));
        return r
    }
    ,
    n.n = function(t2) {
        var e2 = t2 && t2.__esModule ? function() {
            return t2.default
        }
        : function() {
            return t2
        }
        ;
        return n.d(e2, "a", e2),
        e2
    }
    ,
    n.o = function(t2, e2) {
        return Object.prototype.hasOwnProperty.call(t2, e2)
    }
    ,
    n.p = "",
    n(n.s = 65)
}
)([function(t, e, n) {
    var r = n(27)
      , i = n(28)
      , o = n(16)
      , a = n(29);
    t.exports = function(t2) {
        return r(t2) || i(t2) || o(t2) || a()
    }
}
, function(t, e, n) {
    var r, i, o;
    /*!
* Flickity v2.2.1
* Touch, responsive, flickable carousels
*
* Licensed GPLv3 for open source use
* or Flickity Commercial License for commercial use
*
* https://flickity.metafizzy.co
* Copyright 2015-2019 Metafizzy
*/
    i = [n(7), n(40), n(42), n(43), n(44), n(45), n(46)],
    (o = typeof (r = function(t2) {
        return t2
    }
    ) == "function" ? r.apply(e, i) : r) === void 0 || (t.exports = o)
}
, function(t, e, n) {
    (function(e2, n2) {
        var r = function(t2, e3, n3) {
            "use strict";
            var r2, i;
            if (function() {
                var e4, n4 = {
                    lazyClass: "lazyload",
                    loadedClass: "lazyloaded",
                    loadingClass: "lazyloading",
                    preloadClass: "lazypreload",
                    errorClass: "lazyerror",
                    autosizesClass: "lazyautosizes",
                    srcAttr: "data-src",
                    srcsetAttr: "data-srcset",
                    sizesAttr: "data-sizes",
                    minSize: 40,
                    customMedia: {},
                    init: !0,
                    expFactor: 1.5,
                    hFac: .8,
                    loadMode: 2,
                    loadHidden: !0,
                    ricTimeout: 0,
                    throttleDelay: 125
                };
                for (e4 in i = t2.lazySizesConfig || t2.lazysizesConfig || {},
                n4)
                    e4 in i || (i[e4] = n4[e4])
            }(),
            !e3 || !e3.getElementsByClassName)
                return {
                    init: function() {},
                    cfg: i,
                    noSupport: !0
                };
            var o = e3.documentElement, a = t2.HTMLPictureElement, s = t2.addEventListener.bind(t2), c = t2.setTimeout, l = t2.requestAnimationFrame || c, u = t2.requestIdleCallback, d = /^picture$/i, f = ["load", "error", "lazyincluded", "_lazyloaded"], h = {}, p = Array.prototype.forEach, g = function(t3, e4) {
                return h[e4] || (h[e4] = new RegExp("(\\s|^)" + e4 + "(\\s|$)")),
                h[e4].test(t3.getAttribute("class") || "") && h[e4]
            }, v = function(t3, e4) {
                g(t3, e4) || t3.setAttribute("class", (t3.getAttribute("class") || "").trim() + " " + e4)
            }, m = function(t3, e4) {
                var n4;
                (n4 = g(t3, e4)) && t3.setAttribute("class", (t3.getAttribute("class") || "").replace(n4, " "))
            }, y = function(t3, e4, n4) {
                var r3 = n4 ? "addEventListener" : "removeEventListener";
                n4 && y(t3, e4),
                f.forEach(function(n5) {
                    t3[r3](n5, e4)
                })
            }, b = function(t3, n4, i2, o2, a2) {
                var s2 = e3.createEvent("Event");
                return i2 || (i2 = {}),
                i2.instance = r2,
                s2.initEvent(n4, !o2, !a2),
                s2.detail = i2,
                t3.dispatchEvent(s2),
                s2
            }, w = function(e4, n4) {
                var r3;
                !a && (r3 = t2.picturefill || i.pf) ? (n4 && n4.src && !e4.getAttribute("srcset") && e4.setAttribute("srcset", n4.src),
                r3({
                    reevaluate: !0,
                    elements: [e4]
                })) : n4 && n4.src && (e4.src = n4.src)
            }, E = function(t3, e4) {
                return (getComputedStyle(t3, null) || {})[e4]
            }, _ = function(t3, e4, n4) {
                for (n4 = n4 || t3.offsetWidth; n4 < i.minSize && e4 && !t3._lazysizesWidth; )
                    n4 = e4.offsetWidth,
                    e4 = e4.parentNode;
                return n4
            }, A = (ht = [],
            pt = [],
            gt = ht,
            vt = function() {
                var t3 = gt;
                for (gt = ht.length ? pt : ht,
                dt = !0,
                ft = !1; t3.length; )
                    t3.shift()();
                dt = !1
            }
            ,
            mt = function(t3, n4) {
                dt && !n4 ? t3.apply(this, arguments) : (gt.push(t3),
                ft || (ft = !0,
                (e3.hidden ? c : l)(vt)))
            }
            ,
            mt._lsFlush = vt,
            mt), k = function(t3, e4) {
                return e4 ? function() {
                    A(t3)
                }
                : function() {
                    var e5 = this
                      , n4 = arguments;
                    A(function() {
                        t3.apply(e5, n4)
                    })
                }
            }, T = function(t3) {
                var e4, r3, i2 = function() {
                    e4 = null,
                    t3()
                }, o2 = function() {
                    var t4 = n3.now() - r3;
                    t4 < 99 ? c(o2, 99 - t4) : (u || i2)(i2)
                };
                return function() {
                    r3 = n3.now(),
                    e4 || (e4 = c(o2, 99))
                }
            }, S = (W = /^img$/i,
            G = /^iframe$/i,
            $ = "onscroll"in t2 && !/(gle|ing)bot/.test(navigator.userAgent),
            J = 0,
            Y = 0,
            X = -1,
            Q = function(t3) {
                Y--,
                (!t3 || Y < 0 || !t3.target) && (Y = 0)
            }
            ,
            Z = function(t3) {
                return U == null && (U = E(e3.body, "visibility") == "hidden"),
                U || !(E(t3.parentNode, "visibility") == "hidden" && E(t3, "visibility") == "hidden")
            }
            ,
            K = function(t3, n4) {
                var r3, i2 = t3, a2 = Z(t3);
                for (B -= n4,
                V += n4,
                F -= n4,
                H += n4; a2 && (i2 = i2.offsetParent) && i2 != e3.body && i2 != o; )
                    (a2 = (E(i2, "opacity") || 1) > 0) && E(i2, "overflow") != "visible" && (r3 = i2.getBoundingClientRect(),
                    a2 = H > r3.left && F < r3.right && V > r3.top - 1 && B < r3.bottom + 1);
                return a2
            }
            ,
            tt = function() {
                var t3, n4, a2, s2, c2, l2, u2, d2, f2, h2, p2, g2, v2 = r2.elements;
                if ((N = i.loadMode) && Y < 8 && (t3 = v2.length)) {
                    for (n4 = 0,
                    X++; n4 < t3; n4++)
                        if (v2[n4] && !v2[n4]._lazyRace)
                            if (!$ || r2.prematureUnveil && r2.prematureUnveil(v2[n4]))
                                st(v2[n4]);
                            else if ((d2 = v2[n4].getAttribute("data-expand")) && (l2 = 1 * d2) || (l2 = J),
                            h2 || (h2 = !i.expand || i.expand < 1 ? o.clientHeight > 500 && o.clientWidth > 500 ? 500 : 370 : i.expand,
                            r2._defEx = h2,
                            p2 = h2 * i.expFactor,
                            g2 = i.hFac,
                            U = null,
                            J < p2 && Y < 1 && X > 2 && N > 2 && !e3.hidden ? (J = p2,
                            X = 0) : J = N > 1 && X > 1 && Y < 6 ? h2 : 0),
                            f2 !== l2 && (z = innerWidth + l2 * g2,
                            R = innerHeight + l2,
                            u2 = -1 * l2,
                            f2 = l2),
                            a2 = v2[n4].getBoundingClientRect(),
                            (V = a2.bottom) >= u2 && (B = a2.top) <= R && (H = a2.right) >= u2 * g2 && (F = a2.left) <= z && (V || H || F || B) && (i.loadHidden || Z(v2[n4])) && (j && Y < 3 && !d2 && (N < 3 || X < 4) || K(v2[n4], l2))) {
                                if (st(v2[n4]),
                                c2 = !0,
                                Y > 9)
                                    break
                            } else
                                !c2 && j && !s2 && Y < 4 && X < 4 && N > 2 && (P[0] || i.preloadAfterLoad) && (P[0] || !d2 && (V || H || F || B || v2[n4].getAttribute(i.sizesAttr) != "auto")) && (s2 = P[0] || v2[n4]);
                    s2 && !c2 && st(s2)
                }
            }
            ,
            et = function(t3) {
                var e4, r3 = 0, o2 = i.throttleDelay, a2 = i.ricTimeout, s2 = function() {
                    e4 = !1,
                    r3 = n3.now(),
                    t3()
                }, l2 = u && a2 > 49 ? function() {
                    u(s2, {
                        timeout: a2
                    }),
                    a2 !== i.ricTimeout && (a2 = i.ricTimeout)
                }
                : k(function() {
                    c(s2)
                }, !0);
                return function(t4) {
                    var i2;
                    (t4 = t4 === !0) && (a2 = 33),
                    e4 || (e4 = !0,
                    (i2 = o2 - (n3.now() - r3)) < 0 && (i2 = 0),
                    t4 || i2 < 9 ? l2() : c(l2, i2))
                }
            }(tt),
            nt = function(t3) {
                var e4 = t3.target;
                e4._lazyCache ? delete e4._lazyCache : (Q(t3),
                v(e4, i.loadedClass),
                m(e4, i.loadingClass),
                y(e4, it),
                b(e4, "lazyloaded"))
            }
            ,
            rt = k(nt),
            it = function(t3) {
                rt({
                    target: t3.target
                })
            }
            ,
            ot = function(t3) {
                var e4, n4 = t3.getAttribute(i.srcsetAttr);
                (e4 = i.customMedia[t3.getAttribute("data-media") || t3.getAttribute("media")]) && t3.setAttribute("media", e4),
                n4 && t3.setAttribute("srcset", n4)
            }
            ,
            at = k(function(t3, e4, n4, r3, o2) {
                var a2, s2, l2, u2, f2, h2;
                (f2 = b(t3, "lazybeforeunveil", e4)).defaultPrevented || (r3 && (n4 ? v(t3, i.autosizesClass) : t3.setAttribute("sizes", r3)),
                s2 = t3.getAttribute(i.srcsetAttr),
                a2 = t3.getAttribute(i.srcAttr),
                o2 && (u2 = (l2 = t3.parentNode) && d.test(l2.nodeName || "")),
                h2 = e4.firesLoad || "src"in t3 && (s2 || a2 || u2),
                f2 = {
                    target: t3
                },
                v(t3, i.loadingClass),
                h2 && (clearTimeout(I),
                I = c(Q, 2500),
                y(t3, it, !0)),
                u2 && p.call(l2.getElementsByTagName("source"), ot),
                s2 ? t3.setAttribute("srcset", s2) : a2 && !u2 && (G.test(t3.nodeName) ? function(t4, e5) {
                    try {
                        t4.contentWindow.location.replace(e5)
                    } catch {
                        t4.src = e5
                    }
                }(t3, a2) : t3.src = a2),
                o2 && (s2 || u2) && w(t3, {
                    src: a2
                })),
                t3._lazyRace && delete t3._lazyRace,
                m(t3, i.lazyClass),
                A(function() {
                    var e5 = t3.complete && t3.naturalWidth > 1;
                    h2 && !e5 || (e5 && v(t3, "ls-is-cached"),
                    nt(f2),
                    t3._lazyCache = !0,
                    c(function() {
                        "_lazyCache"in t3 && delete t3._lazyCache
                    }, 9)),
                    t3.loading == "lazy" && Y--
                }, !0)
            }),
            st = function(t3) {
                if (!t3._lazyRace) {
                    var e4, n4 = W.test(t3.nodeName), r3 = n4 && (t3.getAttribute(i.sizesAttr) || t3.getAttribute("sizes")), o2 = r3 == "auto";
                    (!o2 && j || !n4 || !t3.getAttribute("src") && !t3.srcset || t3.complete || g(t3, i.errorClass) || !g(t3, i.lazyClass)) && (e4 = b(t3, "lazyunveilread").detail,
                    o2 && x.updateElem(t3, !0, t3.offsetWidth),
                    t3._lazyRace = !0,
                    Y++,
                    at(t3, e4, o2, r3, n4))
                }
            }
            ,
            ct = T(function() {
                i.loadMode = 3,
                et()
            }),
            lt = function() {
                i.loadMode == 3 && (i.loadMode = 2),
                ct()
            }
            ,
            ut = function() {
                j || (n3.now() - M < 999 ? c(ut, 999) : (j = !0,
                i.loadMode = 3,
                et(),
                s("scroll", lt, !0)))
            }
            ,
            {
                _: function() {
                    M = n3.now(),
                    r2.elements = e3.getElementsByClassName(i.lazyClass),
                    P = e3.getElementsByClassName(i.lazyClass + " " + i.preloadClass),
                    s("scroll", et, !0),
                    s("resize", et, !0),
                    s("pageshow", function(t3) {
                        if (t3.persisted) {
                            var n4 = e3.querySelectorAll("." + i.loadingClass);
                            n4.length && n4.forEach && l(function() {
                                n4.forEach(function(t4) {
                                    t4.complete && st(t4)
                                })
                            })
                        }
                    }),
                    t2.MutationObserver ? new MutationObserver(et).observe(o, {
                        childList: !0,
                        subtree: !0,
                        attributes: !0
                    }) : (o.addEventListener("DOMNodeInserted", et, !0),
                    o.addEventListener("DOMAttrModified", et, !0),
                    setInterval(et, 999)),
                    s("hashchange", et, !0),
                    ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(function(t3) {
                        e3.addEventListener(t3, et, !0)
                    }),
                    /d$|^c/.test(e3.readyState) ? ut() : (s("load", ut),
                    e3.addEventListener("DOMContentLoaded", et),
                    c(ut, 2e4)),
                    r2.elements.length ? (tt(),
                    A._lsFlush()) : et()
                },
                checkElems: et,
                unveil: st,
                _aLSL: lt
            }), x = (L = k(function(t3, e4, n4, r3) {
                var i2, o2, a2;
                if (t3._lazysizesWidth = r3,
                r3 += "px",
                t3.setAttribute("sizes", r3),
                d.test(e4.nodeName || ""))
                    for (o2 = 0,
                    a2 = (i2 = e4.getElementsByTagName("source")).length; o2 < a2; o2++)
                        i2[o2].setAttribute("sizes", r3);
                n4.detail.dataAttr || w(t3, n4.detail)
            }),
            q = function(t3, e4, n4) {
                var r3, i2 = t3.parentNode;
                i2 && (n4 = _(t3, i2, n4),
                (r3 = b(t3, "lazybeforesizes", {
                    width: n4,
                    dataAttr: !!e4
                })).defaultPrevented || (n4 = r3.detail.width) && n4 !== t3._lazysizesWidth && L(t3, i2, r3, n4))
            }
            ,
            D = T(function() {
                var t3, e4 = O.length;
                if (e4)
                    for (t3 = 0; t3 < e4; t3++)
                        q(O[t3])
            }),
            {
                _: function() {
                    O = e3.getElementsByClassName(i.autosizesClass),
                    s("resize", D)
                },
                checkElems: D,
                updateElem: q
            }), C = function() {
                !C.i && e3.getElementsByClassName && (C.i = !0,
                x._(),
                S._())
            }, O, L, q, D, P, j, I, N, M, z, R, B, F, H, V, U, W, G, $, J, Y, X, Q, Z, K, tt, et, nt, rt, it, ot, at, st, ct, lt, ut, dt, ft, ht, pt, gt, vt, mt;
            return c(function() {
                i.init && C()
            }),
            r2 = {
                cfg: i,
                autoSizer: x,
                loader: S,
                init: C,
                uP: w,
                aC: v,
                rC: m,
                hC: g,
                fire: b,
                gW: _,
                rAF: A
            }
        }(e2, e2.document, Date);
        e2.lazySizes = r,
        t.exports && (t.exports = r)
    }
    )(typeof window < "u" ? window : {})
}
, function(t, e, n) {
    "use strict";
    function r(t2) {
        this.listenerMap = [{}, {}],
        t2 && this.root(t2),
        this.handle = r.prototype.handle.bind(this),
        this._removedListeners = []
    }
    function i(t2, e2) {
        return t2.toLowerCase() === e2.tagName.toLowerCase()
    }
    function o(t2, e2) {
        return this.rootElement === window ? e2 === document || e2 === document.documentElement || e2 === window : this.rootElement === e2
    }
    function a(t2, e2) {
        return t2 === e2.id
    }
    Object.defineProperty(e, "__esModule", {
        value: !0
    }),
    e.default = void 0,
    r.prototype.root = function(t2) {
        var e2, n2 = this.listenerMap;
        if (this.rootElement) {
            for (e2 in n2[1])
                n2[1].hasOwnProperty(e2) && this.rootElement.removeEventListener(e2, this.handle, !0);
            for (e2 in n2[0])
                n2[0].hasOwnProperty(e2) && this.rootElement.removeEventListener(e2, this.handle, !1)
        }
        if (!t2 || !t2.addEventListener)
            return this.rootElement && delete this.rootElement,
            this;
        for (e2 in this.rootElement = t2,
        n2[1])
            n2[1].hasOwnProperty(e2) && this.rootElement.addEventListener(e2, this.handle, !0);
        for (e2 in n2[0])
            n2[0].hasOwnProperty(e2) && this.rootElement.addEventListener(e2, this.handle, !1);
        return this
    }
    ,
    r.prototype.captureForType = function(t2) {
        return ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(t2) !== -1
    }
    ,
    r.prototype.on = function(t2, e2, n2, r2) {
        var s2, c, l, u;
        if (!t2)
            throw new TypeError("Invalid event type: " + t2);
        if (typeof e2 == "function" && (r2 = n2,
        n2 = e2,
        e2 = null),
        r2 === void 0 && (r2 = this.captureForType(t2)),
        typeof n2 != "function")
            throw new TypeError("Handler must be a type of Function");
        return s2 = this.rootElement,
        (c = this.listenerMap[r2 ? 1 : 0])[t2] || (s2 && s2.addEventListener(t2, this.handle, r2),
        c[t2] = []),
        e2 ? /^[a-z]+$/i.test(e2) ? (u = e2,
        l = i) : /^#[a-z0-9\-_]+$/i.test(e2) ? (u = e2.slice(1),
        l = a) : (u = e2,
        l = Element.prototype.matches) : (u = null,
        l = o.bind(this)),
        c[t2].push({
            selector: e2,
            handler: n2,
            matcher: l,
            matcherParam: u
        }),
        this
    }
    ,
    r.prototype.off = function(t2, e2, n2, r2) {
        var i2, o2, a2, s2, c;
        if (typeof e2 == "function" && (r2 = n2,
        n2 = e2,
        e2 = null),
        r2 === void 0)
            return this.off(t2, e2, n2, !0),
            this.off(t2, e2, n2, !1),
            this;
        if (a2 = this.listenerMap[r2 ? 1 : 0],
        !t2) {
            for (c in a2)
                a2.hasOwnProperty(c) && this.off(c, e2, n2);
            return this
        }
        if (!(s2 = a2[t2]) || !s2.length)
            return this;
        for (i2 = s2.length - 1; i2 >= 0; i2--)
            o2 = s2[i2],
            e2 && e2 !== o2.selector || n2 && n2 !== o2.handler || (this._removedListeners.push(o2),
            s2.splice(i2, 1));
        return s2.length || (delete a2[t2],
        this.rootElement && this.rootElement.removeEventListener(t2, this.handle, r2)),
        this
    }
    ,
    r.prototype.handle = function(t2) {
        var e2, n2, r2, i2, o2, a2 = t2.type, s2 = [];
        if (t2.ftLabsDelegateIgnore !== !0) {
            switch ((o2 = t2.target).nodeType === 3 && (o2 = o2.parentNode),
            o2.correspondingUseElement && (o2 = o2.correspondingUseElement),
            r2 = this.rootElement,
            t2.eventPhase || (t2.target !== t2.currentTarget ? 3 : 2)) {
            case 1:
                s2 = this.listenerMap[1][a2];
                break;
            case 2:
                this.listenerMap[0] && this.listenerMap[0][a2] && (s2 = s2.concat(this.listenerMap[0][a2])),
                this.listenerMap[1] && this.listenerMap[1][a2] && (s2 = s2.concat(this.listenerMap[1][a2]));
                break;
            case 3:
                s2 = this.listenerMap[0][a2]
            }
            var c, l = [];
            for (n2 = s2.length; o2 && n2; ) {
                for (e2 = 0; e2 < n2 && (i2 = s2[e2]); e2++)
                    o2.tagName && ["button", "input", "select", "textarea"].indexOf(o2.tagName.toLowerCase()) > -1 && o2.hasAttribute("disabled") ? l = [] : i2.matcher.call(o2, i2.matcherParam, o2) && l.push([t2, o2, i2]);
                if (o2 === r2 || (n2 = s2.length,
                (o2 = o2.parentElement || o2.parentNode)instanceof HTMLDocument))
                    break
            }
            for (e2 = 0; e2 < l.length; e2++)
                if (!(this._removedListeners.indexOf(l[e2][2]) > -1) && this.fire.apply(this, l[e2]) === !1) {
                    l[e2][0].ftLabsDelegateIgnore = !0,
                    l[e2][0].preventDefault(),
                    c = !1;
                    break
                }
            return c
        }
    }
    ,
    r.prototype.fire = function(t2, e2, n2) {
        return n2.handler.call(e2, t2, e2)
    }
    ,
    r.prototype.destroy = function() {
        this.off(),
        this.root()
    }
    ;
    var s = r;
    e.default = s,
    t.exports = e.default
}
, function(t, e, n) {
    var r, i;
    (function(o, a) {
        r = [n(36)],
        (i = function(t2) {
            return function(t3, e2) {
                "use strict";
                var n2 = {
                    extend: function(t4, e3) {
                        for (var n3 in e3)
                            t4[n3] = e3[n3];
                        return t4
                    },
                    modulo: function(t4, e3) {
                        return (t4 % e3 + e3) % e3
                    }
                }
                  , r2 = Array.prototype.slice;
                n2.makeArray = function(t4) {
                    return Array.isArray(t4) ? t4 : t4 == null ? [] : typeof t4 == "object" && typeof t4.length == "number" ? r2.call(t4) : [t4]
                }
                ,
                n2.removeFrom = function(t4, e3) {
                    var n3 = t4.indexOf(e3);
                    n3 != -1 && t4.splice(n3, 1)
                }
                ,
                n2.getParent = function(t4, n3) {
                    for (; t4.parentNode && t4 != document.body; )
                        if (t4 = t4.parentNode,
                        e2(t4, n3))
                            return t4
                }
                ,
                n2.getQueryElement = function(t4) {
                    return typeof t4 == "string" ? document.querySelector(t4) : t4
                }
                ,
                n2.handleEvent = function(t4) {
                    var e3 = "on" + t4.type;
                    this[e3] && this[e3](t4)
                }
                ,
                n2.filterFindElements = function(t4, r3) {
                    t4 = n2.makeArray(t4);
                    var i3 = [];
                    return t4.forEach(function(t5) {
                        if (t5 instanceof HTMLElement)
                            if (r3) {
                                e2(t5, r3) && i3.push(t5);
                                for (var n3 = t5.querySelectorAll(r3), o2 = 0; o2 < n3.length; o2++)
                                    i3.push(n3[o2])
                            } else
                                i3.push(t5)
                    }),
                    i3
                }
                ,
                n2.debounceMethod = function(t4, e3, n3) {
                    n3 = n3 || 100;
                    var r3 = t4.prototype[e3]
                      , i3 = e3 + "Timeout";
                    t4.prototype[e3] = function() {
                        var t5 = this[i3];
                        clearTimeout(t5);
                        var e4 = arguments
                          , o2 = this;
                        this[i3] = setTimeout(function() {
                            r3.apply(o2, e4),
                            delete o2[i3]
                        }, n3)
                    }
                }
                ,
                n2.docReady = function(t4) {
                    var e3 = document.readyState;
                    e3 == "complete" || e3 == "interactive" ? setTimeout(t4) : document.addEventListener("DOMContentLoaded", t4)
                }
                ,
                n2.toDashed = function(t4) {
                    return t4.replace(/(.)([A-Z])/g, function(t5, e3, n3) {
                        return e3 + "-" + n3
                    }).toLowerCase()
                }
                ;
                var i2 = t3.console;
                return n2.htmlInit = function(e3, r3) {
                    n2.docReady(function() {
                        var o2 = n2.toDashed(r3)
                          , a2 = "data-" + o2
                          , s = document.querySelectorAll("[" + a2 + "]")
                          , c = document.querySelectorAll(".js-" + o2)
                          , l = n2.makeArray(s).concat(n2.makeArray(c))
                          , u = a2 + "-options"
                          , d = t3.jQuery;
                        l.forEach(function(t4) {
                            var n3, o3 = t4.getAttribute(a2) || t4.getAttribute(u);
                            try {
                                n3 = o3 && JSON.parse(o3)
                            } catch (e4) {
                                return void (i2 && i2.error("Error parsing " + a2 + " on " + t4.className + ": " + e4))
                            }
                            var s2 = new e3(t4,n3);
                            d && d.data(t4, r3, s2)
                        })
                    })
                }
                ,
                n2
            }(o, t2)
        }
        .apply(e, r)) === void 0 || (t.exports = i)
    }
    )(window)
}
, function(t, e, n) {
    "use strict";
    function r(t2) {
        new Image().src = t2
    }
    function i(t2, e2) {
        if (e2 === null)
            return t2;
        if (e2 === "master")
            return o(t2);
        var n2 = t2.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (n2) {
            var r2 = t2.split(n2[0])
              , i2 = n2[0];
            return o(r2[0] + "_" + e2 + i2)
        }
        return null
    }
    function o(t2) {
        return t2.replace(/http(s)?:/, "")
    }
    Object.defineProperty(e, "__esModule", {
        value: !0
    }),
    e.preload = function(t2, e2) {
        typeof t2 == "string" && (t2 = [t2]);
        for (var n2 = 0; n2 < t2.length; n2++)
            r(i(t2[n2], e2))
    }
    ,
    e.loadImage = r,
    e.imageSize = function(t2) {
        var e2 = t2.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
        return e2 ? e2[1] : null
    }
    ,
    e.getSizedImageUrl = i,
    e.removeProtocol = o
}
, function(t, e, n) {
    (function(e2) {
        t.exports = function() {
            "use strict";
            function t2(e3) {
                return (t2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t3) {
                    return typeof t3
                }
                : function(t3) {
                    return t3 && typeof Symbol == "function" && t3.constructor === Symbol && t3 !== Symbol.prototype ? "symbol" : typeof t3
                }
                )(e3)
            }
            function n2(t3, e3) {
                for (var n3 = 0; n3 < e3.length; n3++) {
                    var r2 = e3[n3];
                    r2.enumerable = r2.enumerable || !1,
                    r2.configurable = !0,
                    "value"in r2 && (r2.writable = !0),
                    Object.defineProperty(t3, r2.key, r2)
                }
            }
            function r(t3, e3, n3) {
                return e3 in t3 ? Object.defineProperty(t3, e3, {
                    value: n3,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t3[e3] = n3,
                t3
            }
            function i(t3, e3) {
                var n3 = Object.keys(t3);
                if (Object.getOwnPropertySymbols) {
                    var r2 = Object.getOwnPropertySymbols(t3);
                    e3 && (r2 = r2.filter(function(e4) {
                        return Object.getOwnPropertyDescriptor(t3, e4).enumerable
                    })),
                    n3.push.apply(n3, r2)
                }
                return n3
            }
            function o(t3) {
                for (var e3 = 1; e3 < arguments.length; e3++) {
                    var n3 = arguments[e3] != null ? arguments[e3] : {};
                    e3 % 2 ? i(Object(n3), !0).forEach(function(e4) {
                        r(t3, e4, n3[e4])
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t3, Object.getOwnPropertyDescriptors(n3)) : i(Object(n3)).forEach(function(e4) {
                        Object.defineProperty(t3, e4, Object.getOwnPropertyDescriptor(n3, e4))
                    })
                }
                return t3
            }
            function a(t3) {
                return function(t4) {
                    if (Array.isArray(t4))
                        return s(t4)
                }(t3) || function(t4) {
                    if (typeof Symbol < "u" && Symbol.iterator in Object(t4))
                        return Array.from(t4)
                }(t3) || function(t4, e3) {
                    if (t4) {
                        if (typeof t4 == "string")
                            return s(t4, e3);
                        var n3 = Object.prototype.toString.call(t4).slice(8, -1);
                        return n3 === "Object" && t4.constructor && (n3 = t4.constructor.name),
                        n3 === "Map" || n3 === "Set" ? Array.from(t4) : n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3) ? s(t4, e3) : void 0
                    }
                }(t3) || function() {
                    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`)
                }()
            }
            function s(t3, e3) {
                (e3 == null || e3 > t3.length) && (e3 = t3.length);
                for (var n3 = 0, r2 = new Array(e3); n3 < e3; n3++)
                    r2[n3] = t3[n3];
                return r2
            }
            function c(t3, e3) {
                if (!Array.isArray(t3) || !t3.length)
                    return t3;
                var n3, r2, i2 = o(o({}, {
                    strictlyTwoElementsInRangeArrays: !1,
                    progressFn: null
                }), e3);
                if (i2.strictlyTwoElementsInRangeArrays && !t3.every(function(t4, e4) {
                    return t4.length === 2 || (n3 = e4,
                    r2 = t4.length,
                    !1)
                }))
                    throw new TypeError("ranges-sort: [THROW_ID_03] The first argument should be an array and must consist of arrays which are natural number indexes representing TWO string index ranges. However, ".concat(n3, "th range (").concat(JSON.stringify(t3[n3], null, 4), ") has not two but ").concat(r2, " elements!"));
                if (!t3.every(function(t4, e4) {
                    return !(!Number.isInteger(t4[0]) || t4[0] < 0 || !Number.isInteger(t4[1]) || t4[1] < 0) || (n3 = e4,
                    !1)
                }))
                    throw new TypeError("ranges-sort: [THROW_ID_04] The first argument should be an array and must consist of arrays which are natural number indexes representing string index ranges. However, ".concat(n3, "th range (").concat(JSON.stringify(t3[n3], null, 4), ") does not consist of only natural numbers!"));
                var a2 = t3.length * t3.length
                  , s2 = 0;
                return Array.from(t3).sort(function(t4, e4) {
                    return i2.progressFn && (s2 += 1,
                    i2.progressFn(Math.floor(100 * s2 / a2))),
                    t4[0] === e4[0] ? t4[1] < e4[1] ? -1 : t4[1] > e4[1] ? 1 : 0 : t4[0] < e4[0] ? -1 : 1
                })
            }
            function l(e3, n3) {
                function r2(t3) {
                    return typeof t3 == "string"
                }
                function i2(e4) {
                    return e4 && t2(e4) === "object" && !Array.isArray(e4)
                }
                if (!Array.isArray(e3) || !e3.length)
                    return e3;
                var s2, l2 = {
                    mergeType: 1,
                    progressFn: null,
                    joinRangesThatTouchEdges: !0
                };
                if (n3) {
                    if (!i2(n3))
                        throw new Error(`emlint: [THROW_ID_03] the second input argument must be a plain object. It was given as:
`.concat(JSON.stringify(n3, null, 4), " (type ").concat(t2(n3), ")"));
                    if ((s2 = o(o({}, l2), n3)).progressFn && i2(s2.progressFn) && !Object.keys(s2.progressFn).length)
                        s2.progressFn = null;
                    else if (s2.progressFn && typeof s2.progressFn != "function")
                        throw new Error('ranges-merge: [THROW_ID_01] opts.progressFn must be a function! It was given of a type: "'.concat(t2(s2.progressFn), '", equal to ').concat(JSON.stringify(s2.progressFn, null, 4)));
                    if (s2.mergeType && s2.mergeType !== 1 && s2.mergeType !== 2)
                        if (r2(s2.mergeType) && s2.mergeType.trim() === "1")
                            s2.mergeType = 1;
                        else {
                            if (!r2(s2.mergeType) || s2.mergeType.trim() !== "2")
                                throw new Error('ranges-merge: [THROW_ID_02] opts.mergeType was customised to a wrong thing! It was given of a type: "'.concat(t2(s2.mergeType), '", equal to ').concat(JSON.stringify(s2.mergeType, null, 4)));
                            s2.mergeType = 2
                        }
                    if (typeof s2.joinRangesThatTouchEdges != "boolean")
                        throw new Error('ranges-merge: [THROW_ID_04] opts.joinRangesThatTouchEdges was customised to a wrong thing! It was given of a type: "'.concat(t2(s2.joinRangesThatTouchEdges), '", equal to ').concat(JSON.stringify(s2.joinRangesThatTouchEdges, null, 4)))
                } else
                    s2 = o({}, l2);
                for (var u2, d2, f2, h2 = e3.map(function(t3) {
                    return a(t3)
                }).filter(function(t3) {
                    return t3[2] !== void 0 || t3[0] !== t3[1]
                }), p2 = (u2 = s2.progressFn ? c(h2, {
                    progressFn: function(t3) {
                        (f2 = Math.floor(t3 / 5)) !== d2 && (d2 = f2,
                        s2.progressFn(f2))
                    }
                }) : c(h2)).length - 1, g2 = p2; g2 > 0; g2--)
                    s2.progressFn && (f2 = Math.floor(78 * (1 - g2 / p2)) + 21) !== d2 && f2 > d2 && (d2 = f2,
                    s2.progressFn(f2)),
                    (u2[g2][0] <= u2[g2 - 1][0] || !s2.joinRangesThatTouchEdges && u2[g2][0] < u2[g2 - 1][1] || s2.joinRangesThatTouchEdges && u2[g2][0] <= u2[g2 - 1][1]) && (u2[g2 - 1][0] = Math.min(u2[g2][0], u2[g2 - 1][0]),
                    u2[g2 - 1][1] = Math.max(u2[g2][1], u2[g2 - 1][1]),
                    u2[g2][2] !== void 0 && (u2[g2 - 1][0] >= u2[g2][0] || u2[g2 - 1][1] <= u2[g2][1]) && u2[g2 - 1][2] !== null && (u2[g2][2] === null && u2[g2 - 1][2] !== null ? u2[g2 - 1][2] = null : u2[g2 - 1][2] !== void 0 ? s2.mergeType === 2 && u2[g2 - 1][0] === u2[g2][0] ? u2[g2 - 1][2] = u2[g2][2] : u2[g2 - 1][2] += u2[g2][2] : u2[g2 - 1][2] = u2[g2][2]),
                    u2.splice(g2, 1),
                    g2 = u2.length);
                return u2
            }
            function u(t3) {
                return t3 != null
            }
            function d(t3) {
                return typeof t3 == "string"
            }
            function f(e3, n3, r2) {
                var i2, o2 = 0, a2 = 0;
                if (arguments.length === 0)
                    throw new Error("ranges-apply: [THROW_ID_01] inputs missing!");
                if (!d(e3))
                    throw new TypeError("ranges-apply: [THROW_ID_02] first input argument must be a string! Currently it's: ".concat(t2(e3), ", equal to: ").concat(JSON.stringify(e3, null, 4)));
                if (n3 === null)
                    return e3;
                if (!Array.isArray(n3))
                    throw new TypeError("ranges-apply: [THROW_ID_03] second input argument must be an array (or null)! Currently it's: ".concat(t2(n3), ", equal to: ").concat(JSON.stringify(n3, null, 4)));
                if (r2 && typeof r2 != "function")
                    throw new TypeError("ranges-apply: [THROW_ID_04] the third input argument must be a function (or falsey)! Currently it's: ".concat(t2(r2), ", equal to: ").concat(JSON.stringify(r2, null, 4)));
                var s2 = (i2 = Array.isArray(n3) && (Number.isInteger(n3[0]) && n3[0] >= 0 || /^\d*$/.test(n3[0])) && (Number.isInteger(n3[1]) && n3[1] >= 0 || /^\d*$/.test(n3[1])) ? [Array.from(n3)] : Array.from(n3)).length
                  , c2 = 0;
                i2.forEach(function(e4, n4) {
                    if (r2 && (o2 = Math.floor(c2 / s2 * 10)) !== a2 && (a2 = o2,
                    r2(o2)),
                    !Array.isArray(e4))
                        throw new TypeError("ranges-apply: [THROW_ID_05] ranges array, second input arg., has ".concat(n4, "th element not an array: ").concat(JSON.stringify(e4, null, 4), ", which is ").concat(t2(e4)));
                    if (!Number.isInteger(e4[0]) || e4[0] < 0) {
                        if (!/^\d*$/.test(e4[0]))
                            throw new TypeError("ranges-apply: [THROW_ID_06] ranges array, second input arg. has ".concat(n4, "th element, array [").concat(e4[0], ",").concat(e4[1], "]. That array has first element not an integer, but ").concat(t2(e4[0]), ", equal to: ").concat(JSON.stringify(e4[0], null, 4), ". Computer doesn't like this."));
                        i2[n4][0] = Number.parseInt(i2[n4][0], 10)
                    }
                    if (!Number.isInteger(e4[1])) {
                        if (!/^\d*$/.test(e4[1]))
                            throw new TypeError("ranges-apply: [THROW_ID_07] ranges array, second input arg. has ".concat(n4, "th element, array [").concat(e4[0], ",").concat(e4[1], "]. That array has second element not an integer, but ").concat(t2(e4[1]), ", equal to: ").concat(JSON.stringify(e4[1], null, 4), ". Computer doesn't like this."));
                        i2[n4][1] = Number.parseInt(i2[n4][1], 10)
                    }
                    c2 += 1
                });
                var f2 = l(i2, {
                    progressFn: function(t3) {
                        r2 && (o2 = 10 + Math.floor(t3 / 10)) !== a2 && (a2 = o2,
                        r2(o2))
                    }
                })
                  , h2 = f2.length;
                if (h2 > 0) {
                    var p2 = e3.slice(f2[h2 - 1][1]);
                    e3 = f2.reduce(function(t3, n4, i3, s3) {
                        r2 && (o2 = 20 + Math.floor(i3 / h2 * 80)) !== a2 && (a2 = o2,
                        r2(o2));
                        var c3 = i3 === 0 ? 0 : s3[i3 - 1][1]
                          , l2 = s3[i3][0];
                        return t3 + e3.slice(c3, l2) + (u(s3[i3][2]) ? s3[i3][2] : "")
                    }, ""),
                    e3 += p2
                }
                return e3
            }
            function h(t3) {
                var e3 = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1]
                  , n3 = arguments.length > 2 ? arguments[2] : void 0;
                if (!(n3.trim() || t3.length && n3 !== `
` && n3 !== "\xA0" && (e3 ? t3[t3.length - 1] : t3[0]) === " " || t3.length && (e3 ? t3[t3.length - 1] : t3[0]) === `
` && n3 !== `
` && n3 !== "\xA0"))
                    if (e3) {
                        if ((n3 === `
` || n3 === "\xA0") && t3.length && t3[t3.length - 1] === " ")
                            for (; t3.length && t3[t3.length - 1] === " "; )
                                t3.pop();
                        t3.push(n3 === "\xA0" || n3 === `
` ? n3 : " ")
                    } else {
                        if ((n3 === `
` || n3 === "\xA0") && t3.length && t3[0] === " ")
                            for (; t3.length && t3[0] === " "; )
                                t3.shift();
                        t3.unshift(n3 === "\xA0" || n3 === `
` ? n3 : " ")
                    }
            }
            function p(t3, e3) {
                if (typeof t3 == "string" && t3.length) {
                    var n3, r2, i2 = !1;
                    if (t3.includes(`\r
`) && (i2 = !0),
                    n3 = e3 && typeof e3 == "number" ? e3 : 1,
                    t3.trim() === "") {
                        var o2 = [];
                        for (r2 = n3,
                        Array.from(t3).forEach(function(t4) {
                            (t4 !== `
` || r2) && (t4 === `
` && (r2 -= 1),
                            h(o2, !0, t4))
                        }); o2.length > 1 && o2[o2.length - 1] === " "; )
                            o2.pop();
                        return o2.join("")
                    }
                    var a2 = [];
                    if (r2 = n3,
                    t3[0].trim() === "")
                        for (var s2 = 0, c2 = t3.length; s2 < c2 && !t3[s2].trim(); s2++)
                            (t3[s2] !== `
` || r2) && (t3[s2] === `
` && (r2 -= 1),
                            h(a2, !0, t3[s2]));
                    var l2 = [];
                    if (r2 = n3,
                    t3.slice(-1).trim() === "")
                        for (var u2 = t3.length; u2-- && !t3[u2].trim(); )
                            (t3[u2] !== `
` || r2) && (t3[u2] === `
` && (r2 -= 1),
                            h(l2, !1, t3[u2]));
                    return i2 ? "".concat(a2.join("")).concat(t3.trim()).concat(l2.join("")).replace(/\n/g, `\r
`) : a2.join("") + t3.trim() + l2.join("")
                }
                return t3
            }
            function g(t3) {
                return t3 != null
            }
            function v(t3) {
                return Number.isInteger(t3) && t3 >= 0
            }
            function m(t3) {
                return typeof t3 == "string"
            }
            function y(t3) {
                return /^\d*$/.test(t3) ? parseInt(t3, 10) : t3
            }
            var b, w, E = function() {
                function e3(n3) {
                    (function(t3, e4) {
                        if (!(t3 instanceof e4))
                            throw new TypeError("Cannot call a class as a function")
                    }
                    )(this, e3);
                    var r3 = o(o({}, {
                        limitToBeAddedWhitespace: !1,
                        limitLinebreaksCount: 1,
                        mergeType: 1
                    }), n3);
                    if (r3.mergeType && r3.mergeType !== 1 && r3.mergeType !== 2)
                        if (m(r3.mergeType) && r3.mergeType.trim() === "1")
                            r3.mergeType = 1;
                        else {
                            if (!m(r3.mergeType) || r3.mergeType.trim() !== "2")
                                throw new Error('ranges-push: [THROW_ID_02] opts.mergeType was customised to a wrong thing! It was given of a type: "'.concat(t2(r3.mergeType), '", equal to ').concat(JSON.stringify(r3.mergeType, null, 4)));
                            r3.mergeType = 2
                        }
                    this.opts = r3
                }
                var r2, i2;
                return r2 = e3,
                (i2 = [{
                    key: "add",
                    value: function(e4, n3, r3) {
                        for (var i3 = this, o2 = arguments.length, s2 = new Array(o2 > 3 ? o2 - 3 : 0), c2 = 3; c2 < o2; c2++)
                            s2[c2 - 3] = arguments[c2];
                        if (s2.length > 0)
                            throw new TypeError("ranges-push/Ranges/add(): [THROW_ID_03] Please don't overload the add() method. From the 4th input argument onwards we see these redundant arguments: ".concat(JSON.stringify(s2, null, 4)));
                        if (g(e4) || g(n3)) {
                            if (g(e4) && !g(n3)) {
                                if (Array.isArray(e4)) {
                                    if (e4.length) {
                                        if (e4.some(function(t3) {
                                            return Array.isArray(t3)
                                        }))
                                            return void e4.forEach(function(t3) {
                                                Array.isArray(t3) && i3.add.apply(i3, a(t3))
                                            });
                                        e4.length > 1 && v(y(e4[0])) && v(y(e4[1])) && this.add.apply(this, a(e4))
                                    }
                                    return
                                }
                                throw new TypeError('ranges-push/Ranges/add(): [THROW_ID_12] the first input argument, "from" is set ('.concat(JSON.stringify(e4, null, 0), ') but second-one, "to" is not (').concat(JSON.stringify(n3, null, 0), ")"))
                            }
                            if (!g(e4) && g(n3))
                                throw new TypeError('ranges-push/Ranges/add(): [THROW_ID_13] the second input argument, "to" is set ('.concat(JSON.stringify(n3, null, 0), ') but first-one, "from" is not (').concat(JSON.stringify(e4, null, 0), ")"));
                            var l2 = /^\d*$/.test(e4) ? parseInt(e4, 10) : e4
                              , u2 = /^\d*$/.test(n3) ? parseInt(n3, 10) : n3;
                            if (v(r3) && (r3 = String(r3)),
                            !v(l2) || !v(u2))
                                throw v(l2) && l2 >= 0 ? new TypeError(`ranges-push/Ranges/add(): [THROW_ID_10] "to" value, the second input argument, must be a natural number or zero! Currently it's of a type "`.concat(t2(u2), '" equal to: ').concat(JSON.stringify(u2, null, 4))) : new TypeError(`ranges-push/Ranges/add(): [THROW_ID_09] "from" value, the first input argument, must be a natural number or zero! Currently it's of a type "`.concat(t2(l2), '" equal to: ').concat(JSON.stringify(l2, null, 4)));
                            if (g(r3) && !m(r3) && !v(r3))
                                throw new TypeError("ranges-push/Ranges/add(): [THROW_ID_08] The third argument, the value to add, was given not as string but ".concat(t2(r3), `, equal to:
`).concat(JSON.stringify(r3, null, 4)));
                            if (g(this.slices) && Array.isArray(this.last()) && l2 === this.last()[1]) {
                                if (this.last()[1] = u2,
                                this.last()[2],
                                this.last()[2] !== null && g(r3)) {
                                    var d2 = !(g(this.last()[2]) && this.last()[2].length > 0) || this.opts && this.opts.mergeType && this.opts.mergeType !== 1 ? r3 : this.last()[2] + r3;
                                    this.opts.limitToBeAddedWhitespace && (d2 = p(d2, this.opts.limitLinebreaksCount)),
                                    m(d2) && !d2.length || (this.last()[2] = d2)
                                }
                            } else {
                                this.slices || (this.slices = []);
                                var f2 = r3 === void 0 || m(r3) && !r3.length ? [l2, u2] : [l2, u2, this.opts.limitToBeAddedWhitespace ? p(r3, this.opts.limitLinebreaksCount) : r3];
                                this.slices.push(f2)
                            }
                        }
                    }
                }, {
                    key: "push",
                    value: function(t3, e4, n3) {
                        for (var r3 = arguments.length, i3 = new Array(r3 > 3 ? r3 - 3 : 0), o2 = 3; o2 < r3; o2++)
                            i3[o2 - 3] = arguments[o2];
                        this.add.apply(this, [t3, e4, n3].concat(i3))
                    }
                }, {
                    key: "current",
                    value: function() {
                        var t3 = this;
                        return this.slices != null ? (this.slices = l(this.slices, {
                            mergeType: this.opts.mergeType
                        }),
                        this.opts.limitToBeAddedWhitespace ? this.slices.map(function(e4) {
                            return g(e4[2]) ? [e4[0], e4[1], p(e4[2], t3.opts.limitLinebreaksCount)] : e4
                        }) : this.slices) : null
                    }
                }, {
                    key: "wipe",
                    value: function() {
                        this.slices = void 0
                    }
                }, {
                    key: "replace",
                    value: function(t3) {
                        if (Array.isArray(t3) && t3.length) {
                            if (!Array.isArray(t3[0]) || !v(t3[0][0]))
                                throw new Error("ranges-push/Ranges/replace(): [THROW_ID_11] Single range was given but we expected array of arrays! The first element, ".concat(JSON.stringify(t3[0], null, 4), " should be an array and its first element should be an integer, a string index."));
                            this.slices = Array.from(t3)
                        } else
                            this.slices = void 0
                    }
                }, {
                    key: "last",
                    value: function() {
                        return this.slices !== void 0 && Array.isArray(this.slices) ? this.slices[this.slices.length - 1] : null
                    }
                }]) && n2(r2.prototype, i2),
                e3
            }(), _ = Function.prototype, A = Object.prototype, k = _.toString, T = A.hasOwnProperty, S = k.call(Object), x = A.toString, C = (b = Object.getPrototypeOf,
            w = Object,
            function(t3) {
                return b(w(t3))
            }
            ), O = function(e3) {
                if (!function(e4) {
                    return !!e4 && t2(e4) == "object"
                }(e3) || x.call(e3) != "[object Object]" || function(t3) {
                    var e4 = !1;
                    if (t3 != null && typeof t3.toString != "function")
                        try {
                            e4 = !!(t3 + "")
                        } catch {}
                    return e4
                }(e3))
                    return !1;
                var n3 = C(e3);
                if (n3 === null)
                    return !0;
                var r2 = T.call(n3, "constructor") && n3.constructor;
                return typeof r2 == "function" && r2 instanceof r2 && k.call(r2) == S
            }, L = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : e2 !== void 0 ? e2 : typeof self < "u" ? self : {};
            function q(t3) {
                return t3 && t3.default || t3
            }
            var D = /^\s+|\s+$/g
              , P = "[\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0]"
              , j = "\\ud83c[\\udffb-\\udfff]"
              , I = "[^\\ud800-\\udfff]"
              , N = "(?:\\ud83c[\\udde6-\\uddff]){2}"
              , M = "[\\ud800-\\udbff][\\udc00-\\udfff]"
              , z = "(?:" + P + "|" + j + ")?"
              , R = "[\\ufe0e\\ufe0f]?" + z + "(?:\\u200d(?:" + [I, N, M].join("|") + ")[\\ufe0e\\ufe0f]?" + z + ")*"
              , B = "(?:" + [I + P + "?", P, N, M, "[\\ud800-\\udfff]"].join("|") + ")"
              , F = RegExp(j + "(?=" + j + ")|" + B + R, "g")
              , H = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0\\ufe0e\\ufe0f]")
              , V = t2(L) == "object" && L && L.Object === Object && L
              , U = (typeof self > "u" ? "undefined" : t2(self)) == "object" && self && self.Object === Object && self
              , W = V || U || Function("return this")();
            function G(t3, e3, n3) {
                if (e3 != e3)
                    return function(t4, e4, n4, r3) {
                        for (var i3 = t4.length, o2 = n4 + -1; ++o2 < i3; )
                            if (e4(t4[o2], o2, t4))
                                return o2;
                        return -1
                    }(t3, $, n3);
                for (var r2 = n3 - 1, i2 = t3.length; ++r2 < i2; )
                    if (t3[r2] === e3)
                        return r2;
                return -1
            }
            function $(t3) {
                return t3 != t3
            }
            function J(t3) {
                return function(t4) {
                    return H.test(t4)
                }(t3) ? function(t4) {
                    return t4.match(F) || []
                }(t3) : function(t4) {
                    return t4.split("")
                }(t3)
            }
            var Y = Object.prototype.toString
              , X = W.Symbol
              , Q = X ? X.prototype : void 0
              , Z = Q ? Q.toString : void 0;
            function K(e3) {
                if (typeof e3 == "string")
                    return e3;
                if (function(e4) {
                    return t2(e4) == "symbol" || function(e5) {
                        return !!e5 && t2(e5) == "object"
                    }(e4) && Y.call(e4) == "[object Symbol]"
                }(e3))
                    return Z ? Z.call(e3) : "";
                var n3 = e3 + "";
                return n3 == "0" && 1 / e3 == -1 / 0 ? "-0" : n3
            }
            var tt = function(t3, e3, n3) {
                var r2;
                if ((t3 = (r2 = t3) == null ? "" : K(r2)) && (n3 || e3 === void 0))
                    return t3.replace(D, "");
                if (!t3 || !(e3 = K(e3)))
                    return t3;
                var i2 = J(t3)
                  , o2 = J(e3);
                return function(t4, e4, n4) {
                    var r3 = t4.length;
                    return n4 = n4 === void 0 ? r3 : n4,
                    !e4 && n4 >= r3 ? t4 : function(t5, e5, n5) {
                        var r4 = -1
                          , i3 = t5.length;
                        e5 < 0 && (e5 = -e5 > i3 ? 0 : i3 + e5),
                        (n5 = n5 > i3 ? i3 : n5) < 0 && (n5 += i3),
                        i3 = e5 > n5 ? 0 : n5 - e5 >>> 0,
                        e5 >>>= 0;
                        for (var o3 = Array(i3); ++r4 < i3; )
                            o3[r4] = t5[r4 + e5];
                        return o3
                    }(t4, e4, n4)
                }(i2, function(t4, e4) {
                    for (var n4 = -1, r3 = t4.length; ++n4 < r3 && G(e4, t4[n4], 0) > -1; )
                        ;
                    return n4
                }(i2, o2), function(t4, e4) {
                    for (var n4 = t4.length; n4-- && G(e4, t4[n4], 0) > -1; )
                        ;
                    return n4
                }(i2, o2) + 1).join("")
            }
              , et = /^\[object .+?Constructor\]$/
              , nt = t2(L) == "object" && L && L.Object === Object && L
              , rt = (typeof self > "u" ? "undefined" : t2(self)) == "object" && self && self.Object === Object && self
              , it = nt || rt || Function("return this")();
            function ot(t3, e3, n3) {
                switch (n3.length) {
                case 0:
                    return t3.call(e3);
                case 1:
                    return t3.call(e3, n3[0]);
                case 2:
                    return t3.call(e3, n3[0], n3[1]);
                case 3:
                    return t3.call(e3, n3[0], n3[1], n3[2])
                }
                return t3.apply(e3, n3)
            }
            function at(t3, e3) {
                return !(!t3 || !t3.length) && function(t4, e4, n3) {
                    if (e4 != e4)
                        return function(t5, e5, n4, r3) {
                            for (var i3 = t5.length, o2 = -1; ++o2 < i3; )
                                if (e5(t5[o2], o2, t5))
                                    return o2;
                            return -1
                        }(t4, ct);
                    for (var r2 = -1, i2 = t4.length; ++r2 < i2; )
                        if (t4[r2] === e4)
                            return r2;
                    return -1
                }(t3, e3) > -1
            }
            function st(t3, e3, n3) {
                for (var r2 = -1, i2 = t3 ? t3.length : 0; ++r2 < i2; )
                    if (n3(e3, t3[r2]))
                        return !0;
                return !1
            }
            function ct(t3) {
                return t3 != t3
            }
            function lt(t3, e3) {
                return t3.has(e3)
            }
            var ut, dt = Array.prototype, ft = Function.prototype, ht = Object.prototype, pt = it["__core-js_shared__"], gt = (ut = /[^.]+$/.exec(pt && pt.keys && pt.keys.IE_PROTO || "")) ? "Symbol(src)_1." + ut : "", vt = ft.toString, mt = ht.hasOwnProperty, yt = ht.toString, bt = RegExp("^" + vt.call(mt).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), wt = dt.splice, Et = Math.max, _t = Lt(it, "Map"), At = Lt(Object, "create");
            function kt(t3) {
                var e3 = -1
                  , n3 = t3 ? t3.length : 0;
                for (this.clear(); ++e3 < n3; ) {
                    var r2 = t3[e3];
                    this.set(r2[0], r2[1])
                }
            }
            function Tt(t3) {
                var e3 = -1
                  , n3 = t3 ? t3.length : 0;
                for (this.clear(); ++e3 < n3; ) {
                    var r2 = t3[e3];
                    this.set(r2[0], r2[1])
                }
            }
            function St(t3) {
                var e3 = -1
                  , n3 = t3 ? t3.length : 0;
                for (this.clear(); ++e3 < n3; ) {
                    var r2 = t3[e3];
                    this.set(r2[0], r2[1])
                }
            }
            function xt(t3) {
                var e3 = -1
                  , n3 = t3 ? t3.length : 0;
                for (this.__data__ = new St; ++e3 < n3; )
                    this.add(t3[e3])
            }
            function Ct(t3, e3) {
                for (var n3, r2, i2 = t3.length; i2--; )
                    if ((n3 = t3[i2][0]) === (r2 = e3) || n3 != n3 && r2 != r2)
                        return i2;
                return -1
            }
            function Ot(e3, n3) {
                var r2, i2, o2 = e3.__data__;
                return ((i2 = t2(r2 = n3)) == "string" || i2 == "number" || i2 == "symbol" || i2 == "boolean" ? r2 !== "__proto__" : r2 === null) ? o2[typeof n3 == "string" ? "string" : "hash"] : o2.map
            }
            function Lt(t3, e3) {
                var n3 = function(t4, e4) {
                    return t4?.[e4]
                }(t3, e3);
                return function(t4) {
                    return !(!Dt(t4) || function(t5) {
                        return !!gt && gt in t5
                    }(t4)) && (qt(t4) || function(t5) {
                        var e4 = !1;
                        if (t5 != null && typeof t5.toString != "function")
                            try {
                                e4 = !!(t5 + "")
                            } catch {}
                        return e4
                    }(t4) ? bt : et).test(function(t5) {
                        if (t5 != null) {
                            try {
                                return vt.call(t5)
                            } catch {}
                            try {
                                return t5 + ""
                            } catch {}
                        }
                        return ""
                    }(t4))
                }(n3) ? n3 : void 0
            }
            function qt(t3) {
                var e3 = Dt(t3) ? yt.call(t3) : "";
                return e3 == "[object Function]" || e3 == "[object GeneratorFunction]"
            }
            function Dt(e3) {
                var n3 = t2(e3);
                return !!e3 && (n3 == "object" || n3 == "function")
            }
            kt.prototype.clear = function() {
                this.__data__ = At ? At(null) : {}
            }
            ,
            kt.prototype.delete = function(t3) {
                return this.has(t3) && delete this.__data__[t3]
            }
            ,
            kt.prototype.get = function(t3) {
                var e3 = this.__data__;
                if (At) {
                    var n3 = e3[t3];
                    return n3 === "__lodash_hash_undefined__" ? void 0 : n3
                }
                return mt.call(e3, t3) ? e3[t3] : void 0
            }
            ,
            kt.prototype.has = function(t3) {
                var e3 = this.__data__;
                return At ? e3[t3] !== void 0 : mt.call(e3, t3)
            }
            ,
            kt.prototype.set = function(t3, e3) {
                return this.__data__[t3] = At && e3 === void 0 ? "__lodash_hash_undefined__" : e3,
                this
            }
            ,
            Tt.prototype.clear = function() {
                this.__data__ = []
            }
            ,
            Tt.prototype.delete = function(t3) {
                var e3 = this.__data__
                  , n3 = Ct(e3, t3);
                return !(n3 < 0 || (n3 == e3.length - 1 ? e3.pop() : wt.call(e3, n3, 1),
                0))
            }
            ,
            Tt.prototype.get = function(t3) {
                var e3 = this.__data__
                  , n3 = Ct(e3, t3);
                return n3 < 0 ? void 0 : e3[n3][1]
            }
            ,
            Tt.prototype.has = function(t3) {
                return Ct(this.__data__, t3) > -1
            }
            ,
            Tt.prototype.set = function(t3, e3) {
                var n3 = this.__data__
                  , r2 = Ct(n3, t3);
                return r2 < 0 ? n3.push([t3, e3]) : n3[r2][1] = e3,
                this
            }
            ,
            St.prototype.clear = function() {
                this.__data__ = {
                    hash: new kt,
                    map: new (_t || Tt),
                    string: new kt
                }
            }
            ,
            St.prototype.delete = function(t3) {
                return Ot(this, t3).delete(t3)
            }
            ,
            St.prototype.get = function(t3) {
                return Ot(this, t3).get(t3)
            }
            ,
            St.prototype.has = function(t3) {
                return Ot(this, t3).has(t3)
            }
            ,
            St.prototype.set = function(t3, e3) {
                return Ot(this, t3).set(t3, e3),
                this
            }
            ,
            xt.prototype.add = xt.prototype.push = function(t3) {
                return this.__data__.set(t3, "__lodash_hash_undefined__"),
                this
            }
            ,
            xt.prototype.has = function(t3) {
                return this.__data__.has(t3)
            }
            ;
            var Pt = function(t3, e3) {
                return e3 = Et(e3 === void 0 ? t3.length - 1 : e3, 0),
                function() {
                    for (var n3 = arguments, r2 = -1, i2 = Et(n3.length - e3, 0), o2 = Array(i2); ++r2 < i2; )
                        o2[r2] = n3[e3 + r2];
                    r2 = -1;
                    for (var a2 = Array(e3 + 1); ++r2 < e3; )
                        a2[r2] = n3[r2];
                    return a2[e3] = o2,
                    ot(t3, this, a2)
                }
            }(function(e3, n3) {
                return function(e4) {
                    return !!e4 && t2(e4) == "object"
                }(r2 = e3) && function(t3) {
                    return t3 != null && function(t4) {
                        return typeof t4 == "number" && t4 > -1 && t4 % 1 == 0 && t4 <= 9007199254740991
                    }(t3.length) && !qt(t3)
                }(r2) ? function(t3, e4, n4, r3) {
                    var i2 = -1
                      , o2 = at
                      , a2 = !0
                      , s2 = t3.length
                      , c2 = []
                      , l2 = e4.length;
                    if (!s2)
                        return c2;
                    n4 && (e4 = function(t4, e5) {
                        for (var n5 = -1, r4 = t4 ? t4.length : 0, i3 = Array(r4); ++n5 < r4; )
                            i3[n5] = e5(t4[n5], n5, t4);
                        return i3
                    }(e4, function(t4) {
                        return function(e5) {
                            return t4(e5)
                        }
                    }(n4))),
                    r3 ? (o2 = st,
                    a2 = !1) : e4.length >= 200 && (o2 = lt,
                    a2 = !1,
                    e4 = new xt(e4));
                    t: for (; ++i2 < s2; ) {
                        var u2 = t3[i2]
                          , d2 = n4 ? n4(u2) : u2;
                        if (u2 = r3 || u2 !== 0 ? u2 : 0,
                        a2 && d2 == d2) {
                            for (var f2 = l2; f2--; )
                                if (e4[f2] === d2)
                                    continue t;
                            c2.push(u2)
                        } else
                            o2(e4, d2, r3) || c2.push(u2)
                    }
                    return c2
                }(e3, n3) : [];
                var r2
            })
              , jt = 2147483647
              , It = /^xn--/
              , Nt = /[^\x20-\x7E]/
              , Mt = /[\x2E\u3002\uFF0E\uFF61]/g
              , zt = {
                overflow: "Overflow: input needs wider integers to process",
                "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                "invalid-input": "Invalid input"
            }
              , Rt = Math.floor
              , Bt = String.fromCharCode;
            /*! https://mths.be/punycode v1.4.1 by @mathias */
            function Ft(t3) {
                throw new RangeError(zt[t3])
            }
            function Ht(t3, e3) {
                for (var n3 = t3.length, r2 = []; n3--; )
                    r2[n3] = e3(t3[n3]);
                return r2
            }
            function Vt(t3, e3) {
                var n3 = t3.split("@")
                  , r2 = "";
                return n3.length > 1 && (r2 = n3[0] + "@",
                t3 = n3[1]),
                r2 + Ht((t3 = t3.replace(Mt, ".")).split("."), e3).join(".")
            }
            function Ut(t3) {
                for (var e3, n3, r2 = [], i2 = 0, o2 = t3.length; i2 < o2; )
                    (e3 = t3.charCodeAt(i2++)) >= 55296 && e3 <= 56319 && i2 < o2 ? (64512 & (n3 = t3.charCodeAt(i2++))) == 56320 ? r2.push(((1023 & e3) << 10) + (1023 & n3) + 65536) : (r2.push(e3),
                    i2--) : r2.push(e3);
                return r2
            }
            function Wt(t3) {
                return Ht(t3, function(t4) {
                    var e3 = "";
                    return t4 > 65535 && (e3 += Bt((t4 -= 65536) >>> 10 & 1023 | 55296),
                    t4 = 56320 | 1023 & t4),
                    e3 + Bt(t4)
                }).join("")
            }
            function Gt(t3, e3) {
                return t3 + 22 + 75 * (t3 < 26) - ((e3 != 0) << 5)
            }
            function $t(t3, e3, n3) {
                var r2 = 0;
                for (t3 = n3 ? Rt(t3 / 700) : t3 >> 1,
                t3 += Rt(t3 / e3); t3 > 455; r2 += 36)
                    t3 = Rt(t3 / 35);
                return Rt(r2 + 36 * t3 / (t3 + 38))
            }
            function Jt(t3) {
                var e3, n3, r2, i2, o2, a2, s2, c2, l2, u2, d2, f2 = [], h2 = t3.length, p2 = 0, g2 = 128, v2 = 72;
                for ((n3 = t3.lastIndexOf("-")) < 0 && (n3 = 0),
                r2 = 0; r2 < n3; ++r2)
                    t3.charCodeAt(r2) >= 128 && Ft("not-basic"),
                    f2.push(t3.charCodeAt(r2));
                for (i2 = n3 > 0 ? n3 + 1 : 0; i2 < h2; ) {
                    for (o2 = p2,
                    a2 = 1,
                    s2 = 36; i2 >= h2 && Ft("invalid-input"),
                    ((c2 = (d2 = t3.charCodeAt(i2++)) - 48 < 10 ? d2 - 22 : d2 - 65 < 26 ? d2 - 65 : d2 - 97 < 26 ? d2 - 97 : 36) >= 36 || c2 > Rt((jt - p2) / a2)) && Ft("overflow"),
                    p2 += c2 * a2,
                    !(c2 < (l2 = s2 <= v2 ? 1 : s2 >= v2 + 26 ? 26 : s2 - v2)); s2 += 36)
                        a2 > Rt(jt / (u2 = 36 - l2)) && Ft("overflow"),
                        a2 *= u2;
                    v2 = $t(p2 - o2, e3 = f2.length + 1, o2 == 0),
                    Rt(p2 / e3) > jt - g2 && Ft("overflow"),
                    g2 += Rt(p2 / e3),
                    p2 %= e3,
                    f2.splice(p2++, 0, g2)
                }
                return Wt(f2)
            }
            function Yt(t3) {
                var e3, n3, r2, i2, o2, a2, s2, c2, l2, u2, d2, f2, h2, p2, g2, v2 = [];
                for (f2 = (t3 = Ut(t3)).length,
                e3 = 128,
                n3 = 0,
                o2 = 72,
                a2 = 0; a2 < f2; ++a2)
                    (d2 = t3[a2]) < 128 && v2.push(Bt(d2));
                for (r2 = i2 = v2.length,
                i2 && v2.push("-"); r2 < f2; ) {
                    for (s2 = jt,
                    a2 = 0; a2 < f2; ++a2)
                        (d2 = t3[a2]) >= e3 && d2 < s2 && (s2 = d2);
                    for (s2 - e3 > Rt((jt - n3) / (h2 = r2 + 1)) && Ft("overflow"),
                    n3 += (s2 - e3) * h2,
                    e3 = s2,
                    a2 = 0; a2 < f2; ++a2)
                        if ((d2 = t3[a2]) < e3 && ++n3 > jt && Ft("overflow"),
                        d2 == e3) {
                            for (c2 = n3,
                            l2 = 36; !(c2 < (u2 = l2 <= o2 ? 1 : l2 >= o2 + 26 ? 26 : l2 - o2)); l2 += 36)
                                g2 = c2 - u2,
                                p2 = 36 - u2,
                                v2.push(Bt(Gt(u2 + g2 % p2, 0))),
                                c2 = Rt(g2 / p2);
                            v2.push(Bt(Gt(c2, 0))),
                            o2 = $t(n3, h2, r2 == i2),
                            n3 = 0,
                            ++r2
                        }
                    ++n3,
                    ++e3
                }
                return v2.join("")
            }
            var Xt = {
                version: "1.4.1",
                ucs2: {
                    decode: Ut,
                    encode: Wt
                },
                toASCII: function(t3) {
                    return Vt(t3, function(t4) {
                        return Nt.test(t4) ? "xn--" + Yt(t4) : t4
                    })
                },
                toUnicode: function(t3) {
                    return Vt(t3, function(t4) {
                        return It.test(t4) ? Jt(t4.slice(4).toLowerCase()) : t4
                    })
                },
                encode: Yt,
                decode: Jt
            }
              , Qt = (q(Object.freeze({
                __proto__: null,
                default: {
                    9: "Tab;",
                    10: "NewLine;",
                    33: "excl;",
                    34: "quot;",
                    35: "num;",
                    36: "dollar;",
                    37: "percnt;",
                    38: "amp;",
                    39: "apos;",
                    40: "lpar;",
                    41: "rpar;",
                    42: "midast;",
                    43: "plus;",
                    44: "comma;",
                    46: "period;",
                    47: "sol;",
                    58: "colon;",
                    59: "semi;",
                    60: "lt;",
                    61: "equals;",
                    62: "gt;",
                    63: "quest;",
                    64: "commat;",
                    91: "lsqb;",
                    92: "bsol;",
                    93: "rsqb;",
                    94: "Hat;",
                    95: "UnderBar;",
                    96: "grave;",
                    123: "lcub;",
                    124: "VerticalLine;",
                    125: "rcub;",
                    160: "NonBreakingSpace;",
                    161: "iexcl;",
                    162: "cent;",
                    163: "pound;",
                    164: "curren;",
                    165: "yen;",
                    166: "brvbar;",
                    167: "sect;",
                    168: "uml;",
                    169: "copy;",
                    170: "ordf;",
                    171: "laquo;",
                    172: "not;",
                    173: "shy;",
                    174: "reg;",
                    175: "strns;",
                    176: "deg;",
                    177: "pm;",
                    178: "sup2;",
                    179: "sup3;",
                    180: "DiacriticalAcute;",
                    181: "micro;",
                    182: "para;",
                    183: "middot;",
                    184: "Cedilla;",
                    185: "sup1;",
                    186: "ordm;",
                    187: "raquo;",
                    188: "frac14;",
                    189: "half;",
                    190: "frac34;",
                    191: "iquest;",
                    192: "Agrave;",
                    193: "Aacute;",
                    194: "Acirc;",
                    195: "Atilde;",
                    196: "Auml;",
                    197: "Aring;",
                    198: "AElig;",
                    199: "Ccedil;",
                    200: "Egrave;",
                    201: "Eacute;",
                    202: "Ecirc;",
                    203: "Euml;",
                    204: "Igrave;",
                    205: "Iacute;",
                    206: "Icirc;",
                    207: "Iuml;",
                    208: "ETH;",
                    209: "Ntilde;",
                    210: "Ograve;",
                    211: "Oacute;",
                    212: "Ocirc;",
                    213: "Otilde;",
                    214: "Ouml;",
                    215: "times;",
                    216: "Oslash;",
                    217: "Ugrave;",
                    218: "Uacute;",
                    219: "Ucirc;",
                    220: "Uuml;",
                    221: "Yacute;",
                    222: "THORN;",
                    223: "szlig;",
                    224: "agrave;",
                    225: "aacute;",
                    226: "acirc;",
                    227: "atilde;",
                    228: "auml;",
                    229: "aring;",
                    230: "aelig;",
                    231: "ccedil;",
                    232: "egrave;",
                    233: "eacute;",
                    234: "ecirc;",
                    235: "euml;",
                    236: "igrave;",
                    237: "iacute;",
                    238: "icirc;",
                    239: "iuml;",
                    240: "eth;",
                    241: "ntilde;",
                    242: "ograve;",
                    243: "oacute;",
                    244: "ocirc;",
                    245: "otilde;",
                    246: "ouml;",
                    247: "divide;",
                    248: "oslash;",
                    249: "ugrave;",
                    250: "uacute;",
                    251: "ucirc;",
                    252: "uuml;",
                    253: "yacute;",
                    254: "thorn;",
                    255: "yuml;",
                    256: "Amacr;",
                    257: "amacr;",
                    258: "Abreve;",
                    259: "abreve;",
                    260: "Aogon;",
                    261: "aogon;",
                    262: "Cacute;",
                    263: "cacute;",
                    264: "Ccirc;",
                    265: "ccirc;",
                    266: "Cdot;",
                    267: "cdot;",
                    268: "Ccaron;",
                    269: "ccaron;",
                    270: "Dcaron;",
                    271: "dcaron;",
                    272: "Dstrok;",
                    273: "dstrok;",
                    274: "Emacr;",
                    275: "emacr;",
                    278: "Edot;",
                    279: "edot;",
                    280: "Eogon;",
                    281: "eogon;",
                    282: "Ecaron;",
                    283: "ecaron;",
                    284: "Gcirc;",
                    285: "gcirc;",
                    286: "Gbreve;",
                    287: "gbreve;",
                    288: "Gdot;",
                    289: "gdot;",
                    290: "Gcedil;",
                    292: "Hcirc;",
                    293: "hcirc;",
                    294: "Hstrok;",
                    295: "hstrok;",
                    296: "Itilde;",
                    297: "itilde;",
                    298: "Imacr;",
                    299: "imacr;",
                    302: "Iogon;",
                    303: "iogon;",
                    304: "Idot;",
                    305: "inodot;",
                    306: "IJlig;",
                    307: "ijlig;",
                    308: "Jcirc;",
                    309: "jcirc;",
                    310: "Kcedil;",
                    311: "kcedil;",
                    312: "kgreen;",
                    313: "Lacute;",
                    314: "lacute;",
                    315: "Lcedil;",
                    316: "lcedil;",
                    317: "Lcaron;",
                    318: "lcaron;",
                    319: "Lmidot;",
                    320: "lmidot;",
                    321: "Lstrok;",
                    322: "lstrok;",
                    323: "Nacute;",
                    324: "nacute;",
                    325: "Ncedil;",
                    326: "ncedil;",
                    327: "Ncaron;",
                    328: "ncaron;",
                    329: "napos;",
                    330: "ENG;",
                    331: "eng;",
                    332: "Omacr;",
                    333: "omacr;",
                    336: "Odblac;",
                    337: "odblac;",
                    338: "OElig;",
                    339: "oelig;",
                    340: "Racute;",
                    341: "racute;",
                    342: "Rcedil;",
                    343: "rcedil;",
                    344: "Rcaron;",
                    345: "rcaron;",
                    346: "Sacute;",
                    347: "sacute;",
                    348: "Scirc;",
                    349: "scirc;",
                    350: "Scedil;",
                    351: "scedil;",
                    352: "Scaron;",
                    353: "scaron;",
                    354: "Tcedil;",
                    355: "tcedil;",
                    356: "Tcaron;",
                    357: "tcaron;",
                    358: "Tstrok;",
                    359: "tstrok;",
                    360: "Utilde;",
                    361: "utilde;",
                    362: "Umacr;",
                    363: "umacr;",
                    364: "Ubreve;",
                    365: "ubreve;",
                    366: "Uring;",
                    367: "uring;",
                    368: "Udblac;",
                    369: "udblac;",
                    370: "Uogon;",
                    371: "uogon;",
                    372: "Wcirc;",
                    373: "wcirc;",
                    374: "Ycirc;",
                    375: "ycirc;",
                    376: "Yuml;",
                    377: "Zacute;",
                    378: "zacute;",
                    379: "Zdot;",
                    380: "zdot;",
                    381: "Zcaron;",
                    382: "zcaron;",
                    402: "fnof;",
                    437: "imped;",
                    501: "gacute;",
                    567: "jmath;",
                    710: "circ;",
                    711: "Hacek;",
                    728: "breve;",
                    729: "dot;",
                    730: "ring;",
                    731: "ogon;",
                    732: "tilde;",
                    733: "DiacriticalDoubleAcute;",
                    785: "DownBreve;",
                    913: "Alpha;",
                    914: "Beta;",
                    915: "Gamma;",
                    916: "Delta;",
                    917: "Epsilon;",
                    918: "Zeta;",
                    919: "Eta;",
                    920: "Theta;",
                    921: "Iota;",
                    922: "Kappa;",
                    923: "Lambda;",
                    924: "Mu;",
                    925: "Nu;",
                    926: "Xi;",
                    927: "Omicron;",
                    928: "Pi;",
                    929: "Rho;",
                    931: "Sigma;",
                    932: "Tau;",
                    933: "Upsilon;",
                    934: "Phi;",
                    935: "Chi;",
                    936: "Psi;",
                    937: "Omega;",
                    945: "alpha;",
                    946: "beta;",
                    947: "gamma;",
                    948: "delta;",
                    949: "epsilon;",
                    950: "zeta;",
                    951: "eta;",
                    952: "theta;",
                    953: "iota;",
                    954: "kappa;",
                    955: "lambda;",
                    956: "mu;",
                    957: "nu;",
                    958: "xi;",
                    959: "omicron;",
                    960: "pi;",
                    961: "rho;",
                    962: "varsigma;",
                    963: "sigma;",
                    964: "tau;",
                    965: "upsilon;",
                    966: "phi;",
                    967: "chi;",
                    968: "psi;",
                    969: "omega;",
                    977: "vartheta;",
                    978: "upsih;",
                    981: "varphi;",
                    982: "varpi;",
                    988: "Gammad;",
                    989: "gammad;",
                    1008: "varkappa;",
                    1009: "varrho;",
                    1013: "varepsilon;",
                    1014: "bepsi;",
                    1025: "IOcy;",
                    1026: "DJcy;",
                    1027: "GJcy;",
                    1028: "Jukcy;",
                    1029: "DScy;",
                    1030: "Iukcy;",
                    1031: "YIcy;",
                    1032: "Jsercy;",
                    1033: "LJcy;",
                    1034: "NJcy;",
                    1035: "TSHcy;",
                    1036: "KJcy;",
                    1038: "Ubrcy;",
                    1039: "DZcy;",
                    1040: "Acy;",
                    1041: "Bcy;",
                    1042: "Vcy;",
                    1043: "Gcy;",
                    1044: "Dcy;",
                    1045: "IEcy;",
                    1046: "ZHcy;",
                    1047: "Zcy;",
                    1048: "Icy;",
                    1049: "Jcy;",
                    1050: "Kcy;",
                    1051: "Lcy;",
                    1052: "Mcy;",
                    1053: "Ncy;",
                    1054: "Ocy;",
                    1055: "Pcy;",
                    1056: "Rcy;",
                    1057: "Scy;",
                    1058: "Tcy;",
                    1059: "Ucy;",
                    1060: "Fcy;",
                    1061: "KHcy;",
                    1062: "TScy;",
                    1063: "CHcy;",
                    1064: "SHcy;",
                    1065: "SHCHcy;",
                    1066: "HARDcy;",
                    1067: "Ycy;",
                    1068: "SOFTcy;",
                    1069: "Ecy;",
                    1070: "YUcy;",
                    1071: "YAcy;",
                    1072: "acy;",
                    1073: "bcy;",
                    1074: "vcy;",
                    1075: "gcy;",
                    1076: "dcy;",
                    1077: "iecy;",
                    1078: "zhcy;",
                    1079: "zcy;",
                    1080: "icy;",
                    1081: "jcy;",
                    1082: "kcy;",
                    1083: "lcy;",
                    1084: "mcy;",
                    1085: "ncy;",
                    1086: "ocy;",
                    1087: "pcy;",
                    1088: "rcy;",
                    1089: "scy;",
                    1090: "tcy;",
                    1091: "ucy;",
                    1092: "fcy;",
                    1093: "khcy;",
                    1094: "tscy;",
                    1095: "chcy;",
                    1096: "shcy;",
                    1097: "shchcy;",
                    1098: "hardcy;",
                    1099: "ycy;",
                    1100: "softcy;",
                    1101: "ecy;",
                    1102: "yucy;",
                    1103: "yacy;",
                    1105: "iocy;",
                    1106: "djcy;",
                    1107: "gjcy;",
                    1108: "jukcy;",
                    1109: "dscy;",
                    1110: "iukcy;",
                    1111: "yicy;",
                    1112: "jsercy;",
                    1113: "ljcy;",
                    1114: "njcy;",
                    1115: "tshcy;",
                    1116: "kjcy;",
                    1118: "ubrcy;",
                    1119: "dzcy;",
                    8194: "ensp;",
                    8195: "emsp;",
                    8196: "emsp13;",
                    8197: "emsp14;",
                    8199: "numsp;",
                    8200: "puncsp;",
                    8201: "ThinSpace;",
                    8202: "VeryThinSpace;",
                    8203: "ZeroWidthSpace;",
                    8204: "zwnj;",
                    8205: "zwj;",
                    8206: "lrm;",
                    8207: "rlm;",
                    8208: "hyphen;",
                    8211: "ndash;",
                    8212: "mdash;",
                    8213: "horbar;",
                    8214: "Vert;",
                    8216: "OpenCurlyQuote;",
                    8217: "rsquor;",
                    8218: "sbquo;",
                    8220: "OpenCurlyDoubleQuote;",
                    8221: "rdquor;",
                    8222: "ldquor;",
                    8224: "dagger;",
                    8225: "ddagger;",
                    8226: "bullet;",
                    8229: "nldr;",
                    8230: "mldr;",
                    8240: "permil;",
                    8241: "pertenk;",
                    8242: "prime;",
                    8243: "Prime;",
                    8244: "tprime;",
                    8245: "bprime;",
                    8249: "lsaquo;",
                    8250: "rsaquo;",
                    8254: "OverBar;",
                    8257: "caret;",
                    8259: "hybull;",
                    8260: "frasl;",
                    8271: "bsemi;",
                    8279: "qprime;",
                    8287: "MediumSpace;",
                    8288: "NoBreak;",
                    8289: "ApplyFunction;",
                    8290: "it;",
                    8291: "InvisibleComma;",
                    8364: "euro;",
                    8411: "TripleDot;",
                    8412: "DotDot;",
                    8450: "Copf;",
                    8453: "incare;",
                    8458: "gscr;",
                    8459: "Hscr;",
                    8460: "Poincareplane;",
                    8461: "quaternions;",
                    8462: "planckh;",
                    8463: "plankv;",
                    8464: "Iscr;",
                    8465: "imagpart;",
                    8466: "Lscr;",
                    8467: "ell;",
                    8469: "Nopf;",
                    8470: "numero;",
                    8471: "copysr;",
                    8472: "wp;",
                    8473: "primes;",
                    8474: "rationals;",
                    8475: "Rscr;",
                    8476: "Rfr;",
                    8477: "Ropf;",
                    8478: "rx;",
                    8482: "trade;",
                    8484: "Zopf;",
                    8487: "mho;",
                    8488: "Zfr;",
                    8489: "iiota;",
                    8492: "Bscr;",
                    8493: "Cfr;",
                    8495: "escr;",
                    8496: "expectation;",
                    8497: "Fscr;",
                    8499: "phmmat;",
                    8500: "oscr;",
                    8501: "aleph;",
                    8502: "beth;",
                    8503: "gimel;",
                    8504: "daleth;",
                    8517: "DD;",
                    8518: "DifferentialD;",
                    8519: "exponentiale;",
                    8520: "ImaginaryI;",
                    8531: "frac13;",
                    8532: "frac23;",
                    8533: "frac15;",
                    8534: "frac25;",
                    8535: "frac35;",
                    8536: "frac45;",
                    8537: "frac16;",
                    8538: "frac56;",
                    8539: "frac18;",
                    8540: "frac38;",
                    8541: "frac58;",
                    8542: "frac78;",
                    8592: "slarr;",
                    8593: "uparrow;",
                    8594: "srarr;",
                    8595: "ShortDownArrow;",
                    8596: "leftrightarrow;",
                    8597: "varr;",
                    8598: "UpperLeftArrow;",
                    8599: "UpperRightArrow;",
                    8600: "searrow;",
                    8601: "swarrow;",
                    8602: "nleftarrow;",
                    8603: "nrightarrow;",
                    8605: "rightsquigarrow;",
                    8606: "twoheadleftarrow;",
                    8607: "Uarr;",
                    8608: "twoheadrightarrow;",
                    8609: "Darr;",
                    8610: "leftarrowtail;",
                    8611: "rightarrowtail;",
                    8612: "mapstoleft;",
                    8613: "UpTeeArrow;",
                    8614: "RightTeeArrow;",
                    8615: "mapstodown;",
                    8617: "larrhk;",
                    8618: "rarrhk;",
                    8619: "looparrowleft;",
                    8620: "rarrlp;",
                    8621: "leftrightsquigarrow;",
                    8622: "nleftrightarrow;",
                    8624: "lsh;",
                    8625: "rsh;",
                    8626: "ldsh;",
                    8627: "rdsh;",
                    8629: "crarr;",
                    8630: "curvearrowleft;",
                    8631: "curvearrowright;",
                    8634: "olarr;",
                    8635: "orarr;",
                    8636: "lharu;",
                    8637: "lhard;",
                    8638: "upharpoonright;",
                    8639: "upharpoonleft;",
                    8640: "RightVector;",
                    8641: "rightharpoondown;",
                    8642: "RightDownVector;",
                    8643: "LeftDownVector;",
                    8644: "rlarr;",
                    8645: "UpArrowDownArrow;",
                    8646: "lrarr;",
                    8647: "llarr;",
                    8648: "uuarr;",
                    8649: "rrarr;",
                    8650: "downdownarrows;",
                    8651: "ReverseEquilibrium;",
                    8652: "rlhar;",
                    8653: "nLeftarrow;",
                    8654: "nLeftrightarrow;",
                    8655: "nRightarrow;",
                    8656: "Leftarrow;",
                    8657: "Uparrow;",
                    8658: "Rightarrow;",
                    8659: "Downarrow;",
                    8660: "Leftrightarrow;",
                    8661: "vArr;",
                    8662: "nwArr;",
                    8663: "neArr;",
                    8664: "seArr;",
                    8665: "swArr;",
                    8666: "Lleftarrow;",
                    8667: "Rrightarrow;",
                    8669: "zigrarr;",
                    8676: "LeftArrowBar;",
                    8677: "RightArrowBar;",
                    8693: "duarr;",
                    8701: "loarr;",
                    8702: "roarr;",
                    8703: "hoarr;",
                    8704: "forall;",
                    8705: "complement;",
                    8706: "PartialD;",
                    8707: "Exists;",
                    8708: "NotExists;",
                    8709: "varnothing;",
                    8711: "nabla;",
                    8712: "isinv;",
                    8713: "notinva;",
                    8715: "SuchThat;",
                    8716: "NotReverseElement;",
                    8719: "Product;",
                    8720: "Coproduct;",
                    8721: "sum;",
                    8722: "minus;",
                    8723: "mp;",
                    8724: "plusdo;",
                    8726: "ssetmn;",
                    8727: "lowast;",
                    8728: "SmallCircle;",
                    8730: "Sqrt;",
                    8733: "vprop;",
                    8734: "infin;",
                    8735: "angrt;",
                    8736: "angle;",
                    8737: "measuredangle;",
                    8738: "angsph;",
                    8739: "VerticalBar;",
                    8740: "nsmid;",
                    8741: "spar;",
                    8742: "nspar;",
                    8743: "wedge;",
                    8744: "vee;",
                    8745: "cap;",
                    8746: "cup;",
                    8747: "Integral;",
                    8748: "Int;",
                    8749: "tint;",
                    8750: "oint;",
                    8751: "DoubleContourIntegral;",
                    8752: "Cconint;",
                    8753: "cwint;",
                    8754: "cwconint;",
                    8755: "CounterClockwiseContourIntegral;",
                    8756: "therefore;",
                    8757: "because;",
                    8758: "ratio;",
                    8759: "Proportion;",
                    8760: "minusd;",
                    8762: "mDDot;",
                    8763: "homtht;",
                    8764: "Tilde;",
                    8765: "bsim;",
                    8766: "mstpos;",
                    8767: "acd;",
                    8768: "wreath;",
                    8769: "nsim;",
                    8770: "esim;",
                    8771: "TildeEqual;",
                    8772: "nsimeq;",
                    8773: "TildeFullEqual;",
                    8774: "simne;",
                    8775: "NotTildeFullEqual;",
                    8776: "TildeTilde;",
                    8777: "NotTildeTilde;",
                    8778: "approxeq;",
                    8779: "apid;",
                    8780: "bcong;",
                    8781: "CupCap;",
                    8782: "HumpDownHump;",
                    8783: "HumpEqual;",
                    8784: "esdot;",
                    8785: "eDot;",
                    8786: "fallingdotseq;",
                    8787: "risingdotseq;",
                    8788: "coloneq;",
                    8789: "eqcolon;",
                    8790: "eqcirc;",
                    8791: "cire;",
                    8793: "wedgeq;",
                    8794: "veeeq;",
                    8796: "trie;",
                    8799: "questeq;",
                    8800: "NotEqual;",
                    8801: "equiv;",
                    8802: "NotCongruent;",
                    8804: "leq;",
                    8805: "GreaterEqual;",
                    8806: "LessFullEqual;",
                    8807: "GreaterFullEqual;",
                    8808: "lneqq;",
                    8809: "gneqq;",
                    8810: "NestedLessLess;",
                    8811: "NestedGreaterGreater;",
                    8812: "twixt;",
                    8813: "NotCupCap;",
                    8814: "NotLess;",
                    8815: "NotGreater;",
                    8816: "NotLessEqual;",
                    8817: "NotGreaterEqual;",
                    8818: "lsim;",
                    8819: "gtrsim;",
                    8820: "NotLessTilde;",
                    8821: "NotGreaterTilde;",
                    8822: "lg;",
                    8823: "gtrless;",
                    8824: "ntlg;",
                    8825: "ntgl;",
                    8826: "Precedes;",
                    8827: "Succeeds;",
                    8828: "PrecedesSlantEqual;",
                    8829: "SucceedsSlantEqual;",
                    8830: "prsim;",
                    8831: "succsim;",
                    8832: "nprec;",
                    8833: "nsucc;",
                    8834: "subset;",
                    8835: "supset;",
                    8836: "nsub;",
                    8837: "nsup;",
                    8838: "SubsetEqual;",
                    8839: "supseteq;",
                    8840: "nsubseteq;",
                    8841: "nsupseteq;",
                    8842: "subsetneq;",
                    8843: "supsetneq;",
                    8845: "cupdot;",
                    8846: "uplus;",
                    8847: "SquareSubset;",
                    8848: "SquareSuperset;",
                    8849: "SquareSubsetEqual;",
                    8850: "SquareSupersetEqual;",
                    8851: "SquareIntersection;",
                    8852: "SquareUnion;",
                    8853: "oplus;",
                    8854: "ominus;",
                    8855: "otimes;",
                    8856: "osol;",
                    8857: "odot;",
                    8858: "ocir;",
                    8859: "oast;",
                    8861: "odash;",
                    8862: "plusb;",
                    8863: "minusb;",
                    8864: "timesb;",
                    8865: "sdotb;",
                    8866: "vdash;",
                    8867: "LeftTee;",
                    8868: "top;",
                    8869: "UpTee;",
                    8871: "models;",
                    8872: "vDash;",
                    8873: "Vdash;",
                    8874: "Vvdash;",
                    8875: "VDash;",
                    8876: "nvdash;",
                    8877: "nvDash;",
                    8878: "nVdash;",
                    8879: "nVDash;",
                    8880: "prurel;",
                    8882: "vltri;",
                    8883: "vrtri;",
                    8884: "trianglelefteq;",
                    8885: "trianglerighteq;",
                    8886: "origof;",
                    8887: "imof;",
                    8888: "mumap;",
                    8889: "hercon;",
                    8890: "intercal;",
                    8891: "veebar;",
                    8893: "barvee;",
                    8894: "angrtvb;",
                    8895: "lrtri;",
                    8896: "xwedge;",
                    8897: "xvee;",
                    8898: "xcap;",
                    8899: "xcup;",
                    8900: "diamond;",
                    8901: "sdot;",
                    8902: "Star;",
                    8903: "divonx;",
                    8904: "bowtie;",
                    8905: "ltimes;",
                    8906: "rtimes;",
                    8907: "lthree;",
                    8908: "rthree;",
                    8909: "bsime;",
                    8910: "cuvee;",
                    8911: "cuwed;",
                    8912: "Subset;",
                    8913: "Supset;",
                    8914: "Cap;",
                    8915: "Cup;",
                    8916: "pitchfork;",
                    8917: "epar;",
                    8918: "ltdot;",
                    8919: "gtrdot;",
                    8920: "Ll;",
                    8921: "ggg;",
                    8922: "LessEqualGreater;",
                    8923: "gtreqless;",
                    8926: "curlyeqprec;",
                    8927: "curlyeqsucc;",
                    8928: "nprcue;",
                    8929: "nsccue;",
                    8930: "nsqsube;",
                    8931: "nsqsupe;",
                    8934: "lnsim;",
                    8935: "gnsim;",
                    8936: "prnsim;",
                    8937: "succnsim;",
                    8938: "ntriangleleft;",
                    8939: "ntriangleright;",
                    8940: "ntrianglelefteq;",
                    8941: "ntrianglerighteq;",
                    8942: "vellip;",
                    8943: "ctdot;",
                    8944: "utdot;",
                    8945: "dtdot;",
                    8946: "disin;",
                    8947: "isinsv;",
                    8948: "isins;",
                    8949: "isindot;",
                    8950: "notinvc;",
                    8951: "notinvb;",
                    8953: "isinE;",
                    8954: "nisd;",
                    8955: "xnis;",
                    8956: "nis;",
                    8957: "notnivc;",
                    8958: "notnivb;",
                    8965: "barwedge;",
                    8966: "doublebarwedge;",
                    8968: "LeftCeiling;",
                    8969: "RightCeiling;",
                    8970: "lfloor;",
                    8971: "RightFloor;",
                    8972: "drcrop;",
                    8973: "dlcrop;",
                    8974: "urcrop;",
                    8975: "ulcrop;",
                    8976: "bnot;",
                    8978: "profline;",
                    8979: "profsurf;",
                    8981: "telrec;",
                    8982: "target;",
                    8988: "ulcorner;",
                    8989: "urcorner;",
                    8990: "llcorner;",
                    8991: "lrcorner;",
                    8994: "sfrown;",
                    8995: "ssmile;",
                    9005: "cylcty;",
                    9006: "profalar;",
                    9014: "topbot;",
                    9021: "ovbar;",
                    9023: "solbar;",
                    9084: "angzarr;",
                    9136: "lmoustache;",
                    9137: "rmoustache;",
                    9140: "tbrk;",
                    9141: "UnderBracket;",
                    9142: "bbrktbrk;",
                    9180: "OverParenthesis;",
                    9181: "UnderParenthesis;",
                    9182: "OverBrace;",
                    9183: "UnderBrace;",
                    9186: "trpezium;",
                    9191: "elinters;",
                    9251: "blank;",
                    9416: "oS;",
                    9472: "HorizontalLine;",
                    9474: "boxv;",
                    9484: "boxdr;",
                    9488: "boxdl;",
                    9492: "boxur;",
                    9496: "boxul;",
                    9500: "boxvr;",
                    9508: "boxvl;",
                    9516: "boxhd;",
                    9524: "boxhu;",
                    9532: "boxvh;",
                    9552: "boxH;",
                    9553: "boxV;",
                    9554: "boxdR;",
                    9555: "boxDr;",
                    9556: "boxDR;",
                    9557: "boxdL;",
                    9558: "boxDl;",
                    9559: "boxDL;",
                    9560: "boxuR;",
                    9561: "boxUr;",
                    9562: "boxUR;",
                    9563: "boxuL;",
                    9564: "boxUl;",
                    9565: "boxUL;",
                    9566: "boxvR;",
                    9567: "boxVr;",
                    9568: "boxVR;",
                    9569: "boxvL;",
                    9570: "boxVl;",
                    9571: "boxVL;",
                    9572: "boxHd;",
                    9573: "boxhD;",
                    9574: "boxHD;",
                    9575: "boxHu;",
                    9576: "boxhU;",
                    9577: "boxHU;",
                    9578: "boxvH;",
                    9579: "boxVh;",
                    9580: "boxVH;",
                    9600: "uhblk;",
                    9604: "lhblk;",
                    9608: "block;",
                    9617: "blk14;",
                    9618: "blk12;",
                    9619: "blk34;",
                    9633: "square;",
                    9642: "squf;",
                    9643: "EmptyVerySmallSquare;",
                    9645: "rect;",
                    9646: "marker;",
                    9649: "fltns;",
                    9651: "xutri;",
                    9652: "utrif;",
                    9653: "utri;",
                    9656: "rtrif;",
                    9657: "triangleright;",
                    9661: "xdtri;",
                    9662: "dtrif;",
                    9663: "triangledown;",
                    9666: "ltrif;",
                    9667: "triangleleft;",
                    9674: "lozenge;",
                    9675: "cir;",
                    9708: "tridot;",
                    9711: "xcirc;",
                    9720: "ultri;",
                    9721: "urtri;",
                    9722: "lltri;",
                    9723: "EmptySmallSquare;",
                    9724: "FilledSmallSquare;",
                    9733: "starf;",
                    9734: "star;",
                    9742: "phone;",
                    9792: "female;",
                    9794: "male;",
                    9824: "spadesuit;",
                    9827: "clubsuit;",
                    9829: "heartsuit;",
                    9830: "diams;",
                    9834: "sung;",
                    9837: "flat;",
                    9838: "natural;",
                    9839: "sharp;",
                    10003: "checkmark;",
                    10007: "cross;",
                    10016: "maltese;",
                    10038: "sext;",
                    10072: "VerticalSeparator;",
                    10098: "lbbrk;",
                    10099: "rbbrk;",
                    10184: "bsolhsub;",
                    10185: "suphsol;",
                    10214: "lobrk;",
                    10215: "robrk;",
                    10216: "LeftAngleBracket;",
                    10217: "RightAngleBracket;",
                    10218: "Lang;",
                    10219: "Rang;",
                    10220: "loang;",
                    10221: "roang;",
                    10229: "xlarr;",
                    10230: "xrarr;",
                    10231: "xharr;",
                    10232: "xlArr;",
                    10233: "xrArr;",
                    10234: "xhArr;",
                    10236: "xmap;",
                    10239: "dzigrarr;",
                    10498: "nvlArr;",
                    10499: "nvrArr;",
                    10500: "nvHarr;",
                    10501: "Map;",
                    10508: "lbarr;",
                    10509: "rbarr;",
                    10510: "lBarr;",
                    10511: "rBarr;",
                    10512: "RBarr;",
                    10513: "DDotrahd;",
                    10514: "UpArrowBar;",
                    10515: "DownArrowBar;",
                    10518: "Rarrtl;",
                    10521: "latail;",
                    10522: "ratail;",
                    10523: "lAtail;",
                    10524: "rAtail;",
                    10525: "larrfs;",
                    10526: "rarrfs;",
                    10527: "larrbfs;",
                    10528: "rarrbfs;",
                    10531: "nwarhk;",
                    10532: "nearhk;",
                    10533: "searhk;",
                    10534: "swarhk;",
                    10535: "nwnear;",
                    10536: "toea;",
                    10537: "tosa;",
                    10538: "swnwar;",
                    10547: "rarrc;",
                    10549: "cudarrr;",
                    10550: "ldca;",
                    10551: "rdca;",
                    10552: "cudarrl;",
                    10553: "larrpl;",
                    10556: "curarrm;",
                    10557: "cularrp;",
                    10565: "rarrpl;",
                    10568: "harrcir;",
                    10569: "Uarrocir;",
                    10570: "lurdshar;",
                    10571: "ldrushar;",
                    10574: "LeftRightVector;",
                    10575: "RightUpDownVector;",
                    10576: "DownLeftRightVector;",
                    10577: "LeftUpDownVector;",
                    10578: "LeftVectorBar;",
                    10579: "RightVectorBar;",
                    10580: "RightUpVectorBar;",
                    10581: "RightDownVectorBar;",
                    10582: "DownLeftVectorBar;",
                    10583: "DownRightVectorBar;",
                    10584: "LeftUpVectorBar;",
                    10585: "LeftDownVectorBar;",
                    10586: "LeftTeeVector;",
                    10587: "RightTeeVector;",
                    10588: "RightUpTeeVector;",
                    10589: "RightDownTeeVector;",
                    10590: "DownLeftTeeVector;",
                    10591: "DownRightTeeVector;",
                    10592: "LeftUpTeeVector;",
                    10593: "LeftDownTeeVector;",
                    10594: "lHar;",
                    10595: "uHar;",
                    10596: "rHar;",
                    10597: "dHar;",
                    10598: "luruhar;",
                    10599: "ldrdhar;",
                    10600: "ruluhar;",
                    10601: "rdldhar;",
                    10602: "lharul;",
                    10603: "llhard;",
                    10604: "rharul;",
                    10605: "lrhard;",
                    10606: "UpEquilibrium;",
                    10607: "ReverseUpEquilibrium;",
                    10608: "RoundImplies;",
                    10609: "erarr;",
                    10610: "simrarr;",
                    10611: "larrsim;",
                    10612: "rarrsim;",
                    10613: "rarrap;",
                    10614: "ltlarr;",
                    10616: "gtrarr;",
                    10617: "subrarr;",
                    10619: "suplarr;",
                    10620: "lfisht;",
                    10621: "rfisht;",
                    10622: "ufisht;",
                    10623: "dfisht;",
                    10629: "lopar;",
                    10630: "ropar;",
                    10635: "lbrke;",
                    10636: "rbrke;",
                    10637: "lbrkslu;",
                    10638: "rbrksld;",
                    10639: "lbrksld;",
                    10640: "rbrkslu;",
                    10641: "langd;",
                    10642: "rangd;",
                    10643: "lparlt;",
                    10644: "rpargt;",
                    10645: "gtlPar;",
                    10646: "ltrPar;",
                    10650: "vzigzag;",
                    10652: "vangrt;",
                    10653: "angrtvbd;",
                    10660: "ange;",
                    10661: "range;",
                    10662: "dwangle;",
                    10663: "uwangle;",
                    10664: "angmsdaa;",
                    10665: "angmsdab;",
                    10666: "angmsdac;",
                    10667: "angmsdad;",
                    10668: "angmsdae;",
                    10669: "angmsdaf;",
                    10670: "angmsdag;",
                    10671: "angmsdah;",
                    10672: "bemptyv;",
                    10673: "demptyv;",
                    10674: "cemptyv;",
                    10675: "raemptyv;",
                    10676: "laemptyv;",
                    10677: "ohbar;",
                    10678: "omid;",
                    10679: "opar;",
                    10681: "operp;",
                    10683: "olcross;",
                    10684: "odsold;",
                    10686: "olcir;",
                    10687: "ofcir;",
                    10688: "olt;",
                    10689: "ogt;",
                    10690: "cirscir;",
                    10691: "cirE;",
                    10692: "solb;",
                    10693: "bsolb;",
                    10697: "boxbox;",
                    10701: "trisb;",
                    10702: "rtriltri;",
                    10703: "LeftTriangleBar;",
                    10704: "RightTriangleBar;",
                    10716: "iinfin;",
                    10717: "infintie;",
                    10718: "nvinfin;",
                    10723: "eparsl;",
                    10724: "smeparsl;",
                    10725: "eqvparsl;",
                    10731: "lozf;",
                    10740: "RuleDelayed;",
                    10742: "dsol;",
                    10752: "xodot;",
                    10753: "xoplus;",
                    10754: "xotime;",
                    10756: "xuplus;",
                    10758: "xsqcup;",
                    10764: "qint;",
                    10765: "fpartint;",
                    10768: "cirfnint;",
                    10769: "awint;",
                    10770: "rppolint;",
                    10771: "scpolint;",
                    10772: "npolint;",
                    10773: "pointint;",
                    10774: "quatint;",
                    10775: "intlarhk;",
                    10786: "pluscir;",
                    10787: "plusacir;",
                    10788: "simplus;",
                    10789: "plusdu;",
                    10790: "plussim;",
                    10791: "plustwo;",
                    10793: "mcomma;",
                    10794: "minusdu;",
                    10797: "loplus;",
                    10798: "roplus;",
                    10799: "Cross;",
                    10800: "timesd;",
                    10801: "timesbar;",
                    10803: "smashp;",
                    10804: "lotimes;",
                    10805: "rotimes;",
                    10806: "otimesas;",
                    10807: "Otimes;",
                    10808: "odiv;",
                    10809: "triplus;",
                    10810: "triminus;",
                    10811: "tritime;",
                    10812: "iprod;",
                    10815: "amalg;",
                    10816: "capdot;",
                    10818: "ncup;",
                    10819: "ncap;",
                    10820: "capand;",
                    10821: "cupor;",
                    10822: "cupcap;",
                    10823: "capcup;",
                    10824: "cupbrcap;",
                    10825: "capbrcup;",
                    10826: "cupcup;",
                    10827: "capcap;",
                    10828: "ccups;",
                    10829: "ccaps;",
                    10832: "ccupssm;",
                    10835: "And;",
                    10836: "Or;",
                    10837: "andand;",
                    10838: "oror;",
                    10839: "orslope;",
                    10840: "andslope;",
                    10842: "andv;",
                    10843: "orv;",
                    10844: "andd;",
                    10845: "ord;",
                    10847: "wedbar;",
                    10854: "sdote;",
                    10858: "simdot;",
                    10861: "congdot;",
                    10862: "easter;",
                    10863: "apacir;",
                    10864: "apE;",
                    10865: "eplus;",
                    10866: "pluse;",
                    10867: "Esim;",
                    10868: "Colone;",
                    10869: "Equal;",
                    10871: "eDDot;",
                    10872: "equivDD;",
                    10873: "ltcir;",
                    10874: "gtcir;",
                    10875: "ltquest;",
                    10876: "gtquest;",
                    10877: "LessSlantEqual;",
                    10878: "GreaterSlantEqual;",
                    10879: "lesdot;",
                    10880: "gesdot;",
                    10881: "lesdoto;",
                    10882: "gesdoto;",
                    10883: "lesdotor;",
                    10884: "gesdotol;",
                    10885: "lessapprox;",
                    10886: "gtrapprox;",
                    10887: "lneq;",
                    10888: "gneq;",
                    10889: "lnapprox;",
                    10890: "gnapprox;",
                    10891: "lesseqqgtr;",
                    10892: "gtreqqless;",
                    10893: "lsime;",
                    10894: "gsime;",
                    10895: "lsimg;",
                    10896: "gsiml;",
                    10897: "lgE;",
                    10898: "glE;",
                    10899: "lesges;",
                    10900: "gesles;",
                    10901: "eqslantless;",
                    10902: "eqslantgtr;",
                    10903: "elsdot;",
                    10904: "egsdot;",
                    10905: "el;",
                    10906: "eg;",
                    10909: "siml;",
                    10910: "simg;",
                    10911: "simlE;",
                    10912: "simgE;",
                    10913: "LessLess;",
                    10914: "GreaterGreater;",
                    10916: "glj;",
                    10917: "gla;",
                    10918: "ltcc;",
                    10919: "gtcc;",
                    10920: "lescc;",
                    10921: "gescc;",
                    10922: "smt;",
                    10923: "lat;",
                    10924: "smte;",
                    10925: "late;",
                    10926: "bumpE;",
                    10927: "preceq;",
                    10928: "succeq;",
                    10931: "prE;",
                    10932: "scE;",
                    10933: "prnE;",
                    10934: "succneqq;",
                    10935: "precapprox;",
                    10936: "succapprox;",
                    10937: "prnap;",
                    10938: "succnapprox;",
                    10939: "Pr;",
                    10940: "Sc;",
                    10941: "subdot;",
                    10942: "supdot;",
                    10943: "subplus;",
                    10944: "supplus;",
                    10945: "submult;",
                    10946: "supmult;",
                    10947: "subedot;",
                    10948: "supedot;",
                    10949: "subseteqq;",
                    10950: "supseteqq;",
                    10951: "subsim;",
                    10952: "supsim;",
                    10955: "subsetneqq;",
                    10956: "supsetneqq;",
                    10959: "csub;",
                    10960: "csup;",
                    10961: "csube;",
                    10962: "csupe;",
                    10963: "subsup;",
                    10964: "supsub;",
                    10965: "subsub;",
                    10966: "supsup;",
                    10967: "suphsub;",
                    10968: "supdsub;",
                    10969: "forkv;",
                    10970: "topfork;",
                    10971: "mlcp;",
                    10980: "DoubleLeftTee;",
                    10982: "Vdashl;",
                    10983: "Barv;",
                    10984: "vBar;",
                    10985: "vBarv;",
                    10987: "Vbar;",
                    10988: "Not;",
                    10989: "bNot;",
                    10990: "rnmid;",
                    10991: "cirmid;",
                    10992: "midcir;",
                    10993: "topcir;",
                    10994: "nhpar;",
                    10995: "parsim;",
                    11005: "parsl;",
                    64256: "fflig;",
                    64257: "filig;",
                    64258: "fllig;",
                    64259: "ffilig;",
                    64260: "ffllig;"
                }
            })),
            q(Object.freeze({
                __proto__: null,
                Aacute: "\xC1",
                aacute: "\xE1",
                Acirc: "\xC2",
                acirc: "\xE2",
                acute: "\xB4",
                AElig: "\xC6",
                aelig: "\xE6",
                Agrave: "\xC0",
                agrave: "\xE0",
                AMP: "&",
                amp: "&",
                Aring: "\xC5",
                aring: "\xE5",
                Atilde: "\xC3",
                atilde: "\xE3",
                Auml: "\xC4",
                auml: "\xE4",
                brvbar: "\xA6",
                Ccedil: "\xC7",
                ccedil: "\xE7",
                cedil: "\xB8",
                cent: "\xA2",
                COPY: "\xA9",
                copy: "\xA9",
                curren: "\xA4",
                deg: "\xB0",
                divide: "\xF7",
                Eacute: "\xC9",
                eacute: "\xE9",
                Ecirc: "\xCA",
                ecirc: "\xEA",
                Egrave: "\xC8",
                egrave: "\xE8",
                ETH: "\xD0",
                eth: "\xF0",
                Euml: "\xCB",
                euml: "\xEB",
                frac12: "\xBD",
                frac14: "\xBC",
                frac34: "\xBE",
                GT: ">",
                gt: ">",
                Iacute: "\xCD",
                iacute: "\xED",
                Icirc: "\xCE",
                icirc: "\xEE",
                iexcl: "\xA1",
                Igrave: "\xCC",
                igrave: "\xEC",
                iquest: "\xBF",
                Iuml: "\xCF",
                iuml: "\xEF",
                laquo: "\xAB",
                LT: "<",
                lt: "<",
                macr: "\xAF",
                micro: "\xB5",
                middot: "\xB7",
                nbsp: "\xA0",
                not: "\xAC",
                Ntilde: "\xD1",
                ntilde: "\xF1",
                Oacute: "\xD3",
                oacute: "\xF3",
                Ocirc: "\xD4",
                ocirc: "\xF4",
                Ograve: "\xD2",
                ograve: "\xF2",
                ordf: "\xAA",
                ordm: "\xBA",
                Oslash: "\xD8",
                oslash: "\xF8",
                Otilde: "\xD5",
                otilde: "\xF5",
                Ouml: "\xD6",
                ouml: "\xF6",
                para: "\xB6",
                plusmn: "\xB1",
                pound: "\xA3",
                QUOT: '"',
                quot: '"',
                raquo: "\xBB",
                REG: "\xAE",
                reg: "\xAE",
                sect: "\xA7",
                shy: "\xAD",
                sup1: "\xB9",
                sup2: "\xB2",
                sup3: "\xB3",
                szlig: "\xDF",
                THORN: "\xDE",
                thorn: "\xFE",
                times: "\xD7",
                Uacute: "\xDA",
                uacute: "\xFA",
                Ucirc: "\xDB",
                ucirc: "\xFB",
                Ugrave: "\xD9",
                ugrave: "\xF9",
                uml: "\xA8",
                Uuml: "\xDC",
                uuml: "\xFC",
                Yacute: "\xDD",
                yacute: "\xFD",
                yen: "\xA5",
                yuml: "\xFF",
                default: {
                    "Aacute;": "\xC1",
                    Aacute: "\xC1",
                    "aacute;": "\xE1",
                    aacute: "\xE1",
                    "Abreve;": "\u0102",
                    "abreve;": "\u0103",
                    "ac;": "\u223E",
                    "acd;": "\u223F",
                    "acE;": "\u223E\u0333",
                    "Acirc;": "\xC2",
                    Acirc: "\xC2",
                    "acirc;": "\xE2",
                    acirc: "\xE2",
                    "acute;": "\xB4",
                    acute: "\xB4",
                    "Acy;": "\u0410",
                    "acy;": "\u0430",
                    "AElig;": "\xC6",
                    AElig: "\xC6",
                    "aelig;": "\xE6",
                    aelig: "\xE6",
                    "af;": "\u2061",
                    "Afr;": "\u{1D504}",
                    "afr;": "\u{1D51E}",
                    "Agrave;": "\xC0",
                    Agrave: "\xC0",
                    "agrave;": "\xE0",
                    agrave: "\xE0",
                    "alefsym;": "\u2135",
                    "aleph;": "\u2135",
                    "Alpha;": "\u0391",
                    "alpha;": "\u03B1",
                    "Amacr;": "\u0100",
                    "amacr;": "\u0101",
                    "amalg;": "\u2A3F",
                    "AMP;": "&",
                    AMP: "&",
                    "amp;": "&",
                    amp: "&",
                    "And;": "\u2A53",
                    "and;": "\u2227",
                    "andand;": "\u2A55",
                    "andd;": "\u2A5C",
                    "andslope;": "\u2A58",
                    "andv;": "\u2A5A",
                    "ang;": "\u2220",
                    "ange;": "\u29A4",
                    "angle;": "\u2220",
                    "angmsd;": "\u2221",
                    "angmsdaa;": "\u29A8",
                    "angmsdab;": "\u29A9",
                    "angmsdac;": "\u29AA",
                    "angmsdad;": "\u29AB",
                    "angmsdae;": "\u29AC",
                    "angmsdaf;": "\u29AD",
                    "angmsdag;": "\u29AE",
                    "angmsdah;": "\u29AF",
                    "angrt;": "\u221F",
                    "angrtvb;": "\u22BE",
                    "angrtvbd;": "\u299D",
                    "angsph;": "\u2222",
                    "angst;": "\xC5",
                    "angzarr;": "\u237C",
                    "Aogon;": "\u0104",
                    "aogon;": "\u0105",
                    "Aopf;": "\u{1D538}",
                    "aopf;": "\u{1D552}",
                    "ap;": "\u2248",
                    "apacir;": "\u2A6F",
                    "apE;": "\u2A70",
                    "ape;": "\u224A",
                    "apid;": "\u224B",
                    "apos;": "'",
                    "ApplyFunction;": "\u2061",
                    "approx;": "\u2248",
                    "approxeq;": "\u224A",
                    "Aring;": "\xC5",
                    Aring: "\xC5",
                    "aring;": "\xE5",
                    aring: "\xE5",
                    "Ascr;": "\u{1D49C}",
                    "ascr;": "\u{1D4B6}",
                    "Assign;": "\u2254",
                    "ast;": "*",
                    "asymp;": "\u2248",
                    "asympeq;": "\u224D",
                    "Atilde;": "\xC3",
                    Atilde: "\xC3",
                    "atilde;": "\xE3",
                    atilde: "\xE3",
                    "Auml;": "\xC4",
                    Auml: "\xC4",
                    "auml;": "\xE4",
                    auml: "\xE4",
                    "awconint;": "\u2233",
                    "awint;": "\u2A11",
                    "backcong;": "\u224C",
                    "backepsilon;": "\u03F6",
                    "backprime;": "\u2035",
                    "backsim;": "\u223D",
                    "backsimeq;": "\u22CD",
                    "Backslash;": "\u2216",
                    "Barv;": "\u2AE7",
                    "barvee;": "\u22BD",
                    "Barwed;": "\u2306",
                    "barwed;": "\u2305",
                    "barwedge;": "\u2305",
                    "bbrk;": "\u23B5",
                    "bbrktbrk;": "\u23B6",
                    "bcong;": "\u224C",
                    "Bcy;": "\u0411",
                    "bcy;": "\u0431",
                    "bdquo;": "\u201E",
                    "becaus;": "\u2235",
                    "Because;": "\u2235",
                    "because;": "\u2235",
                    "bemptyv;": "\u29B0",
                    "bepsi;": "\u03F6",
                    "bernou;": "\u212C",
                    "Bernoullis;": "\u212C",
                    "Beta;": "\u0392",
                    "beta;": "\u03B2",
                    "beth;": "\u2136",
                    "between;": "\u226C",
                    "Bfr;": "\u{1D505}",
                    "bfr;": "\u{1D51F}",
                    "bigcap;": "\u22C2",
                    "bigcirc;": "\u25EF",
                    "bigcup;": "\u22C3",
                    "bigodot;": "\u2A00",
                    "bigoplus;": "\u2A01",
                    "bigotimes;": "\u2A02",
                    "bigsqcup;": "\u2A06",
                    "bigstar;": "\u2605",
                    "bigtriangledown;": "\u25BD",
                    "bigtriangleup;": "\u25B3",
                    "biguplus;": "\u2A04",
                    "bigvee;": "\u22C1",
                    "bigwedge;": "\u22C0",
                    "bkarow;": "\u290D",
                    "blacklozenge;": "\u29EB",
                    "blacksquare;": "\u25AA",
                    "blacktriangle;": "\u25B4",
                    "blacktriangledown;": "\u25BE",
                    "blacktriangleleft;": "\u25C2",
                    "blacktriangleright;": "\u25B8",
                    "blank;": "\u2423",
                    "blk12;": "\u2592",
                    "blk14;": "\u2591",
                    "blk34;": "\u2593",
                    "block;": "\u2588",
                    "bne;": "=\u20E5",
                    "bnequiv;": "\u2261\u20E5",
                    "bNot;": "\u2AED",
                    "bnot;": "\u2310",
                    "Bopf;": "\u{1D539}",
                    "bopf;": "\u{1D553}",
                    "bot;": "\u22A5",
                    "bottom;": "\u22A5",
                    "bowtie;": "\u22C8",
                    "boxbox;": "\u29C9",
                    "boxDL;": "\u2557",
                    "boxDl;": "\u2556",
                    "boxdL;": "\u2555",
                    "boxdl;": "\u2510",
                    "boxDR;": "\u2554",
                    "boxDr;": "\u2553",
                    "boxdR;": "\u2552",
                    "boxdr;": "\u250C",
                    "boxH;": "\u2550",
                    "boxh;": "\u2500",
                    "boxHD;": "\u2566",
                    "boxHd;": "\u2564",
                    "boxhD;": "\u2565",
                    "boxhd;": "\u252C",
                    "boxHU;": "\u2569",
                    "boxHu;": "\u2567",
                    "boxhU;": "\u2568",
                    "boxhu;": "\u2534",
                    "boxminus;": "\u229F",
                    "boxplus;": "\u229E",
                    "boxtimes;": "\u22A0",
                    "boxUL;": "\u255D",
                    "boxUl;": "\u255C",
                    "boxuL;": "\u255B",
                    "boxul;": "\u2518",
                    "boxUR;": "\u255A",
                    "boxUr;": "\u2559",
                    "boxuR;": "\u2558",
                    "boxur;": "\u2514",
                    "boxV;": "\u2551",
                    "boxv;": "\u2502",
                    "boxVH;": "\u256C",
                    "boxVh;": "\u256B",
                    "boxvH;": "\u256A",
                    "boxvh;": "\u253C",
                    "boxVL;": "\u2563",
                    "boxVl;": "\u2562",
                    "boxvL;": "\u2561",
                    "boxvl;": "\u2524",
                    "boxVR;": "\u2560",
                    "boxVr;": "\u255F",
                    "boxvR;": "\u255E",
                    "boxvr;": "\u251C",
                    "bprime;": "\u2035",
                    "Breve;": "\u02D8",
                    "breve;": "\u02D8",
                    "brvbar;": "\xA6",
                    brvbar: "\xA6",
                    "Bscr;": "\u212C",
                    "bscr;": "\u{1D4B7}",
                    "bsemi;": "\u204F",
                    "bsim;": "\u223D",
                    "bsime;": "\u22CD",
                    "bsol;": "\\",
                    "bsolb;": "\u29C5",
                    "bsolhsub;": "\u27C8",
                    "bull;": "\u2022",
                    "bullet;": "\u2022",
                    "bump;": "\u224E",
                    "bumpE;": "\u2AAE",
                    "bumpe;": "\u224F",
                    "Bumpeq;": "\u224E",
                    "bumpeq;": "\u224F",
                    "Cacute;": "\u0106",
                    "cacute;": "\u0107",
                    "Cap;": "\u22D2",
                    "cap;": "\u2229",
                    "capand;": "\u2A44",
                    "capbrcup;": "\u2A49",
                    "capcap;": "\u2A4B",
                    "capcup;": "\u2A47",
                    "capdot;": "\u2A40",
                    "CapitalDifferentialD;": "\u2145",
                    "caps;": "\u2229\uFE00",
                    "caret;": "\u2041",
                    "caron;": "\u02C7",
                    "Cayleys;": "\u212D",
                    "ccaps;": "\u2A4D",
                    "Ccaron;": "\u010C",
                    "ccaron;": "\u010D",
                    "Ccedil;": "\xC7",
                    Ccedil: "\xC7",
                    "ccedil;": "\xE7",
                    ccedil: "\xE7",
                    "Ccirc;": "\u0108",
                    "ccirc;": "\u0109",
                    "Cconint;": "\u2230",
                    "ccups;": "\u2A4C",
                    "ccupssm;": "\u2A50",
                    "Cdot;": "\u010A",
                    "cdot;": "\u010B",
                    "cedil;": "\xB8",
                    cedil: "\xB8",
                    "Cedilla;": "\xB8",
                    "cemptyv;": "\u29B2",
                    "cent;": "\xA2",
                    cent: "\xA2",
                    "CenterDot;": "\xB7",
                    "centerdot;": "\xB7",
                    "Cfr;": "\u212D",
                    "cfr;": "\u{1D520}",
                    "CHcy;": "\u0427",
                    "chcy;": "\u0447",
                    "check;": "\u2713",
                    "checkmark;": "\u2713",
                    "Chi;": "\u03A7",
                    "chi;": "\u03C7",
                    "cir;": "\u25CB",
                    "circ;": "\u02C6",
                    "circeq;": "\u2257",
                    "circlearrowleft;": "\u21BA",
                    "circlearrowright;": "\u21BB",
                    "circledast;": "\u229B",
                    "circledcirc;": "\u229A",
                    "circleddash;": "\u229D",
                    "CircleDot;": "\u2299",
                    "circledR;": "\xAE",
                    "circledS;": "\u24C8",
                    "CircleMinus;": "\u2296",
                    "CirclePlus;": "\u2295",
                    "CircleTimes;": "\u2297",
                    "cirE;": "\u29C3",
                    "cire;": "\u2257",
                    "cirfnint;": "\u2A10",
                    "cirmid;": "\u2AEF",
                    "cirscir;": "\u29C2",
                    "ClockwiseContourIntegral;": "\u2232",
                    "CloseCurlyDoubleQuote;": "\u201D",
                    "CloseCurlyQuote;": "\u2019",
                    "clubs;": "\u2663",
                    "clubsuit;": "\u2663",
                    "Colon;": "\u2237",
                    "colon;": ":",
                    "Colone;": "\u2A74",
                    "colone;": "\u2254",
                    "coloneq;": "\u2254",
                    "comma;": ",",
                    "commat;": "@",
                    "comp;": "\u2201",
                    "compfn;": "\u2218",
                    "complement;": "\u2201",
                    "complexes;": "\u2102",
                    "cong;": "\u2245",
                    "congdot;": "\u2A6D",
                    "Congruent;": "\u2261",
                    "Conint;": "\u222F",
                    "conint;": "\u222E",
                    "ContourIntegral;": "\u222E",
                    "Copf;": "\u2102",
                    "copf;": "\u{1D554}",
                    "coprod;": "\u2210",
                    "Coproduct;": "\u2210",
                    "COPY;": "\xA9",
                    COPY: "\xA9",
                    "copy;": "\xA9",
                    copy: "\xA9",
                    "copysr;": "\u2117",
                    "CounterClockwiseContourIntegral;": "\u2233",
                    "crarr;": "\u21B5",
                    "Cross;": "\u2A2F",
                    "cross;": "\u2717",
                    "Cscr;": "\u{1D49E}",
                    "cscr;": "\u{1D4B8}",
                    "csub;": "\u2ACF",
                    "csube;": "\u2AD1",
                    "csup;": "\u2AD0",
                    "csupe;": "\u2AD2",
                    "ctdot;": "\u22EF",
                    "cudarrl;": "\u2938",
                    "cudarrr;": "\u2935",
                    "cuepr;": "\u22DE",
                    "cuesc;": "\u22DF",
                    "cularr;": "\u21B6",
                    "cularrp;": "\u293D",
                    "Cup;": "\u22D3",
                    "cup;": "\u222A",
                    "cupbrcap;": "\u2A48",
                    "CupCap;": "\u224D",
                    "cupcap;": "\u2A46",
                    "cupcup;": "\u2A4A",
                    "cupdot;": "\u228D",
                    "cupor;": "\u2A45",
                    "cups;": "\u222A\uFE00",
                    "curarr;": "\u21B7",
                    "curarrm;": "\u293C",
                    "curlyeqprec;": "\u22DE",
                    "curlyeqsucc;": "\u22DF",
                    "curlyvee;": "\u22CE",
                    "curlywedge;": "\u22CF",
                    "curren;": "\xA4",
                    curren: "\xA4",
                    "curvearrowleft;": "\u21B6",
                    "curvearrowright;": "\u21B7",
                    "cuvee;": "\u22CE",
                    "cuwed;": "\u22CF",
                    "cwconint;": "\u2232",
                    "cwint;": "\u2231",
                    "cylcty;": "\u232D",
                    "Dagger;": "\u2021",
                    "dagger;": "\u2020",
                    "daleth;": "\u2138",
                    "Darr;": "\u21A1",
                    "dArr;": "\u21D3",
                    "darr;": "\u2193",
                    "dash;": "\u2010",
                    "Dashv;": "\u2AE4",
                    "dashv;": "\u22A3",
                    "dbkarow;": "\u290F",
                    "dblac;": "\u02DD",
                    "Dcaron;": "\u010E",
                    "dcaron;": "\u010F",
                    "Dcy;": "\u0414",
                    "dcy;": "\u0434",
                    "DD;": "\u2145",
                    "dd;": "\u2146",
                    "ddagger;": "\u2021",
                    "ddarr;": "\u21CA",
                    "DDotrahd;": "\u2911",
                    "ddotseq;": "\u2A77",
                    "deg;": "\xB0",
                    deg: "\xB0",
                    "Del;": "\u2207",
                    "Delta;": "\u0394",
                    "delta;": "\u03B4",
                    "demptyv;": "\u29B1",
                    "dfisht;": "\u297F",
                    "Dfr;": "\u{1D507}",
                    "dfr;": "\u{1D521}",
                    "dHar;": "\u2965",
                    "dharl;": "\u21C3",
                    "dharr;": "\u21C2",
                    "DiacriticalAcute;": "\xB4",
                    "DiacriticalDot;": "\u02D9",
                    "DiacriticalDoubleAcute;": "\u02DD",
                    "DiacriticalGrave;": "`",
                    "DiacriticalTilde;": "\u02DC",
                    "diam;": "\u22C4",
                    "Diamond;": "\u22C4",
                    "diamond;": "\u22C4",
                    "diamondsuit;": "\u2666",
                    "diams;": "\u2666",
                    "die;": "\xA8",
                    "DifferentialD;": "\u2146",
                    "digamma;": "\u03DD",
                    "disin;": "\u22F2",
                    "div;": "\xF7",
                    "divide;": "\xF7",
                    divide: "\xF7",
                    "divideontimes;": "\u22C7",
                    "divonx;": "\u22C7",
                    "DJcy;": "\u0402",
                    "djcy;": "\u0452",
                    "dlcorn;": "\u231E",
                    "dlcrop;": "\u230D",
                    "dollar;": "$",
                    "Dopf;": "\u{1D53B}",
                    "dopf;": "\u{1D555}",
                    "Dot;": "\xA8",
                    "dot;": "\u02D9",
                    "DotDot;": "\u20DC",
                    "doteq;": "\u2250",
                    "doteqdot;": "\u2251",
                    "DotEqual;": "\u2250",
                    "dotminus;": "\u2238",
                    "dotplus;": "\u2214",
                    "dotsquare;": "\u22A1",
                    "doublebarwedge;": "\u2306",
                    "DoubleContourIntegral;": "\u222F",
                    "DoubleDot;": "\xA8",
                    "DoubleDownArrow;": "\u21D3",
                    "DoubleLeftArrow;": "\u21D0",
                    "DoubleLeftRightArrow;": "\u21D4",
                    "DoubleLeftTee;": "\u2AE4",
                    "DoubleLongLeftArrow;": "\u27F8",
                    "DoubleLongLeftRightArrow;": "\u27FA",
                    "DoubleLongRightArrow;": "\u27F9",
                    "DoubleRightArrow;": "\u21D2",
                    "DoubleRightTee;": "\u22A8",
                    "DoubleUpArrow;": "\u21D1",
                    "DoubleUpDownArrow;": "\u21D5",
                    "DoubleVerticalBar;": "\u2225",
                    "DownArrow;": "\u2193",
                    "Downarrow;": "\u21D3",
                    "downarrow;": "\u2193",
                    "DownArrowBar;": "\u2913",
                    "DownArrowUpArrow;": "\u21F5",
                    "DownBreve;": "\u0311",
                    "downdownarrows;": "\u21CA",
                    "downharpoonleft;": "\u21C3",
                    "downharpoonright;": "\u21C2",
                    "DownLeftRightVector;": "\u2950",
                    "DownLeftTeeVector;": "\u295E",
                    "DownLeftVector;": "\u21BD",
                    "DownLeftVectorBar;": "\u2956",
                    "DownRightTeeVector;": "\u295F",
                    "DownRightVector;": "\u21C1",
                    "DownRightVectorBar;": "\u2957",
                    "DownTee;": "\u22A4",
                    "DownTeeArrow;": "\u21A7",
                    "drbkarow;": "\u2910",
                    "drcorn;": "\u231F",
                    "drcrop;": "\u230C",
                    "Dscr;": "\u{1D49F}",
                    "dscr;": "\u{1D4B9}",
                    "DScy;": "\u0405",
                    "dscy;": "\u0455",
                    "dsol;": "\u29F6",
                    "Dstrok;": "\u0110",
                    "dstrok;": "\u0111",
                    "dtdot;": "\u22F1",
                    "dtri;": "\u25BF",
                    "dtrif;": "\u25BE",
                    "duarr;": "\u21F5",
                    "duhar;": "\u296F",
                    "dwangle;": "\u29A6",
                    "DZcy;": "\u040F",
                    "dzcy;": "\u045F",
                    "dzigrarr;": "\u27FF",
                    "Eacute;": "\xC9",
                    Eacute: "\xC9",
                    "eacute;": "\xE9",
                    eacute: "\xE9",
                    "easter;": "\u2A6E",
                    "Ecaron;": "\u011A",
                    "ecaron;": "\u011B",
                    "ecir;": "\u2256",
                    "Ecirc;": "\xCA",
                    Ecirc: "\xCA",
                    "ecirc;": "\xEA",
                    ecirc: "\xEA",
                    "ecolon;": "\u2255",
                    "Ecy;": "\u042D",
                    "ecy;": "\u044D",
                    "eDDot;": "\u2A77",
                    "Edot;": "\u0116",
                    "eDot;": "\u2251",
                    "edot;": "\u0117",
                    "ee;": "\u2147",
                    "efDot;": "\u2252",
                    "Efr;": "\u{1D508}",
                    "efr;": "\u{1D522}",
                    "eg;": "\u2A9A",
                    "Egrave;": "\xC8",
                    Egrave: "\xC8",
                    "egrave;": "\xE8",
                    egrave: "\xE8",
                    "egs;": "\u2A96",
                    "egsdot;": "\u2A98",
                    "el;": "\u2A99",
                    "Element;": "\u2208",
                    "elinters;": "\u23E7",
                    "ell;": "\u2113",
                    "els;": "\u2A95",
                    "elsdot;": "\u2A97",
                    "Emacr;": "\u0112",
                    "emacr;": "\u0113",
                    "empty;": "\u2205",
                    "emptyset;": "\u2205",
                    "EmptySmallSquare;": "\u25FB",
                    "emptyv;": "\u2205",
                    "EmptyVerySmallSquare;": "\u25AB",
                    "emsp;": "\u2003",
                    "emsp13;": "\u2004",
                    "emsp14;": "\u2005",
                    "ENG;": "\u014A",
                    "eng;": "\u014B",
                    "ensp;": "\u2002",
                    "Eogon;": "\u0118",
                    "eogon;": "\u0119",
                    "Eopf;": "\u{1D53C}",
                    "eopf;": "\u{1D556}",
                    "epar;": "\u22D5",
                    "eparsl;": "\u29E3",
                    "eplus;": "\u2A71",
                    "epsi;": "\u03B5",
                    "Epsilon;": "\u0395",
                    "epsilon;": "\u03B5",
                    "epsiv;": "\u03F5",
                    "eqcirc;": "\u2256",
                    "eqcolon;": "\u2255",
                    "eqsim;": "\u2242",
                    "eqslantgtr;": "\u2A96",
                    "eqslantless;": "\u2A95",
                    "Equal;": "\u2A75",
                    "equals;": "=",
                    "EqualTilde;": "\u2242",
                    "equest;": "\u225F",
                    "Equilibrium;": "\u21CC",
                    "equiv;": "\u2261",
                    "equivDD;": "\u2A78",
                    "eqvparsl;": "\u29E5",
                    "erarr;": "\u2971",
                    "erDot;": "\u2253",
                    "Escr;": "\u2130",
                    "escr;": "\u212F",
                    "esdot;": "\u2250",
                    "Esim;": "\u2A73",
                    "esim;": "\u2242",
                    "Eta;": "\u0397",
                    "eta;": "\u03B7",
                    "ETH;": "\xD0",
                    ETH: "\xD0",
                    "eth;": "\xF0",
                    eth: "\xF0",
                    "Euml;": "\xCB",
                    Euml: "\xCB",
                    "euml;": "\xEB",
                    euml: "\xEB",
                    "euro;": "\u20AC",
                    "excl;": "!",
                    "exist;": "\u2203",
                    "Exists;": "\u2203",
                    "expectation;": "\u2130",
                    "ExponentialE;": "\u2147",
                    "exponentiale;": "\u2147",
                    "fallingdotseq;": "\u2252",
                    "Fcy;": "\u0424",
                    "fcy;": "\u0444",
                    "female;": "\u2640",
                    "ffilig;": "\uFB03",
                    "fflig;": "\uFB00",
                    "ffllig;": "\uFB04",
                    "Ffr;": "\u{1D509}",
                    "ffr;": "\u{1D523}",
                    "filig;": "\uFB01",
                    "FilledSmallSquare;": "\u25FC",
                    "FilledVerySmallSquare;": "\u25AA",
                    "fjlig;": "fj",
                    "flat;": "\u266D",
                    "fllig;": "\uFB02",
                    "fltns;": "\u25B1",
                    "fnof;": "\u0192",
                    "Fopf;": "\u{1D53D}",
                    "fopf;": "\u{1D557}",
                    "ForAll;": "\u2200",
                    "forall;": "\u2200",
                    "fork;": "\u22D4",
                    "forkv;": "\u2AD9",
                    "Fouriertrf;": "\u2131",
                    "fpartint;": "\u2A0D",
                    "frac12;": "\xBD",
                    frac12: "\xBD",
                    "frac13;": "\u2153",
                    "frac14;": "\xBC",
                    frac14: "\xBC",
                    "frac15;": "\u2155",
                    "frac16;": "\u2159",
                    "frac18;": "\u215B",
                    "frac23;": "\u2154",
                    "frac25;": "\u2156",
                    "frac34;": "\xBE",
                    frac34: "\xBE",
                    "frac35;": "\u2157",
                    "frac38;": "\u215C",
                    "frac45;": "\u2158",
                    "frac56;": "\u215A",
                    "frac58;": "\u215D",
                    "frac78;": "\u215E",
                    "frasl;": "\u2044",
                    "frown;": "\u2322",
                    "Fscr;": "\u2131",
                    "fscr;": "\u{1D4BB}",
                    "gacute;": "\u01F5",
                    "Gamma;": "\u0393",
                    "gamma;": "\u03B3",
                    "Gammad;": "\u03DC",
                    "gammad;": "\u03DD",
                    "gap;": "\u2A86",
                    "Gbreve;": "\u011E",
                    "gbreve;": "\u011F",
                    "Gcedil;": "\u0122",
                    "Gcirc;": "\u011C",
                    "gcirc;": "\u011D",
                    "Gcy;": "\u0413",
                    "gcy;": "\u0433",
                    "Gdot;": "\u0120",
                    "gdot;": "\u0121",
                    "gE;": "\u2267",
                    "ge;": "\u2265",
                    "gEl;": "\u2A8C",
                    "gel;": "\u22DB",
                    "geq;": "\u2265",
                    "geqq;": "\u2267",
                    "geqslant;": "\u2A7E",
                    "ges;": "\u2A7E",
                    "gescc;": "\u2AA9",
                    "gesdot;": "\u2A80",
                    "gesdoto;": "\u2A82",
                    "gesdotol;": "\u2A84",
                    "gesl;": "\u22DB\uFE00",
                    "gesles;": "\u2A94",
                    "Gfr;": "\u{1D50A}",
                    "gfr;": "\u{1D524}",
                    "Gg;": "\u22D9",
                    "gg;": "\u226B",
                    "ggg;": "\u22D9",
                    "gimel;": "\u2137",
                    "GJcy;": "\u0403",
                    "gjcy;": "\u0453",
                    "gl;": "\u2277",
                    "gla;": "\u2AA5",
                    "glE;": "\u2A92",
                    "glj;": "\u2AA4",
                    "gnap;": "\u2A8A",
                    "gnapprox;": "\u2A8A",
                    "gnE;": "\u2269",
                    "gne;": "\u2A88",
                    "gneq;": "\u2A88",
                    "gneqq;": "\u2269",
                    "gnsim;": "\u22E7",
                    "Gopf;": "\u{1D53E}",
                    "gopf;": "\u{1D558}",
                    "grave;": "`",
                    "GreaterEqual;": "\u2265",
                    "GreaterEqualLess;": "\u22DB",
                    "GreaterFullEqual;": "\u2267",
                    "GreaterGreater;": "\u2AA2",
                    "GreaterLess;": "\u2277",
                    "GreaterSlantEqual;": "\u2A7E",
                    "GreaterTilde;": "\u2273",
                    "Gscr;": "\u{1D4A2}",
                    "gscr;": "\u210A",
                    "gsim;": "\u2273",
                    "gsime;": "\u2A8E",
                    "gsiml;": "\u2A90",
                    "GT;": ">",
                    GT: ">",
                    "Gt;": "\u226B",
                    "gt;": ">",
                    gt: ">",
                    "gtcc;": "\u2AA7",
                    "gtcir;": "\u2A7A",
                    "gtdot;": "\u22D7",
                    "gtlPar;": "\u2995",
                    "gtquest;": "\u2A7C",
                    "gtrapprox;": "\u2A86",
                    "gtrarr;": "\u2978",
                    "gtrdot;": "\u22D7",
                    "gtreqless;": "\u22DB",
                    "gtreqqless;": "\u2A8C",
                    "gtrless;": "\u2277",
                    "gtrsim;": "\u2273",
                    "gvertneqq;": "\u2269\uFE00",
                    "gvnE;": "\u2269\uFE00",
                    "Hacek;": "\u02C7",
                    "hairsp;": "\u200A",
                    "half;": "\xBD",
                    "hamilt;": "\u210B",
                    "HARDcy;": "\u042A",
                    "hardcy;": "\u044A",
                    "hArr;": "\u21D4",
                    "harr;": "\u2194",
                    "harrcir;": "\u2948",
                    "harrw;": "\u21AD",
                    "Hat;": "^",
                    "hbar;": "\u210F",
                    "Hcirc;": "\u0124",
                    "hcirc;": "\u0125",
                    "hearts;": "\u2665",
                    "heartsuit;": "\u2665",
                    "hellip;": "\u2026",
                    "hercon;": "\u22B9",
                    "Hfr;": "\u210C",
                    "hfr;": "\u{1D525}",
                    "HilbertSpace;": "\u210B",
                    "hksearow;": "\u2925",
                    "hkswarow;": "\u2926",
                    "hoarr;": "\u21FF",
                    "homtht;": "\u223B",
                    "hookleftarrow;": "\u21A9",
                    "hookrightarrow;": "\u21AA",
                    "Hopf;": "\u210D",
                    "hopf;": "\u{1D559}",
                    "horbar;": "\u2015",
                    "HorizontalLine;": "\u2500",
                    "Hscr;": "\u210B",
                    "hscr;": "\u{1D4BD}",
                    "hslash;": "\u210F",
                    "Hstrok;": "\u0126",
                    "hstrok;": "\u0127",
                    "HumpDownHump;": "\u224E",
                    "HumpEqual;": "\u224F",
                    "hybull;": "\u2043",
                    "hyphen;": "\u2010",
                    "Iacute;": "\xCD",
                    Iacute: "\xCD",
                    "iacute;": "\xED",
                    iacute: "\xED",
                    "ic;": "\u2063",
                    "Icirc;": "\xCE",
                    Icirc: "\xCE",
                    "icirc;": "\xEE",
                    icirc: "\xEE",
                    "Icy;": "\u0418",
                    "icy;": "\u0438",
                    "Idot;": "\u0130",
                    "IEcy;": "\u0415",
                    "iecy;": "\u0435",
                    "iexcl;": "\xA1",
                    iexcl: "\xA1",
                    "iff;": "\u21D4",
                    "Ifr;": "\u2111",
                    "ifr;": "\u{1D526}",
                    "Igrave;": "\xCC",
                    Igrave: "\xCC",
                    "igrave;": "\xEC",
                    igrave: "\xEC",
                    "ii;": "\u2148",
                    "iiiint;": "\u2A0C",
                    "iiint;": "\u222D",
                    "iinfin;": "\u29DC",
                    "iiota;": "\u2129",
                    "IJlig;": "\u0132",
                    "ijlig;": "\u0133",
                    "Im;": "\u2111",
                    "Imacr;": "\u012A",
                    "imacr;": "\u012B",
                    "image;": "\u2111",
                    "ImaginaryI;": "\u2148",
                    "imagline;": "\u2110",
                    "imagpart;": "\u2111",
                    "imath;": "\u0131",
                    "imof;": "\u22B7",
                    "imped;": "\u01B5",
                    "Implies;": "\u21D2",
                    "in;": "\u2208",
                    "incare;": "\u2105",
                    "infin;": "\u221E",
                    "infintie;": "\u29DD",
                    "inodot;": "\u0131",
                    "Int;": "\u222C",
                    "int;": "\u222B",
                    "intcal;": "\u22BA",
                    "integers;": "\u2124",
                    "Integral;": "\u222B",
                    "intercal;": "\u22BA",
                    "Intersection;": "\u22C2",
                    "intlarhk;": "\u2A17",
                    "intprod;": "\u2A3C",
                    "InvisibleComma;": "\u2063",
                    "InvisibleTimes;": "\u2062",
                    "IOcy;": "\u0401",
                    "iocy;": "\u0451",
                    "Iogon;": "\u012E",
                    "iogon;": "\u012F",
                    "Iopf;": "\u{1D540}",
                    "iopf;": "\u{1D55A}",
                    "Iota;": "\u0399",
                    "iota;": "\u03B9",
                    "iprod;": "\u2A3C",
                    "iquest;": "\xBF",
                    iquest: "\xBF",
                    "Iscr;": "\u2110",
                    "iscr;": "\u{1D4BE}",
                    "isin;": "\u2208",
                    "isindot;": "\u22F5",
                    "isinE;": "\u22F9",
                    "isins;": "\u22F4",
                    "isinsv;": "\u22F3",
                    "isinv;": "\u2208",
                    "it;": "\u2062",
                    "Itilde;": "\u0128",
                    "itilde;": "\u0129",
                    "Iukcy;": "\u0406",
                    "iukcy;": "\u0456",
                    "Iuml;": "\xCF",
                    Iuml: "\xCF",
                    "iuml;": "\xEF",
                    iuml: "\xEF",
                    "Jcirc;": "\u0134",
                    "jcirc;": "\u0135",
                    "Jcy;": "\u0419",
                    "jcy;": "\u0439",
                    "Jfr;": "\u{1D50D}",
                    "jfr;": "\u{1D527}",
                    "jmath;": "\u0237",
                    "Jopf;": "\u{1D541}",
                    "jopf;": "\u{1D55B}",
                    "Jscr;": "\u{1D4A5}",
                    "jscr;": "\u{1D4BF}",
                    "Jsercy;": "\u0408",
                    "jsercy;": "\u0458",
                    "Jukcy;": "\u0404",
                    "jukcy;": "\u0454",
                    "Kappa;": "\u039A",
                    "kappa;": "\u03BA",
                    "kappav;": "\u03F0",
                    "Kcedil;": "\u0136",
                    "kcedil;": "\u0137",
                    "Kcy;": "\u041A",
                    "kcy;": "\u043A",
                    "Kfr;": "\u{1D50E}",
                    "kfr;": "\u{1D528}",
                    "kgreen;": "\u0138",
                    "KHcy;": "\u0425",
                    "khcy;": "\u0445",
                    "KJcy;": "\u040C",
                    "kjcy;": "\u045C",
                    "Kopf;": "\u{1D542}",
                    "kopf;": "\u{1D55C}",
                    "Kscr;": "\u{1D4A6}",
                    "kscr;": "\u{1D4C0}",
                    "lAarr;": "\u21DA",
                    "Lacute;": "\u0139",
                    "lacute;": "\u013A",
                    "laemptyv;": "\u29B4",
                    "lagran;": "\u2112",
                    "Lambda;": "\u039B",
                    "lambda;": "\u03BB",
                    "Lang;": "\u27EA",
                    "lang;": "\u27E8",
                    "langd;": "\u2991",
                    "langle;": "\u27E8",
                    "lap;": "\u2A85",
                    "Laplacetrf;": "\u2112",
                    "laquo;": "\xAB",
                    laquo: "\xAB",
                    "Larr;": "\u219E",
                    "lArr;": "\u21D0",
                    "larr;": "\u2190",
                    "larrb;": "\u21E4",
                    "larrbfs;": "\u291F",
                    "larrfs;": "\u291D",
                    "larrhk;": "\u21A9",
                    "larrlp;": "\u21AB",
                    "larrpl;": "\u2939",
                    "larrsim;": "\u2973",
                    "larrtl;": "\u21A2",
                    "lat;": "\u2AAB",
                    "lAtail;": "\u291B",
                    "latail;": "\u2919",
                    "late;": "\u2AAD",
                    "lates;": "\u2AAD\uFE00",
                    "lBarr;": "\u290E",
                    "lbarr;": "\u290C",
                    "lbbrk;": "\u2772",
                    "lbrace;": "{",
                    "lbrack;": "[",
                    "lbrke;": "\u298B",
                    "lbrksld;": "\u298F",
                    "lbrkslu;": "\u298D",
                    "Lcaron;": "\u013D",
                    "lcaron;": "\u013E",
                    "Lcedil;": "\u013B",
                    "lcedil;": "\u013C",
                    "lceil;": "\u2308",
                    "lcub;": "{",
                    "Lcy;": "\u041B",
                    "lcy;": "\u043B",
                    "ldca;": "\u2936",
                    "ldquo;": "\u201C",
                    "ldquor;": "\u201E",
                    "ldrdhar;": "\u2967",
                    "ldrushar;": "\u294B",
                    "ldsh;": "\u21B2",
                    "lE;": "\u2266",
                    "le;": "\u2264",
                    "LeftAngleBracket;": "\u27E8",
                    "LeftArrow;": "\u2190",
                    "Leftarrow;": "\u21D0",
                    "leftarrow;": "\u2190",
                    "LeftArrowBar;": "\u21E4",
                    "LeftArrowRightArrow;": "\u21C6",
                    "leftarrowtail;": "\u21A2",
                    "LeftCeiling;": "\u2308",
                    "LeftDoubleBracket;": "\u27E6",
                    "LeftDownTeeVector;": "\u2961",
                    "LeftDownVector;": "\u21C3",
                    "LeftDownVectorBar;": "\u2959",
                    "LeftFloor;": "\u230A",
                    "leftharpoondown;": "\u21BD",
                    "leftharpoonup;": "\u21BC",
                    "leftleftarrows;": "\u21C7",
                    "LeftRightArrow;": "\u2194",
                    "Leftrightarrow;": "\u21D4",
                    "leftrightarrow;": "\u2194",
                    "leftrightarrows;": "\u21C6",
                    "leftrightharpoons;": "\u21CB",
                    "leftrightsquigarrow;": "\u21AD",
                    "LeftRightVector;": "\u294E",
                    "LeftTee;": "\u22A3",
                    "LeftTeeArrow;": "\u21A4",
                    "LeftTeeVector;": "\u295A",
                    "leftthreetimes;": "\u22CB",
                    "LeftTriangle;": "\u22B2",
                    "LeftTriangleBar;": "\u29CF",
                    "LeftTriangleEqual;": "\u22B4",
                    "LeftUpDownVector;": "\u2951",
                    "LeftUpTeeVector;": "\u2960",
                    "LeftUpVector;": "\u21BF",
                    "LeftUpVectorBar;": "\u2958",
                    "LeftVector;": "\u21BC",
                    "LeftVectorBar;": "\u2952",
                    "lEg;": "\u2A8B",
                    "leg;": "\u22DA",
                    "leq;": "\u2264",
                    "leqq;": "\u2266",
                    "leqslant;": "\u2A7D",
                    "les;": "\u2A7D",
                    "lescc;": "\u2AA8",
                    "lesdot;": "\u2A7F",
                    "lesdoto;": "\u2A81",
                    "lesdotor;": "\u2A83",
                    "lesg;": "\u22DA\uFE00",
                    "lesges;": "\u2A93",
                    "lessapprox;": "\u2A85",
                    "lessdot;": "\u22D6",
                    "lesseqgtr;": "\u22DA",
                    "lesseqqgtr;": "\u2A8B",
                    "LessEqualGreater;": "\u22DA",
                    "LessFullEqual;": "\u2266",
                    "LessGreater;": "\u2276",
                    "lessgtr;": "\u2276",
                    "LessLess;": "\u2AA1",
                    "lesssim;": "\u2272",
                    "LessSlantEqual;": "\u2A7D",
                    "LessTilde;": "\u2272",
                    "lfisht;": "\u297C",
                    "lfloor;": "\u230A",
                    "Lfr;": "\u{1D50F}",
                    "lfr;": "\u{1D529}",
                    "lg;": "\u2276",
                    "lgE;": "\u2A91",
                    "lHar;": "\u2962",
                    "lhard;": "\u21BD",
                    "lharu;": "\u21BC",
                    "lharul;": "\u296A",
                    "lhblk;": "\u2584",
                    "LJcy;": "\u0409",
                    "ljcy;": "\u0459",
                    "Ll;": "\u22D8",
                    "ll;": "\u226A",
                    "llarr;": "\u21C7",
                    "llcorner;": "\u231E",
                    "Lleftarrow;": "\u21DA",
                    "llhard;": "\u296B",
                    "lltri;": "\u25FA",
                    "Lmidot;": "\u013F",
                    "lmidot;": "\u0140",
                    "lmoust;": "\u23B0",
                    "lmoustache;": "\u23B0",
                    "lnap;": "\u2A89",
                    "lnapprox;": "\u2A89",
                    "lnE;": "\u2268",
                    "lne;": "\u2A87",
                    "lneq;": "\u2A87",
                    "lneqq;": "\u2268",
                    "lnsim;": "\u22E6",
                    "loang;": "\u27EC",
                    "loarr;": "\u21FD",
                    "lobrk;": "\u27E6",
                    "LongLeftArrow;": "\u27F5",
                    "Longleftarrow;": "\u27F8",
                    "longleftarrow;": "\u27F5",
                    "LongLeftRightArrow;": "\u27F7",
                    "Longleftrightarrow;": "\u27FA",
                    "longleftrightarrow;": "\u27F7",
                    "longmapsto;": "\u27FC",
                    "LongRightArrow;": "\u27F6",
                    "Longrightarrow;": "\u27F9",
                    "longrightarrow;": "\u27F6",
                    "looparrowleft;": "\u21AB",
                    "looparrowright;": "\u21AC",
                    "lopar;": "\u2985",
                    "Lopf;": "\u{1D543}",
                    "lopf;": "\u{1D55D}",
                    "loplus;": "\u2A2D",
                    "lotimes;": "\u2A34",
                    "lowast;": "\u2217",
                    "lowbar;": "_",
                    "LowerLeftArrow;": "\u2199",
                    "LowerRightArrow;": "\u2198",
                    "loz;": "\u25CA",
                    "lozenge;": "\u25CA",
                    "lozf;": "\u29EB",
                    "lpar;": "(",
                    "lparlt;": "\u2993",
                    "lrarr;": "\u21C6",
                    "lrcorner;": "\u231F",
                    "lrhar;": "\u21CB",
                    "lrhard;": "\u296D",
                    "lrm;": "\u200E",
                    "lrtri;": "\u22BF",
                    "lsaquo;": "\u2039",
                    "Lscr;": "\u2112",
                    "lscr;": "\u{1D4C1}",
                    "Lsh;": "\u21B0",
                    "lsh;": "\u21B0",
                    "lsim;": "\u2272",
                    "lsime;": "\u2A8D",
                    "lsimg;": "\u2A8F",
                    "lsqb;": "[",
                    "lsquo;": "\u2018",
                    "lsquor;": "\u201A",
                    "Lstrok;": "\u0141",
                    "lstrok;": "\u0142",
                    "LT;": "<",
                    LT: "<",
                    "Lt;": "\u226A",
                    "lt;": "<",
                    lt: "<",
                    "ltcc;": "\u2AA6",
                    "ltcir;": "\u2A79",
                    "ltdot;": "\u22D6",
                    "lthree;": "\u22CB",
                    "ltimes;": "\u22C9",
                    "ltlarr;": "\u2976",
                    "ltquest;": "\u2A7B",
                    "ltri;": "\u25C3",
                    "ltrie;": "\u22B4",
                    "ltrif;": "\u25C2",
                    "ltrPar;": "\u2996",
                    "lurdshar;": "\u294A",
                    "luruhar;": "\u2966",
                    "lvertneqq;": "\u2268\uFE00",
                    "lvnE;": "\u2268\uFE00",
                    "macr;": "\xAF",
                    macr: "\xAF",
                    "male;": "\u2642",
                    "malt;": "\u2720",
                    "maltese;": "\u2720",
                    "Map;": "\u2905",
                    "map;": "\u21A6",
                    "mapsto;": "\u21A6",
                    "mapstodown;": "\u21A7",
                    "mapstoleft;": "\u21A4",
                    "mapstoup;": "\u21A5",
                    "marker;": "\u25AE",
                    "mcomma;": "\u2A29",
                    "Mcy;": "\u041C",
                    "mcy;": "\u043C",
                    "mdash;": "\u2014",
                    "mDDot;": "\u223A",
                    "measuredangle;": "\u2221",
                    "MediumSpace;": "\u205F",
                    "Mellintrf;": "\u2133",
                    "Mfr;": "\u{1D510}",
                    "mfr;": "\u{1D52A}",
                    "mho;": "\u2127",
                    "micro;": "\xB5",
                    micro: "\xB5",
                    "mid;": "\u2223",
                    "midast;": "*",
                    "midcir;": "\u2AF0",
                    "middot;": "\xB7",
                    middot: "\xB7",
                    "minus;": "\u2212",
                    "minusb;": "\u229F",
                    "minusd;": "\u2238",
                    "minusdu;": "\u2A2A",
                    "MinusPlus;": "\u2213",
                    "mlcp;": "\u2ADB",
                    "mldr;": "\u2026",
                    "mnplus;": "\u2213",
                    "models;": "\u22A7",
                    "Mopf;": "\u{1D544}",
                    "mopf;": "\u{1D55E}",
                    "mp;": "\u2213",
                    "Mscr;": "\u2133",
                    "mscr;": "\u{1D4C2}",
                    "mstpos;": "\u223E",
                    "Mu;": "\u039C",
                    "mu;": "\u03BC",
                    "multimap;": "\u22B8",
                    "mumap;": "\u22B8",
                    "nabla;": "\u2207",
                    "Nacute;": "\u0143",
                    "nacute;": "\u0144",
                    "nang;": "\u2220\u20D2",
                    "nap;": "\u2249",
                    "napE;": "\u2A70\u0338",
                    "napid;": "\u224B\u0338",
                    "napos;": "\u0149",
                    "napprox;": "\u2249",
                    "natur;": "\u266E",
                    "natural;": "\u266E",
                    "naturals;": "\u2115",
                    "nbsp;": "\xA0",
                    nbsp: "\xA0",
                    "nbump;": "\u224E\u0338",
                    "nbumpe;": "\u224F\u0338",
                    "ncap;": "\u2A43",
                    "Ncaron;": "\u0147",
                    "ncaron;": "\u0148",
                    "Ncedil;": "\u0145",
                    "ncedil;": "\u0146",
                    "ncong;": "\u2247",
                    "ncongdot;": "\u2A6D\u0338",
                    "ncup;": "\u2A42",
                    "Ncy;": "\u041D",
                    "ncy;": "\u043D",
                    "ndash;": "\u2013",
                    "ne;": "\u2260",
                    "nearhk;": "\u2924",
                    "neArr;": "\u21D7",
                    "nearr;": "\u2197",
                    "nearrow;": "\u2197",
                    "nedot;": "\u2250\u0338",
                    "NegativeMediumSpace;": "\u200B",
                    "NegativeThickSpace;": "\u200B",
                    "NegativeThinSpace;": "\u200B",
                    "NegativeVeryThinSpace;": "\u200B",
                    "nequiv;": "\u2262",
                    "nesear;": "\u2928",
                    "nesim;": "\u2242\u0338",
                    "NestedGreaterGreater;": "\u226B",
                    "NestedLessLess;": "\u226A",
                    "NewLine;": `
`,
                    "nexist;": "\u2204",
                    "nexists;": "\u2204",
                    "Nfr;": "\u{1D511}",
                    "nfr;": "\u{1D52B}",
                    "ngE;": "\u2267\u0338",
                    "nge;": "\u2271",
                    "ngeq;": "\u2271",
                    "ngeqq;": "\u2267\u0338",
                    "ngeqslant;": "\u2A7E\u0338",
                    "nges;": "\u2A7E\u0338",
                    "nGg;": "\u22D9\u0338",
                    "ngsim;": "\u2275",
                    "nGt;": "\u226B\u20D2",
                    "ngt;": "\u226F",
                    "ngtr;": "\u226F",
                    "nGtv;": "\u226B\u0338",
                    "nhArr;": "\u21CE",
                    "nharr;": "\u21AE",
                    "nhpar;": "\u2AF2",
                    "ni;": "\u220B",
                    "nis;": "\u22FC",
                    "nisd;": "\u22FA",
                    "niv;": "\u220B",
                    "NJcy;": "\u040A",
                    "njcy;": "\u045A",
                    "nlArr;": "\u21CD",
                    "nlarr;": "\u219A",
                    "nldr;": "\u2025",
                    "nlE;": "\u2266\u0338",
                    "nle;": "\u2270",
                    "nLeftarrow;": "\u21CD",
                    "nleftarrow;": "\u219A",
                    "nLeftrightarrow;": "\u21CE",
                    "nleftrightarrow;": "\u21AE",
                    "nleq;": "\u2270",
                    "nleqq;": "\u2266\u0338",
                    "nleqslant;": "\u2A7D\u0338",
                    "nles;": "\u2A7D\u0338",
                    "nless;": "\u226E",
                    "nLl;": "\u22D8\u0338",
                    "nlsim;": "\u2274",
                    "nLt;": "\u226A\u20D2",
                    "nlt;": "\u226E",
                    "nltri;": "\u22EA",
                    "nltrie;": "\u22EC",
                    "nLtv;": "\u226A\u0338",
                    "nmid;": "\u2224",
                    "NoBreak;": "\u2060",
                    "NonBreakingSpace;": "\xA0",
                    "Nopf;": "\u2115",
                    "nopf;": "\u{1D55F}",
                    "Not;": "\u2AEC",
                    "not;": "\xAC",
                    not: "\xAC",
                    "NotCongruent;": "\u2262",
                    "NotCupCap;": "\u226D",
                    "NotDoubleVerticalBar;": "\u2226",
                    "NotElement;": "\u2209",
                    "NotEqual;": "\u2260",
                    "NotEqualTilde;": "\u2242\u0338",
                    "NotExists;": "\u2204",
                    "NotGreater;": "\u226F",
                    "NotGreaterEqual;": "\u2271",
                    "NotGreaterFullEqual;": "\u2267\u0338",
                    "NotGreaterGreater;": "\u226B\u0338",
                    "NotGreaterLess;": "\u2279",
                    "NotGreaterSlantEqual;": "\u2A7E\u0338",
                    "NotGreaterTilde;": "\u2275",
                    "NotHumpDownHump;": "\u224E\u0338",
                    "NotHumpEqual;": "\u224F\u0338",
                    "notin;": "\u2209",
                    "notindot;": "\u22F5\u0338",
                    "notinE;": "\u22F9\u0338",
                    "notinva;": "\u2209",
                    "notinvb;": "\u22F7",
                    "notinvc;": "\u22F6",
                    "NotLeftTriangle;": "\u22EA",
                    "NotLeftTriangleBar;": "\u29CF\u0338",
                    "NotLeftTriangleEqual;": "\u22EC",
                    "NotLess;": "\u226E",
                    "NotLessEqual;": "\u2270",
                    "NotLessGreater;": "\u2278",
                    "NotLessLess;": "\u226A\u0338",
                    "NotLessSlantEqual;": "\u2A7D\u0338",
                    "NotLessTilde;": "\u2274",
                    "NotNestedGreaterGreater;": "\u2AA2\u0338",
                    "NotNestedLessLess;": "\u2AA1\u0338",
                    "notni;": "\u220C",
                    "notniva;": "\u220C",
                    "notnivb;": "\u22FE",
                    "notnivc;": "\u22FD",
                    "NotPrecedes;": "\u2280",
                    "NotPrecedesEqual;": "\u2AAF\u0338",
                    "NotPrecedesSlantEqual;": "\u22E0",
                    "NotReverseElement;": "\u220C",
                    "NotRightTriangle;": "\u22EB",
                    "NotRightTriangleBar;": "\u29D0\u0338",
                    "NotRightTriangleEqual;": "\u22ED",
                    "NotSquareSubset;": "\u228F\u0338",
                    "NotSquareSubsetEqual;": "\u22E2",
                    "NotSquareSuperset;": "\u2290\u0338",
                    "NotSquareSupersetEqual;": "\u22E3",
                    "NotSubset;": "\u2282\u20D2",
                    "NotSubsetEqual;": "\u2288",
                    "NotSucceeds;": "\u2281",
                    "NotSucceedsEqual;": "\u2AB0\u0338",
                    "NotSucceedsSlantEqual;": "\u22E1",
                    "NotSucceedsTilde;": "\u227F\u0338",
                    "NotSuperset;": "\u2283\u20D2",
                    "NotSupersetEqual;": "\u2289",
                    "NotTilde;": "\u2241",
                    "NotTildeEqual;": "\u2244",
                    "NotTildeFullEqual;": "\u2247",
                    "NotTildeTilde;": "\u2249",
                    "NotVerticalBar;": "\u2224",
                    "npar;": "\u2226",
                    "nparallel;": "\u2226",
                    "nparsl;": "\u2AFD\u20E5",
                    "npart;": "\u2202\u0338",
                    "npolint;": "\u2A14",
                    "npr;": "\u2280",
                    "nprcue;": "\u22E0",
                    "npre;": "\u2AAF\u0338",
                    "nprec;": "\u2280",
                    "npreceq;": "\u2AAF\u0338",
                    "nrArr;": "\u21CF",
                    "nrarr;": "\u219B",
                    "nrarrc;": "\u2933\u0338",
                    "nrarrw;": "\u219D\u0338",
                    "nRightarrow;": "\u21CF",
                    "nrightarrow;": "\u219B",
                    "nrtri;": "\u22EB",
                    "nrtrie;": "\u22ED",
                    "nsc;": "\u2281",
                    "nsccue;": "\u22E1",
                    "nsce;": "\u2AB0\u0338",
                    "Nscr;": "\u{1D4A9}",
                    "nscr;": "\u{1D4C3}",
                    "nshortmid;": "\u2224",
                    "nshortparallel;": "\u2226",
                    "nsim;": "\u2241",
                    "nsime;": "\u2244",
                    "nsimeq;": "\u2244",
                    "nsmid;": "\u2224",
                    "nspar;": "\u2226",
                    "nsqsube;": "\u22E2",
                    "nsqsupe;": "\u22E3",
                    "nsub;": "\u2284",
                    "nsubE;": "\u2AC5\u0338",
                    "nsube;": "\u2288",
                    "nsubset;": "\u2282\u20D2",
                    "nsubseteq;": "\u2288",
                    "nsubseteqq;": "\u2AC5\u0338",
                    "nsucc;": "\u2281",
                    "nsucceq;": "\u2AB0\u0338",
                    "nsup;": "\u2285",
                    "nsupE;": "\u2AC6\u0338",
                    "nsupe;": "\u2289",
                    "nsupset;": "\u2283\u20D2",
                    "nsupseteq;": "\u2289",
                    "nsupseteqq;": "\u2AC6\u0338",
                    "ntgl;": "\u2279",
                    "Ntilde;": "\xD1",
                    Ntilde: "\xD1",
                    "ntilde;": "\xF1",
                    ntilde: "\xF1",
                    "ntlg;": "\u2278",
                    "ntriangleleft;": "\u22EA",
                    "ntrianglelefteq;": "\u22EC",
                    "ntriangleright;": "\u22EB",
                    "ntrianglerighteq;": "\u22ED",
                    "Nu;": "\u039D",
                    "nu;": "\u03BD",
                    "num;": "#",
                    "numero;": "\u2116",
                    "numsp;": "\u2007",
                    "nvap;": "\u224D\u20D2",
                    "nVDash;": "\u22AF",
                    "nVdash;": "\u22AE",
                    "nvDash;": "\u22AD",
                    "nvdash;": "\u22AC",
                    "nvge;": "\u2265\u20D2",
                    "nvgt;": ">\u20D2",
                    "nvHarr;": "\u2904",
                    "nvinfin;": "\u29DE",
                    "nvlArr;": "\u2902",
                    "nvle;": "\u2264\u20D2",
                    "nvlt;": "<\u20D2",
                    "nvltrie;": "\u22B4\u20D2",
                    "nvrArr;": "\u2903",
                    "nvrtrie;": "\u22B5\u20D2",
                    "nvsim;": "\u223C\u20D2",
                    "nwarhk;": "\u2923",
                    "nwArr;": "\u21D6",
                    "nwarr;": "\u2196",
                    "nwarrow;": "\u2196",
                    "nwnear;": "\u2927",
                    "Oacute;": "\xD3",
                    Oacute: "\xD3",
                    "oacute;": "\xF3",
                    oacute: "\xF3",
                    "oast;": "\u229B",
                    "ocir;": "\u229A",
                    "Ocirc;": "\xD4",
                    Ocirc: "\xD4",
                    "ocirc;": "\xF4",
                    ocirc: "\xF4",
                    "Ocy;": "\u041E",
                    "ocy;": "\u043E",
                    "odash;": "\u229D",
                    "Odblac;": "\u0150",
                    "odblac;": "\u0151",
                    "odiv;": "\u2A38",
                    "odot;": "\u2299",
                    "odsold;": "\u29BC",
                    "OElig;": "\u0152",
                    "oelig;": "\u0153",
                    "ofcir;": "\u29BF",
                    "Ofr;": "\u{1D512}",
                    "ofr;": "\u{1D52C}",
                    "ogon;": "\u02DB",
                    "Ograve;": "\xD2",
                    Ograve: "\xD2",
                    "ograve;": "\xF2",
                    ograve: "\xF2",
                    "ogt;": "\u29C1",
                    "ohbar;": "\u29B5",
                    "ohm;": "\u03A9",
                    "oint;": "\u222E",
                    "olarr;": "\u21BA",
                    "olcir;": "\u29BE",
                    "olcross;": "\u29BB",
                    "oline;": "\u203E",
                    "olt;": "\u29C0",
                    "Omacr;": "\u014C",
                    "omacr;": "\u014D",
                    "Omega;": "\u03A9",
                    "omega;": "\u03C9",
                    "Omicron;": "\u039F",
                    "omicron;": "\u03BF",
                    "omid;": "\u29B6",
                    "ominus;": "\u2296",
                    "Oopf;": "\u{1D546}",
                    "oopf;": "\u{1D560}",
                    "opar;": "\u29B7",
                    "OpenCurlyDoubleQuote;": "\u201C",
                    "OpenCurlyQuote;": "\u2018",
                    "operp;": "\u29B9",
                    "oplus;": "\u2295",
                    "Or;": "\u2A54",
                    "or;": "\u2228",
                    "orarr;": "\u21BB",
                    "ord;": "\u2A5D",
                    "order;": "\u2134",
                    "orderof;": "\u2134",
                    "ordf;": "\xAA",
                    ordf: "\xAA",
                    "ordm;": "\xBA",
                    ordm: "\xBA",
                    "origof;": "\u22B6",
                    "oror;": "\u2A56",
                    "orslope;": "\u2A57",
                    "orv;": "\u2A5B",
                    "oS;": "\u24C8",
                    "Oscr;": "\u{1D4AA}",
                    "oscr;": "\u2134",
                    "Oslash;": "\xD8",
                    Oslash: "\xD8",
                    "oslash;": "\xF8",
                    oslash: "\xF8",
                    "osol;": "\u2298",
                    "Otilde;": "\xD5",
                    Otilde: "\xD5",
                    "otilde;": "\xF5",
                    otilde: "\xF5",
                    "Otimes;": "\u2A37",
                    "otimes;": "\u2297",
                    "otimesas;": "\u2A36",
                    "Ouml;": "\xD6",
                    Ouml: "\xD6",
                    "ouml;": "\xF6",
                    ouml: "\xF6",
                    "ovbar;": "\u233D",
                    "OverBar;": "\u203E",
                    "OverBrace;": "\u23DE",
                    "OverBracket;": "\u23B4",
                    "OverParenthesis;": "\u23DC",
                    "par;": "\u2225",
                    "para;": "\xB6",
                    para: "\xB6",
                    "parallel;": "\u2225",
                    "parsim;": "\u2AF3",
                    "parsl;": "\u2AFD",
                    "part;": "\u2202",
                    "PartialD;": "\u2202",
                    "Pcy;": "\u041F",
                    "pcy;": "\u043F",
                    "percnt;": "%",
                    "period;": ".",
                    "permil;": "\u2030",
                    "perp;": "\u22A5",
                    "pertenk;": "\u2031",
                    "Pfr;": "\u{1D513}",
                    "pfr;": "\u{1D52D}",
                    "Phi;": "\u03A6",
                    "phi;": "\u03C6",
                    "phiv;": "\u03D5",
                    "phmmat;": "\u2133",
                    "phone;": "\u260E",
                    "Pi;": "\u03A0",
                    "pi;": "\u03C0",
                    "pitchfork;": "\u22D4",
                    "piv;": "\u03D6",
                    "planck;": "\u210F",
                    "planckh;": "\u210E",
                    "plankv;": "\u210F",
                    "plus;": "+",
                    "plusacir;": "\u2A23",
                    "plusb;": "\u229E",
                    "pluscir;": "\u2A22",
                    "plusdo;": "\u2214",
                    "plusdu;": "\u2A25",
                    "pluse;": "\u2A72",
                    "PlusMinus;": "\xB1",
                    "plusmn;": "\xB1",
                    plusmn: "\xB1",
                    "plussim;": "\u2A26",
                    "plustwo;": "\u2A27",
                    "pm;": "\xB1",
                    "Poincareplane;": "\u210C",
                    "pointint;": "\u2A15",
                    "Popf;": "\u2119",
                    "popf;": "\u{1D561}",
                    "pound;": "\xA3",
                    pound: "\xA3",
                    "Pr;": "\u2ABB",
                    "pr;": "\u227A",
                    "prap;": "\u2AB7",
                    "prcue;": "\u227C",
                    "prE;": "\u2AB3",
                    "pre;": "\u2AAF",
                    "prec;": "\u227A",
                    "precapprox;": "\u2AB7",
                    "preccurlyeq;": "\u227C",
                    "Precedes;": "\u227A",
                    "PrecedesEqual;": "\u2AAF",
                    "PrecedesSlantEqual;": "\u227C",
                    "PrecedesTilde;": "\u227E",
                    "preceq;": "\u2AAF",
                    "precnapprox;": "\u2AB9",
                    "precneqq;": "\u2AB5",
                    "precnsim;": "\u22E8",
                    "precsim;": "\u227E",
                    "Prime;": "\u2033",
                    "prime;": "\u2032",
                    "primes;": "\u2119",
                    "prnap;": "\u2AB9",
                    "prnE;": "\u2AB5",
                    "prnsim;": "\u22E8",
                    "prod;": "\u220F",
                    "Product;": "\u220F",
                    "profalar;": "\u232E",
                    "profline;": "\u2312",
                    "profsurf;": "\u2313",
                    "prop;": "\u221D",
                    "Proportion;": "\u2237",
                    "Proportional;": "\u221D",
                    "propto;": "\u221D",
                    "prsim;": "\u227E",
                    "prurel;": "\u22B0",
                    "Pscr;": "\u{1D4AB}",
                    "pscr;": "\u{1D4C5}",
                    "Psi;": "\u03A8",
                    "psi;": "\u03C8",
                    "puncsp;": "\u2008",
                    "Qfr;": "\u{1D514}",
                    "qfr;": "\u{1D52E}",
                    "qint;": "\u2A0C",
                    "Qopf;": "\u211A",
                    "qopf;": "\u{1D562}",
                    "qprime;": "\u2057",
                    "Qscr;": "\u{1D4AC}",
                    "qscr;": "\u{1D4C6}",
                    "quaternions;": "\u210D",
                    "quatint;": "\u2A16",
                    "quest;": "?",
                    "questeq;": "\u225F",
                    "QUOT;": '"',
                    QUOT: '"',
                    "quot;": '"',
                    quot: '"',
                    "rAarr;": "\u21DB",
                    "race;": "\u223D\u0331",
                    "Racute;": "\u0154",
                    "racute;": "\u0155",
                    "radic;": "\u221A",
                    "raemptyv;": "\u29B3",
                    "Rang;": "\u27EB",
                    "rang;": "\u27E9",
                    "rangd;": "\u2992",
                    "range;": "\u29A5",
                    "rangle;": "\u27E9",
                    "raquo;": "\xBB",
                    raquo: "\xBB",
                    "Rarr;": "\u21A0",
                    "rArr;": "\u21D2",
                    "rarr;": "\u2192",
                    "rarrap;": "\u2975",
                    "rarrb;": "\u21E5",
                    "rarrbfs;": "\u2920",
                    "rarrc;": "\u2933",
                    "rarrfs;": "\u291E",
                    "rarrhk;": "\u21AA",
                    "rarrlp;": "\u21AC",
                    "rarrpl;": "\u2945",
                    "rarrsim;": "\u2974",
                    "Rarrtl;": "\u2916",
                    "rarrtl;": "\u21A3",
                    "rarrw;": "\u219D",
                    "rAtail;": "\u291C",
                    "ratail;": "\u291A",
                    "ratio;": "\u2236",
                    "rationals;": "\u211A",
                    "RBarr;": "\u2910",
                    "rBarr;": "\u290F",
                    "rbarr;": "\u290D",
                    "rbbrk;": "\u2773",
                    "rbrace;": "}",
                    "rbrack;": "]",
                    "rbrke;": "\u298C",
                    "rbrksld;": "\u298E",
                    "rbrkslu;": "\u2990",
                    "Rcaron;": "\u0158",
                    "rcaron;": "\u0159",
                    "Rcedil;": "\u0156",
                    "rcedil;": "\u0157",
                    "rceil;": "\u2309",
                    "rcub;": "}",
                    "Rcy;": "\u0420",
                    "rcy;": "\u0440",
                    "rdca;": "\u2937",
                    "rdldhar;": "\u2969",
                    "rdquo;": "\u201D",
                    "rdquor;": "\u201D",
                    "rdsh;": "\u21B3",
                    "Re;": "\u211C",
                    "real;": "\u211C",
                    "realine;": "\u211B",
                    "realpart;": "\u211C",
                    "reals;": "\u211D",
                    "rect;": "\u25AD",
                    "REG;": "\xAE",
                    REG: "\xAE",
                    "reg;": "\xAE",
                    reg: "\xAE",
                    "ReverseElement;": "\u220B",
                    "ReverseEquilibrium;": "\u21CB",
                    "ReverseUpEquilibrium;": "\u296F",
                    "rfisht;": "\u297D",
                    "rfloor;": "\u230B",
                    "Rfr;": "\u211C",
                    "rfr;": "\u{1D52F}",
                    "rHar;": "\u2964",
                    "rhard;": "\u21C1",
                    "rharu;": "\u21C0",
                    "rharul;": "\u296C",
                    "Rho;": "\u03A1",
                    "rho;": "\u03C1",
                    "rhov;": "\u03F1",
                    "RightAngleBracket;": "\u27E9",
                    "RightArrow;": "\u2192",
                    "Rightarrow;": "\u21D2",
                    "rightarrow;": "\u2192",
                    "RightArrowBar;": "\u21E5",
                    "RightArrowLeftArrow;": "\u21C4",
                    "rightarrowtail;": "\u21A3",
                    "RightCeiling;": "\u2309",
                    "RightDoubleBracket;": "\u27E7",
                    "RightDownTeeVector;": "\u295D",
                    "RightDownVector;": "\u21C2",
                    "RightDownVectorBar;": "\u2955",
                    "RightFloor;": "\u230B",
                    "rightharpoondown;": "\u21C1",
                    "rightharpoonup;": "\u21C0",
                    "rightleftarrows;": "\u21C4",
                    "rightleftharpoons;": "\u21CC",
                    "rightrightarrows;": "\u21C9",
                    "rightsquigarrow;": "\u219D",
                    "RightTee;": "\u22A2",
                    "RightTeeArrow;": "\u21A6",
                    "RightTeeVector;": "\u295B",
                    "rightthreetimes;": "\u22CC",
                    "RightTriangle;": "\u22B3",
                    "RightTriangleBar;": "\u29D0",
                    "RightTriangleEqual;": "\u22B5",
                    "RightUpDownVector;": "\u294F",
                    "RightUpTeeVector;": "\u295C",
                    "RightUpVector;": "\u21BE",
                    "RightUpVectorBar;": "\u2954",
                    "RightVector;": "\u21C0",
                    "RightVectorBar;": "\u2953",
                    "ring;": "\u02DA",
                    "risingdotseq;": "\u2253",
                    "rlarr;": "\u21C4",
                    "rlhar;": "\u21CC",
                    "rlm;": "\u200F",
                    "rmoust;": "\u23B1",
                    "rmoustache;": "\u23B1",
                    "rnmid;": "\u2AEE",
                    "roang;": "\u27ED",
                    "roarr;": "\u21FE",
                    "robrk;": "\u27E7",
                    "ropar;": "\u2986",
                    "Ropf;": "\u211D",
                    "ropf;": "\u{1D563}",
                    "roplus;": "\u2A2E",
                    "rotimes;": "\u2A35",
                    "RoundImplies;": "\u2970",
                    "rpar;": ")",
                    "rpargt;": "\u2994",
                    "rppolint;": "\u2A12",
                    "rrarr;": "\u21C9",
                    "Rrightarrow;": "\u21DB",
                    "rsaquo;": "\u203A",
                    "Rscr;": "\u211B",
                    "rscr;": "\u{1D4C7}",
                    "Rsh;": "\u21B1",
                    "rsh;": "\u21B1",
                    "rsqb;": "]",
                    "rsquo;": "\u2019",
                    "rsquor;": "\u2019",
                    "rthree;": "\u22CC",
                    "rtimes;": "\u22CA",
                    "rtri;": "\u25B9",
                    "rtrie;": "\u22B5",
                    "rtrif;": "\u25B8",
                    "rtriltri;": "\u29CE",
                    "RuleDelayed;": "\u29F4",
                    "ruluhar;": "\u2968",
                    "rx;": "\u211E",
                    "Sacute;": "\u015A",
                    "sacute;": "\u015B",
                    "sbquo;": "\u201A",
                    "Sc;": "\u2ABC",
                    "sc;": "\u227B",
                    "scap;": "\u2AB8",
                    "Scaron;": "\u0160",
                    "scaron;": "\u0161",
                    "sccue;": "\u227D",
                    "scE;": "\u2AB4",
                    "sce;": "\u2AB0",
                    "Scedil;": "\u015E",
                    "scedil;": "\u015F",
                    "Scirc;": "\u015C",
                    "scirc;": "\u015D",
                    "scnap;": "\u2ABA",
                    "scnE;": "\u2AB6",
                    "scnsim;": "\u22E9",
                    "scpolint;": "\u2A13",
                    "scsim;": "\u227F",
                    "Scy;": "\u0421",
                    "scy;": "\u0441",
                    "sdot;": "\u22C5",
                    "sdotb;": "\u22A1",
                    "sdote;": "\u2A66",
                    "searhk;": "\u2925",
                    "seArr;": "\u21D8",
                    "searr;": "\u2198",
                    "searrow;": "\u2198",
                    "sect;": "\xA7",
                    sect: "\xA7",
                    "semi;": ";",
                    "seswar;": "\u2929",
                    "setminus;": "\u2216",
                    "setmn;": "\u2216",
                    "sext;": "\u2736",
                    "Sfr;": "\u{1D516}",
                    "sfr;": "\u{1D530}",
                    "sfrown;": "\u2322",
                    "sharp;": "\u266F",
                    "SHCHcy;": "\u0429",
                    "shchcy;": "\u0449",
                    "SHcy;": "\u0428",
                    "shcy;": "\u0448",
                    "ShortDownArrow;": "\u2193",
                    "ShortLeftArrow;": "\u2190",
                    "shortmid;": "\u2223",
                    "shortparallel;": "\u2225",
                    "ShortRightArrow;": "\u2192",
                    "ShortUpArrow;": "\u2191",
                    "shy;": "\xAD",
                    shy: "\xAD",
                    "Sigma;": "\u03A3",
                    "sigma;": "\u03C3",
                    "sigmaf;": "\u03C2",
                    "sigmav;": "\u03C2",
                    "sim;": "\u223C",
                    "simdot;": "\u2A6A",
                    "sime;": "\u2243",
                    "simeq;": "\u2243",
                    "simg;": "\u2A9E",
                    "simgE;": "\u2AA0",
                    "siml;": "\u2A9D",
                    "simlE;": "\u2A9F",
                    "simne;": "\u2246",
                    "simplus;": "\u2A24",
                    "simrarr;": "\u2972",
                    "slarr;": "\u2190",
                    "SmallCircle;": "\u2218",
                    "smallsetminus;": "\u2216",
                    "smashp;": "\u2A33",
                    "smeparsl;": "\u29E4",
                    "smid;": "\u2223",
                    "smile;": "\u2323",
                    "smt;": "\u2AAA",
                    "smte;": "\u2AAC",
                    "smtes;": "\u2AAC\uFE00",
                    "SOFTcy;": "\u042C",
                    "softcy;": "\u044C",
                    "sol;": "/",
                    "solb;": "\u29C4",
                    "solbar;": "\u233F",
                    "Sopf;": "\u{1D54A}",
                    "sopf;": "\u{1D564}",
                    "spades;": "\u2660",
                    "spadesuit;": "\u2660",
                    "spar;": "\u2225",
                    "sqcap;": "\u2293",
                    "sqcaps;": "\u2293\uFE00",
                    "sqcup;": "\u2294",
                    "sqcups;": "\u2294\uFE00",
                    "Sqrt;": "\u221A",
                    "sqsub;": "\u228F",
                    "sqsube;": "\u2291",
                    "sqsubset;": "\u228F",
                    "sqsubseteq;": "\u2291",
                    "sqsup;": "\u2290",
                    "sqsupe;": "\u2292",
                    "sqsupset;": "\u2290",
                    "sqsupseteq;": "\u2292",
                    "squ;": "\u25A1",
                    "Square;": "\u25A1",
                    "square;": "\u25A1",
                    "SquareIntersection;": "\u2293",
                    "SquareSubset;": "\u228F",
                    "SquareSubsetEqual;": "\u2291",
                    "SquareSuperset;": "\u2290",
                    "SquareSupersetEqual;": "\u2292",
                    "SquareUnion;": "\u2294",
                    "squarf;": "\u25AA",
                    "squf;": "\u25AA",
                    "srarr;": "\u2192",
                    "Sscr;": "\u{1D4AE}",
                    "sscr;": "\u{1D4C8}",
                    "ssetmn;": "\u2216",
                    "ssmile;": "\u2323",
                    "sstarf;": "\u22C6",
                    "Star;": "\u22C6",
                    "star;": "\u2606",
                    "starf;": "\u2605",
                    "straightepsilon;": "\u03F5",
                    "straightphi;": "\u03D5",
                    "strns;": "\xAF",
                    "Sub;": "\u22D0",
                    "sub;": "\u2282",
                    "subdot;": "\u2ABD",
                    "subE;": "\u2AC5",
                    "sube;": "\u2286",
                    "subedot;": "\u2AC3",
                    "submult;": "\u2AC1",
                    "subnE;": "\u2ACB",
                    "subne;": "\u228A",
                    "subplus;": "\u2ABF",
                    "subrarr;": "\u2979",
                    "Subset;": "\u22D0",
                    "subset;": "\u2282",
                    "subseteq;": "\u2286",
                    "subseteqq;": "\u2AC5",
                    "SubsetEqual;": "\u2286",
                    "subsetneq;": "\u228A",
                    "subsetneqq;": "\u2ACB",
                    "subsim;": "\u2AC7",
                    "subsub;": "\u2AD5",
                    "subsup;": "\u2AD3",
                    "succ;": "\u227B",
                    "succapprox;": "\u2AB8",
                    "succcurlyeq;": "\u227D",
                    "Succeeds;": "\u227B",
                    "SucceedsEqual;": "\u2AB0",
                    "SucceedsSlantEqual;": "\u227D",
                    "SucceedsTilde;": "\u227F",
                    "succeq;": "\u2AB0",
                    "succnapprox;": "\u2ABA",
                    "succneqq;": "\u2AB6",
                    "succnsim;": "\u22E9",
                    "succsim;": "\u227F",
                    "SuchThat;": "\u220B",
                    "Sum;": "\u2211",
                    "sum;": "\u2211",
                    "sung;": "\u266A",
                    "Sup;": "\u22D1",
                    "sup;": "\u2283",
                    "sup1;": "\xB9",
                    sup1: "\xB9",
                    "sup2;": "\xB2",
                    sup2: "\xB2",
                    "sup3;": "\xB3",
                    sup3: "\xB3",
                    "supdot;": "\u2ABE",
                    "supdsub;": "\u2AD8",
                    "supE;": "\u2AC6",
                    "supe;": "\u2287",
                    "supedot;": "\u2AC4",
                    "Superset;": "\u2283",
                    "SupersetEqual;": "\u2287",
                    "suphsol;": "\u27C9",
                    "suphsub;": "\u2AD7",
                    "suplarr;": "\u297B",
                    "supmult;": "\u2AC2",
                    "supnE;": "\u2ACC",
                    "supne;": "\u228B",
                    "supplus;": "\u2AC0",
                    "Supset;": "\u22D1",
                    "supset;": "\u2283",
                    "supseteq;": "\u2287",
                    "supseteqq;": "\u2AC6",
                    "supsetneq;": "\u228B",
                    "supsetneqq;": "\u2ACC",
                    "supsim;": "\u2AC8",
                    "supsub;": "\u2AD4",
                    "supsup;": "\u2AD6",
                    "swarhk;": "\u2926",
                    "swArr;": "\u21D9",
                    "swarr;": "\u2199",
                    "swarrow;": "\u2199",
                    "swnwar;": "\u292A",
                    "szlig;": "\xDF",
                    szlig: "\xDF",
                    "Tab;": "	",
                    "target;": "\u2316",
                    "Tau;": "\u03A4",
                    "tau;": "\u03C4",
                    "tbrk;": "\u23B4",
                    "Tcaron;": "\u0164",
                    "tcaron;": "\u0165",
                    "Tcedil;": "\u0162",
                    "tcedil;": "\u0163",
                    "Tcy;": "\u0422",
                    "tcy;": "\u0442",
                    "tdot;": "\u20DB",
                    "telrec;": "\u2315",
                    "Tfr;": "\u{1D517}",
                    "tfr;": "\u{1D531}",
                    "there4;": "\u2234",
                    "Therefore;": "\u2234",
                    "therefore;": "\u2234",
                    "Theta;": "\u0398",
                    "theta;": "\u03B8",
                    "thetasym;": "\u03D1",
                    "thetav;": "\u03D1",
                    "thickapprox;": "\u2248",
                    "thicksim;": "\u223C",
                    "ThickSpace;": "\u205F\u200A",
                    "thinsp;": "\u2009",
                    "ThinSpace;": "\u2009",
                    "thkap;": "\u2248",
                    "thksim;": "\u223C",
                    "THORN;": "\xDE",
                    THORN: "\xDE",
                    "thorn;": "\xFE",
                    thorn: "\xFE",
                    "Tilde;": "\u223C",
                    "tilde;": "\u02DC",
                    "TildeEqual;": "\u2243",
                    "TildeFullEqual;": "\u2245",
                    "TildeTilde;": "\u2248",
                    "times;": "\xD7",
                    times: "\xD7",
                    "timesb;": "\u22A0",
                    "timesbar;": "\u2A31",
                    "timesd;": "\u2A30",
                    "tint;": "\u222D",
                    "toea;": "\u2928",
                    "top;": "\u22A4",
                    "topbot;": "\u2336",
                    "topcir;": "\u2AF1",
                    "Topf;": "\u{1D54B}",
                    "topf;": "\u{1D565}",
                    "topfork;": "\u2ADA",
                    "tosa;": "\u2929",
                    "tprime;": "\u2034",
                    "TRADE;": "\u2122",
                    "trade;": "\u2122",
                    "triangle;": "\u25B5",
                    "triangledown;": "\u25BF",
                    "triangleleft;": "\u25C3",
                    "trianglelefteq;": "\u22B4",
                    "triangleq;": "\u225C",
                    "triangleright;": "\u25B9",
                    "trianglerighteq;": "\u22B5",
                    "tridot;": "\u25EC",
                    "trie;": "\u225C",
                    "triminus;": "\u2A3A",
                    "TripleDot;": "\u20DB",
                    "triplus;": "\u2A39",
                    "trisb;": "\u29CD",
                    "tritime;": "\u2A3B",
                    "trpezium;": "\u23E2",
                    "Tscr;": "\u{1D4AF}",
                    "tscr;": "\u{1D4C9}",
                    "TScy;": "\u0426",
                    "tscy;": "\u0446",
                    "TSHcy;": "\u040B",
                    "tshcy;": "\u045B",
                    "Tstrok;": "\u0166",
                    "tstrok;": "\u0167",
                    "twixt;": "\u226C",
                    "twoheadleftarrow;": "\u219E",
                    "twoheadrightarrow;": "\u21A0",
                    "Uacute;": "\xDA",
                    Uacute: "\xDA",
                    "uacute;": "\xFA",
                    uacute: "\xFA",
                    "Uarr;": "\u219F",
                    "uArr;": "\u21D1",
                    "uarr;": "\u2191",
                    "Uarrocir;": "\u2949",
                    "Ubrcy;": "\u040E",
                    "ubrcy;": "\u045E",
                    "Ubreve;": "\u016C",
                    "ubreve;": "\u016D",
                    "Ucirc;": "\xDB",
                    Ucirc: "\xDB",
                    "ucirc;": "\xFB",
                    ucirc: "\xFB",
                    "Ucy;": "\u0423",
                    "ucy;": "\u0443",
                    "udarr;": "\u21C5",
                    "Udblac;": "\u0170",
                    "udblac;": "\u0171",
                    "udhar;": "\u296E",
                    "ufisht;": "\u297E",
                    "Ufr;": "\u{1D518}",
                    "ufr;": "\u{1D532}",
                    "Ugrave;": "\xD9",
                    Ugrave: "\xD9",
                    "ugrave;": "\xF9",
                    ugrave: "\xF9",
                    "uHar;": "\u2963",
                    "uharl;": "\u21BF",
                    "uharr;": "\u21BE",
                    "uhblk;": "\u2580",
                    "ulcorn;": "\u231C",
                    "ulcorner;": "\u231C",
                    "ulcrop;": "\u230F",
                    "ultri;": "\u25F8",
                    "Umacr;": "\u016A",
                    "umacr;": "\u016B",
                    "uml;": "\xA8",
                    uml: "\xA8",
                    "UnderBar;": "_",
                    "UnderBrace;": "\u23DF",
                    "UnderBracket;": "\u23B5",
                    "UnderParenthesis;": "\u23DD",
                    "Union;": "\u22C3",
                    "UnionPlus;": "\u228E",
                    "Uogon;": "\u0172",
                    "uogon;": "\u0173",
                    "Uopf;": "\u{1D54C}",
                    "uopf;": "\u{1D566}",
                    "UpArrow;": "\u2191",
                    "Uparrow;": "\u21D1",
                    "uparrow;": "\u2191",
                    "UpArrowBar;": "\u2912",
                    "UpArrowDownArrow;": "\u21C5",
                    "UpDownArrow;": "\u2195",
                    "Updownarrow;": "\u21D5",
                    "updownarrow;": "\u2195",
                    "UpEquilibrium;": "\u296E",
                    "upharpoonleft;": "\u21BF",
                    "upharpoonright;": "\u21BE",
                    "uplus;": "\u228E",
                    "UpperLeftArrow;": "\u2196",
                    "UpperRightArrow;": "\u2197",
                    "Upsi;": "\u03D2",
                    "upsi;": "\u03C5",
                    "upsih;": "\u03D2",
                    "Upsilon;": "\u03A5",
                    "upsilon;": "\u03C5",
                    "UpTee;": "\u22A5",
                    "UpTeeArrow;": "\u21A5",
                    "upuparrows;": "\u21C8",
                    "urcorn;": "\u231D",
                    "urcorner;": "\u231D",
                    "urcrop;": "\u230E",
                    "Uring;": "\u016E",
                    "uring;": "\u016F",
                    "urtri;": "\u25F9",
                    "Uscr;": "\u{1D4B0}",
                    "uscr;": "\u{1D4CA}",
                    "utdot;": "\u22F0",
                    "Utilde;": "\u0168",
                    "utilde;": "\u0169",
                    "utri;": "\u25B5",
                    "utrif;": "\u25B4",
                    "uuarr;": "\u21C8",
                    "Uuml;": "\xDC",
                    Uuml: "\xDC",
                    "uuml;": "\xFC",
                    uuml: "\xFC",
                    "uwangle;": "\u29A7",
                    "vangrt;": "\u299C",
                    "varepsilon;": "\u03F5",
                    "varkappa;": "\u03F0",
                    "varnothing;": "\u2205",
                    "varphi;": "\u03D5",
                    "varpi;": "\u03D6",
                    "varpropto;": "\u221D",
                    "vArr;": "\u21D5",
                    "varr;": "\u2195",
                    "varrho;": "\u03F1",
                    "varsigma;": "\u03C2",
                    "varsubsetneq;": "\u228A\uFE00",
                    "varsubsetneqq;": "\u2ACB\uFE00",
                    "varsupsetneq;": "\u228B\uFE00",
                    "varsupsetneqq;": "\u2ACC\uFE00",
                    "vartheta;": "\u03D1",
                    "vartriangleleft;": "\u22B2",
                    "vartriangleright;": "\u22B3",
                    "Vbar;": "\u2AEB",
                    "vBar;": "\u2AE8",
                    "vBarv;": "\u2AE9",
                    "Vcy;": "\u0412",
                    "vcy;": "\u0432",
                    "VDash;": "\u22AB",
                    "Vdash;": "\u22A9",
                    "vDash;": "\u22A8",
                    "vdash;": "\u22A2",
                    "Vdashl;": "\u2AE6",
                    "Vee;": "\u22C1",
                    "vee;": "\u2228",
                    "veebar;": "\u22BB",
                    "veeeq;": "\u225A",
                    "vellip;": "\u22EE",
                    "Verbar;": "\u2016",
                    "verbar;": "|",
                    "Vert;": "\u2016",
                    "vert;": "|",
                    "VerticalBar;": "\u2223",
                    "VerticalLine;": "|",
                    "VerticalSeparator;": "\u2758",
                    "VerticalTilde;": "\u2240",
                    "VeryThinSpace;": "\u200A",
                    "Vfr;": "\u{1D519}",
                    "vfr;": "\u{1D533}",
                    "vltri;": "\u22B2",
                    "vnsub;": "\u2282\u20D2",
                    "vnsup;": "\u2283\u20D2",
                    "Vopf;": "\u{1D54D}",
                    "vopf;": "\u{1D567}",
                    "vprop;": "\u221D",
                    "vrtri;": "\u22B3",
                    "Vscr;": "\u{1D4B1}",
                    "vscr;": "\u{1D4CB}",
                    "vsubnE;": "\u2ACB\uFE00",
                    "vsubne;": "\u228A\uFE00",
                    "vsupnE;": "\u2ACC\uFE00",
                    "vsupne;": "\u228B\uFE00",
                    "Vvdash;": "\u22AA",
                    "vzigzag;": "\u299A",
                    "Wcirc;": "\u0174",
                    "wcirc;": "\u0175",
                    "wedbar;": "\u2A5F",
                    "Wedge;": "\u22C0",
                    "wedge;": "\u2227",
                    "wedgeq;": "\u2259",
                    "weierp;": "\u2118",
                    "Wfr;": "\u{1D51A}",
                    "wfr;": "\u{1D534}",
                    "Wopf;": "\u{1D54E}",
                    "wopf;": "\u{1D568}",
                    "wp;": "\u2118",
                    "wr;": "\u2240",
                    "wreath;": "\u2240",
                    "Wscr;": "\u{1D4B2}",
                    "wscr;": "\u{1D4CC}",
                    "xcap;": "\u22C2",
                    "xcirc;": "\u25EF",
                    "xcup;": "\u22C3",
                    "xdtri;": "\u25BD",
                    "Xfr;": "\u{1D51B}",
                    "xfr;": "\u{1D535}",
                    "xhArr;": "\u27FA",
                    "xharr;": "\u27F7",
                    "Xi;": "\u039E",
                    "xi;": "\u03BE",
                    "xlArr;": "\u27F8",
                    "xlarr;": "\u27F5",
                    "xmap;": "\u27FC",
                    "xnis;": "\u22FB",
                    "xodot;": "\u2A00",
                    "Xopf;": "\u{1D54F}",
                    "xopf;": "\u{1D569}",
                    "xoplus;": "\u2A01",
                    "xotime;": "\u2A02",
                    "xrArr;": "\u27F9",
                    "xrarr;": "\u27F6",
                    "Xscr;": "\u{1D4B3}",
                    "xscr;": "\u{1D4CD}",
                    "xsqcup;": "\u2A06",
                    "xuplus;": "\u2A04",
                    "xutri;": "\u25B3",
                    "xvee;": "\u22C1",
                    "xwedge;": "\u22C0",
                    "Yacute;": "\xDD",
                    Yacute: "\xDD",
                    "yacute;": "\xFD",
                    yacute: "\xFD",
                    "YAcy;": "\u042F",
                    "yacy;": "\u044F",
                    "Ycirc;": "\u0176",
                    "ycirc;": "\u0177",
                    "Ycy;": "\u042B",
                    "ycy;": "\u044B",
                    "yen;": "\xA5",
                    yen: "\xA5",
                    "Yfr;": "\u{1D51C}",
                    "yfr;": "\u{1D536}",
                    "YIcy;": "\u0407",
                    "yicy;": "\u0457",
                    "Yopf;": "\u{1D550}",
                    "yopf;": "\u{1D56A}",
                    "Yscr;": "\u{1D4B4}",
                    "yscr;": "\u{1D4CE}",
                    "YUcy;": "\u042E",
                    "yucy;": "\u044E",
                    "Yuml;": "\u0178",
                    "yuml;": "\xFF",
                    yuml: "\xFF",
                    "Zacute;": "\u0179",
                    "zacute;": "\u017A",
                    "Zcaron;": "\u017D",
                    "zcaron;": "\u017E",
                    "Zcy;": "\u0417",
                    "zcy;": "\u0437",
                    "Zdot;": "\u017B",
                    "zdot;": "\u017C",
                    "zeetrf;": "\u2128",
                    "ZeroWidthSpace;": "\u200B",
                    "Zeta;": "\u0396",
                    "zeta;": "\u03B6",
                    "Zfr;": "\u2128",
                    "zfr;": "\u{1D537}",
                    "ZHcy;": "\u0416",
                    "zhcy;": "\u0436",
                    "zigrarr;": "\u21DD",
                    "Zopf;": "\u2124",
                    "zopf;": "\u{1D56B}",
                    "Zscr;": "\u{1D4B5}",
                    "zscr;": "\u{1D4CF}",
                    "zwj;": "\u200D",
                    "zwnj;": "\u200C"
                }
            })))
              , Zt = function(t3) {
                if (typeof t3 != "string")
                    throw new TypeError("Expected a String");
                return t3.replace(/&(#?[^;\W]+;?)/g, function(t4, e3) {
                    var n3;
                    if (n3 = /^#(\d+);?$/.exec(e3))
                        return Xt.ucs2.encode([parseInt(n3[1], 10)]);
                    if (n3 = /^#[Xx]([A-Fa-f0-9]+);?/.exec(e3))
                        return Xt.ucs2.encode([parseInt(n3[1], 16)]);
                    var r2 = /;$/.test(e3)
                      , i2 = r2 ? e3.replace(/;$/, "") : e3
                      , o2 = Qt[i2] || r2 && Qt[e3];
                    return typeof o2 == "number" ? Xt.ucs2.encode([o2]) : typeof o2 == "string" ? o2 : "&" + e3
                })
            };
            function Kt(t3, e3) {
                return function(t4, e4, n3) {
                    if (typeof t4 != "string" || !t4.length || (e4 && typeof e4 == "number" || (e4 = 0),
                    !t4[e4 + 1]))
                        return null;
                    if (t4[e4 + 1] && t4[e4 + 1].trim())
                        return e4 + 1;
                    if (t4[e4 + 2] && t4[e4 + 2].trim())
                        return e4 + 2;
                    for (var r2 = e4 + 1, i2 = t4.length; r2 < i2; r2++)
                        if (t4[r2] && t4[r2].trim())
                            return r2;
                    return null
                }(t3, e3)
            }
            function te(e3, n3) {
                if (!e3)
                    return [];
                if (Array.isArray(e3))
                    return e3.filter(function(t3) {
                        return typeof t3 == "string" && t3.trim()
                    });
                if (typeof e3 == "string")
                    return e3.trim() ? [e3] : [];
                throw new TypeError("string-strip-html/stripHtml(): [THROW_ID_03] ".concat(n3, " must be array containing zero or more strings or something falsey. Currently it's equal to: ").concat(e3, ", that a type of ").concat(t2(e3), "."))
            }
            return function(t3, e3, n3) {
                t3(n3 = {
                    path: void 0,
                    exports: {},
                    require: function(t4, e4) {
                        return function() {
                            throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs")
                        }(e4 == null && n3.path)
                    }
                }, n3.exports),
                n3.exports
            }(function(e3, n3) {
                var r2 = "[object Arguments]"
                  , i2 = "[object Function]"
                  , o2 = "[object GeneratorFunction]"
                  , a2 = "[object Map]"
                  , s2 = "[object Set]"
                  , c2 = /\w*$/
                  , l2 = /^\[object .+?Constructor\]$/
                  , u2 = /^(?:0|[1-9]\d*)$/
                  , d2 = {};
                d2[r2] = d2["[object Array]"] = d2["[object ArrayBuffer]"] = d2["[object DataView]"] = d2["[object Boolean]"] = d2["[object Date]"] = d2["[object Float32Array]"] = d2["[object Float64Array]"] = d2["[object Int8Array]"] = d2["[object Int16Array]"] = d2["[object Int32Array]"] = d2[a2] = d2["[object Number]"] = d2["[object Object]"] = d2["[object RegExp]"] = d2[s2] = d2["[object String]"] = d2["[object Symbol]"] = d2["[object Uint8Array]"] = d2["[object Uint8ClampedArray]"] = d2["[object Uint16Array]"] = d2["[object Uint32Array]"] = !0,
                d2["[object Error]"] = d2[i2] = d2["[object WeakMap]"] = !1;
                var f2 = t2(L) == "object" && L && L.Object === Object && L
                  , h2 = (typeof self > "u" ? "undefined" : t2(self)) == "object" && self && self.Object === Object && self
                  , p2 = f2 || h2 || Function("return this")()
                  , g2 = n3 && !n3.nodeType && n3
                  , v2 = g2 && e3 && !e3.nodeType && e3
                  , m2 = v2 && v2.exports === g2;
                function y2(t3, e4) {
                    return t3.set(e4[0], e4[1]),
                    t3
                }
                function b2(t3, e4) {
                    return t3.add(e4),
                    t3
                }
                function w2(t3, e4, n4, r3) {
                    var i3 = -1
                      , o3 = t3 ? t3.length : 0;
                    for (r3 && o3 && (n4 = t3[++i3]); ++i3 < o3; )
                        n4 = e4(n4, t3[i3], i3, t3);
                    return n4
                }
                function E2(t3) {
                    var e4 = !1;
                    if (t3 != null && typeof t3.toString != "function")
                        try {
                            e4 = !!(t3 + "")
                        } catch {}
                    return e4
                }
                function _2(t3) {
                    var e4 = -1
                      , n4 = Array(t3.size);
                    return t3.forEach(function(t4, r3) {
                        n4[++e4] = [r3, t4]
                    }),
                    n4
                }
                function A2(t3, e4) {
                    return function(n4) {
                        return t3(e4(n4))
                    }
                }
                function k2(t3) {
                    var e4 = -1
                      , n4 = Array(t3.size);
                    return t3.forEach(function(t4) {
                        n4[++e4] = t4
                    }),
                    n4
                }
                var T2 = Array.prototype
                  , S2 = Function.prototype
                  , x2 = Object.prototype
                  , C2 = p2["__core-js_shared__"]
                  , O2 = function() {
                    var t3 = /[^.]+$/.exec(C2 && C2.keys && C2.keys.IE_PROTO || "");
                    return t3 ? "Symbol(src)_1." + t3 : ""
                }()
                  , q2 = S2.toString
                  , D2 = x2.hasOwnProperty
                  , P2 = x2.toString
                  , j2 = RegExp("^" + q2.call(D2).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$")
                  , I2 = m2 ? p2.Buffer : void 0
                  , N2 = p2.Symbol
                  , M2 = p2.Uint8Array
                  , z2 = A2(Object.getPrototypeOf, Object)
                  , R2 = Object.create
                  , B2 = x2.propertyIsEnumerable
                  , F2 = T2.splice
                  , H2 = Object.getOwnPropertySymbols
                  , V2 = I2 ? I2.isBuffer : void 0
                  , U2 = A2(Object.keys, Object)
                  , W2 = gt2(p2, "DataView")
                  , G2 = gt2(p2, "Map")
                  , $2 = gt2(p2, "Promise")
                  , J2 = gt2(p2, "Set")
                  , Y2 = gt2(p2, "WeakMap")
                  , X2 = gt2(Object, "create")
                  , Q2 = wt2(W2)
                  , Z2 = wt2(G2)
                  , K2 = wt2($2)
                  , tt2 = wt2(J2)
                  , et2 = wt2(Y2)
                  , nt2 = N2 ? N2.prototype : void 0
                  , rt2 = nt2 ? nt2.valueOf : void 0;
                function it2(t3) {
                    var e4 = -1
                      , n4 = t3 ? t3.length : 0;
                    for (this.clear(); ++e4 < n4; ) {
                        var r3 = t3[e4];
                        this.set(r3[0], r3[1])
                    }
                }
                function ot2(t3) {
                    var e4 = -1
                      , n4 = t3 ? t3.length : 0;
                    for (this.clear(); ++e4 < n4; ) {
                        var r3 = t3[e4];
                        this.set(r3[0], r3[1])
                    }
                }
                function at2(t3) {
                    var e4 = -1
                      , n4 = t3 ? t3.length : 0;
                    for (this.clear(); ++e4 < n4; ) {
                        var r3 = t3[e4];
                        this.set(r3[0], r3[1])
                    }
                }
                function st2(t3) {
                    this.__data__ = new ot2(t3)
                }
                function ct2(e4, n4) {
                    var i3 = _t2(e4) || function(e5) {
                        return function(e6) {
                            return function(e7) {
                                return !!e7 && t2(e7) == "object"
                            }(e6) && At2(e6)
                        }(e5) && D2.call(e5, "callee") && (!B2.call(e5, "callee") || P2.call(e5) == r2)
                    }(e4) ? function(t3, e5) {
                        for (var n5 = -1, r3 = Array(t3); ++n5 < t3; )
                            r3[n5] = e5(n5);
                        return r3
                    }(e4.length, String) : []
                      , o3 = i3.length
                      , a3 = !!o3;
                    for (var s3 in e4)
                        !n4 && !D2.call(e4, s3) || a3 && (s3 == "length" || yt2(s3, o3)) || i3.push(s3);
                    return i3
                }
                function lt2(t3, e4, n4) {
                    var r3 = t3[e4];
                    D2.call(t3, e4) && Et2(r3, n4) && (n4 !== void 0 || e4 in t3) || (t3[e4] = n4)
                }
                function ut2(t3, e4) {
                    for (var n4 = t3.length; n4--; )
                        if (Et2(t3[n4][0], e4))
                            return n4;
                    return -1
                }
                function dt2(t3, e4, n4, l3, u3, f3, h3) {
                    var p3;
                    if (l3 && (p3 = f3 ? l3(t3, u3, f3, h3) : l3(t3)),
                    p3 !== void 0)
                        return p3;
                    if (!St2(t3))
                        return t3;
                    var g3 = _t2(t3);
                    if (g3) {
                        if (p3 = function(t4) {
                            var e5 = t4.length
                              , n5 = t4.constructor(e5);
                            return e5 && typeof t4[0] == "string" && D2.call(t4, "index") && (n5.index = t4.index,
                            n5.input = t4.input),
                            n5
                        }(t3),
                        !e4)
                            return function(t4, e5) {
                                var n5 = -1
                                  , r3 = t4.length;
                                for (e5 || (e5 = Array(r3)); ++n5 < r3; )
                                    e5[n5] = t4[n5];
                                return e5
                            }(t3, p3)
                    } else {
                        var v3 = mt2(t3)
                          , m3 = v3 == i2 || v3 == o2;
                        if (kt2(t3))
                            return function(t4, e5) {
                                if (e5)
                                    return t4.slice();
                                var n5 = new t4.constructor(t4.length);
                                return t4.copy(n5),
                                n5
                            }(t3, e4);
                        if (v3 == "[object Object]" || v3 == r2 || m3 && !f3) {
                            if (E2(t3))
                                return f3 ? t3 : {};
                            if (p3 = function(t4) {
                                return typeof t4.constructor != "function" || bt2(t4) ? {} : St2(e5 = z2(t4)) ? R2(e5) : {};
                                var e5
                            }(m3 ? {} : t3),
                            !e4)
                                return function(t4, e5) {
                                    return ht2(t4, vt2(t4), e5)
                                }(t3, function(t4, e5) {
                                    return t4 && ht2(e5, xt2(e5), t4)
                                }(p3, t3))
                        } else {
                            if (!d2[v3])
                                return f3 ? t3 : {};
                            p3 = function(t4, e5, n5, r3) {
                                var i3, o3 = t4.constructor;
                                switch (e5) {
                                case "[object ArrayBuffer]":
                                    return ft2(t4);
                                case "[object Boolean]":
                                case "[object Date]":
                                    return new o3(+t4);
                                case "[object DataView]":
                                    return function(t5, e6) {
                                        var n6 = e6 ? ft2(t5.buffer) : t5.buffer;
                                        return new t5.constructor(n6,t5.byteOffset,t5.byteLength)
                                    }(t4, r3);
                                case "[object Float32Array]":
                                case "[object Float64Array]":
                                case "[object Int8Array]":
                                case "[object Int16Array]":
                                case "[object Int32Array]":
                                case "[object Uint8Array]":
                                case "[object Uint8ClampedArray]":
                                case "[object Uint16Array]":
                                case "[object Uint32Array]":
                                    return function(t5, e6) {
                                        var n6 = e6 ? ft2(t5.buffer) : t5.buffer;
                                        return new t5.constructor(n6,t5.byteOffset,t5.length)
                                    }(t4, r3);
                                case a2:
                                    return function(t5, e6, n6) {
                                        return w2(e6 ? n6(_2(t5), !0) : _2(t5), y2, new t5.constructor)
                                    }(t4, r3, n5);
                                case "[object Number]":
                                case "[object String]":
                                    return new o3(t4);
                                case "[object RegExp]":
                                    return function(t5) {
                                        var e6 = new t5.constructor(t5.source,c2.exec(t5));
                                        return e6.lastIndex = t5.lastIndex,
                                        e6
                                    }(t4);
                                case s2:
                                    return function(t5, e6, n6) {
                                        return w2(e6 ? n6(k2(t5), !0) : k2(t5), b2, new t5.constructor)
                                    }(t4, r3, n5);
                                case "[object Symbol]":
                                    return i3 = t4,
                                    rt2 ? Object(rt2.call(i3)) : {}
                                }
                            }(t3, v3, dt2, e4)
                        }
                    }
                    h3 || (h3 = new st2);
                    var A3 = h3.get(t3);
                    if (A3)
                        return A3;
                    if (h3.set(t3, p3),
                    !g3)
                        var T3 = n4 ? function(t4) {
                            return function(t5, e5, n5) {
                                var r3 = e5(t5);
                                return _t2(t5) ? r3 : function(t6, e6) {
                                    for (var n6 = -1, r4 = e6.length, i3 = t6.length; ++n6 < r4; )
                                        t6[i3 + n6] = e6[n6];
                                    return t6
                                }(r3, n5(t5))
                            }(t4, xt2, vt2)
                        }(t3) : xt2(t3);
                    return function(t4, e5) {
                        for (var n5 = -1, r3 = t4 ? t4.length : 0; ++n5 < r3 && e5(t4[n5], n5) !== !1; )
                            ;
                    }(T3 || t3, function(r3, i3) {
                        T3 && (r3 = t3[i3 = r3]),
                        lt2(p3, i3, dt2(r3, e4, n4, l3, i3, t3, h3))
                    }),
                    p3
                }
                function ft2(t3) {
                    var e4 = new t3.constructor(t3.byteLength);
                    return new M2(e4).set(new M2(t3)),
                    e4
                }
                function ht2(t3, e4, n4, r3) {
                    n4 || (n4 = {});
                    for (var i3 = -1, o3 = e4.length; ++i3 < o3; ) {
                        var a3 = e4[i3]
                          , s3 = r3 ? r3(n4[a3], t3[a3], a3, n4, t3) : void 0;
                        lt2(n4, a3, s3 === void 0 ? t3[a3] : s3)
                    }
                    return n4
                }
                function pt2(e4, n4) {
                    var r3, i3, o3 = e4.__data__;
                    return ((i3 = t2(r3 = n4)) == "string" || i3 == "number" || i3 == "symbol" || i3 == "boolean" ? r3 !== "__proto__" : r3 === null) ? o3[typeof n4 == "string" ? "string" : "hash"] : o3.map
                }
                function gt2(t3, e4) {
                    var n4 = function(t4, e5) {
                        return t4?.[e5]
                    }(t3, e4);
                    return function(t4) {
                        return !(!St2(t4) || function(t5) {
                            return !!O2 && O2 in t5
                        }(t4)) && (Tt2(t4) || E2(t4) ? j2 : l2).test(wt2(t4))
                    }(n4) ? n4 : void 0
                }
                it2.prototype.clear = function() {
                    this.__data__ = X2 ? X2(null) : {}
                }
                ,
                it2.prototype.delete = function(t3) {
                    return this.has(t3) && delete this.__data__[t3]
                }
                ,
                it2.prototype.get = function(t3) {
                    var e4 = this.__data__;
                    if (X2) {
                        var n4 = e4[t3];
                        return n4 === "__lodash_hash_undefined__" ? void 0 : n4
                    }
                    return D2.call(e4, t3) ? e4[t3] : void 0
                }
                ,
                it2.prototype.has = function(t3) {
                    var e4 = this.__data__;
                    return X2 ? e4[t3] !== void 0 : D2.call(e4, t3)
                }
                ,
                it2.prototype.set = function(t3, e4) {
                    return this.__data__[t3] = X2 && e4 === void 0 ? "__lodash_hash_undefined__" : e4,
                    this
                }
                ,
                ot2.prototype.clear = function() {
                    this.__data__ = []
                }
                ,
                ot2.prototype.delete = function(t3) {
                    var e4 = this.__data__
                      , n4 = ut2(e4, t3);
                    return !(n4 < 0 || (n4 == e4.length - 1 ? e4.pop() : F2.call(e4, n4, 1),
                    0))
                }
                ,
                ot2.prototype.get = function(t3) {
                    var e4 = this.__data__
                      , n4 = ut2(e4, t3);
                    return n4 < 0 ? void 0 : e4[n4][1]
                }
                ,
                ot2.prototype.has = function(t3) {
                    return ut2(this.__data__, t3) > -1
                }
                ,
                ot2.prototype.set = function(t3, e4) {
                    var n4 = this.__data__
                      , r3 = ut2(n4, t3);
                    return r3 < 0 ? n4.push([t3, e4]) : n4[r3][1] = e4,
                    this
                }
                ,
                at2.prototype.clear = function() {
                    this.__data__ = {
                        hash: new it2,
                        map: new (G2 || ot2),
                        string: new it2
                    }
                }
                ,
                at2.prototype.delete = function(t3) {
                    return pt2(this, t3).delete(t3)
                }
                ,
                at2.prototype.get = function(t3) {
                    return pt2(this, t3).get(t3)
                }
                ,
                at2.prototype.has = function(t3) {
                    return pt2(this, t3).has(t3)
                }
                ,
                at2.prototype.set = function(t3, e4) {
                    return pt2(this, t3).set(t3, e4),
                    this
                }
                ,
                st2.prototype.clear = function() {
                    this.__data__ = new ot2
                }
                ,
                st2.prototype.delete = function(t3) {
                    return this.__data__.delete(t3)
                }
                ,
                st2.prototype.get = function(t3) {
                    return this.__data__.get(t3)
                }
                ,
                st2.prototype.has = function(t3) {
                    return this.__data__.has(t3)
                }
                ,
                st2.prototype.set = function(t3, e4) {
                    var n4 = this.__data__;
                    if (n4 instanceof ot2) {
                        var r3 = n4.__data__;
                        if (!G2 || r3.length < 199)
                            return r3.push([t3, e4]),
                            this;
                        n4 = this.__data__ = new at2(r3)
                    }
                    return n4.set(t3, e4),
                    this
                }
                ;
                var vt2 = H2 ? A2(H2, Object) : function() {
                    return []
                }
                  , mt2 = function(t3) {
                    return P2.call(t3)
                };
                function yt2(t3, e4) {
                    return !!(e4 = e4 ?? 9007199254740991) && (typeof t3 == "number" || u2.test(t3)) && t3 > -1 && t3 % 1 == 0 && t3 < e4
                }
                function bt2(t3) {
                    var e4 = t3 && t3.constructor;
                    return t3 === (typeof e4 == "function" && e4.prototype || x2)
                }
                function wt2(t3) {
                    if (t3 != null) {
                        try {
                            return q2.call(t3)
                        } catch {}
                        try {
                            return t3 + ""
                        } catch {}
                    }
                    return ""
                }
                function Et2(t3, e4) {
                    return t3 === e4 || t3 != t3 && e4 != e4
                }
                (W2 && mt2(new W2(new ArrayBuffer(1))) != "[object DataView]" || G2 && mt2(new G2) != a2 || $2 && mt2($2.resolve()) != "[object Promise]" || J2 && mt2(new J2) != s2 || Y2 && mt2(new Y2) != "[object WeakMap]") && (mt2 = function(t3) {
                    var e4 = P2.call(t3)
                      , n4 = e4 == "[object Object]" ? t3.constructor : void 0
                      , r3 = n4 ? wt2(n4) : void 0;
                    if (r3)
                        switch (r3) {
                        case Q2:
                            return "[object DataView]";
                        case Z2:
                            return a2;
                        case K2:
                            return "[object Promise]";
                        case tt2:
                            return s2;
                        case et2:
                            return "[object WeakMap]"
                        }
                    return e4
                }
                );
                var _t2 = Array.isArray;
                function At2(t3) {
                    return t3 != null && function(t4) {
                        return typeof t4 == "number" && t4 > -1 && t4 % 1 == 0 && t4 <= 9007199254740991
                    }(t3.length) && !Tt2(t3)
                }
                var kt2 = V2 || function() {
                    return !1
                }
                ;
                function Tt2(t3) {
                    var e4 = St2(t3) ? P2.call(t3) : "";
                    return e4 == i2 || e4 == o2
                }
                function St2(e4) {
                    var n4 = t2(e4);
                    return !!e4 && (n4 == "object" || n4 == "function")
                }
                function xt2(t3) {
                    return At2(t3) ? ct2(t3) : function(t4) {
                        if (!bt2(t4))
                            return U2(t4);
                        var e4 = [];
                        for (var n4 in Object(t4))
                            D2.call(t4, n4) && n4 != "constructor" && e4.push(n4);
                        return e4
                    }(t3)
                }
                e3.exports = function(t3) {
                    return dt2(t3, !0, !0)
                }
            }),
            function e3(n3, r2) {
                var i2, s2 = new Set(["!doctype", "abbr", "address", "area", "article", "aside", "audio", "base", "bdi", "bdo", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "doctype", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "math", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "param", "picture", "pre", "progress", "rb", "rp", "rt", "rtc", "ruby", "samp", "script", "section", "select", "slot", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "svg", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "ul", "var", "video", "wbr", "xml"]), c2 = new Set(["a", "b", "i", "p", "q", "s", "u"]), l2 = new Set([".", ",", "?", ";", ")", "\u2026", '"', "\xBB"]), u2 = new Set(["script", "style", "xml"]), d2 = {
                    attributes: []
                }, h2 = null, p2 = null, g2 = [], v2 = {}, m2 = {}, y2 = "", b2 = null;
                function w2(t3, e4, r3) {
                    if (Array.isArray(e4.stripTogetherWithTheirContents) && e4.stripTogetherWithTheirContents.includes(d2.name))
                        if (Array.isArray(g2) && g2.some(function(e5) {
                            return e5.name === d2.name && e5.lastClosingBracketAt < t3
                        })) {
                            for (var i3 = g2.length; i3--; )
                                if (g2[i3].name === d2.name) {
                                    l2.has(n3[t3]) ? e4.cb({
                                        tag: d2,
                                        deleteFrom: g2[i3].lastOpeningBracketAt,
                                        deleteTo: t3,
                                        insert: null,
                                        rangesArr: r3,
                                        proposedReturn: [g2[i3].lastOpeningBracketAt, t3, null]
                                    }) : e4.cb({
                                        tag: d2,
                                        deleteFrom: g2[i3].lastOpeningBracketAt,
                                        deleteTo: t3,
                                        insert: "",
                                        rangesArr: r3,
                                        proposedReturn: [g2[i3].lastOpeningBracketAt, t3, ""]
                                    }),
                                    g2.splice(i3, 1);
                                    break
                                }
                        } else
                            g2.push(d2)
                }
                function _2(t3, e4, n4, r3, i3, o2) {
                    var a2 = "";
                    if (n4 < i3 && (a2 += t3.slice(n4, i3)),
                    r3 > o2 + 1) {
                        var s3 = t3.slice(o2 + 1, r3);
                        s3.includes(`
`) && t3[r3] === "<" ? a2 += " " : a2 += s3
                    }
                    if (!l2.has(t3[e4]) && t3[e4] !== "!") {
                        var c3 = a2.match(/\n/g);
                        return Array.isArray(c3) && c3.length ? c3.length === 1 ? `
` : c3.length === 2 ? `

` : `


` : " "
                    }
                    return ""
                }
                function A2(t3) {
                    if (t3.dumpLinkHrefsNearby.enabled && Object.keys(m2).length && m2.tagName === d2.name && d2.lastOpeningBracketAt && (m2.openingTagEnds && d2.lastOpeningBracketAt > m2.openingTagEnds || !m2.openingTagEnds) && (i2 = !0),
                    i2) {
                        var e4 = t3.dumpLinkHrefsNearby.putOnNewLine ? `

` : "";
                        y2 = "".concat(e4).concat(m2.hrefValue).concat(e4)
                    }
                }
                if (typeof n3 != "string")
                    throw new TypeError("string-strip-html/stripHtml(): [THROW_ID_01] Input must be string! Currently it's: ".concat(t2(n3).toLowerCase(), `, equal to:
`).concat(JSON.stringify(n3, null, 4)));
                if (!n3 || !n3.trim())
                    return n3;
                if (r2 != null && !O(r2))
                    throw new TypeError("string-strip-html/stripHtml(): [THROW_ID_02] Optional Options Object must be a plain object! Currently it's: ".concat(t2(r2).toLowerCase(), `, equal to:
`).concat(JSON.stringify(r2, null, 4)));
                function k2() {
                    i2 && (m2 = {},
                    i2 = !1)
                }
                var T2 = {
                    ignoreTags: [],
                    onlyStripTags: [],
                    stripTogetherWithTheirContents: a(u2),
                    skipHtmlDecoding: !1,
                    returnRangesOnly: !1,
                    trimOnlySpaces: !1,
                    dumpLinkHrefsNearby: {
                        enabled: !1,
                        putOnNewLine: !1,
                        wrapHeads: "",
                        wrapTails: ""
                    },
                    cb: null
                }
                  , S2 = o(o({}, T2), r2);
                S2.ignoreTags = te(S2.ignoreTags, "opts.ignoreTags"),
                S2.onlyStripTags = te(S2.onlyStripTags, "opts.onlyStripTags");
                var x2 = !!S2.onlyStripTags.length;
                if (S2.onlyStripTags.length && S2.ignoreTags.length && (S2.onlyStripTags = Pt.apply(void 0, [S2.onlyStripTags].concat(a(S2.ignoreTags)))),
                O(S2.dumpLinkHrefsNearby) || (S2.dumpLinkHrefsNearby = o({}, T2.dumpLinkHrefsNearby)),
                S2.dumpLinkHrefsNearby = T2.dumpLinkHrefsNearby,
                O(r2) && Object.prototype.hasOwnProperty.call(r2, "dumpLinkHrefsNearby") && r2.dumpLinkHrefsNearby != null) {
                    if (O(r2.dumpLinkHrefsNearby))
                        S2.dumpLinkHrefsNearby = o(o({}, T2.dumpLinkHrefsNearby), r2.dumpLinkHrefsNearby);
                    else if (r2.dumpLinkHrefsNearby)
                        throw new TypeError("string-strip-html/stripHtml(): [THROW_ID_04] Optional Options Object's key dumpLinkHrefsNearby was set to ".concat(t2(r2.dumpLinkHrefsNearby), ", equal to ").concat(JSON.stringify(r2.dumpLinkHrefsNearby, null, 4), ". The only allowed value is a plain object. See the API reference."))
                }
                S2.stripTogetherWithTheirContents ? typeof S2.stripTogetherWithTheirContents == "string" && S2.stripTogetherWithTheirContents.length > 0 && (S2.stripTogetherWithTheirContents = [S2.stripTogetherWithTheirContents]) : S2.stripTogetherWithTheirContents = [];
                var C2 = {};
                if (S2.stripTogetherWithTheirContents && Array.isArray(S2.stripTogetherWithTheirContents) && S2.stripTogetherWithTheirContents.length && !S2.stripTogetherWithTheirContents.every(function(t3, e4) {
                    return typeof t3 == "string" || (C2.el = t3,
                    C2.i = e4,
                    !1)
                }))
                    throw new TypeError("string-strip-html/stripHtml(): [THROW_ID_06] Optional Options Object's key stripTogetherWithTheirContents was set to contain not just string elements! For example, element at index ".concat(C2.i, " has a value ").concat(C2.el, " which is not string but ").concat(t2(C2.el).toLowerCase(), "."));
                S2.cb || (S2.cb = function(t3) {
                    var e4 = t3.rangesArr
                      , n4 = t3.proposedReturn;
                    e4.push.apply(e4, a(n4))
                }
                );
                var L2, q2 = new E({
                    limitToBeAddedWhitespace: !0,
                    limitLinebreaksCount: 2
                });
                if (!S2.skipHtmlDecoding)
                    for (; n3 !== Zt(n3); )
                        n3 = Zt(n3);
                S2.trimOnlySpaces || (n3 = n3.trim());
                for (var D2 = 0, P2 = n3.length; D2 < P2; D2++) {
                    if (Object.keys(d2).length > 1 && d2.lastClosingBracketAt && d2.lastClosingBracketAt < D2 && n3[D2] !== " " && b2 === null && (b2 = D2),
                    n3[D2] === ">" && (!d2 || Object.keys(d2).length < 2) && D2 > 1)
                        for (var j2 = D2; j2-- && (n3[j2 - 1] !== void 0 && n3[j2] !== ">" || function() {
                            var t3 = n3[j2 - 1] === void 0 ? j2 : j2 + 1
                              , r3 = n3.slice(t3, D2 + 1);
                            if (n3 !== "<".concat(tt(r3.trim(), "/>"), ">") && a(s2).some(function(t4) {
                                return tt(r3.trim().split(" ").filter(function(t5) {
                                    return t5.trim()
                                }).filter(function(t5, e4) {
                                    return e4 === 0
                                }), "/>").toLowerCase() === t4
                            }) && e3("<".concat(r3.trim(), ">"), S2) === "") {
                                var i3 = _2(n3, D2, t3, D2 + 1, t3, D2 + 1)
                                  , o2 = D2 + 1;
                                if (n3[o2] && !n3[o2].trim()) {
                                    for (var c3 = o2; c3 < P2; c3++)
                                        if (n3[c3].trim()) {
                                            o2 = c3;
                                            break
                                        }
                                }
                                S2.cb({
                                    tag: d2,
                                    deleteFrom: t3,
                                    deleteTo: o2,
                                    insert: i3,
                                    rangesArr: q2,
                                    proposedReturn: [t3, o2, i3]
                                })
                            }
                            return "break"
                        }() !== "break"); )
                            ;
                    if (n3[D2] !== "/" || d2.quotes && d2.quotes.value || !Number.isInteger(d2.lastOpeningBracketAt) || Number.isInteger(d2.lastClosingBracketAt) || (d2.slashPresent = D2),
                    n3[D2] === '"' || n3[D2] === "'")
                        if (d2.nameStarts && d2.quotes && d2.quotes.value && d2.quotes.value === n3[D2]) {
                            v2.valueEnds = D2,
                            v2.value = n3.slice(v2.valueStarts, D2),
                            d2.attributes.push(v2),
                            v2 = {},
                            d2.quotes = void 0;
                            var I2 = void 0;
                            S2.dumpLinkHrefsNearby.enabled && d2.attributes.some(function(t3) {
                                if (t3.name && t3.name.toLowerCase() === "href")
                                    return I2 = "".concat(S2.dumpLinkHrefsNearby.wrapHeads || "").concat(t3.value).concat(S2.dumpLinkHrefsNearby.wrapTails || ""),
                                    !0
                            }) && (m2 = {
                                tagName: d2.name,
                                hrefValue: I2
                            })
                        } else
                            !d2.quotes && d2.nameStarts && (d2.quotes = {},
                            d2.quotes.value = n3[D2],
                            d2.quotes.start = D2,
                            v2.nameStarts && v2.nameEnds && v2.nameEnds < D2 && v2.nameStarts < D2 && !v2.valueStarts && (v2.name = n3.slice(v2.nameStarts, v2.nameEnds)));
                    if (!(d2.nameStarts === void 0 || d2.nameEnds !== void 0 || n3[D2].trim() && (L2 = n3[D2],
                    /[-_A-Za-z0-9]/.test(L2)))) {
                        if (d2.nameEnds = D2,
                        d2.name = n3.slice(d2.nameStarts, d2.nameEnds + (n3[D2] !== ">" && n3[D2] !== "/" && n3[D2 + 1] === void 0 ? 1 : 0)),
                        n3[d2.nameStarts - 1] !== "!" && !d2.name.replace(/-/g, "").length || /^\d+$/.test(d2.name[0])) {
                            d2 = {};
                            continue
                        }
                        if (n3[D2] === "<") {
                            A2(S2);
                            var N2 = _2(n3, D2, d2.leftOuterWhitespace, D2, d2.lastOpeningBracketAt, D2);
                            S2.cb({
                                tag: d2,
                                deleteFrom: d2.leftOuterWhitespace,
                                deleteTo: D2,
                                insert: "".concat(N2).concat(y2).concat(N2),
                                rangesArr: q2,
                                proposedReturn: [d2.leftOuterWhitespace, D2, "".concat(N2).concat(y2).concat(N2)]
                            }),
                            k2(),
                            w2(D2, S2, q2)
                        }
                    }
                    if (d2.quotes && d2.quotes.start && d2.quotes.start < D2 && !d2.quotes.end && v2.nameEnds && v2.equalsAt && !v2.valueStarts && (v2.valueStarts = D2),
                    d2.quotes || !v2.nameEnds || n3[D2] !== "=" || v2.valueStarts || v2.equalsAt || (v2.equalsAt = D2),
                    !d2.quotes && v2.nameStarts && v2.nameEnds && !v2.valueStarts && n3[D2].trim() && n3[D2] !== "=" && (d2.attributes.push(v2),
                    v2 = {}),
                    d2.quotes || !v2.nameStarts || v2.nameEnds || (n3[D2].trim() ? n3[D2] === "=" ? v2.equalsAt || (v2.nameEnds = D2,
                    v2.equalsAt = D2,
                    v2.name = n3.slice(v2.nameStarts, v2.nameEnds)) : (n3[D2] === "/" || n3[D2] === ">" || n3[D2] === "<") && (v2.nameEnds = D2,
                    v2.name = n3.slice(v2.nameStarts, v2.nameEnds),
                    d2.attributes.push(v2),
                    v2 = {}) : (v2.nameEnds = D2,
                    v2.name = n3.slice(v2.nameStarts, v2.nameEnds))),
                    d2.quotes || !(d2.nameEnds < D2) || n3[D2 - 1].trim() || !n3[D2].trim() || "<>/!".includes(n3[D2]) || v2.nameStarts || d2.lastClosingBracketAt || (v2.nameStarts = D2),
                    d2.lastOpeningBracketAt !== null && d2.lastOpeningBracketAt < D2 && n3[D2] === "/" && d2.onlyPlausible && (d2.onlyPlausible = !1),
                    d2.lastOpeningBracketAt !== null && d2.lastOpeningBracketAt < D2 && n3[D2] !== "/" && (d2.onlyPlausible === void 0 && (n3[D2].trim() && n3[D2] !== "<" || d2.slashPresent ? d2.onlyPlausible = !1 : d2.onlyPlausible = !0),
                    n3[D2].trim() && d2.nameStarts === void 0 && n3[D2] !== "<" && n3[D2] !== "/" && n3[D2] !== ">" && n3[D2] !== "!" && (d2.nameStarts = D2,
                    d2.nameContainsLetters = !1)),
                    d2.nameStarts && !d2.quotes && n3[D2].toLowerCase() !== n3[D2].toUpperCase() && (d2.nameContainsLetters = !0),
                    n3[D2] === ">" && d2.lastOpeningBracketAt !== void 0 && (d2.lastClosingBracketAt = D2,
                    b2 = null,
                    Object.keys(v2).length && (d2.attributes.push(v2),
                    v2 = {}),
                    S2.dumpLinkHrefsNearby.enabled && m2.tagName && !m2.openingTagEnds && (m2.openingTagEnds = D2)),
                    d2.lastOpeningBracketAt !== void 0) {
                        if (d2.lastClosingBracketAt === void 0) {
                            if (d2.lastOpeningBracketAt < D2 && n3[D2] !== "<" && (n3[D2 + 1] === void 0 || n3[D2 + 1] === "<") && d2.nameContainsLetters) {
                                if (d2.name = n3.slice(d2.nameStarts, d2.nameEnds ? d2.nameEnds : D2 + 1).toLowerCase(),
                                S2.ignoreTags.includes(d2.name) || d2.onlyPlausible && !s2.has(d2.name)) {
                                    d2 = {},
                                    v2 = {};
                                    continue
                                }
                                if ((s2.has(d2.name) || c2.has(d2.name)) && (d2.onlyPlausible === !1 || d2.onlyPlausible === !0 && d2.attributes.length) || n3[D2 + 1] === void 0) {
                                    A2(S2);
                                    var M2 = _2(n3, D2, d2.leftOuterWhitespace, D2 + 1, d2.lastOpeningBracketAt, d2.lastClosingBracketAt);
                                    S2.cb({
                                        tag: d2,
                                        deleteFrom: d2.leftOuterWhitespace,
                                        deleteTo: D2 + 1,
                                        insert: "".concat(M2).concat(y2).concat(M2),
                                        rangesArr: q2,
                                        proposedReturn: [d2.leftOuterWhitespace, D2 + 1, "".concat(M2).concat(y2).concat(M2)]
                                    }),
                                    k2(),
                                    w2(D2, S2, q2)
                                }
                            }
                        } else if (D2 > d2.lastClosingBracketAt && n3[D2].trim() || n3[D2 + 1] === void 0) {
                            var z2 = d2.lastClosingBracketAt === D2 ? D2 + 1 : D2;
                            if (S2.trimOnlySpaces && z2 === P2 - 1 && b2 !== null && b2 < D2 && (z2 = b2),
                            !x2 && S2.ignoreTags.includes(d2.name) || x2 && !S2.onlyStripTags.includes(d2.name))
                                S2.cb({
                                    tag: d2,
                                    deleteFrom: null,
                                    deleteTo: null,
                                    insert: null,
                                    rangesArr: q2,
                                    proposedReturn: []
                                }),
                                d2 = {},
                                v2 = {};
                            else if (!d2.onlyPlausible || d2.attributes.length === 0 && d2.name && (s2.has(d2.name.toLowerCase()) || c2.has(d2.name.toLowerCase())) || d2.attributes && d2.attributes.some(function(t3) {
                                return t3.equalsAt
                            })) {
                                var R2 = _2(n3, D2, d2.leftOuterWhitespace, z2, d2.lastOpeningBracketAt, d2.lastClosingBracketAt);
                                y2 = "",
                                i2 = !1,
                                A2(S2);
                                var B2 = void 0;
                                B2 = typeof y2 == "string" && y2.length ? "".concat(R2).concat(y2).concat(R2 === `

` ? `
` : R2) : R2,
                                d2.leftOuterWhitespace !== 0 && Kt(n3, z2 - 1) || (B2 = ""),
                                S2.cb({
                                    tag: d2,
                                    deleteFrom: d2.leftOuterWhitespace,
                                    deleteTo: z2,
                                    insert: B2,
                                    rangesArr: q2,
                                    proposedReturn: [d2.leftOuterWhitespace, z2, B2]
                                }),
                                k2(),
                                w2(D2, S2, q2)
                            } else
                                d2 = {};
                            n3[D2] !== ">" && (d2 = {})
                        }
                    }
                    if (n3[D2] === "<" && n3[D2 - 1] !== "<") {
                        if (n3[Kt(n3, D2)] === ">")
                            continue;
                        if (d2.nameEnds && d2.nameEnds < D2 && !d2.lastClosingBracketAt && (d2.onlyPlausible === !0 && d2.attributes && d2.attributes.length || d2.onlyPlausible === !1)) {
                            var F2 = _2(n3, D2, d2.leftOuterWhitespace, D2, d2.lastOpeningBracketAt, D2);
                            S2.cb({
                                tag: d2,
                                deleteFrom: d2.leftOuterWhitespace,
                                deleteTo: D2,
                                insert: F2,
                                rangesArr: q2,
                                proposedReturn: [d2.leftOuterWhitespace, D2, F2]
                            }),
                            w2(D2, S2, q2),
                            d2 = {},
                            v2 = {}
                        }
                        if (d2.lastOpeningBracketAt !== void 0 && d2.onlyPlausible && d2.name && !d2.quotes && (d2.lastOpeningBracketAt = void 0,
                        d2.onlyPlausible = !1),
                        !(d2.lastOpeningBracketAt !== void 0 && d2.onlyPlausible || d2.quotes) && (d2.lastOpeningBracketAt = D2,
                        d2.slashPresent = !1,
                        d2.attributes = [],
                        h2 === null ? d2.leftOuterWhitespace = D2 : S2.trimOnlySpaces && h2 === 0 ? d2.leftOuterWhitespace = p2 || D2 : d2.leftOuterWhitespace = h2,
                        "".concat(n3[D2 + 1]).concat(n3[D2 + 2]).concat(n3[D2 + 3]) === "!--" || "".concat(n3[D2 + 1]).concat(n3[D2 + 2]).concat(n3[D2 + 3]).concat(n3[D2 + 4]).concat(n3[D2 + 5]).concat(n3[D2 + 6]).concat(n3[D2 + 7]).concat(n3[D2 + 8]) === "![CDATA[")) {
                            var H2 = !0;
                            n3[D2 + 2] === "-" && (H2 = !1);
                            for (var V2 = void 0, U2 = D2; U2 < P2; U2++)
                                if ((!V2 && H2 && "".concat(n3[U2 - 2]).concat(n3[U2 - 1]).concat(n3[U2]) === "]]>" || !H2 && "".concat(n3[U2 - 2]).concat(n3[U2 - 1]).concat(n3[U2]) === "-->") && (V2 = U2),
                                V2 && (V2 < U2 && n3[U2].trim() || n3[U2 + 1] === void 0)) {
                                    var W2 = U2;
                                    (n3[U2 + 1] === void 0 && !n3[U2].trim() || n3[U2] === ">") && (W2 += 1);
                                    var G2 = _2(n3, U2, d2.leftOuterWhitespace, W2, d2.lastOpeningBracketAt, V2);
                                    S2.cb({
                                        tag: d2,
                                        deleteFrom: d2.leftOuterWhitespace,
                                        deleteTo: W2,
                                        insert: G2,
                                        rangesArr: q2,
                                        proposedReturn: [d2.leftOuterWhitespace, W2, G2]
                                    }),
                                    D2 = U2 - 1,
                                    n3[U2] === ">" && (D2 = U2),
                                    d2 = {},
                                    v2 = {};
                                    break
                                }
                        }
                    }
                    n3[D2].trim() === "" ? h2 === null && (h2 = D2,
                    d2.lastOpeningBracketAt !== void 0 && d2.lastOpeningBracketAt < D2 && d2.nameStarts && d2.nameStarts < d2.lastOpeningBracketAt && D2 === d2.lastOpeningBracketAt + 1 && !g2.some(function(t3) {
                        return t3.name === d2.name
                    }) && (d2.onlyPlausible = !0,
                    d2.name = void 0,
                    d2.nameStarts = void 0)) : h2 !== null && (!d2.quotes && v2.equalsAt > h2 - 1 && v2.nameEnds && v2.equalsAt > v2.nameEnds && n3[D2] !== '"' && n3[D2] !== "'" && (O(v2) && d2.attributes.push(v2),
                    v2 = {},
                    d2.equalsSpottedAt = void 0),
                    h2 = null),
                    n3[D2] === " " ? p2 === null && (p2 = D2) : p2 !== null && (p2 = null)
                }
                if (q2.current()) {
                    if (S2.returnRangesOnly)
                        return q2.current();
                    var $2 = f(n3, q2.current());
                    return S2.trimOnlySpaces ? tt($2, " ") : $2.trim()
                }
                return S2.returnRangesOnly ? [] : S2.trimOnlySpaces ? tt(n3, " ") : n3.trim()
            }
        }()
    }
    ).call(this, n(8))
}
, function(t, e, n) {
    var r, i;
    (function(o, a) {
        r = [n(12), n(17), n(4), n(37), n(38), n(39)],
        (i = function(t2, e2, n2, r2, i2, a2) {
            return function(t3, e3, n3, r3, i3, o2, a3) {
                "use strict";
                var s = t3.jQuery
                  , c = t3.getComputedStyle
                  , l = t3.console;
                function u(t4, e4) {
                    for (t4 = r3.makeArray(t4); t4.length; )
                        e4.appendChild(t4.shift())
                }
                var d = 0
                  , f = {};
                function h(t4, e4) {
                    var n4 = r3.getQueryElement(t4);
                    if (n4) {
                        if (this.element = n4,
                        this.element.flickityGUID) {
                            var i4 = f[this.element.flickityGUID];
                            return i4.option(e4),
                            i4
                        }
                        s && (this.$element = s(this.element)),
                        this.options = r3.extend({}, this.constructor.defaults),
                        this.option(e4),
                        this._create()
                    } else
                        l && l.error("Bad element for Flickity: " + (n4 || t4))
                }
                h.defaults = {
                    accessibility: !0,
                    cellAlign: "center",
                    freeScrollFriction: .075,
                    friction: .28,
                    namespaceJQueryEvents: !0,
                    percentPosition: !0,
                    resize: !0,
                    selectedAttraction: .025,
                    setGallerySize: !0
                },
                h.createMethods = [];
                var p = h.prototype;
                r3.extend(p, e3.prototype),
                p._create = function() {
                    var e4 = this.guid = ++d;
                    for (var n4 in this.element.flickityGUID = e4,
                    f[e4] = this,
                    this.selectedIndex = 0,
                    this.restingFrames = 0,
                    this.x = 0,
                    this.velocity = 0,
                    this.originSide = this.options.rightToLeft ? "right" : "left",
                    this.viewport = document.createElement("div"),
                    this.viewport.className = "flickity-viewport",
                    this._createSlider(),
                    (this.options.resize || this.options.watchCSS) && t3.addEventListener("resize", this),
                    this.options.on) {
                        var r4 = this.options.on[n4];
                        this.on(n4, r4)
                    }
                    h.createMethods.forEach(function(t4) {
                        this[t4]()
                    }, this),
                    this.options.watchCSS ? this.watchCSS() : this.activate()
                }
                ,
                p.option = function(t4) {
                    r3.extend(this.options, t4)
                }
                ,
                p.activate = function() {
                    this.isActive || (this.isActive = !0,
                    this.element.classList.add("flickity-enabled"),
                    this.options.rightToLeft && this.element.classList.add("flickity-rtl"),
                    this.getSize(),
                    u(this._filterFindCellElements(this.element.children), this.slider),
                    this.viewport.appendChild(this.slider),
                    this.element.appendChild(this.viewport),
                    this.reloadCells(),
                    this.options.accessibility && (this.element.tabIndex = 0,
                    this.element.addEventListener("keydown", this)),
                    this.emitEvent("activate"),
                    this.selectInitialIndex(),
                    this.isInitActivated = !0,
                    this.dispatchEvent("ready"))
                }
                ,
                p._createSlider = function() {
                    var t4 = document.createElement("div");
                    t4.className = "flickity-slider",
                    t4.style[this.originSide] = 0,
                    this.slider = t4
                }
                ,
                p._filterFindCellElements = function(t4) {
                    return r3.filterFindElements(t4, this.options.cellSelector)
                }
                ,
                p.reloadCells = function() {
                    this.cells = this._makeCells(this.slider.children),
                    this.positionCells(),
                    this._getWrapShiftCells(),
                    this.setGallerySize()
                }
                ,
                p._makeCells = function(t4) {
                    return this._filterFindCellElements(t4).map(function(t5) {
                        return new i3(t5,this)
                    }, this)
                }
                ,
                p.getLastCell = function() {
                    return this.cells[this.cells.length - 1]
                }
                ,
                p.getLastSlide = function() {
                    return this.slides[this.slides.length - 1]
                }
                ,
                p.positionCells = function() {
                    this._sizeCells(this.cells),
                    this._positionCells(0)
                }
                ,
                p._positionCells = function(t4) {
                    t4 = t4 || 0,
                    this.maxCellHeight = t4 && this.maxCellHeight || 0;
                    var e4 = 0;
                    if (t4 > 0) {
                        var n4 = this.cells[t4 - 1];
                        e4 = n4.x + n4.size.outerWidth
                    }
                    for (var r4 = this.cells.length, i4 = t4; i4 < r4; i4++) {
                        var o3 = this.cells[i4];
                        o3.setPosition(e4),
                        e4 += o3.size.outerWidth,
                        this.maxCellHeight = Math.max(o3.size.outerHeight, this.maxCellHeight)
                    }
                    this.slideableWidth = e4,
                    this.updateSlides(),
                    this._containSlides(),
                    this.slidesWidth = r4 ? this.getLastSlide().target - this.slides[0].target : 0
                }
                ,
                p._sizeCells = function(t4) {
                    t4.forEach(function(t5) {
                        t5.getSize()
                    })
                }
                ,
                p.updateSlides = function() {
                    if (this.slides = [],
                    this.cells.length) {
                        var t4 = new o2(this);
                        this.slides.push(t4);
                        var e4 = this.originSide == "left" ? "marginRight" : "marginLeft"
                          , n4 = this._getCanCellFit();
                        this.cells.forEach(function(r4, i4) {
                            if (t4.cells.length) {
                                var a4 = t4.outerWidth - t4.firstMargin + (r4.size.outerWidth - r4.size[e4]);
                                n4.call(this, i4, a4) || (t4.updateTarget(),
                                t4 = new o2(this),
                                this.slides.push(t4)),
                                t4.addCell(r4)
                            } else
                                t4.addCell(r4)
                        }, this),
                        t4.updateTarget(),
                        this.updateSelectedSlide()
                    }
                }
                ,
                p._getCanCellFit = function() {
                    var t4 = this.options.groupCells;
                    if (!t4)
                        return function() {
                            return !1
                        }
                        ;
                    if (typeof t4 == "number") {
                        var e4 = parseInt(t4, 10);
                        return function(t5) {
                            return t5 % e4 != 0
                        }
                    }
                    var n4 = typeof t4 == "string" && t4.match(/^(\d+)%$/)
                      , r4 = n4 ? parseInt(n4[1], 10) / 100 : 1;
                    return function(t5, e5) {
                        return e5 <= (this.size.innerWidth + 1) * r4
                    }
                }
                ,
                p._init = p.reposition = function() {
                    this.positionCells(),
                    this.positionSliderAtSelected()
                }
                ,
                p.getSize = function() {
                    this.size = n3(this.element),
                    this.setCellAlign(),
                    this.cursorPosition = this.size.innerWidth * this.cellAlign
                }
                ;
                var g = {
                    center: {
                        left: .5,
                        right: .5
                    },
                    left: {
                        left: 0,
                        right: 1
                    },
                    right: {
                        right: 0,
                        left: 1
                    }
                };
                return p.setCellAlign = function() {
                    var t4 = g[this.options.cellAlign];
                    this.cellAlign = t4 ? t4[this.originSide] : this.options.cellAlign
                }
                ,
                p.setGallerySize = function() {
                    if (this.options.setGallerySize) {
                        var t4 = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
                        this.viewport.style.height = t4 + "px"
                    }
                }
                ,
                p._getWrapShiftCells = function() {
                    if (this.options.wrapAround) {
                        this._unshiftCells(this.beforeShiftCells),
                        this._unshiftCells(this.afterShiftCells);
                        var t4 = this.cursorPosition
                          , e4 = this.cells.length - 1;
                        this.beforeShiftCells = this._getGapCells(t4, e4, -1),
                        t4 = this.size.innerWidth - this.cursorPosition,
                        this.afterShiftCells = this._getGapCells(t4, 0, 1)
                    }
                }
                ,
                p._getGapCells = function(t4, e4, n4) {
                    for (var r4 = []; t4 > 0; ) {
                        var i4 = this.cells[e4];
                        if (!i4)
                            break;
                        r4.push(i4),
                        e4 += n4,
                        t4 -= i4.size.outerWidth
                    }
                    return r4
                }
                ,
                p._containSlides = function() {
                    if (this.options.contain && !this.options.wrapAround && this.cells.length) {
                        var t4 = this.options.rightToLeft
                          , e4 = t4 ? "marginRight" : "marginLeft"
                          , n4 = t4 ? "marginLeft" : "marginRight"
                          , r4 = this.slideableWidth - this.getLastCell().size[n4]
                          , i4 = r4 < this.size.innerWidth
                          , o3 = this.cursorPosition + this.cells[0].size[e4]
                          , a4 = r4 - this.size.innerWidth * (1 - this.cellAlign);
                        this.slides.forEach(function(t5) {
                            i4 ? t5.target = r4 * this.cellAlign : (t5.target = Math.max(t5.target, o3),
                            t5.target = Math.min(t5.target, a4))
                        }, this)
                    }
                }
                ,
                p.dispatchEvent = function(t4, e4, n4) {
                    var r4 = e4 ? [e4].concat(n4) : n4;
                    if (this.emitEvent(t4, r4),
                    s && this.$element) {
                        var i4 = t4 += this.options.namespaceJQueryEvents ? ".flickity" : "";
                        if (e4) {
                            var o3 = s.Event(e4);
                            o3.type = t4,
                            i4 = o3
                        }
                        this.$element.trigger(i4, n4)
                    }
                }
                ,
                p.select = function(t4, e4, n4) {
                    if (this.isActive && (t4 = parseInt(t4, 10),
                    this._wrapSelect(t4),
                    (this.options.wrapAround || e4) && (t4 = r3.modulo(t4, this.slides.length)),
                    this.slides[t4])) {
                        var i4 = this.selectedIndex;
                        this.selectedIndex = t4,
                        this.updateSelectedSlide(),
                        n4 ? this.positionSliderAtSelected() : this.startAnimation(),
                        this.options.adaptiveHeight && this.setGallerySize(),
                        this.dispatchEvent("select", null, [t4]),
                        t4 != i4 && this.dispatchEvent("change", null, [t4]),
                        this.dispatchEvent("cellSelect")
                    }
                }
                ,
                p._wrapSelect = function(t4) {
                    var e4 = this.slides.length;
                    if (!(this.options.wrapAround && e4 > 1))
                        return t4;
                    var n4 = r3.modulo(t4, e4)
                      , i4 = Math.abs(n4 - this.selectedIndex)
                      , o3 = Math.abs(n4 + e4 - this.selectedIndex)
                      , a4 = Math.abs(n4 - e4 - this.selectedIndex);
                    !this.isDragSelect && o3 < i4 ? t4 += e4 : !this.isDragSelect && a4 < i4 && (t4 -= e4),
                    t4 < 0 ? this.x -= this.slideableWidth : t4 >= e4 && (this.x += this.slideableWidth)
                }
                ,
                p.previous = function(t4, e4) {
                    this.select(this.selectedIndex - 1, t4, e4)
                }
                ,
                p.next = function(t4, e4) {
                    this.select(this.selectedIndex + 1, t4, e4)
                }
                ,
                p.updateSelectedSlide = function() {
                    var t4 = this.slides[this.selectedIndex];
                    t4 && (this.unselectSelectedSlide(),
                    this.selectedSlide = t4,
                    t4.select(),
                    this.selectedCells = t4.cells,
                    this.selectedElements = t4.getCellElements(),
                    this.selectedCell = t4.cells[0],
                    this.selectedElement = this.selectedElements[0])
                }
                ,
                p.unselectSelectedSlide = function() {
                    this.selectedSlide && this.selectedSlide.unselect()
                }
                ,
                p.selectInitialIndex = function() {
                    var t4 = this.options.initialIndex;
                    if (this.isInitActivated)
                        this.select(this.selectedIndex, !1, !0);
                    else {
                        if (t4 && typeof t4 == "string" && this.queryCell(t4))
                            return void this.selectCell(t4, !1, !0);
                        var e4 = 0;
                        t4 && this.slides[t4] && (e4 = t4),
                        this.select(e4, !1, !0)
                    }
                }
                ,
                p.selectCell = function(t4, e4, n4) {
                    var r4 = this.queryCell(t4);
                    if (r4) {
                        var i4 = this.getCellSlideIndex(r4);
                        this.select(i4, e4, n4)
                    }
                }
                ,
                p.getCellSlideIndex = function(t4) {
                    for (var e4 = 0; e4 < this.slides.length; e4++)
                        if (this.slides[e4].cells.indexOf(t4) != -1)
                            return e4
                }
                ,
                p.getCell = function(t4) {
                    for (var e4 = 0; e4 < this.cells.length; e4++) {
                        var n4 = this.cells[e4];
                        if (n4.element == t4)
                            return n4
                    }
                }
                ,
                p.getCells = function(t4) {
                    t4 = r3.makeArray(t4);
                    var e4 = [];
                    return t4.forEach(function(t5) {
                        var n4 = this.getCell(t5);
                        n4 && e4.push(n4)
                    }, this),
                    e4
                }
                ,
                p.getCellElements = function() {
                    return this.cells.map(function(t4) {
                        return t4.element
                    })
                }
                ,
                p.getParentCell = function(t4) {
                    var e4 = this.getCell(t4);
                    return e4 || (t4 = r3.getParent(t4, ".flickity-slider > *"),
                    this.getCell(t4))
                }
                ,
                p.getAdjacentCellElements = function(t4, e4) {
                    if (!t4)
                        return this.selectedSlide.getCellElements();
                    e4 = e4 === void 0 ? this.selectedIndex : e4;
                    var n4 = this.slides.length;
                    if (1 + 2 * t4 >= n4)
                        return this.getCellElements();
                    for (var i4 = [], o3 = e4 - t4; o3 <= e4 + t4; o3++) {
                        var a4 = this.options.wrapAround ? r3.modulo(o3, n4) : o3
                          , s2 = this.slides[a4];
                        s2 && (i4 = i4.concat(s2.getCellElements()))
                    }
                    return i4
                }
                ,
                p.queryCell = function(t4) {
                    if (typeof t4 == "number")
                        return this.cells[t4];
                    if (typeof t4 == "string") {
                        if (t4.match(/^[#\.]?[\d\/]/))
                            return;
                        t4 = this.element.querySelector(t4)
                    }
                    return this.getCell(t4)
                }
                ,
                p.uiChange = function() {
                    this.emitEvent("uiChange")
                }
                ,
                p.childUIPointerDown = function(t4) {
                    t4.type != "touchstart" && t4.preventDefault(),
                    this.focus()
                }
                ,
                p.onresize = function() {
                    this.watchCSS(),
                    this.resize()
                }
                ,
                r3.debounceMethod(h, "onresize", 150),
                p.resize = function() {
                    if (this.isActive) {
                        this.getSize(),
                        this.options.wrapAround && (this.x = r3.modulo(this.x, this.slideableWidth)),
                        this.positionCells(),
                        this._getWrapShiftCells(),
                        this.setGallerySize(),
                        this.emitEvent("resize");
                        var t4 = this.selectedElements && this.selectedElements[0];
                        this.selectCell(t4, !1, !0)
                    }
                }
                ,
                p.watchCSS = function() {
                    this.options.watchCSS && (c(this.element, ":after").content.indexOf("flickity") != -1 ? this.activate() : this.deactivate())
                }
                ,
                p.onkeydown = function(t4) {
                    var e4 = document.activeElement && document.activeElement != this.element;
                    if (this.options.accessibility && !e4) {
                        var n4 = h.keyboardHandlers[t4.keyCode];
                        n4 && n4.call(this)
                    }
                }
                ,
                h.keyboardHandlers = {
                    37: function() {
                        var t4 = this.options.rightToLeft ? "next" : "previous";
                        this.uiChange(),
                        this[t4]()
                    },
                    39: function() {
                        var t4 = this.options.rightToLeft ? "previous" : "next";
                        this.uiChange(),
                        this[t4]()
                    }
                },
                p.focus = function() {
                    var e4 = t3.pageYOffset;
                    this.element.focus({
                        preventScroll: !0
                    }),
                    t3.pageYOffset != e4 && t3.scrollTo(t3.pageXOffset, e4)
                }
                ,
                p.deactivate = function() {
                    this.isActive && (this.element.classList.remove("flickity-enabled"),
                    this.element.classList.remove("flickity-rtl"),
                    this.unselectSelectedSlide(),
                    this.cells.forEach(function(t4) {
                        t4.destroy()
                    }),
                    this.element.removeChild(this.viewport),
                    u(this.slider.children, this.element),
                    this.options.accessibility && (this.element.removeAttribute("tabIndex"),
                    this.element.removeEventListener("keydown", this)),
                    this.isActive = !1,
                    this.emitEvent("deactivate"))
                }
                ,
                p.destroy = function() {
                    this.deactivate(),
                    t3.removeEventListener("resize", this),
                    this.allOff(),
                    this.emitEvent("destroy"),
                    s && this.$element && s.removeData(this.element, "flickity"),
                    delete this.element.flickityGUID,
                    delete f[this.guid]
                }
                ,
                r3.extend(p, a3),
                h.data = function(t4) {
                    var e4 = (t4 = r3.getQueryElement(t4)) && t4.flickityGUID;
                    return e4 && f[e4]
                }
                ,
                r3.htmlInit(h, "flickity"),
                s && s.bridget && s.bridget("flickity", h),
                h.setJQuery = function(t4) {
                    s = t4
                }
                ,
                h.Cell = i3,
                h.Slide = o2,
                h
            }(o, t2, e2, n2, r2, i2, a2)
        }
        .apply(e, r)) === void 0 || (t.exports = i)
    }
    )(window)
}
, function(t, e) {
    var n;
    n = function() {
        return this
    }();
    try {
        n = n || new Function("return this")()
    } catch {
        typeof window == "object" && (n = window)
    }
    t.exports = n
}
, function(t, e) {
    t.exports = function(t2, e2, n) {
        return e2 in t2 ? Object.defineProperty(t2, e2, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t2[e2] = n,
        t2
    }
}
, function(t, e, n) {
    "use strict";
    t.exports = o,
    t.exports.isMobile = o,
    t.exports.default = o;
    var r = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i
      , i = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i;
    function o(t2) {
        t2 || (t2 = {});
        var e2 = t2.ua;
        if (e2 || typeof navigator > "u" || (e2 = navigator.userAgent),
        e2 && e2.headers && typeof e2.headers["user-agent"] == "string" && (e2 = e2.headers["user-agent"]),
        typeof e2 != "string")
            return !1;
        var n2 = t2.tablet ? i.test(e2) : r.test(e2);
        return !n2 && t2.tablet && t2.featureDetect && navigator && navigator.maxTouchPoints > 1 && e2.indexOf("Macintosh") !== -1 && e2.indexOf("Safari") !== -1 && (n2 = !0),
        n2
    }
}
, function(t, e, n) {
    var r = n(47)
      , i = n(48)
      , o = n(16)
      , a = n(49);
    t.exports = function(t2, e2) {
        return r(t2) || i(t2, e2) || o(t2, e2) || a()
    }
}
, function(t, e, n) {
    var r, i;
    typeof window < "u",
    (i = typeof (r = function() {
        "use strict";
        function t2() {}
        var e2 = t2.prototype;
        return e2.on = function(t3, e3) {
            if (t3 && e3) {
                var n2 = this._events = this._events || {}
                  , r2 = n2[t3] = n2[t3] || [];
                return r2.indexOf(e3) == -1 && r2.push(e3),
                this
            }
        }
        ,
        e2.once = function(t3, e3) {
            if (t3 && e3) {
                this.on(t3, e3);
                var n2 = this._onceEvents = this._onceEvents || {};
                return (n2[t3] = n2[t3] || {})[e3] = !0,
                this
            }
        }
        ,
        e2.off = function(t3, e3) {
            var n2 = this._events && this._events[t3];
            if (n2 && n2.length) {
                var r2 = n2.indexOf(e3);
                return r2 != -1 && n2.splice(r2, 1),
                this
            }
        }
        ,
        e2.emitEvent = function(t3, e3) {
            var n2 = this._events && this._events[t3];
            if (n2 && n2.length) {
                n2 = n2.slice(0),
                e3 = e3 || [];
                for (var r2 = this._onceEvents && this._onceEvents[t3], i2 = 0; i2 < n2.length; i2++) {
                    var o = n2[i2];
                    r2 && r2[o] && (this.off(t3, o),
                    delete r2[o]),
                    o.apply(this, e3)
                }
                return this
            }
        }
        ,
        e2.allOff = function() {
            delete this._events,
            delete this._onceEvents
        }
        ,
        t2
    }
    ) == "function" ? r.call(e, n, e, t) : r) === void 0 || (t.exports = i)
}
, function(t, e, n) {
    var r, i;
    /*!
* Unipointer v2.3.0
* base class for doing one thing with pointer event
* MIT license
*/
    (function(o, a) {
        r = [n(12)],
        (i = function(t2) {
            return function(t3, e2) {
                "use strict";
                function n2() {}
                var r2 = n2.prototype = Object.create(e2.prototype);
                r2.bindStartEvent = function(t4) {
                    this._bindStartEvent(t4, !0)
                }
                ,
                r2.unbindStartEvent = function(t4) {
                    this._bindStartEvent(t4, !1)
                }
                ,
                r2._bindStartEvent = function(e3, n3) {
                    var r3 = (n3 = n3 === void 0 || n3) ? "addEventListener" : "removeEventListener"
                      , i3 = "mousedown";
                    t3.PointerEvent ? i3 = "pointerdown" : "ontouchstart"in t3 && (i3 = "touchstart"),
                    e3[r3](i3, this)
                }
                ,
                r2.handleEvent = function(t4) {
                    var e3 = "on" + t4.type;
                    this[e3] && this[e3](t4)
                }
                ,
                r2.getTouch = function(t4) {
                    for (var e3 = 0; e3 < t4.length; e3++) {
                        var n3 = t4[e3];
                        if (n3.identifier == this.pointerIdentifier)
                            return n3
                    }
                }
                ,
                r2.onmousedown = function(t4) {
                    var e3 = t4.button;
                    e3 && e3 !== 0 && e3 !== 1 || this._pointerDown(t4, t4)
                }
                ,
                r2.ontouchstart = function(t4) {
                    this._pointerDown(t4, t4.changedTouches[0])
                }
                ,
                r2.onpointerdown = function(t4) {
                    this._pointerDown(t4, t4)
                }
                ,
                r2._pointerDown = function(t4, e3) {
                    t4.button || this.isPointerDown || (this.isPointerDown = !0,
                    this.pointerIdentifier = e3.pointerId !== void 0 ? e3.pointerId : e3.identifier,
                    this.pointerDown(t4, e3))
                }
                ,
                r2.pointerDown = function(t4, e3) {
                    this._bindPostStartEvents(t4),
                    this.emitEvent("pointerDown", [t4, e3])
                }
                ;
                var i2 = {
                    mousedown: ["mousemove", "mouseup"],
                    touchstart: ["touchmove", "touchend", "touchcancel"],
                    pointerdown: ["pointermove", "pointerup", "pointercancel"]
                };
                return r2._bindPostStartEvents = function(e3) {
                    if (e3) {
                        var n3 = i2[e3.type];
                        n3.forEach(function(e4) {
                            t3.addEventListener(e4, this)
                        }, this),
                        this._boundPointerEvents = n3
                    }
                }
                ,
                r2._unbindPostStartEvents = function() {
                    this._boundPointerEvents && (this._boundPointerEvents.forEach(function(e3) {
                        t3.removeEventListener(e3, this)
                    }, this),
                    delete this._boundPointerEvents)
                }
                ,
                r2.onmousemove = function(t4) {
                    this._pointerMove(t4, t4)
                }
                ,
                r2.onpointermove = function(t4) {
                    t4.pointerId == this.pointerIdentifier && this._pointerMove(t4, t4)
                }
                ,
                r2.ontouchmove = function(t4) {
                    var e3 = this.getTouch(t4.changedTouches);
                    e3 && this._pointerMove(t4, e3)
                }
                ,
                r2._pointerMove = function(t4, e3) {
                    this.pointerMove(t4, e3)
                }
                ,
                r2.pointerMove = function(t4, e3) {
                    this.emitEvent("pointerMove", [t4, e3])
                }
                ,
                r2.onmouseup = function(t4) {
                    this._pointerUp(t4, t4)
                }
                ,
                r2.onpointerup = function(t4) {
                    t4.pointerId == this.pointerIdentifier && this._pointerUp(t4, t4)
                }
                ,
                r2.ontouchend = function(t4) {
                    var e3 = this.getTouch(t4.changedTouches);
                    e3 && this._pointerUp(t4, e3)
                }
                ,
                r2._pointerUp = function(t4, e3) {
                    this._pointerDone(),
                    this.pointerUp(t4, e3)
                }
                ,
                r2.pointerUp = function(t4, e3) {
                    this.emitEvent("pointerUp", [t4, e3])
                }
                ,
                r2._pointerDone = function() {
                    this._pointerReset(),
                    this._unbindPostStartEvents(),
                    this.pointerDone()
                }
                ,
                r2._pointerReset = function() {
                    this.isPointerDown = !1,
                    delete this.pointerIdentifier
                }
                ,
                r2.pointerDone = function() {}
                ,
                r2.onpointercancel = function(t4) {
                    t4.pointerId == this.pointerIdentifier && this._pointerCancel(t4, t4)
                }
                ,
                r2.ontouchcancel = function(t4) {
                    var e3 = this.getTouch(t4.changedTouches);
                    e3 && this._pointerCancel(t4, e3)
                }
                ,
                r2._pointerCancel = function(t4, e3) {
                    this._pointerDone(),
                    this.pointerCancel(t4, e3)
                }
                ,
                r2.pointerCancel = function(t4, e3) {
                    this.emitEvent("pointerCancel", [t4, e3])
                }
                ,
                n2.getPointerPoint = function(t4) {
                    return {
                        x: t4.pageX,
                        y: t4.pageY
                    }
                }
                ,
                n2
            }(o, t2)
        }
        .apply(e, r)) === void 0 || (t.exports = i)
    }
    )(window)
}
, function(t, e) {
    var n, r, i = t.exports = {};
    function o() {
        throw new Error("setTimeout has not been defined")
    }
    function a() {
        throw new Error("clearTimeout has not been defined")
    }
    function s(t2) {
        if (n === setTimeout)
            return setTimeout(t2, 0);
        if ((n === o || !n) && setTimeout)
            return n = setTimeout,
            setTimeout(t2, 0);
        try {
            return n(t2, 0)
        } catch {
            try {
                return n.call(null, t2, 0)
            } catch {
                return n.call(this, t2, 0)
            }
        }
    }
    (function() {
        try {
            n = typeof setTimeout == "function" ? setTimeout : o
        } catch {
            n = o
        }
        try {
            r = typeof clearTimeout == "function" ? clearTimeout : a
        } catch {
            r = a
        }
    }
    )();
    var c, l = [], u = !1, d = -1;
    function f() {
        u && c && (u = !1,
        c.length ? l = c.concat(l) : d = -1,
        l.length && h())
    }
    function h() {
        if (!u) {
            var t2 = s(f);
            u = !0;
            for (var e2 = l.length; e2; ) {
                for (c = l,
                l = []; ++d < e2; )
                    c && c[d].run();
                d = -1,
                e2 = l.length
            }
            c = null,
            u = !1,
            function(t3) {
                if (r === clearTimeout)
                    return clearTimeout(t3);
                if ((r === a || !r) && clearTimeout)
                    return r = clearTimeout,
                    clearTimeout(t3);
                try {
                    r(t3)
                } catch {
                    try {
                        return r.call(null, t3)
                    } catch {
                        return r.call(this, t3)
                    }
                }
            }(t2)
        }
    }
    function p(t2, e2) {
        this.fun = t2,
        this.array = e2
    }
    function g() {}
    i.nextTick = function(t2) {
        var e2 = new Array(arguments.length - 1);
        if (arguments.length > 1)
            for (var n2 = 1; n2 < arguments.length; n2++)
                e2[n2 - 1] = arguments[n2];
        l.push(new p(t2,e2)),
        l.length !== 1 || u || s(h)
    }
    ,
    p.prototype.run = function() {
        this.fun.apply(null, this.array)
    }
    ,
    i.title = "browser",
    i.browser = !0,
    i.env = {},
    i.argv = [],
    i.version = "",
    i.versions = {},
    i.on = g,
    i.addListener = g,
    i.once = g,
    i.off = g,
    i.removeListener = g,
    i.removeAllListeners = g,
    i.emit = g,
    i.prependListener = g,
    i.prependOnceListener = g,
    i.listeners = function(t2) {
        return []
    }
    ,
    i.binding = function(t2) {
        throw new Error("process.binding is not supported")
    }
    ,
    i.cwd = function() {
        return "/"
    }
    ,
    i.chdir = function(t2) {
        throw new Error("process.chdir is not supported")
    }
    ,
    i.umask = function() {
        return 0
    }
}
, function(t, e) {
    t.exports = function(t2, e2) {
        (e2 == null || e2 > t2.length) && (e2 = t2.length);
        for (var n = 0, r = new Array(e2); n < e2; n++)
            r[n] = t2[n];
        return r
    }
}
, function(t, e, n) {
    var r = n(15);
    t.exports = function(t2, e2) {
        if (t2) {
            if (typeof t2 == "string")
                return r(t2, e2);
            var n2 = Object.prototype.toString.call(t2).slice(8, -1);
            return n2 === "Object" && t2.constructor && (n2 = t2.constructor.name),
            n2 === "Map" || n2 === "Set" ? Array.from(t2) : n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2) ? r(t2, e2) : void 0
        }
    }
}
, function(t, e, n) {
    var r, i;
    /*!
* getSize v2.0.3
* measure size of elements
* MIT license
*/
    (i = typeof (r = function() {
        "use strict";
        function t2(t3) {
            var e3 = parseFloat(t3);
            return t3.indexOf("%") == -1 && !isNaN(e3) && e3
        }
        var e2 = typeof console > "u" ? function() {}
        : function(t3) {
            console.error(t3)
        }
          , n2 = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"]
          , r2 = n2.length;
        function i2(t3) {
            var n3 = getComputedStyle(t3);
            return n3 || e2("Style returned " + n3 + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"),
            n3
        }
        var o, a = !1;
        function s(e3) {
            if (function() {
                if (!a) {
                    a = !0;
                    var e4 = document.createElement("div");
                    e4.style.width = "200px",
                    e4.style.padding = "1px 2px 3px 4px",
                    e4.style.borderStyle = "solid",
                    e4.style.borderWidth = "1px 2px 3px 4px",
                    e4.style.boxSizing = "border-box";
                    var n3 = document.body || document.documentElement;
                    n3.appendChild(e4);
                    var r3 = i2(e4);
                    o = Math.round(t2(r3.width)) == 200,
                    s.isBoxSizeOuter = o,
                    n3.removeChild(e4)
                }
            }(),
            typeof e3 == "string" && (e3 = document.querySelector(e3)),
            e3 && typeof e3 == "object" && e3.nodeType) {
                var c = i2(e3);
                if (c.display == "none")
                    return function() {
                        for (var t3 = {
                            width: 0,
                            height: 0,
                            innerWidth: 0,
                            innerHeight: 0,
                            outerWidth: 0,
                            outerHeight: 0
                        }, e4 = 0; e4 < r2; e4++)
                            t3[n2[e4]] = 0;
                        return t3
                    }();
                var l = {};
                l.width = e3.offsetWidth,
                l.height = e3.offsetHeight;
                for (var u = l.isBorderBox = c.boxSizing == "border-box", d = 0; d < r2; d++) {
                    var f = n2[d]
                      , h = c[f]
                      , p = parseFloat(h);
                    l[f] = isNaN(p) ? 0 : p
                }
                var g = l.paddingLeft + l.paddingRight
                  , v = l.paddingTop + l.paddingBottom
                  , m = l.marginLeft + l.marginRight
                  , y = l.marginTop + l.marginBottom
                  , b = l.borderLeftWidth + l.borderRightWidth
                  , w = l.borderTopWidth + l.borderBottomWidth
                  , E = u && o
                  , _ = t2(c.width);
                _ !== !1 && (l.width = _ + (E ? 0 : g + b));
                var A = t2(c.height);
                return A !== !1 && (l.height = A + (E ? 0 : v + w)),
                l.innerWidth = l.width - (g + b),
                l.innerHeight = l.height - (v + w),
                l.outerWidth = l.width + m,
                l.outerHeight = l.height + y,
                l
            }
        }
        return s
    }
    ) == "function" ? r.call(e, n, e, t) : r) === void 0 || (t.exports = i)
}
, function(t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", {
        value: !0
    }),
    e.formatMoney = function(t2, e2) {
        typeof t2 == "string" && (t2 = t2.replace(".", ""));
        var n2 = ""
          , r = /\{\{\s*(\w+)\s*\}\}/
          , i = e2 || "${{amount}}";
        function o(t3) {
            var e3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2
              , n3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ","
              , r2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".";
            if (isNaN(t3) || t3 == null)
                return 0;
            var i2 = (t3 = (t3 / 100).toFixed(e3)).split(".")
              , o2 = i2[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n3)
              , a = i2[1] ? r2 + i2[1] : "";
            return o2 + a
        }
        switch (i.match(r)[1]) {
        case "amount":
            n2 = o(t2, 2);
            break;
        case "amount_no_decimals":
            n2 = o(t2, 0);
            break;
        case "amount_with_comma_separator":
            n2 = o(t2, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            n2 = o(t2, 0, ".", ",")
        }
        return i.replace(r, n2)
    }
}
, function(t, e) {
    function n(e2) {
        return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t.exports = n = function(t2) {
            return typeof t2
        }
        : t.exports = n = function(t2) {
            return t2 && typeof Symbol == "function" && t2.constructor === Symbol && t2 !== Symbol.prototype ? "symbol" : typeof t2
        }
        ,
        n(e2)
    }
    t.exports = n
}
, function(t, e, n) {
    "use strict";
    (function(t2) {
        var n2 = function() {
            if (typeof Map < "u")
                return Map;
            function t3(t4, e2) {
                var n3 = -1;
                return t4.some(function(t5, r2) {
                    return t5[0] === e2 && (n3 = r2,
                    !0)
                }),
                n3
            }
            return function() {
                function e2() {
                    this.__entries__ = []
                }
                return Object.defineProperty(e2.prototype, "size", {
                    get: function() {
                        return this.__entries__.length
                    },
                    enumerable: !0,
                    configurable: !0
                }),
                e2.prototype.get = function(e3) {
                    var n3 = t3(this.__entries__, e3)
                      , r2 = this.__entries__[n3];
                    return r2 && r2[1]
                }
                ,
                e2.prototype.set = function(e3, n3) {
                    var r2 = t3(this.__entries__, e3);
                    ~r2 ? this.__entries__[r2][1] = n3 : this.__entries__.push([e3, n3])
                }
                ,
                e2.prototype.delete = function(e3) {
                    var n3 = this.__entries__
                      , r2 = t3(n3, e3);
                    ~r2 && n3.splice(r2, 1)
                }
                ,
                e2.prototype.has = function(e3) {
                    return !!~t3(this.__entries__, e3)
                }
                ,
                e2.prototype.clear = function() {
                    this.__entries__.splice(0)
                }
                ,
                e2.prototype.forEach = function(t4, e3) {
                    e3 === void 0 && (e3 = null);
                    for (var n3 = 0, r2 = this.__entries__; n3 < r2.length; n3++) {
                        var i2 = r2[n3];
                        t4.call(e3, i2[1], i2[0])
                    }
                }
                ,
                e2
            }()
        }()
          , r = typeof window < "u" && typeof document < "u" && window.document === document
          , i = t2 !== void 0 && t2.Math === Math ? t2 : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")()
          , o = typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(i) : function(t3) {
            return setTimeout(function() {
                return t3(Date.now())
            }, 1e3 / 60)
        }
          , a = ["top", "right", "bottom", "left", "width", "height", "size", "weight"]
          , s = typeof MutationObserver < "u"
          , c = function() {
            function t3() {
                this.connected_ = !1,
                this.mutationEventsAdded_ = !1,
                this.mutationsObserver_ = null,
                this.observers_ = [],
                this.onTransitionEnd_ = this.onTransitionEnd_.bind(this),
                this.refresh = function(t4, e2) {
                    var n3 = !1
                      , r2 = !1
                      , i2 = 0;
                    function a2() {
                        n3 && (n3 = !1,
                        t4()),
                        r2 && c2()
                    }
                    function s2() {
                        o(a2)
                    }
                    function c2() {
                        var t5 = Date.now();
                        if (n3) {
                            if (t5 - i2 < 2)
                                return;
                            r2 = !0
                        } else
                            n3 = !0,
                            r2 = !1,
                            setTimeout(s2, e2);
                        i2 = t5
                    }
                    return c2
                }(this.refresh.bind(this), 20)
            }
            return t3.prototype.addObserver = function(t4) {
                ~this.observers_.indexOf(t4) || this.observers_.push(t4),
                this.connected_ || this.connect_()
            }
            ,
            t3.prototype.removeObserver = function(t4) {
                var e2 = this.observers_
                  , n3 = e2.indexOf(t4);
                ~n3 && e2.splice(n3, 1),
                !e2.length && this.connected_ && this.disconnect_()
            }
            ,
            t3.prototype.refresh = function() {
                this.updateObservers_() && this.refresh()
            }
            ,
            t3.prototype.updateObservers_ = function() {
                var t4 = this.observers_.filter(function(t5) {
                    return t5.gatherActive(),
                    t5.hasActive()
                });
                return t4.forEach(function(t5) {
                    return t5.broadcastActive()
                }),
                t4.length > 0
            }
            ,
            t3.prototype.connect_ = function() {
                r && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_),
                window.addEventListener("resize", this.refresh),
                s ? (this.mutationsObserver_ = new MutationObserver(this.refresh),
                this.mutationsObserver_.observe(document, {
                    attributes: !0,
                    childList: !0,
                    characterData: !0,
                    subtree: !0
                })) : (document.addEventListener("DOMSubtreeModified", this.refresh),
                this.mutationEventsAdded_ = !0),
                this.connected_ = !0)
            }
            ,
            t3.prototype.disconnect_ = function() {
                r && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_),
                window.removeEventListener("resize", this.refresh),
                this.mutationsObserver_ && this.mutationsObserver_.disconnect(),
                this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh),
                this.mutationsObserver_ = null,
                this.mutationEventsAdded_ = !1,
                this.connected_ = !1)
            }
            ,
            t3.prototype.onTransitionEnd_ = function(t4) {
                var e2 = t4.propertyName
                  , n3 = e2 === void 0 ? "" : e2;
                a.some(function(t5) {
                    return !!~n3.indexOf(t5)
                }) && this.refresh()
            }
            ,
            t3.getInstance = function() {
                return this.instance_ || (this.instance_ = new t3),
                this.instance_
            }
            ,
            t3.instance_ = null,
            t3
        }()
          , l = function(t3, e2) {
            for (var n3 = 0, r2 = Object.keys(e2); n3 < r2.length; n3++) {
                var i2 = r2[n3];
                Object.defineProperty(t3, i2, {
                    value: e2[i2],
                    enumerable: !1,
                    writable: !1,
                    configurable: !0
                })
            }
            return t3
        }
          , u = function(t3) {
            return t3 && t3.ownerDocument && t3.ownerDocument.defaultView || i
        }
          , d = m(0, 0, 0, 0);
        function f(t3) {
            return parseFloat(t3) || 0
        }
        function h(t3) {
            for (var e2 = [], n3 = 1; n3 < arguments.length; n3++)
                e2[n3 - 1] = arguments[n3];
            return e2.reduce(function(e3, n4) {
                return e3 + f(t3["border-" + n4 + "-width"])
            }, 0)
        }
        function p(t3) {
            var e2 = t3.clientWidth
              , n3 = t3.clientHeight;
            if (!e2 && !n3)
                return d;
            var r2 = u(t3).getComputedStyle(t3)
              , i2 = function(t4) {
                for (var e3 = {}, n4 = 0, r3 = ["top", "right", "bottom", "left"]; n4 < r3.length; n4++) {
                    var i3 = r3[n4]
                      , o3 = t4["padding-" + i3];
                    e3[i3] = f(o3)
                }
                return e3
            }(r2)
              , o2 = i2.left + i2.right
              , a2 = i2.top + i2.bottom
              , s2 = f(r2.width)
              , c2 = f(r2.height);
            if (r2.boxSizing === "border-box" && (Math.round(s2 + o2) !== e2 && (s2 -= h(r2, "left", "right") + o2),
            Math.round(c2 + a2) !== n3 && (c2 -= h(r2, "top", "bottom") + a2)),
            !function(t4) {
                return t4 === u(t4).document.documentElement
            }(t3)) {
                var l2 = Math.round(s2 + o2) - e2
                  , p2 = Math.round(c2 + a2) - n3;
                Math.abs(l2) !== 1 && (s2 -= l2),
                Math.abs(p2) !== 1 && (c2 -= p2)
            }
            return m(i2.left, i2.top, s2, c2)
        }
        var g = typeof SVGGraphicsElement < "u" ? function(t3) {
            return t3 instanceof u(t3).SVGGraphicsElement
        }
        : function(t3) {
            return t3 instanceof u(t3).SVGElement && typeof t3.getBBox == "function"
        }
        ;
        function v(t3) {
            return r ? g(t3) ? function(t4) {
                var e2 = t4.getBBox();
                return m(0, 0, e2.width, e2.height)
            }(t3) : p(t3) : d
        }
        function m(t3, e2, n3, r2) {
            return {
                x: t3,
                y: e2,
                width: n3,
                height: r2
            }
        }
        var y = function() {
            function t3(t4) {
                this.broadcastWidth = 0,
                this.broadcastHeight = 0,
                this.contentRect_ = m(0, 0, 0, 0),
                this.target = t4
            }
            return t3.prototype.isActive = function() {
                var t4 = v(this.target);
                return this.contentRect_ = t4,
                t4.width !== this.broadcastWidth || t4.height !== this.broadcastHeight
            }
            ,
            t3.prototype.broadcastRect = function() {
                var t4 = this.contentRect_;
                return this.broadcastWidth = t4.width,
                this.broadcastHeight = t4.height,
                t4
            }
            ,
            t3
        }()
          , b = function(t3, e2) {
            var n3, r2, i2, o2, a2, s2, c2, u2 = (r2 = (n3 = e2).x,
            i2 = n3.y,
            o2 = n3.width,
            a2 = n3.height,
            s2 = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object,
            c2 = Object.create(s2.prototype),
            l(c2, {
                x: r2,
                y: i2,
                width: o2,
                height: a2,
                top: i2,
                right: r2 + o2,
                bottom: a2 + i2,
                left: r2
            }),
            c2);
            l(this, {
                target: t3,
                contentRect: u2
            })
        }
          , w = function() {
            function t3(t4, e2, r2) {
                if (this.activeObservations_ = [],
                this.observations_ = new n2,
                typeof t4 != "function")
                    throw new TypeError("The callback provided as parameter 1 is not a function.");
                this.callback_ = t4,
                this.controller_ = e2,
                this.callbackCtx_ = r2
            }
            return t3.prototype.observe = function(t4) {
                if (!arguments.length)
                    throw new TypeError("1 argument required, but only 0 present.");
                if (typeof Element < "u" && Element instanceof Object) {
                    if (!(t4 instanceof u(t4).Element))
                        throw new TypeError('parameter 1 is not of type "Element".');
                    var e2 = this.observations_;
                    e2.has(t4) || (e2.set(t4, new y(t4)),
                    this.controller_.addObserver(this),
                    this.controller_.refresh())
                }
            }
            ,
            t3.prototype.unobserve = function(t4) {
                if (!arguments.length)
                    throw new TypeError("1 argument required, but only 0 present.");
                if (typeof Element < "u" && Element instanceof Object) {
                    if (!(t4 instanceof u(t4).Element))
                        throw new TypeError('parameter 1 is not of type "Element".');
                    var e2 = this.observations_;
                    e2.has(t4) && (e2.delete(t4),
                    e2.size || this.controller_.removeObserver(this))
                }
            }
            ,
            t3.prototype.disconnect = function() {
                this.clearActive(),
                this.observations_.clear(),
                this.controller_.removeObserver(this)
            }
            ,
            t3.prototype.gatherActive = function() {
                var t4 = this;
                this.clearActive(),
                this.observations_.forEach(function(e2) {
                    e2.isActive() && t4.activeObservations_.push(e2)
                })
            }
            ,
            t3.prototype.broadcastActive = function() {
                if (this.hasActive()) {
                    var t4 = this.callbackCtx_
                      , e2 = this.activeObservations_.map(function(t5) {
                        return new b(t5.target,t5.broadcastRect())
                    });
                    this.callback_.call(t4, e2, t4),
                    this.clearActive()
                }
            }
            ,
            t3.prototype.clearActive = function() {
                this.activeObservations_.splice(0)
            }
            ,
            t3.prototype.hasActive = function() {
                return this.activeObservations_.length > 0
            }
            ,
            t3
        }()
          , E = typeof WeakMap < "u" ? new WeakMap : new n2
          , _ = function t3(e2) {
            if (!(this instanceof t3))
                throw new TypeError("Cannot call a class as a function.");
            if (!arguments.length)
                throw new TypeError("1 argument required, but only 0 present.");
            var n3 = c.getInstance()
              , r2 = new w(e2,n3,this);
            E.set(this, r2)
        };
        ["observe", "unobserve", "disconnect"].forEach(function(t3) {
            _.prototype[t3] = function() {
                var e2;
                return (e2 = E.get(this))[t3].apply(e2, arguments)
            }
        });
        var A = i.ResizeObserver !== void 0 ? i.ResizeObserver : _;
        e.a = A
    }
    ).call(this, n(8))
}
, function(t, e, n) {
    var r = n(50);
    t.exports = function(t2, e2) {
        if (t2 == null)
            return {};
        var n2, i, o = r(t2, e2);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(t2);
            for (i = 0; i < a.length; i++)
                n2 = a[i],
                e2.indexOf(n2) >= 0 || Object.prototype.propertyIsEnumerable.call(t2, n2) && (o[n2] = t2[n2])
        }
        return o
    }
}
, function(t, e) {
    var n = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])']
      , r = n.join(",")
      , i = typeof Element > "u" ? function() {}
    : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    function o(t2, e2) {
        e2 = e2 || {};
        var n2, o2, s2, c2 = [], d2 = [], f = t2.querySelectorAll(r);
        for (e2.includeContainer && i.call(t2, r) && (f = Array.prototype.slice.apply(f)).unshift(t2),
        n2 = 0; n2 < f.length; n2++)
            a(o2 = f[n2]) && ((s2 = l(o2)) === 0 ? c2.push(o2) : d2.push({
                documentOrder: n2,
                tabIndex: s2,
                node: o2
            }));
        return d2.sort(u).map(function(t3) {
            return t3.node
        }).concat(c2)
    }
    function a(t2) {
        return !(!s(t2) || function(t3) {
            return function(t4) {
                return d(t4) && t4.type === "radio"
            }(t3) && !function(t4) {
                if (!t4.name)
                    return !0;
                var e2 = function(t5) {
                    for (var e3 = 0; e3 < t5.length; e3++)
                        if (t5[e3].checked)
                            return t5[e3]
                }(t4.ownerDocument.querySelectorAll('input[type="radio"][name="' + t4.name + '"]'));
                return !e2 || e2 === t4
            }(t3)
        }(t2) || l(t2) < 0)
    }
    function s(t2) {
        return !(t2.disabled || function(t3) {
            return d(t3) && t3.type === "hidden"
        }(t2) || function(t3) {
            return t3.offsetParent === null || getComputedStyle(t3).visibility === "hidden"
        }(t2))
    }
    o.isTabbable = function(t2) {
        if (!t2)
            throw new Error("No node provided");
        return i.call(t2, r) !== !1 && a(t2)
    }
    ,
    o.isFocusable = function(t2) {
        if (!t2)
            throw new Error("No node provided");
        return i.call(t2, c) !== !1 && s(t2)
    }
    ;
    var c = n.concat("iframe").join(",");
    function l(t2) {
        var e2 = parseInt(t2.getAttribute("tabindex"), 10);
        return isNaN(e2) ? function(t3) {
            return t3.contentEditable === "true"
        }(t2) ? 0 : t2.tabIndex : e2
    }
    function u(t2, e2) {
        return t2.tabIndex === e2.tabIndex ? t2.documentOrder - e2.documentOrder : t2.tabIndex - e2.tabIndex
    }
    function d(t2) {
        return t2.tagName === "INPUT"
    }
    t.exports = o
}
, function(t, e, n) {
    /*!
* simpleParallax.min - simpleParallax is a simple JavaScript library that gives your website parallax animations on any images or videos,
* @date: 20-08-2020 14:0:14,
* @version: 5.6.2,
* @link: https://simpleparallax.com/
*/
    t.exports = function(t2) {
        var e2 = {};
        function n2(r) {
            if (e2[r])
                return e2[r].exports;
            var i = e2[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return t2[r].call(i.exports, i, i.exports, n2),
            i.l = !0,
            i.exports
        }
        return n2.m = t2,
        n2.c = e2,
        n2.d = function(t3, e3, r) {
            n2.o(t3, e3) || Object.defineProperty(t3, e3, {
                enumerable: !0,
                get: r
            })
        }
        ,
        n2.r = function(t3) {
            typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(t3, Symbol.toStringTag, {
                value: "Module"
            }),
            Object.defineProperty(t3, "__esModule", {
                value: !0
            })
        }
        ,
        n2.t = function(t3, e3) {
            if (1 & e3 && (t3 = n2(t3)),
            8 & e3 || 4 & e3 && typeof t3 == "object" && t3 && t3.__esModule)
                return t3;
            var r = Object.create(null);
            if (n2.r(r),
            Object.defineProperty(r, "default", {
                enumerable: !0,
                value: t3
            }),
            2 & e3 && typeof t3 != "string")
                for (var i in t3)
                    n2.d(r, i, function(e4) {
                        return t3[e4]
                    }
                    .bind(null, i));
            return r
        }
        ,
        n2.n = function(t3) {
            var e3 = t3 && t3.__esModule ? function() {
                return t3.default
            }
            : function() {
                return t3
            }
            ;
            return n2.d(e3, "a", e3),
            e3
        }
        ,
        n2.o = function(t3, e3) {
            return Object.prototype.hasOwnProperty.call(t3, e3)
        }
        ,
        n2.p = "",
        n2(n2.s = 0)
    }([function(t2, e2, n2) {
        "use strict";
        function r(t3, e3) {
            for (var n3 = 0; n3 < e3.length; n3++) {
                var r2 = e3[n3];
                r2.enumerable = r2.enumerable || !1,
                r2.configurable = !0,
                "value"in r2 && (r2.writable = !0),
                Object.defineProperty(t3, r2.key, r2)
            }
        }
        n2.r(e2),
        n2.d(e2, "default", function() {
            return y
        });
        var i = new (function() {
            function t3() {
                (function(t4, e4) {
                    if (!(t4 instanceof e4))
                        throw new TypeError("Cannot call a class as a function")
                }
                )(this, t3),
                this.positions = {
                    top: 0,
                    bottom: 0,
                    height: 0
                }
            }
            var e3, n3;
            return e3 = t3,
            (n3 = [{
                key: "setViewportTop",
                value: function(t4) {
                    return this.positions.top = t4 ? t4.scrollTop : window.pageYOffset,
                    this.positions
                }
            }, {
                key: "setViewportBottom",
                value: function() {
                    return this.positions.bottom = this.positions.top + this.positions.height,
                    this.positions
                }
            }, {
                key: "setViewportAll",
                value: function(t4) {
                    return this.positions.top = t4 ? t4.scrollTop : window.pageYOffset,
                    this.positions.height = t4 ? t4.clientHeight : document.documentElement.clientHeight,
                    this.positions.bottom = this.positions.top + this.positions.height,
                    this.positions
                }
            }]) && r(e3.prototype, n3),
            t3
        }())
          , o = function(t3) {
            return NodeList.prototype.isPrototypeOf(t3) || HTMLCollection.prototype.isPrototypeOf(t3) ? Array.from(t3) : typeof t3 == "string" || t3 instanceof String ? document.querySelectorAll(t3) : [t3]
        }
          , a = function() {
            for (var t3, e3 = "transform webkitTransform mozTransform oTransform msTransform".split(" "), n3 = 0; t3 === void 0; )
                t3 = document.createElement("div").style[e3[n3]] !== void 0 ? e3[n3] : void 0,
                n3 += 1;
            return t3
        }();
        function s(t3, e3) {
            (e3 == null || e3 > t3.length) && (e3 = t3.length);
            for (var n3 = 0, r2 = new Array(e3); n3 < e3; n3++)
                r2[n3] = t3[n3];
            return r2
        }
        function c(t3, e3) {
            for (var n3 = 0; n3 < e3.length; n3++) {
                var r2 = e3[n3];
                r2.enumerable = r2.enumerable || !1,
                r2.configurable = !0,
                "value"in r2 && (r2.writable = !0),
                Object.defineProperty(t3, r2.key, r2)
            }
        }
        var l = function() {
            function t3(e4, n4) {
                var r2 = this;
                (function(t4, e5) {
                    if (!(t4 instanceof e5))
                        throw new TypeError("Cannot call a class as a function")
                }
                )(this, t3),
                this.element = e4,
                this.elementContainer = e4,
                this.settings = n4,
                this.isVisible = !0,
                this.isInit = !1,
                this.oldTranslateValue = -1,
                this.init = this.init.bind(this),
                this.customWrapper = this.settings.customWrapper && this.element.closest(this.settings.customWrapper) ? this.element.closest(this.settings.customWrapper) : null,
                function(t4) {
                    return t4.tagName.toLowerCase() !== "img" && t4.tagName.toLowerCase() !== "picture" || !!t4 && !!t4.complete && (t4.naturalWidth === void 0 || t4.naturalWidth !== 0)
                }(e4) ? this.init() : this.element.addEventListener("load", function() {
                    setTimeout(function() {
                        r2.init(!0)
                    }, 50)
                })
            }
            var e3, n3;
            return e3 = t3,
            (n3 = [{
                key: "init",
                value: function(t4) {
                    var e4 = this;
                    this.isInit || (t4 && (this.rangeMax = null),
                    this.element.closest(".simpleParallax") || (this.settings.overflow === !1 && this.wrapElement(this.element),
                    this.setTransformCSS(),
                    this.getElementOffset(),
                    this.intersectionObserver(),
                    this.getTranslateValue(),
                    this.animate(),
                    this.settings.delay > 0 ? setTimeout(function() {
                        e4.setTransitionCSS(),
                        e4.elementContainer.classList.add("simple-parallax-initialized")
                    }, 10) : this.elementContainer.classList.add("simple-parallax-initialized"),
                    this.isInit = !0))
                }
            }, {
                key: "wrapElement",
                value: function() {
                    var t4 = this.element.closest("picture") || this.element
                      , e4 = this.customWrapper || document.createElement("div");
                    e4.classList.add("simpleParallax"),
                    e4.style.overflow = "hidden",
                    this.customWrapper || (t4.parentNode.insertBefore(e4, t4),
                    e4.appendChild(t4)),
                    this.elementContainer = e4
                }
            }, {
                key: "unWrapElement",
                value: function() {
                    var t4 = this.elementContainer;
                    this.customWrapper ? (t4.classList.remove("simpleParallax"),
                    t4.style.overflow = "") : t4.replaceWith.apply(t4, function(t5) {
                        return function(t6) {
                            if (Array.isArray(t6))
                                return s(t6)
                        }(t5) || function(t6) {
                            if (typeof Symbol < "u" && Symbol.iterator in Object(t6))
                                return Array.from(t6)
                        }(t5) || function(t6, e4) {
                            if (t6) {
                                if (typeof t6 == "string")
                                    return s(t6, e4);
                                var n4 = Object.prototype.toString.call(t6).slice(8, -1);
                                return n4 === "Object" && t6.constructor && (n4 = t6.constructor.name),
                                n4 === "Map" || n4 === "Set" ? Array.from(t6) : n4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n4) ? s(t6, e4) : void 0
                            }
                        }(t5) || function() {
                            throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`)
                        }()
                    }(t4.childNodes))
                }
            }, {
                key: "setTransformCSS",
                value: function() {
                    this.settings.overflow === !1 && (this.element.style[a] = "scale(".concat(this.settings.scale, ")")),
                    this.element.style.willChange = "transform"
                }
            }, {
                key: "setTransitionCSS",
                value: function() {
                    this.element.style.transition = "transform ".concat(this.settings.delay, "s ").concat(this.settings.transition)
                }
            }, {
                key: "unSetStyle",
                value: function() {
                    this.element.style.willChange = "",
                    this.element.style[a] = "",
                    this.element.style.transition = ""
                }
            }, {
                key: "getElementOffset",
                value: function() {
                    var t4 = this.elementContainer.getBoundingClientRect();
                    if (this.elementHeight = t4.height,
                    this.elementTop = t4.top + i.positions.top,
                    this.settings.customContainer) {
                        var e4 = this.settings.customContainer.getBoundingClientRect();
                        this.elementTop = t4.top - e4.top + i.positions.top
                    }
                    this.elementBottom = this.elementHeight + this.elementTop
                }
            }, {
                key: "buildThresholdList",
                value: function() {
                    for (var t4 = [], e4 = 1; e4 <= this.elementHeight; e4++) {
                        var n4 = e4 / this.elementHeight;
                        t4.push(n4)
                    }
                    return t4
                }
            }, {
                key: "intersectionObserver",
                value: function() {
                    var t4 = {
                        root: null,
                        threshold: this.buildThresholdList()
                    };
                    this.observer = new IntersectionObserver(this.intersectionObserverCallback.bind(this),t4),
                    this.observer.observe(this.element)
                }
            }, {
                key: "intersectionObserverCallback",
                value: function(t4) {
                    var e4 = this;
                    t4.forEach(function(t5) {
                        t5.isIntersecting ? e4.isVisible = !0 : e4.isVisible = !1
                    })
                }
            }, {
                key: "checkIfVisible",
                value: function() {
                    return this.elementBottom > i.positions.top && this.elementTop < i.positions.bottom
                }
            }, {
                key: "getRangeMax",
                value: function() {
                    var t4 = this.element.clientHeight;
                    this.rangeMax = t4 * this.settings.scale - t4
                }
            }, {
                key: "getTranslateValue",
                value: function() {
                    var t4 = ((i.positions.bottom - this.elementTop) / ((i.positions.height + this.elementHeight) / 100)).toFixed(1);
                    return t4 = Math.min(100, Math.max(0, t4)),
                    this.settings.maxTransition !== 0 && t4 > this.settings.maxTransition && (t4 = this.settings.maxTransition),
                    this.oldPercentage !== t4 && (this.rangeMax || this.getRangeMax(),
                    this.translateValue = (t4 / 100 * this.rangeMax - this.rangeMax / 2).toFixed(0),
                    this.oldTranslateValue !== this.translateValue && (this.oldPercentage = t4,
                    this.oldTranslateValue = this.translateValue,
                    !0))
                }
            }, {
                key: "animate",
                value: function() {
                    var t4, e4 = 0, n4 = 0;
                    (this.settings.orientation.includes("left") || this.settings.orientation.includes("right")) && (n4 = "".concat(this.settings.orientation.includes("left") ? -1 * this.translateValue : this.translateValue, "px")),
                    (this.settings.orientation.includes("up") || this.settings.orientation.includes("down")) && (e4 = "".concat(this.settings.orientation.includes("up") ? -1 * this.translateValue : this.translateValue, "px")),
                    t4 = this.settings.overflow === !1 ? "translate3d(".concat(n4, ", ").concat(e4, ", 0) scale(").concat(this.settings.scale, ")") : "translate3d(".concat(n4, ", ").concat(e4, ", 0)"),
                    this.element.style[a] = t4
                }
            }]) && c(e3.prototype, n3),
            t3
        }();
        function u(t3) {
            return function(t4) {
                if (Array.isArray(t4))
                    return f(t4)
            }(t3) || function(t4) {
                if (typeof Symbol < "u" && Symbol.iterator in Object(t4))
                    return Array.from(t4)
            }(t3) || d(t3) || function() {
                throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`)
            }()
        }
        function d(t3, e3) {
            if (t3) {
                if (typeof t3 == "string")
                    return f(t3, e3);
                var n3 = Object.prototype.toString.call(t3).slice(8, -1);
                return n3 === "Object" && t3.constructor && (n3 = t3.constructor.name),
                n3 === "Map" || n3 === "Set" ? Array.from(t3) : n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3) ? f(t3, e3) : void 0
            }
        }
        function f(t3, e3) {
            (e3 == null || e3 > t3.length) && (e3 = t3.length);
            for (var n3 = 0, r2 = new Array(e3); n3 < e3; n3++)
                r2[n3] = t3[n3];
            return r2
        }
        function h(t3, e3) {
            for (var n3 = 0; n3 < e3.length; n3++) {
                var r2 = e3[n3];
                r2.enumerable = r2.enumerable || !1,
                r2.configurable = !0,
                "value"in r2 && (r2.writable = !0),
                Object.defineProperty(t3, r2.key, r2)
            }
        }
        var p, g, v = !1, m = [], y = function() {
            function t3(e4, n4) {
                if (function(t4, e5) {
                    if (!(t4 instanceof e5))
                        throw new TypeError("Cannot call a class as a function")
                }(this, t3),
                e4 && Element.prototype.closest && "IntersectionObserver"in window) {
                    if (this.elements = o(e4),
                    this.defaults = {
                        delay: 0,
                        orientation: "up",
                        scale: 1.3,
                        overflow: !1,
                        transition: "cubic-bezier(0,0,0,1)",
                        customContainer: "",
                        customWrapper: "",
                        maxTransition: 0
                    },
                    this.settings = Object.assign(this.defaults, n4),
                    this.settings.customContainer) {
                        var r2 = function(t4, e5) {
                            return function(t5) {
                                if (Array.isArray(t5))
                                    return t5
                            }(t4) || function(t5, e6) {
                                if (typeof Symbol < "u" && Symbol.iterator in Object(t5)) {
                                    var n5 = []
                                      , r3 = !0
                                      , i2 = !1
                                      , o2 = void 0;
                                    try {
                                        for (var a2, s2 = t5[Symbol.iterator](); !(r3 = (a2 = s2.next()).done) && (n5.push(a2.value),
                                        !e6 || n5.length !== e6); r3 = !0)
                                            ;
                                    } catch (t6) {
                                        i2 = !0,
                                        o2 = t6
                                    } finally {
                                        try {
                                            r3 || s2.return == null || s2.return()
                                        } finally {
                                            if (i2)
                                                throw o2
                                        }
                                    }
                                    return n5
                                }
                            }(t4, e5) || d(t4, e5) || function() {
                                throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`)
                            }()
                        }(o(this.settings.customContainer), 1);
                        this.customContainer = r2[0]
                    }
                    this.lastPosition = -1,
                    this.resizeIsDone = this.resizeIsDone.bind(this),
                    this.refresh = this.refresh.bind(this),
                    this.proceedRequestAnimationFrame = this.proceedRequestAnimationFrame.bind(this),
                    this.init()
                }
            }
            var e3, n3;
            return e3 = t3,
            (n3 = [{
                key: "init",
                value: function() {
                    var t4 = this;
                    i.setViewportAll(this.customContainer),
                    m = [].concat(u(this.elements.map(function(e4) {
                        return new l(e4,t4.settings)
                    })), u(m)),
                    v || (this.proceedRequestAnimationFrame(),
                    window.addEventListener("resize", this.resizeIsDone),
                    v = !0)
                }
            }, {
                key: "resizeIsDone",
                value: function() {
                    clearTimeout(g),
                    g = setTimeout(this.refresh, 200)
                }
            }, {
                key: "proceedRequestAnimationFrame",
                value: function() {
                    var t4 = this;
                    i.setViewportTop(this.customContainer),
                    this.lastPosition !== i.positions.top ? (i.setViewportBottom(),
                    m.forEach(function(e4) {
                        t4.proceedElement(e4)
                    }),
                    p = window.requestAnimationFrame(this.proceedRequestAnimationFrame),
                    this.lastPosition = i.positions.top) : p = window.requestAnimationFrame(this.proceedRequestAnimationFrame)
                }
            }, {
                key: "proceedElement",
                value: function(t4) {
                    (this.customContainer ? t4.checkIfVisible() : t4.isVisible) && t4.getTranslateValue() && t4.animate()
                }
            }, {
                key: "refresh",
                value: function() {
                    i.setViewportAll(this.customContainer),
                    m.forEach(function(t4) {
                        t4.getElementOffset(),
                        t4.getRangeMax()
                    }),
                    this.lastPosition = -1
                }
            }, {
                key: "destroy",
                value: function() {
                    var t4 = this
                      , e4 = [];
                    m = m.filter(function(n4) {
                        return t4.elements.includes(n4.element) ? (e4.push(n4),
                        !1) : n4
                    }),
                    e4.forEach(function(e5) {
                        e5.unSetStyle(),
                        t4.settings.overflow === !1 && e5.unWrapElement()
                    }),
                    m.length || (window.cancelAnimationFrame(p),
                    window.removeEventListener("resize", this.refresh),
                    v = !1)
                }
            }]) && h(e3.prototype, n3),
            t3
        }()
    }
    ]).default
}
, function(t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", {
        value: !0
    });
    var r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t2) {
        return typeof t2
    }
    : function(t2) {
        return t2 && typeof Symbol == "function" && t2.constructor === Symbol && t2 !== Symbol.prototype ? "symbol" : typeof t2
    }
      , i = s(n(51))
      , o = s(n(52))
      , a = s(n(54));
    function s(t2) {
        return t2 && t2.__esModule ? t2 : {
            default: t2
        }
    }
    var c = void 0;
    e.default = function(t2) {
        var e2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}
          , n2 = arguments.length > 2 && arguments[2] !== void 0 && arguments[2]
          , s2 = (0,
        i.default)();
        if (c || (c = (0,
        o.default)(s2)),
        e2.events)
            throw new Error("Event handlers cannot be overwritten.");
        if (typeof t2 == "string" && !document.getElementById(t2))
            throw new Error('Element "' + t2 + '" does not exist.');
        e2.events = a.default.proxyEvents(s2);
        var l = new Promise(function(n3) {
            (t2 === void 0 ? "undefined" : r(t2)) === "object" && t2.playVideo instanceof Function ? n3(t2) : c.then(function(r2) {
                var i2 = new r2.Player(t2,e2);
                return s2.on("ready", function() {
                    n3(i2)
                }),
                null
            })
        }
        )
          , u = a.default.promisifyPlayer(l, n2);
        return u.on = s2.on,
        u.off = s2.off,
        u
    }
    ,
    t.exports = e.default
}
, function(t, e, n) {
    "use strict";
    (function(t2, n2) {
        /*! @vimeo/player v2.13.0 | (c) 2020 Vimeo | MIT License | https://github.com/vimeo/player.js */
        function r(t3, e2) {
            if (!(t3 instanceof e2))
                throw new TypeError("Cannot call a class as a function")
        }
        function i(t3, e2) {
            for (var n3 = 0; n3 < e2.length; n3++) {
                var r2 = e2[n3];
                r2.enumerable = r2.enumerable || !1,
                r2.configurable = !0,
                "value"in r2 && (r2.writable = !0),
                Object.defineProperty(t3, r2.key, r2)
            }
        }
        var o = t2 !== void 0 && {}.toString.call(t2) === "[object global]";
        function a(t3, e2) {
            return t3.indexOf(e2.toLowerCase()) === 0 ? t3 : "".concat(e2.toLowerCase()).concat(t3.substr(0, 1).toUpperCase()).concat(t3.substr(1))
        }
        function s(t3) {
            return !!(t3 && t3.nodeType === 1 && "nodeName"in t3 && t3.ownerDocument && t3.ownerDocument.defaultView)
        }
        function c(t3) {
            return !isNaN(parseFloat(t3)) && isFinite(t3) && Math.floor(t3) == t3
        }
        function l(t3) {
            return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(t3)
        }
        function u() {
            var t3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}
              , e2 = t3.id
              , n3 = t3.url
              , r2 = e2 || n3;
            if (!r2)
                throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
            if (c(r2))
                return "https://vimeo.com/".concat(r2);
            if (l(r2))
                return r2.replace("http:", "https:");
            throw e2 ? new TypeError("\u201C".concat(e2, "\u201D is not a valid video id.")) : new TypeError("\u201C".concat(r2, "\u201D is not a vimeo.com url."))
        }
        var d = Array.prototype.indexOf !== void 0
          , f = typeof window < "u" && window.postMessage !== void 0;
        if (!(o || d && f))
            throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
        var h = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : t2 !== void 0 ? t2 : typeof self < "u" ? self : {};
        /*!
* weakmap-polyfill v2.0.1 - ECMAScript6 WeakMap polyfill
* https://github.com/polygonplanet/weakmap-polyfill
* Copyright (c) 2015-2020 Polygon Planet <polygon.planet.aqua@gmail.com>
* @license MIT
*/
        (function(t3) {
            if (!t3.WeakMap) {
                var e2 = Object.prototype.hasOwnProperty
                  , n3 = function(t4, e3, n4) {
                    Object.defineProperty ? Object.defineProperty(t4, e3, {
                        configurable: !0,
                        writable: !0,
                        value: n4
                    }) : t4[e3] = n4
                };
                t3.WeakMap = function() {
                    function t4() {
                        if (this === void 0)
                            throw new TypeError("Constructor WeakMap requires 'new'");
                        if (n3(this, "_id", o2("_WeakMap")),
                        arguments.length > 0)
                            throw new TypeError("WeakMap iterable is not supported")
                    }
                    function i2(t5, n4) {
                        if (!r2(t5) || !e2.call(t5, "_id"))
                            throw new TypeError(n4 + " method called on incompatible receiver " + typeof t5)
                    }
                    function o2(t5) {
                        return t5 + "_" + a2() + "." + a2()
                    }
                    function a2() {
                        return Math.random().toString().substring(2)
                    }
                    return n3(t4.prototype, "delete", function(t5) {
                        if (i2(this, "delete"),
                        !r2(t5))
                            return !1;
                        var e3 = t5[this._id];
                        return !(!e3 || e3[0] !== t5) && (delete t5[this._id],
                        !0)
                    }),
                    n3(t4.prototype, "get", function(t5) {
                        if (i2(this, "get"),
                        r2(t5)) {
                            var e3 = t5[this._id];
                            return e3 && e3[0] === t5 ? e3[1] : void 0
                        }
                    }),
                    n3(t4.prototype, "has", function(t5) {
                        if (i2(this, "has"),
                        !r2(t5))
                            return !1;
                        var e3 = t5[this._id];
                        return !(!e3 || e3[0] !== t5)
                    }),
                    n3(t4.prototype, "set", function(t5, e3) {
                        if (i2(this, "set"),
                        !r2(t5))
                            throw new TypeError("Invalid value used as weak map key");
                        var o3 = t5[this._id];
                        return o3 && o3[0] === t5 ? (o3[1] = e3,
                        this) : (n3(t5, this._id, [t5, e3]),
                        this)
                    }),
                    n3(t4, "_polyfill", !0),
                    t4
                }()
            }
            function r2(t4) {
                return Object(t4) === t4
            }
        }
        )(typeof self < "u" ? self : typeof window < "u" ? window : h);
        var p = function(t3, e2) {
            return t3(e2 = {
                exports: {}
            }, e2.exports),
            e2.exports
        }(function(t3) {
            /*! Native Promise Only
v0.8.1 (c) Kyle Simpson
MIT License: http://getify.mit-license.org
*/
            var e2, r2, i2;
            i2 = function() {
                var t4, e3, r3, i3 = Object.prototype.toString, o2 = n2 !== void 0 ? function(t5) {
                    return n2(t5)
                }
                : setTimeout;
                try {
                    Object.defineProperty({}, "x", {}),
                    t4 = function(t5, e4, n3, r4) {
                        return Object.defineProperty(t5, e4, {
                            value: n3,
                            writable: !0,
                            configurable: r4 !== !1
                        })
                    }
                } catch {
                    t4 = function(t5, e5, n3) {
                        return t5[e5] = n3,
                        t5
                    }
                }
                function a2(t5, n3) {
                    r3.add(t5, n3),
                    e3 || (e3 = o2(r3.drain))
                }
                function s2(t5) {
                    var e4, n3 = typeof t5;
                    return t5 == null || n3 != "object" && n3 != "function" || (e4 = t5.then),
                    typeof e4 == "function" && e4
                }
                function c2() {
                    for (var t5 = 0; t5 < this.chain.length; t5++)
                        l2(this, this.state === 1 ? this.chain[t5].success : this.chain[t5].failure, this.chain[t5]);
                    this.chain.length = 0
                }
                function l2(t5, e4, n3) {
                    var r4, i4;
                    try {
                        e4 === !1 ? n3.reject(t5.msg) : (r4 = e4 === !0 ? t5.msg : e4.call(void 0, t5.msg)) === n3.promise ? n3.reject(TypeError("Promise-chain cycle")) : (i4 = s2(r4)) ? i4.call(r4, n3.resolve, n3.reject) : n3.resolve(r4)
                    } catch (t6) {
                        n3.reject(t6)
                    }
                }
                function u2(t5) {
                    var e4, n3 = this;
                    if (!n3.triggered) {
                        n3.triggered = !0,
                        n3.def && (n3 = n3.def);
                        try {
                            (e4 = s2(t5)) ? a2(function() {
                                var r4 = new h2(n3);
                                try {
                                    e4.call(t5, function() {
                                        u2.apply(r4, arguments)
                                    }, function() {
                                        d2.apply(r4, arguments)
                                    })
                                } catch (t6) {
                                    d2.call(r4, t6)
                                }
                            }) : (n3.msg = t5,
                            n3.state = 1,
                            n3.chain.length > 0 && a2(c2, n3))
                        } catch (t6) {
                            d2.call(new h2(n3), t6)
                        }
                    }
                }
                function d2(t5) {
                    var e4 = this;
                    e4.triggered || (e4.triggered = !0,
                    e4.def && (e4 = e4.def),
                    e4.msg = t5,
                    e4.state = 2,
                    e4.chain.length > 0 && a2(c2, e4))
                }
                function f2(t5, e4, n3, r4) {
                    for (var i4 = 0; i4 < e4.length; i4++)
                        (function(i5) {
                            t5.resolve(e4[i5]).then(function(t6) {
                                n3(i5, t6)
                            }, r4)
                        }
                        )(i4)
                }
                function h2(t5) {
                    this.def = t5,
                    this.triggered = !1
                }
                function p2(t5) {
                    this.promise = t5,
                    this.state = 0,
                    this.triggered = !1,
                    this.chain = [],
                    this.msg = void 0
                }
                function g2(t5) {
                    if (typeof t5 != "function")
                        throw TypeError("Not a function");
                    if (this.__NPO__ !== 0)
                        throw TypeError("Not a promise");
                    this.__NPO__ = 1;
                    var e4 = new p2(this);
                    this.then = function(t6, n3) {
                        var r4 = {
                            success: typeof t6 != "function" || t6,
                            failure: typeof n3 == "function" && n3
                        };
                        return r4.promise = new this.constructor(function(t7, e5) {
                            if (typeof t7 != "function" || typeof e5 != "function")
                                throw TypeError("Not a function");
                            r4.resolve = t7,
                            r4.reject = e5
                        }
                        ),
                        e4.chain.push(r4),
                        e4.state !== 0 && a2(c2, e4),
                        r4.promise
                    }
                    ,
                    this.catch = function(t6) {
                        return this.then(void 0, t6)
                    }
                    ;
                    try {
                        t5.call(void 0, function(t6) {
                            u2.call(e4, t6)
                        }, function(t6) {
                            d2.call(e4, t6)
                        })
                    } catch (t6) {
                        d2.call(e4, t6)
                    }
                }
                r3 = function() {
                    var t5, n3, r4;
                    function i4(t6, e4) {
                        this.fn = t6,
                        this.self = e4,
                        this.next = void 0
                    }
                    return {
                        add: function(e4, o3) {
                            r4 = new i4(e4,o3),
                            n3 ? n3.next = r4 : t5 = r4,
                            n3 = r4,
                            r4 = void 0
                        },
                        drain: function() {
                            var r5 = t5;
                            for (t5 = n3 = e3 = void 0; r5; )
                                r5.fn.call(r5.self),
                                r5 = r5.next
                        }
                    }
                }();
                var v2 = t4({}, "constructor", g2, !1);
                return g2.prototype = v2,
                t4(v2, "__NPO__", 0, !1),
                t4(g2, "resolve", function(t5) {
                    return t5 && typeof t5 == "object" && t5.__NPO__ === 1 ? t5 : new this(function(e4, n3) {
                        if (typeof e4 != "function" || typeof n3 != "function")
                            throw TypeError("Not a function");
                        e4(t5)
                    }
                    )
                }),
                t4(g2, "reject", function(t5) {
                    return new this(function(e4, n3) {
                        if (typeof e4 != "function" || typeof n3 != "function")
                            throw TypeError("Not a function");
                        n3(t5)
                    }
                    )
                }),
                t4(g2, "all", function(t5) {
                    var e4 = this;
                    return i3.call(t5) != "[object Array]" ? e4.reject(TypeError("Not an array")) : t5.length === 0 ? e4.resolve([]) : new e4(function(n3, r4) {
                        if (typeof n3 != "function" || typeof r4 != "function")
                            throw TypeError("Not a function");
                        var i4 = t5.length
                          , o3 = Array(i4)
                          , a3 = 0;
                        f2(e4, t5, function(t6, e5) {
                            o3[t6] = e5,
                            ++a3 === i4 && n3(o3)
                        }, r4)
                    }
                    )
                }),
                t4(g2, "race", function(t5) {
                    var e4 = this;
                    return i3.call(t5) != "[object Array]" ? e4.reject(TypeError("Not an array")) : new e4(function(n3, r4) {
                        if (typeof n3 != "function" || typeof r4 != "function")
                            throw TypeError("Not a function");
                        f2(e4, t5, function(t6, e5) {
                            n3(e5)
                        }, r4)
                    }
                    )
                }),
                g2
            }
            ,
            (r2 = h)[e2 = "Promise"] = r2[e2] || i2(),
            t3.exports && (t3.exports = r2[e2])
        })
          , g = new WeakMap;
        function v(t3, e2, n3) {
            var r2 = g.get(t3.element) || {};
            e2 in r2 || (r2[e2] = []),
            r2[e2].push(n3),
            g.set(t3.element, r2)
        }
        function m(t3, e2) {
            return (g.get(t3.element) || {})[e2] || []
        }
        function y(t3, e2, n3) {
            var r2 = g.get(t3.element) || {};
            if (!r2[e2])
                return !0;
            if (!n3)
                return r2[e2] = [],
                g.set(t3.element, r2),
                !0;
            var i2 = r2[e2].indexOf(n3);
            return i2 !== -1 && r2[e2].splice(i2, 1),
            g.set(t3.element, r2),
            r2[e2] && r2[e2].length === 0
        }
        function b(t3, e2) {
            var n3 = g.get(t3);
            g.set(e2, n3),
            g.delete(t3)
        }
        var w = ["autopause", "autoplay", "background", "byline", "color", "controls", "dnt", "height", "id", "loop", "maxheight", "maxwidth", "muted", "playsinline", "portrait", "responsive", "speed", "texttrack", "title", "transparent", "url", "width"];
        function E(t3) {
            var e2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return w.reduce(function(e3, n3) {
                var r2 = t3.getAttribute("data-vimeo-".concat(n3));
                return (r2 || r2 === "") && (e3[n3] = r2 === "" ? 1 : r2),
                e3
            }, e2)
        }
        function _(t3, e2) {
            var n3 = t3.html;
            if (!e2)
                throw new TypeError("An element must be provided");
            if (e2.getAttribute("data-vimeo-initialized") !== null)
                return e2.querySelector("iframe");
            var r2 = document.createElement("div");
            return r2.innerHTML = n3,
            e2.appendChild(r2.firstChild),
            e2.setAttribute("data-vimeo-initialized", "true"),
            e2.querySelector("iframe")
        }
        function A(t3) {
            var e2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}
              , n3 = arguments.length > 2 ? arguments[2] : void 0;
            return new Promise(function(r2, i2) {
                if (!l(t3))
                    throw new TypeError("\u201C".concat(t3, "\u201D is not a vimeo.com url."));
                var o2 = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(t3));
                for (var a2 in e2)
                    e2.hasOwnProperty(a2) && (o2 += "&".concat(a2, "=").concat(encodeURIComponent(e2[a2])));
                var s2 = "XDomainRequest"in window ? new XDomainRequest : new XMLHttpRequest;
                s2.open("GET", o2, !0),
                s2.onload = function() {
                    if (s2.status !== 404)
                        if (s2.status !== 403)
                            try {
                                var e3 = JSON.parse(s2.responseText);
                                if (e3.domain_status_code === 403)
                                    return _(e3, n3),
                                    void i2(new Error("\u201C".concat(t3, "\u201D is not embeddable.")));
                                r2(e3)
                            } catch (t4) {
                                i2(t4)
                            }
                        else
                            i2(new Error("\u201C".concat(t3, "\u201D is not embeddable.")));
                    else
                        i2(new Error("\u201C".concat(t3, "\u201D was not found.")))
                }
                ,
                s2.onerror = function() {
                    var t4 = s2.status ? " (".concat(s2.status, ")") : "";
                    i2(new Error("There was an error fetching the embed code from Vimeo".concat(t4, ".")))
                }
                ,
                s2.send()
            }
            )
        }
        function k(t3) {
            if (typeof t3 == "string")
                try {
                    t3 = JSON.parse(t3)
                } catch (t4) {
                    return console.warn(t4),
                    {}
                }
            return t3
        }
        function T(t3, e2, n3) {
            if (t3.element.contentWindow && t3.element.contentWindow.postMessage) {
                var r2 = {
                    method: e2
                };
                n3 !== void 0 && (r2.value = n3);
                var i2 = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
                i2 >= 8 && i2 < 10 && (r2 = JSON.stringify(r2)),
                t3.element.contentWindow.postMessage(r2, t3.origin)
            }
        }
        function S(t3, e2) {
            var n3, r2 = [];
            if ((e2 = k(e2)).event)
                e2.event === "error" && m(t3, e2.data.method).forEach(function(n4) {
                    var r3 = new Error(e2.data.message);
                    r3.name = e2.data.name,
                    n4.reject(r3),
                    y(t3, e2.data.method, n4)
                }),
                r2 = m(t3, "event:".concat(e2.event)),
                n3 = e2.data;
            else if (e2.method) {
                var i2 = function(t4, e3) {
                    var n4 = m(t4, e3);
                    if (n4.length < 1)
                        return !1;
                    var r3 = n4.shift();
                    return y(t4, e3, r3),
                    r3
                }(t3, e2.method);
                i2 && (r2.push(i2),
                n3 = e2.value)
            }
            r2.forEach(function(e3) {
                try {
                    if (typeof e3 == "function")
                        return void e3.call(t3, n3);
                    e3.resolve(n3)
                } catch {}
            })
        }
        var x = new WeakMap
          , C = new WeakMap
          , O = {}
          , L = function() {
            function t3(e3) {
                var n4 = this
                  , i2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (r(this, t3),
                window.jQuery && e3 instanceof jQuery && (e3.length > 1 && window.console && console.warn && console.warn("A jQuery object with multiple elements was passed, using the first element."),
                e3 = e3[0]),
                typeof document < "u" && typeof e3 == "string" && (e3 = document.getElementById(e3)),
                !s(e3))
                    throw new TypeError("You must pass either a valid element or a valid id.");
                if (e3.nodeName !== "IFRAME") {
                    var o3 = e3.querySelector("iframe");
                    o3 && (e3 = o3)
                }
                if (e3.nodeName === "IFRAME" && !l(e3.getAttribute("src") || ""))
                    throw new Error("The player element passed isn\u2019t a Vimeo embed.");
                if (x.has(e3))
                    return x.get(e3);
                this._window = e3.ownerDocument.defaultView,
                this.element = e3,
                this.origin = "*";
                var a2 = new p(function(t4, r2) {
                    if (n4._onMessage = function(e4) {
                        if (l(e4.origin) && n4.element.contentWindow === e4.source) {
                            n4.origin === "*" && (n4.origin = e4.origin);
                            var i3 = k(e4.data);
                            if (i3 && i3.event === "error" && i3.data && i3.data.method === "ready") {
                                var o5 = new Error(i3.data.message);
                                return o5.name = i3.data.name,
                                void r2(o5)
                            }
                            var a3 = i3 && i3.event === "ready"
                              , s2 = i3 && i3.method === "ping";
                            if (a3 || s2)
                                return n4.element.setAttribute("data-ready", "true"),
                                void t4();
                            S(n4, i3)
                        }
                    }
                    ,
                    n4._window.addEventListener("message", n4._onMessage),
                    n4.element.nodeName !== "IFRAME") {
                        var o4 = E(e3, i2);
                        A(u(o4), o4, e3).then(function(t5) {
                            var r3 = _(t5, e3);
                            return n4.element = r3,
                            n4._originalElement = e3,
                            b(e3, r3),
                            x.set(n4.element, n4),
                            t5
                        }).catch(r2)
                    }
                }
                );
                if (C.set(this, a2),
                x.set(this.element, this),
                this.element.nodeName === "IFRAME" && T(this, "ping"),
                O.isEnabled) {
                    var c2 = function() {
                        return O.exit()
                    };
                    O.on("fullscreenchange", function() {
                        O.isFullscreen ? v(n4, "event:exitFullscreen", c2) : y(n4, "event:exitFullscreen", c2),
                        n4.ready().then(function() {
                            T(n4, "fullscreenchange", O.isFullscreen)
                        })
                    })
                }
                return this
            }
            var e2, n3, o2;
            return e2 = t3,
            (n3 = [{
                key: "callMethod",
                value: function(t4) {
                    var e3 = this
                      , n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    return new p(function(r2, i2) {
                        return e3.ready().then(function() {
                            v(e3, t4, {
                                resolve: r2,
                                reject: i2
                            }),
                            T(e3, t4, n4)
                        }).catch(i2)
                    }
                    )
                }
            }, {
                key: "get",
                value: function(t4) {
                    var e3 = this;
                    return new p(function(n4, r2) {
                        return t4 = a(t4, "get"),
                        e3.ready().then(function() {
                            v(e3, t4, {
                                resolve: n4,
                                reject: r2
                            }),
                            T(e3, t4)
                        }).catch(r2)
                    }
                    )
                }
            }, {
                key: "set",
                value: function(t4, e3) {
                    var n4 = this;
                    return new p(function(r2, i2) {
                        if (t4 = a(t4, "set"),
                        e3 == null)
                            throw new TypeError("There must be a value to set.");
                        return n4.ready().then(function() {
                            v(n4, t4, {
                                resolve: r2,
                                reject: i2
                            }),
                            T(n4, t4, e3)
                        }).catch(i2)
                    }
                    )
                }
            }, {
                key: "on",
                value: function(t4, e3) {
                    if (!t4)
                        throw new TypeError("You must pass an event name.");
                    if (!e3)
                        throw new TypeError("You must pass a callback function.");
                    if (typeof e3 != "function")
                        throw new TypeError("The callback must be a function.");
                    m(this, "event:".concat(t4)).length === 0 && this.callMethod("addEventListener", t4).catch(function() {}),
                    v(this, "event:".concat(t4), e3)
                }
            }, {
                key: "off",
                value: function(t4, e3) {
                    if (!t4)
                        throw new TypeError("You must pass an event name.");
                    if (e3 && typeof e3 != "function")
                        throw new TypeError("The callback must be a function.");
                    y(this, "event:".concat(t4), e3) && this.callMethod("removeEventListener", t4).catch(function(t5) {})
                }
            }, {
                key: "loadVideo",
                value: function(t4) {
                    return this.callMethod("loadVideo", t4)
                }
            }, {
                key: "ready",
                value: function() {
                    var t4 = C.get(this) || new p(function(t5, e3) {
                        e3(new Error("Unknown player. Probably unloaded."))
                    }
                    );
                    return p.resolve(t4)
                }
            }, {
                key: "addCuePoint",
                value: function(t4) {
                    var e3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    return this.callMethod("addCuePoint", {
                        time: t4,
                        data: e3
                    })
                }
            }, {
                key: "removeCuePoint",
                value: function(t4) {
                    return this.callMethod("removeCuePoint", t4)
                }
            }, {
                key: "enableTextTrack",
                value: function(t4, e3) {
                    if (!t4)
                        throw new TypeError("You must pass a language.");
                    return this.callMethod("enableTextTrack", {
                        language: t4,
                        kind: e3
                    })
                }
            }, {
                key: "disableTextTrack",
                value: function() {
                    return this.callMethod("disableTextTrack")
                }
            }, {
                key: "pause",
                value: function() {
                    return this.callMethod("pause")
                }
            }, {
                key: "play",
                value: function() {
                    return this.callMethod("play")
                }
            }, {
                key: "requestFullscreen",
                value: function() {
                    return O.isEnabled ? O.request(this.element) : this.callMethod("requestFullscreen")
                }
            }, {
                key: "exitFullscreen",
                value: function() {
                    return O.isEnabled ? O.exit() : this.callMethod("exitFullscreen")
                }
            }, {
                key: "getFullscreen",
                value: function() {
                    return O.isEnabled ? p.resolve(O.isFullscreen) : this.get("fullscreen")
                }
            }, {
                key: "unload",
                value: function() {
                    return this.callMethod("unload")
                }
            }, {
                key: "destroy",
                value: function() {
                    var t4 = this;
                    return new p(function(e3) {
                        C.delete(t4),
                        x.delete(t4.element),
                        t4._originalElement && (x.delete(t4._originalElement),
                        t4._originalElement.removeAttribute("data-vimeo-initialized")),
                        t4.element && t4.element.nodeName === "IFRAME" && t4.element.parentNode && t4.element.parentNode.removeChild(t4.element),
                        t4._window.removeEventListener("message", t4._onMessage),
                        e3()
                    }
                    )
                }
            }, {
                key: "getAutopause",
                value: function() {
                    return this.get("autopause")
                }
            }, {
                key: "setAutopause",
                value: function(t4) {
                    return this.set("autopause", t4)
                }
            }, {
                key: "getBuffered",
                value: function() {
                    return this.get("buffered")
                }
            }, {
                key: "getChapters",
                value: function() {
                    return this.get("chapters")
                }
            }, {
                key: "getCurrentChapter",
                value: function() {
                    return this.get("currentChapter")
                }
            }, {
                key: "getColor",
                value: function() {
                    return this.get("color")
                }
            }, {
                key: "setColor",
                value: function(t4) {
                    return this.set("color", t4)
                }
            }, {
                key: "getCuePoints",
                value: function() {
                    return this.get("cuePoints")
                }
            }, {
                key: "getCurrentTime",
                value: function() {
                    return this.get("currentTime")
                }
            }, {
                key: "setCurrentTime",
                value: function(t4) {
                    return this.set("currentTime", t4)
                }
            }, {
                key: "getDuration",
                value: function() {
                    return this.get("duration")
                }
            }, {
                key: "getEnded",
                value: function() {
                    return this.get("ended")
                }
            }, {
                key: "getLoop",
                value: function() {
                    return this.get("loop")
                }
            }, {
                key: "setLoop",
                value: function(t4) {
                    return this.set("loop", t4)
                }
            }, {
                key: "setMuted",
                value: function(t4) {
                    return this.set("muted", t4)
                }
            }, {
                key: "getMuted",
                value: function() {
                    return this.get("muted")
                }
            }, {
                key: "getPaused",
                value: function() {
                    return this.get("paused")
                }
            }, {
                key: "getPlaybackRate",
                value: function() {
                    return this.get("playbackRate")
                }
            }, {
                key: "setPlaybackRate",
                value: function(t4) {
                    return this.set("playbackRate", t4)
                }
            }, {
                key: "getPlayed",
                value: function() {
                    return this.get("played")
                }
            }, {
                key: "getQualities",
                value: function() {
                    return this.get("qualities")
                }
            }, {
                key: "getQuality",
                value: function() {
                    return this.get("quality")
                }
            }, {
                key: "setQuality",
                value: function(t4) {
                    return this.set("quality", t4)
                }
            }, {
                key: "getSeekable",
                value: function() {
                    return this.get("seekable")
                }
            }, {
                key: "getSeeking",
                value: function() {
                    return this.get("seeking")
                }
            }, {
                key: "getTextTracks",
                value: function() {
                    return this.get("textTracks")
                }
            }, {
                key: "getVideoEmbedCode",
                value: function() {
                    return this.get("videoEmbedCode")
                }
            }, {
                key: "getVideoId",
                value: function() {
                    return this.get("videoId")
                }
            }, {
                key: "getVideoTitle",
                value: function() {
                    return this.get("videoTitle")
                }
            }, {
                key: "getVideoWidth",
                value: function() {
                    return this.get("videoWidth")
                }
            }, {
                key: "getVideoHeight",
                value: function() {
                    return this.get("videoHeight")
                }
            }, {
                key: "getVideoUrl",
                value: function() {
                    return this.get("videoUrl")
                }
            }, {
                key: "getVolume",
                value: function() {
                    return this.get("volume")
                }
            }, {
                key: "setVolume",
                value: function(t4) {
                    return this.set("volume", t4)
                }
            }]) && i(e2.prototype, n3),
            o2 && i(e2, o2),
            t3
        }();
        o || (O = function() {
            var t3 = function() {
                for (var t4, e3 = [["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"], ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"], ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"], ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"], ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]], n4 = 0, r2 = e3.length, i2 = {}; n4 < r2; n4++)
                    if ((t4 = e3[n4]) && t4[1]in document) {
                        for (n4 = 0; n4 < t4.length; n4++)
                            i2[e3[0][n4]] = t4[n4];
                        return i2
                    }
                return !1
            }()
              , e2 = {
                fullscreenchange: t3.fullscreenchange,
                fullscreenerror: t3.fullscreenerror
            }
              , n3 = {
                request: function(e3) {
                    return new Promise(function(r2, i2) {
                        var o2 = function t4() {
                            n3.off("fullscreenchange", t4),
                            r2()
                        };
                        n3.on("fullscreenchange", o2);
                        var a2 = (e3 = e3 || document.documentElement)[t3.requestFullscreen]();
                        a2 instanceof Promise && a2.then(o2).catch(i2)
                    }
                    )
                },
                exit: function() {
                    return new Promise(function(e3, r2) {
                        if (n3.isFullscreen) {
                            var i2 = function t4() {
                                n3.off("fullscreenchange", t4),
                                e3()
                            };
                            n3.on("fullscreenchange", i2);
                            var o2 = document[t3.exitFullscreen]();
                            o2 instanceof Promise && o2.then(i2).catch(r2)
                        } else
                            e3()
                    }
                    )
                },
                on: function(t4, n4) {
                    var r2 = e2[t4];
                    r2 && document.addEventListener(r2, n4)
                },
                off: function(t4, n4) {
                    var r2 = e2[t4];
                    r2 && document.removeEventListener(r2, n4)
                }
            };
            return Object.defineProperties(n3, {
                isFullscreen: {
                    get: function() {
                        return !!document[t3.fullscreenElement]
                    }
                },
                element: {
                    enumerable: !0,
                    get: function() {
                        return document[t3.fullscreenElement]
                    }
                },
                isEnabled: {
                    enumerable: !0,
                    get: function() {
                        return !!document[t3.fullscreenEnabled]
                    }
                }
            }),
            n3
        }(),
        function() {
            var t3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document
              , e2 = [].slice.call(t3.querySelectorAll("[data-vimeo-id], [data-vimeo-url]"))
              , n3 = function(t4) {
                "console"in window && console.error && console.error("There was an error creating an embed: ".concat(t4))
            };
            e2.forEach(function(t4) {
                try {
                    if (t4.getAttribute("data-vimeo-defer") !== null)
                        return;
                    var e3 = E(t4);
                    A(u(e3), e3, t4).then(function(e4) {
                        return _(e4, t4)
                    }).catch(n3)
                } catch (t5) {
                    n3(t5)
                }
            })
        }(),
        function() {
            var t3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
            if (!window.VimeoPlayerResizeEmbeds_) {
                window.VimeoPlayerResizeEmbeds_ = !0;
                var e2 = function(e3) {
                    if (l(e3.origin) && e3.data && e3.data.event === "spacechange") {
                        for (var n3 = t3.querySelectorAll("iframe"), r2 = 0; r2 < n3.length; r2++)
                            if (n3[r2].contentWindow === e3.source) {
                                n3[r2].parentElement.style.paddingBottom = "".concat(e3.data.data[0].bottom, "px");
                                break
                            }
                    }
                };
                window.addEventListener("message", e2)
            }
        }()),
        e.a = L
    }
    ).call(this, n(8), n(62).setImmediate)
}
, function(t, e, n) {
    (function(t2, e2, n2) {
        (function(t3) {
            "use strict";
            var r, i = /^[a-z]+:/, o = /[-a-z0-9]+(\.[-a-z0-9])*:\d+/i, a = /\/\/(.*?)(?::(.*?))?@/, s = /^win/i, c = /:$/, l = /^\?/, u = /^#/, d = /(.*\/)/, f = /^\/{2,}/, h = /(^\/?)/, p = /'/g, g = /%([ef][0-9a-f])%([89ab][0-9a-f])%([89ab][0-9a-f])/gi, v = /%([cd][0-9a-f])%([89ab][0-9a-f])/gi, m = /%([0-7][0-9a-f])/gi, y = /\+/g, b = /^\w:$/, w = /[^/#?]/, E = typeof window > "u" && e2 !== void 0 && !0, _ = !E && t3.navigator && t3.navigator.userAgent && ~t3.navigator.userAgent.indexOf("MSIE"), A = E ? t3.require : null, k = {
                protocol: "protocol",
                host: "hostname",
                port: "port",
                path: "pathname",
                query: "search",
                hash: "hash"
            }, T = {
                ftp: 21,
                gopher: 70,
                http: 80,
                https: 443,
                ws: 80,
                wss: 443
            };
            function S() {
                return E ? r = r || "file://" + (n2.platform.match(s) ? "/" : "") + A("fs").realpathSync(".") : document.location.href === "about:srcdoc" ? self.parent.document.location.href : document.location.href
            }
            function x(t4) {
                return encodeURIComponent(t4).replace(p, "%27")
            }
            function C(t4) {
                return (t4 = (t4 = (t4 = t4.replace(y, " ")).replace(g, function(t5, e3, n3, r2) {
                    var i2 = parseInt(e3, 16) - 224
                      , o2 = parseInt(n3, 16) - 128;
                    if (i2 == 0 && o2 < 32)
                        return t5;
                    var a2 = (i2 << 12) + (o2 << 6) + (parseInt(r2, 16) - 128);
                    return 65535 < a2 ? t5 : String.fromCharCode(a2)
                })).replace(v, function(t5, e3, n3) {
                    var r2 = parseInt(e3, 16) - 192;
                    if (r2 < 2)
                        return t5;
                    var i2 = parseInt(n3, 16) - 128;
                    return String.fromCharCode((r2 << 6) + i2)
                })).replace(m, function(t5, e3) {
                    return String.fromCharCode(parseInt(e3, 16))
                })
            }
            function O(t4) {
                for (var e3 = t4.split("&"), n3 = 0, r2 = e3.length; n3 < r2; n3++) {
                    var i2 = e3[n3].split("=")
                      , o2 = decodeURIComponent(i2[0].replace(y, " "));
                    if (o2) {
                        var a2 = i2[1] !== void 0 ? C(i2[1]) : null;
                        this[o2] === void 0 ? this[o2] = a2 : (this[o2]instanceof Array || (this[o2] = [this[o2]]),
                        this[o2].push(a2))
                    }
                }
            }
            function L(t4, e3) {
                (function(t5, e4, n3) {
                    var r2, s2, p2;
                    e4 = e4 || S(),
                    E ? r2 = A("url").parse(e4) : (r2 = document.createElement("a")).href = e4;
                    var g2, v2, m2 = (v2 = {
                        path: !0,
                        query: !0,
                        hash: !0
                    },
                    (g2 = e4) && i.test(g2) && (v2.protocol = !0,
                    v2.host = !0,
                    o.test(g2) && (v2.port = !0),
                    a.test(g2) && (v2.user = !0,
                    v2.pass = !0)),
                    v2);
                    for (s2 in p2 = e4.match(a) || [],
                    k)
                        m2[s2] ? t5[s2] = r2[k[s2]] || "" : t5[s2] = "";
                    if (t5.protocol = t5.protocol.replace(c, ""),
                    t5.query = t5.query.replace(l, ""),
                    t5.hash = C(t5.hash.replace(u, "")),
                    t5.user = C(p2[1] || ""),
                    t5.pass = C(p2[2] || ""),
                    t5.port = T[t5.protocol] == t5.port || t5.port == 0 ? "" : t5.port,
                    !m2.protocol && w.test(e4.charAt(0)) && (t5.path = e4.split("?")[0].split("#")[0]),
                    !m2.protocol && n3) {
                        var y2 = new L(S().match(d)[0])
                          , b2 = y2.path.split("/")
                          , x2 = t5.path.split("/")
                          , q = ["protocol", "user", "pass", "host", "port"]
                          , D = q.length;
                        for (b2.pop(),
                        s2 = 0; s2 < D; s2++)
                            t5[q[s2]] = y2[q[s2]];
                        for (; x2[0] === ".."; )
                            b2.pop(),
                            x2.shift();
                        t5.path = (e4.charAt(0) !== "/" ? b2.join("/") : "") + "/" + x2.join("/")
                    }
                    t5.path = t5.path.replace(f, "/"),
                    _ && (t5.path = t5.path.replace(h, "/")),
                    t5.paths(t5.paths()),
                    t5.query = new O(t5.query)
                }
                )(this, t4, !e3)
            }
            O.prototype.toString = function() {
                var t4, e3, n3 = "", r2 = x;
                for (t4 in this) {
                    var i2 = this[t4];
                    if (!(i2 instanceof Function || i2 === void 0))
                        if (i2 instanceof Array) {
                            var o2 = i2.length;
                            if (!o2) {
                                n3 += (n3 ? "&" : "") + r2(t4) + "=";
                                continue
                            }
                            for (e3 = 0; e3 < o2; e3++) {
                                var a2 = i2[e3];
                                a2 !== void 0 && (n3 += n3 ? "&" : "",
                                n3 += r2(t4) + (a2 === null ? "" : "=" + r2(a2)))
                            }
                        } else
                            n3 += n3 ? "&" : "",
                            n3 += r2(t4) + (i2 === null ? "" : "=" + r2(i2))
                }
                return n3
            }
            ,
            L.prototype.clearQuery = function() {
                for (var t4 in this.query)
                    this.query[t4]instanceof Function || delete this.query[t4];
                return this
            }
            ,
            L.prototype.queryLength = function() {
                var t4 = 0;
                for (var e3 in this.query)
                    this.query[e3]instanceof Function || t4++;
                return t4
            }
            ,
            L.prototype.isEmptyQuery = function() {
                return this.queryLength() === 0
            }
            ,
            L.prototype.paths = function(t4) {
                var e3, n3 = "", r2 = 0;
                if (t4 && t4.length && t4 + "" !== t4) {
                    for (this.isAbsolute() && (n3 = "/"),
                    e3 = t4.length; r2 < e3; r2++)
                        t4[r2] = !r2 && b.test(t4[r2]) ? t4[r2] : x(t4[r2]);
                    this.path = n3 + t4.join("/")
                }
                for (r2 = 0,
                e3 = (t4 = (this.path.charAt(0) === "/" ? this.path.slice(1) : this.path).split("/")).length; r2 < e3; r2++)
                    t4[r2] = C(t4[r2]);
                return t4
            }
            ,
            L.prototype.encode = x,
            L.prototype.decode = C,
            L.prototype.isAbsolute = function() {
                return this.protocol || this.path.charAt(0) === "/"
            }
            ,
            L.prototype.toString = function() {
                return (this.protocol && this.protocol + "://") + (this.user && x(this.user) + (this.pass && ":" + x(this.pass)) + "@") + (this.host && this.host) + (this.port && ":" + this.port) + (this.path && this.path) + (this.query.toString() && "?" + this.query) + (this.hash && "#" + x(this.hash))
            }
            ,
            t3[t3.exports ? "exports" : "Url"] = L
        }
        )(t2.exports ? t2 : window)
    }
    ).call(this, n(64)(t), n(8), n(14))
}
, function(t, e, n) {
    var r = n(15);
    t.exports = function(t2) {
        if (Array.isArray(t2))
            return r(t2)
    }
}
, function(t, e) {
    t.exports = function(t2) {
        if (typeof Symbol < "u" && Symbol.iterator in Object(t2))
            return Array.from(t2)
    }
}
, function(t, e) {
    t.exports = function() {
        throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`)
    }
}
, function(t, e, n) {}
, function(t, e, n) {
    var r, i, o;
    (function(a, s) {
        a && (s = s.bind(null, a, a.document),
        t.exports ? s(n(2)) : (i = [n(2)],
        (o = typeof (r = s) == "function" ? r.apply(e, i) : r) === void 0 || (t.exports = o)))
    }
    )(typeof window < "u" ? window : 0, function(t2, e2, n2, r2) {
        "use strict";
        var i2, o2 = e2.createElement("a").style, a = "objectFit"in o2, s = /object-fit["']*\s*:\s*["']*(contain|cover)/, c = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/, l = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", u = /\(|\)|'/, d = {
            center: "center",
            "50% 50%": "center"
        };
        function f(t3, r3) {
            var o3, a2, s2, c2, d2 = n2.cfg, f2 = function() {
                var e3 = t3.currentSrc || t3.src;
                e3 && a2 !== e3 && (a2 = e3,
                c2.backgroundImage = "url(" + (u.test(e3) ? JSON.stringify(e3) : e3) + ")",
                o3 || (o3 = !0,
                n2.rC(s2, d2.loadingClass),
                n2.aC(s2, d2.loadedClass)))
            }, h2 = function() {
                n2.rAF(f2)
            };
            t3._lazysizesParentFit = r3.fit,
            t3.addEventListener("lazyloaded", h2, !0),
            t3.addEventListener("load", h2, !0),
            n2.rAF(function() {
                var o4 = t3
                  , a3 = t3.parentNode;
                a3.nodeName.toUpperCase() == "PICTURE" && (o4 = a3,
                a3 = a3.parentNode),
                function(t4) {
                    var e3 = t4.previousElementSibling;
                    e3 && n2.hC(e3, i2) && (e3.parentNode.removeChild(e3),
                    t4.style.position = e3.getAttribute("data-position") || "",
                    t4.style.visibility = e3.getAttribute("data-visibility") || "")
                }(o4),
                i2 || function() {
                    if (!i2) {
                        var t4 = e2.createElement("style");
                        i2 = n2.cfg.objectFitClass || "lazysizes-display-clone",
                        e2.querySelector("head").appendChild(t4)
                    }
                }(),
                s2 = t3.cloneNode(!1),
                c2 = s2.style,
                s2.addEventListener("load", function() {
                    var t4 = s2.currentSrc || s2.src;
                    t4 && t4 != l && (s2.src = l,
                    s2.srcset = "")
                }),
                n2.rC(s2, d2.loadedClass),
                n2.rC(s2, d2.lazyClass),
                n2.rC(s2, d2.autosizesClass),
                n2.aC(s2, d2.loadingClass),
                n2.aC(s2, i2),
                ["data-parent-fit", "data-parent-container", "data-object-fit-polyfilled", d2.srcsetAttr, d2.srcAttr].forEach(function(t4) {
                    s2.removeAttribute(t4)
                }),
                s2.src = l,
                s2.srcset = "",
                c2.backgroundRepeat = "no-repeat",
                c2.backgroundPosition = r3.position,
                c2.backgroundSize = r3.fit,
                s2.setAttribute("data-position", o4.style.position),
                s2.setAttribute("data-visibility", o4.style.visibility),
                o4.style.visibility = "hidden",
                o4.style.position = "absolute",
                t3.setAttribute("data-parent-fit", r3.fit),
                t3.setAttribute("data-parent-container", "prev"),
                t3.setAttribute("data-object-fit-polyfilled", ""),
                t3._objectFitPolyfilledDisplay = s2,
                a3.insertBefore(s2, o4),
                t3._lazysizesParentFit && delete t3._lazysizesParentFit,
                t3.complete && f2()
            })
        }
        if (!a || !(a && "objectPosition"in o2)) {
            var h = function(t3) {
                if (t3.detail.instance == n2) {
                    var e3 = t3.target
                      , r3 = function(t4) {
                        var e4 = (getComputedStyle(t4, null) || {}).fontFamily || ""
                          , n3 = e4.match(s) || ""
                          , r4 = n3 && e4.match(c) || "";
                        return r4 && (r4 = r4[1]),
                        {
                            fit: n3 && n3[1] || "",
                            position: d[r4] || r4 || "center"
                        }
                    }(e3);
                    return !(!r3.fit || a && r3.position == "center") && (f(e3, r3),
                    !0)
                }
            };
            t2.addEventListener("lazybeforesizes", function(t3) {
                if (t3.detail.instance == n2) {
                    var e3 = t3.target;
                    e3.getAttribute("data-object-fit-polyfilled") == null || e3._objectFitPolyfilledDisplay || h(t3) || n2.rAF(function() {
                        e3.removeAttribute("data-object-fit-polyfilled")
                    })
                }
            }),
            t2.addEventListener("lazyunveilread", h, !0),
            r2 && r2.detail && h(r2)
        }
    })
}
, function(t, e, n) {
    var r, i, o;
    (function(a, s) {
        a && (s = s.bind(null, a, a.document),
        t.exports ? s(n(2)) : (i = [n(2)],
        (o = typeof (r = s) == "function" ? r.apply(e, i) : r) === void 0 || (t.exports = o)))
    }
    )(typeof window < "u" ? window : 0, function(t2, e2, n2) {
        "use strict";
        if (t2.addEventListener) {
            var r2 = /\s+(\d+)(w|h)\s+(\d+)(w|h)/
              , i2 = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/
              , o2 = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/
              , a = /^picture$/i
              , s = n2.cfg
              , c = {
                getParent: function(e3, n3) {
                    var r3 = e3
                      , i3 = e3.parentNode;
                    return n3 && n3 != "prev" || !i3 || !a.test(i3.nodeName || "") || (i3 = i3.parentNode),
                    n3 != "self" && (r3 = n3 == "prev" ? e3.previousElementSibling : n3 && (i3.closest || t2.jQuery) && (i3.closest ? i3.closest(n3) : jQuery(i3).closest(n3)[0]) || i3),
                    r3
                },
                getFit: function(t3) {
                    var e3, n3, r3 = getComputedStyle(t3, null) || {}, a2 = r3.content || r3.fontFamily, s2 = {
                        fit: t3._lazysizesParentFit || t3.getAttribute("data-parent-fit")
                    };
                    return !s2.fit && a2 && (e3 = a2.match(i2)) && (s2.fit = e3[1]),
                    s2.fit ? (!(n3 = t3._lazysizesParentContainer || t3.getAttribute("data-parent-container")) && a2 && (e3 = a2.match(o2)) && (n3 = e3[1]),
                    s2.parent = c.getParent(t3, n3)) : s2.fit = r3.objectFit,
                    s2
                },
                getImageRatio: function(e3) {
                    var n3, i3, o3, c2, l, u, d, f = e3.parentNode, h = f && a.test(f.nodeName || "") ? f.querySelectorAll("source, img") : [e3];
                    for (n3 = 0; n3 < h.length; n3++)
                        if (i3 = (e3 = h[n3]).getAttribute(s.srcsetAttr) || e3.getAttribute("srcset") || e3.getAttribute("data-pfsrcset") || e3.getAttribute("data-risrcset") || "",
                        o3 = e3._lsMedia || e3.getAttribute("media"),
                        o3 = s.customMedia[e3.getAttribute("data-media") || o3] || o3,
                        i3 && (!o3 || (t2.matchMedia && matchMedia(o3) || {}).matches)) {
                            (c2 = parseFloat(e3.getAttribute("data-aspectratio"))) || ((l = i3.match(r2)) ? l[2] == "w" ? (u = l[1],
                            d = l[3]) : (u = l[3],
                            d = l[1]) : (u = e3.getAttribute("width"),
                            d = e3.getAttribute("height")),
                            c2 = u / d);
                            break
                        }
                    return c2
                },
                calculateSize: function(t3, e3) {
                    var n3, r3, i3, o3 = this.getFit(t3), a2 = o3.fit, s2 = o3.parent;
                    return a2 == "width" || (a2 == "contain" || a2 == "cover") && (r3 = this.getImageRatio(t3)) ? (s2 ? e3 = s2.clientWidth : s2 = t3,
                    i3 = e3,
                    a2 == "width" ? i3 = e3 : (n3 = e3 / s2.clientHeight) && (a2 == "cover" && n3 < r3 || a2 == "contain" && n3 > r3) && (i3 = e3 * (r3 / n3)),
                    i3) : e3
                }
            };
            n2.parentFit = c,
            e2.addEventListener("lazybeforesizes", function(t3) {
                if (!t3.defaultPrevented && t3.detail.instance == n2) {
                    var e3 = t3.target;
                    t3.detail.width = c.calculateSize(e3, t3.detail.width)
                }
            })
        }
    })
}
, function(t, e, n) {
    var r, i, o;
    (function(a, s) {
        s = s.bind(null, a, a.document),
        t.exports ? s(n(2)) : (i = [n(2)],
        (o = typeof (r = s) == "function" ? r.apply(e, i) : r) === void 0 || (t.exports = o))
    }
    )(window, function(t2, e2, n2) {
        "use strict";
        var r2, i2, o2 = n2.cfg, a = {
            string: 1,
            number: 1
        }, s = /^\-*\+*\d+\.*\d*$/, c = /^picture$/i, l = /\s*\{\s*width\s*\}\s*/i, u = /\s*\{\s*height\s*\}\s*/i, d = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, f = /^\[.*\]|\{.*\}$/, h = /^(?:auto|\d+(px)?)$/, p = e2.createElement("a"), g = e2.createElement("img"), v = "srcset"in g && !("sizes"in g), m = !!t2.HTMLPictureElement && !v;
        function y(t3, n3, o3) {
            var s2 = 0
              , c2 = 0
              , f2 = o3;
            if (t3) {
                if (n3.ratio === "container") {
                    for (s2 = f2.scrollWidth,
                    c2 = f2.scrollHeight; !(s2 && c2 || f2 === e2); )
                        s2 = (f2 = f2.parentNode).scrollWidth,
                        c2 = f2.scrollHeight;
                    s2 && c2 && (n3.ratio = n3.traditionalRatio ? c2 / s2 : s2 / c2)
                }
                var h2, g2, m2;
                h2 = t3,
                g2 = n3,
                (m2 = []).srcset = [],
                g2.absUrl && (p.setAttribute("href", h2),
                h2 = p.href),
                h2 = ((g2.prefix || "") + h2 + (g2.postfix || "")).replace(d, function(t4, e3) {
                    return a[typeof g2[e3]] ? g2[e3] : t4
                }),
                g2.widths.forEach(function(t4) {
                    var e3 = g2.widthmap[t4] || t4
                      , n4 = g2.aspectratio || g2.ratio
                      , r3 = !g2.aspectratio && i2.traditionalRatio
                      , o4 = {
                        u: h2.replace(l, e3).replace(u, n4 ? Math.round(r3 ? t4 * n4 : t4 / n4) : ""),
                        w: t4
                    };
                    m2.push(o4),
                    m2.srcset.push(o4.c = o4.u + " " + t4 + "w")
                }),
                (t3 = m2).isPicture = n3.isPicture,
                v && o3.nodeName.toUpperCase() == "IMG" ? o3.removeAttribute(r2.srcsetAttr) : o3.setAttribute(r2.srcsetAttr, t3.srcset.join(", ")),
                Object.defineProperty(o3, "_lazyrias", {
                    value: t3,
                    writable: !0
                })
            }
        }
        function b(e3, r3) {
            var o3 = function(e4, n3) {
                var r4, o4, a2, l2, u2 = t2.getComputedStyle(e4);
                for (r4 in o4 = e4.parentNode,
                l2 = {
                    isPicture: !(!o4 || !c.test(o4.nodeName || ""))
                },
                a2 = function(t3, n4) {
                    var r5 = e4.getAttribute("data-" + t3);
                    if (!r5) {
                        var o5 = u2.getPropertyValue("--ls-" + t3);
                        o5 && (r5 = o5.trim())
                    }
                    if (r5) {
                        if (r5 == "true")
                            r5 = !0;
                        else if (r5 == "false")
                            r5 = !1;
                        else if (s.test(r5))
                            r5 = parseFloat(r5);
                        else if (typeof i2[t3] == "function")
                            r5 = i2[t3](e4, r5);
                        else if (f.test(r5))
                            try {
                                r5 = JSON.parse(r5)
                            } catch {}
                        l2[t3] = r5
                    } else
                        t3 in i2 && typeof i2[t3] != "function" ? l2[t3] = i2[t3] : n4 && typeof i2[t3] == "function" && (l2[t3] = i2[t3](e4, r5))
                }
                ,
                i2)
                    a2(r4);
                return n3.replace(d, function(t3, e5) {
                    e5 in l2 || a2(e5, !0)
                }),
                l2
            }(e3, r3);
            return i2.modifyOptions.call(e3, {
                target: e3,
                details: o3,
                detail: o3
            }),
            n2.fire(e3, "lazyriasmodifyoptions", o3),
            o3
        }
        function w(t3) {
            return t3.getAttribute(t3.getAttribute("data-srcattr") || i2.srcAttr) || t3.getAttribute(r2.srcsetAttr) || t3.getAttribute(r2.srcAttr) || t3.getAttribute("data-pfsrcset") || ""
        }
        (function() {
            var t3, e3 = {
                prefix: "",
                postfix: "",
                srcAttr: "data-src",
                absUrl: !1,
                modifyOptions: function() {},
                widthmap: {},
                ratio: !1,
                traditionalRatio: !1,
                aspectratio: !1
            };
            for (t3 in (r2 = n2 && n2.cfg).supportsType || (r2.supportsType = function(t4) {
                return !t4
            }
            ),
            r2.rias || (r2.rias = {}),
            "widths"in (i2 = r2.rias) || (i2.widths = [],
            function(t4) {
                for (var e4, n3 = 0; !e4 || e4 < 3e3; )
                    (n3 += 5) > 30 && (n3 += 1),
                    e4 = 36 * n3,
                    t4.push(e4)
            }(i2.widths)),
            e3)
                t3 in i2 || (i2[t3] = e3[t3])
        }
        )(),
        addEventListener("lazybeforesizes", function(t3) {
            var e3, o3, a2, s2, c2, u2, d2, f2, p2, g2, v2, _, A;
            if (t3.detail.instance == n2 && (e3 = t3.target,
            t3.detail.dataAttr && !t3.defaultPrevented && !i2.disabled && (p2 = e3.getAttribute(r2.sizesAttr) || e3.getAttribute("sizes")) && h.test(p2))) {
                if (a2 = b(e3, o3 = w(e3)),
                v2 = l.test(a2.prefix) || l.test(a2.postfix),
                a2.isPicture && (s2 = e3.parentNode))
                    for (u2 = 0,
                    d2 = (c2 = s2.getElementsByTagName("source")).length; u2 < d2; u2++)
                        (v2 || l.test(f2 = w(c2[u2]))) && (y(f2, a2, c2[u2]),
                        _ = !0);
                v2 || l.test(o3) ? (y(o3, a2, e3),
                _ = !0) : _ && ((A = []).srcset = [],
                A.isPicture = !0,
                Object.defineProperty(e3, "_lazyrias", {
                    value: A,
                    writable: !0
                })),
                _ && (m ? e3.removeAttribute(r2.srcAttr) : p2 != "auto" && (g2 = {
                    width: parseInt(p2, 10)
                },
                E({
                    target: e3,
                    detail: g2
                })))
            }
        }, !0);
        var E = function() {
            var i3 = function(t3, e3) {
                return t3.w - e3.w
            }
              , a2 = function(t3, e3) {
                var i4;
                return !t3._lazyrias && n2.pWS && (i4 = n2.pWS(t3.getAttribute(r2.srcsetAttr || ""))).length && (Object.defineProperty(t3, "_lazyrias", {
                    value: i4,
                    writable: !0
                }),
                e3 && t3.parentNode && (i4.isPicture = t3.parentNode.nodeName.toUpperCase() == "PICTURE")),
                t3._lazyrias
            }
              , s2 = function(e3, r3) {
                var o3, s3, c3, l2, u2, d2;
                if ((u2 = e3._lazyrias).isPicture && t2.matchMedia) {
                    for (s3 = 0,
                    c3 = (o3 = e3.parentNode.getElementsByTagName("source")).length; s3 < c3; s3++)
                        if (a2(o3[s3]) && !o3[s3].getAttribute("type") && (!(l2 = o3[s3].getAttribute("media")) || (matchMedia(l2) || {}).matches)) {
                            u2 = o3[s3]._lazyrias;
                            break
                        }
                }
                return (!u2.w || u2.w < r3) && (u2.w = r3,
                u2.d = function(e4) {
                    var r4 = t2.devicePixelRatio || 1
                      , i4 = n2.getX && n2.getX(e4);
                    return Math.min(i4 || r4, 2.4, r4)
                }(e3),
                d2 = function(t3) {
                    for (var e4, n3, r4 = t3.length, i4 = t3[r4 - 1], o4 = 0; o4 < r4; o4++)
                        if ((i4 = t3[o4]).d = i4.w / t3.w,
                        i4.d >= t3.d) {
                            !i4.cached && (e4 = t3[o4 - 1]) && e4.d > t3.d - .13 * Math.pow(t3.d, 2.2) && (n3 = Math.pow(e4.d - .6, 1.6),
                            e4.cached && (e4.d += .15 * n3),
                            e4.d + (i4.d - t3.d) * n3 > t3.d && (i4 = e4));
                            break
                        }
                    return i4
                }(u2.sort(i3))),
                d2
            }
              , c2 = function(i4) {
                if (i4.detail.instance == n2) {
                    var l2, u2 = i4.target;
                    v || !(t2.respimage || t2.picturefill || o2.pf) ? ("_lazyrias"in u2 || i4.detail.dataAttr && a2(u2, !0)) && (l2 = s2(u2, i4.detail.width)) && l2.u && u2._lazyrias.cur != l2.u && (u2._lazyrias.cur = l2.u,
                    l2.cached = !0,
                    n2.rAF(function() {
                        u2.setAttribute(r2.srcAttr, l2.u),
                        u2.setAttribute("src", l2.u)
                    })) : e2.removeEventListener("lazybeforesizes", c2)
                }
            };
            return m ? c2 = function() {}
            : addEventListener("lazybeforesizes", c2),
            c2
        }()
    })
}
, function(t, e, n) {
    var r, i, o;
    (function(a, s) {
        s = s.bind(null, a, a.document),
        t.exports ? s(n(2)) : (i = [n(2)],
        (o = typeof (r = s) == "function" ? r.apply(e, i) : r) === void 0 || (t.exports = o))
    }
    )(window, function(t2, e2, n2) {
        "use strict";
        if (t2.addEventListener) {
            var r2 = n2.cfg
              , i2 = /\s+/g
              , o2 = /\s*\|\s+|\s+\|\s*/g
              , a = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/
              , s = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/
              , c = /\(|\)|'/
              , l = {
                contain: 1,
                cover: 1
            }
              , u = function(t3, e3) {
                if (e3) {
                    var n3 = e3.match(s);
                    n3 && n3[1] ? t3.setAttribute("type", n3[1]) : t3.setAttribute("media", r2.customMedia[e3] || e3)
                }
            }
              , d = function(t3) {
                if (t3.target._lazybgset) {
                    var e3 = t3.target
                      , r3 = e3._lazybgset
                      , i3 = e3.currentSrc || e3.src;
                    if (i3) {
                        var o3 = n2.fire(r3, "bgsetproxy", {
                            src: i3,
                            useSrc: c.test(i3) ? JSON.stringify(i3) : i3
                        });
                        o3.defaultPrevented || (r3.style.backgroundImage = "url(" + o3.detail.useSrc + ")")
                    }
                    e3._lazybgsetLoading && (n2.fire(r3, "_lazyloaded", {}, !1, !0),
                    delete e3._lazybgsetLoading)
                }
            };
            addEventListener("lazybeforeunveil", function(t3) {
                var s2, c2, l2;
                !t3.defaultPrevented && (s2 = t3.target.getAttribute("data-bgset")) && (l2 = t3.target,
                (c2 = e2.createElement("img")).alt = "",
                c2._lazybgsetLoading = !0,
                t3.detail.firesLoad = !0,
                function(t4, n3, s3) {
                    var c3 = e2.createElement("picture")
                      , l3 = n3.getAttribute(r2.sizesAttr)
                      , d2 = n3.getAttribute("data-ratio")
                      , f = n3.getAttribute("data-optimumx");
                    n3._lazybgset && n3._lazybgset.parentNode == n3 && n3.removeChild(n3._lazybgset),
                    Object.defineProperty(s3, "_lazybgset", {
                        value: n3,
                        writable: !0
                    }),
                    Object.defineProperty(n3, "_lazybgset", {
                        value: c3,
                        writable: !0
                    }),
                    t4 = t4.replace(i2, " ").split(o2),
                    c3.style.display = "none",
                    s3.className = r2.lazyClass,
                    t4.length != 1 || l3 || (l3 = "auto"),
                    t4.forEach(function(t5) {
                        var n4, i3 = e2.createElement("source");
                        l3 && l3 != "auto" && i3.setAttribute("sizes", l3),
                        (n4 = t5.match(a)) ? (i3.setAttribute(r2.srcsetAttr, n4[1]),
                        u(i3, n4[2]),
                        u(i3, n4[3])) : i3.setAttribute(r2.srcsetAttr, t5),
                        c3.appendChild(i3)
                    }),
                    l3 && (s3.setAttribute(r2.sizesAttr, l3),
                    n3.removeAttribute(r2.sizesAttr),
                    n3.removeAttribute("sizes")),
                    f && s3.setAttribute("data-optimumx", f),
                    d2 && s3.setAttribute("data-ratio", d2),
                    c3.appendChild(s3),
                    n3.appendChild(c3)
                }(s2, l2, c2),
                setTimeout(function() {
                    n2.loader.unveil(c2),
                    n2.rAF(function() {
                        n2.fire(c2, "_lazyloaded", {}, !0, !0),
                        c2.complete && d({
                            target: c2
                        })
                    })
                }))
            }),
            e2.addEventListener("load", d, !0),
            t2.addEventListener("lazybeforesizes", function(t3) {
                if (t3.detail.instance == n2 && t3.target._lazybgset && t3.detail.dataAttr) {
                    var e3 = function(t4) {
                        var e4;
                        return e4 = (getComputedStyle(t4) || {
                            getPropertyValue: function() {}
                        }).getPropertyValue("background-size"),
                        !l[e4] && l[t4.style.backgroundSize] && (e4 = t4.style.backgroundSize),
                        e4
                    }(t3.target._lazybgset);
                    l[e3] && (t3.target._lazysizesParentFit = e3,
                    n2.rAF(function() {
                        t3.target.setAttribute("data-parent-fit", e3),
                        t3.target._lazysizesParentFit && delete t3.target._lazysizesParentFit
                    }))
                }
            }, !0),
            e2.documentElement.addEventListener("lazybeforesizes", function(t3) {
                var e3, r3;
                !t3.defaultPrevented && t3.target._lazybgset && t3.detail.instance == n2 && (t3.detail.width = (e3 = t3.target._lazybgset,
                r3 = n2.gW(e3, e3.parentNode),
                (!e3._lazysizesWidth || r3 > e3._lazysizesWidth) && (e3._lazysizesWidth = r3),
                e3._lazysizesWidth))
            })
        }
    })
}
, function(t, e, n) {
    var r, i, o;
    (function(a, s) {
        a && (s = s.bind(null, a, a.document),
        t.exports ? s(n(2)) : (i = [n(2)],
        (o = typeof (r = s) == "function" ? r.apply(e, i) : r) === void 0 || (t.exports = o)))
    }
    )(typeof window < "u" ? window : 0, function(t2, e2, n2) {
        "use strict";
        var r2, i2, o2, a, s, c, l, u, d, f, h, p, g, v, m, y, b = n2.cfg, w = e2.createElement("img"), E = "sizes"in w && "srcset"in w, _ = /\s+\d+h/g, A = (i2 = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
        o2 = Array.prototype.forEach,
        function() {
            var t3 = e2.createElement("img")
              , r3 = function(t4) {
                var e3, n3, r4 = t4.getAttribute(b.srcsetAttr);
                r4 && (n3 = r4.match(i2)) && ((e3 = n3[2] == "w" ? n3[1] / n3[3] : n3[3] / n3[1]) && t4.setAttribute("data-aspectratio", e3),
                t4.setAttribute(b.srcsetAttr, r4.replace(_, "")))
            }
              , a2 = function(t4) {
                if (t4.detail.instance == n2) {
                    var e3 = t4.target.parentNode;
                    e3 && e3.nodeName == "PICTURE" && o2.call(e3.getElementsByTagName("source"), r3),
                    r3(t4.target)
                }
            }
              , s2 = function() {
                t3.currentSrc && e2.removeEventListener("lazybeforeunveil", a2)
            };
            e2.addEventListener("lazybeforeunveil", a2),
            t3.onload = s2,
            t3.onerror = s2,
            t3.srcset = "data:,a 1w 1h",
            t3.complete && s2()
        }
        );
        b.supportsType || (b.supportsType = function(t3) {
            return !t3
        }
        ),
        t2.HTMLPictureElement && E ? !n2.hasHDescriptorFix && e2.msElementsFromPoint && (n2.hasHDescriptorFix = !0,
        A()) : t2.picturefill || b.pf || (b.pf = function(e3) {
            var n3, i3;
            if (!t2.picturefill)
                for (n3 = 0,
                i3 = e3.elements.length; n3 < i3; n3++)
                    r2(e3.elements[n3])
        }
        ,
        u = function(t3, e3) {
            return t3.w - e3.w
        }
        ,
        d = /^\s*\d+\.*\d*px\s*$/,
        s = /(([^,\s].[^\s]+)\s+(\d+)w)/g,
        c = /\s/,
        l = function(t3, e3, n3, r3) {
            a.push({
                c: e3,
                u: n3,
                w: 1 * r3
            })
        }
        ,
        h = function() {
            var t3, n3, i3;
            h.init || (h.init = !0,
            addEventListener("resize", (n3 = e2.getElementsByClassName("lazymatchmedia"),
            i3 = function() {
                var t4, e3;
                for (t4 = 0,
                e3 = n3.length; t4 < e3; t4++)
                    r2(n3[t4])
            }
            ,
            function() {
                clearTimeout(t3),
                t3 = setTimeout(i3, 66)
            }
            )))
        }
        ,
        p = function(e3, r3) {
            var i3, o3 = e3.getAttribute("srcset") || e3.getAttribute(b.srcsetAttr);
            !o3 && r3 && (o3 = e3._lazypolyfill ? e3._lazypolyfill._set : e3.getAttribute(b.srcAttr) || e3.getAttribute("src")),
            e3._lazypolyfill && e3._lazypolyfill._set == o3 || (i3 = f(o3 || ""),
            r3 && e3.parentNode && (i3.isPicture = e3.parentNode.nodeName.toUpperCase() == "PICTURE",
            i3.isPicture && t2.matchMedia && (n2.aC(e3, "lazymatchmedia"),
            h())),
            i3._set = o3,
            Object.defineProperty(e3, "_lazypolyfill", {
                value: i3,
                writable: !0
            }))
        }
        ,
        g = function(e3) {
            return t2.matchMedia ? (g = function(t3) {
                return !t3 || (matchMedia(t3) || {}).matches
            }
            )(e3) : !e3
        }
        ,
        v = function(e3) {
            var r3, i3, o3, a2, s2, c2, l2;
            if (p(a2 = e3, !0),
            (s2 = a2._lazypolyfill).isPicture) {
                for (i3 = 0,
                o3 = (r3 = e3.parentNode.getElementsByTagName("source")).length; i3 < o3; i3++)
                    if (b.supportsType(r3[i3].getAttribute("type"), e3) && g(r3[i3].getAttribute("media"))) {
                        a2 = r3[i3],
                        p(a2),
                        s2 = a2._lazypolyfill;
                        break
                    }
            }
            return s2.length > 1 ? (l2 = a2.getAttribute("sizes") || "",
            l2 = d.test(l2) && parseInt(l2, 10) || n2.gW(e3, e3.parentNode),
            s2.d = function(e4) {
                var r4 = t2.devicePixelRatio || 1
                  , i4 = n2.getX && n2.getX(e4);
                return Math.min(i4 || r4, 2.5, r4)
            }(e3),
            !s2.src || !s2.w || s2.w < l2 ? (s2.w = l2,
            c2 = function(t3) {
                for (var e4, n3, r4 = t3.length, i4 = t3[r4 - 1], o4 = 0; o4 < r4; o4++)
                    if ((i4 = t3[o4]).d = i4.w / t3.w,
                    i4.d >= t3.d) {
                        !i4.cached && (e4 = t3[o4 - 1]) && e4.d > t3.d - .13 * Math.pow(t3.d, 2.2) && (n3 = Math.pow(e4.d - .6, 1.6),
                        e4.cached && (e4.d += .15 * n3),
                        e4.d + (i4.d - t3.d) * n3 > t3.d && (i4 = e4));
                        break
                    }
                return i4
            }(s2.sort(u)),
            s2.src = c2) : c2 = s2.src) : c2 = s2[0],
            c2
        }
        ,
        (m = function(t3) {
            if (!E || !t3.parentNode || t3.parentNode.nodeName.toUpperCase() == "PICTURE") {
                var e3 = v(t3);
                e3 && e3.u && t3._lazypolyfill.cur != e3.u && (t3._lazypolyfill.cur = e3.u,
                e3.cached = !0,
                t3.setAttribute(b.srcAttr, e3.u),
                t3.setAttribute("src", e3.u))
            }
        }
        ).parse = f = function(t3) {
            return a = [],
            (t3 = t3.trim()).replace(_, "").replace(s, l),
            a.length || !t3 || c.test(t3) || a.push({
                c: t3,
                u: t3,
                w: 99
            }),
            a
        }
        ,
        r2 = m,
        b.loadedClass && b.loadingClass && (y = [],
        ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function(t3) {
            y.push(t3 + b.loadedClass),
            y.push(t3 + b.loadingClass)
        }),
        b.pf({
            elements: e2.querySelectorAll(y.join(", "))
        })))
    })
}
, function(t, e, n) {
    var r, i;
    (function(o, a) {
        "use strict";
        (i = typeof (r = a) == "function" ? r.call(e, n, e, t) : r) === void 0 || (t.exports = i)
    }
    )(window, function() {
        "use strict";
        var t2 = function() {
            var t3 = window.Element.prototype;
            if (t3.matches)
                return "matches";
            if (t3.matchesSelector)
                return "matchesSelector";
            for (var e2 = ["webkit", "moz", "ms", "o"], n2 = 0; n2 < e2.length; n2++) {
                var r2 = e2[n2] + "MatchesSelector";
                if (t3[r2])
                    return r2
            }
        }();
        return function(e2, n2) {
            return e2[t2](n2)
        }
    })
}
, function(t, e, n) {
    var r, i;
    r = [n(17)],
    (i = function(t2) {
        return function(t3, e2) {
            "use strict";
            function n2(t4, e3) {
                this.element = t4,
                this.parent = e3,
                this.create()
            }
            var r2 = n2.prototype;
            return r2.create = function() {
                this.element.style.position = "absolute",
                this.element.setAttribute("aria-hidden", "true"),
                this.x = 0,
                this.shift = 0
            }
            ,
            r2.destroy = function() {
                this.unselect(),
                this.element.style.position = "";
                var t4 = this.parent.originSide;
                this.element.style[t4] = ""
            }
            ,
            r2.getSize = function() {
                this.size = e2(this.element)
            }
            ,
            r2.setPosition = function(t4) {
                this.x = t4,
                this.updateTarget(),
                this.renderPosition(t4)
            }
            ,
            r2.updateTarget = r2.setDefaultTarget = function() {
                var t4 = this.parent.originSide == "left" ? "marginLeft" : "marginRight";
                this.target = this.x + this.size[t4] + this.size.width * this.parent.cellAlign
            }
            ,
            r2.renderPosition = function(t4) {
                var e3 = this.parent.originSide;
                this.element.style[e3] = this.parent.getPositionValue(t4)
            }
            ,
            r2.select = function() {
                this.element.classList.add("is-selected"),
                this.element.removeAttribute("aria-hidden")
            }
            ,
            r2.unselect = function() {
                this.element.classList.remove("is-selected"),
                this.element.setAttribute("aria-hidden", "true")
            }
            ,
            r2.wrapShift = function(t4) {
                this.shift = t4,
                this.renderPosition(this.x + this.parent.slideableWidth * t4)
            }
            ,
            r2.remove = function() {
                this.element.parentNode.removeChild(this.element)
            }
            ,
            n2
        }(0, t2)
    }
    .apply(e, r)) === void 0 || (t.exports = i)
}
, function(t, e, n) {
    var r, i;
    (i = typeof (r = function() {
        "use strict";
        function t2(t3) {
            this.parent = t3,
            this.isOriginLeft = t3.originSide == "left",
            this.cells = [],
            this.outerWidth = 0,
            this.height = 0
        }
        var e2 = t2.prototype;
        return e2.addCell = function(t3) {
            if (this.cells.push(t3),
            this.outerWidth += t3.size.outerWidth,
            this.height = Math.max(t3.size.outerHeight, this.height),
            this.cells.length == 1) {
                this.x = t3.x;
                var e3 = this.isOriginLeft ? "marginLeft" : "marginRight";
                this.firstMargin = t3.size[e3]
            }
        }
        ,
        e2.updateTarget = function() {
            var t3 = this.isOriginLeft ? "marginRight" : "marginLeft"
              , e3 = this.getLastCell()
              , n2 = e3 ? e3.size[t3] : 0
              , r2 = this.outerWidth - (this.firstMargin + n2);
            this.target = this.x + this.firstMargin + r2 * this.parent.cellAlign
        }
        ,
        e2.getLastCell = function() {
            return this.cells[this.cells.length - 1]
        }
        ,
        e2.select = function() {
            this.cells.forEach(function(t3) {
                t3.select()
            })
        }
        ,
        e2.unselect = function() {
            this.cells.forEach(function(t3) {
                t3.unselect()
            })
        }
        ,
        e2.getCellElements = function() {
            return this.cells.map(function(t3) {
                return t3.element
            })
        }
        ,
        t2
    }
    ) == "function" ? r.call(e, n, e, t) : r) === void 0 || (t.exports = i)
}
, function(t, e, n) {
    var r, i;
    r = [n(4)],
    (i = function(t2) {
        return function(t3, e2) {
            "use strict";
            var n2 = {
                startAnimation: function() {
                    this.isAnimating || (this.isAnimating = !0,
                    this.restingFrames = 0,
                    this.animate())
                },
                animate: function() {
                    this.applyDragForce(),
                    this.applySelectedAttraction();
                    var t4 = this.x;
                    if (this.integratePhysics(),
                    this.positionSlider(),
                    this.settle(t4),
                    this.isAnimating) {
                        var e3 = this;
                        requestAnimationFrame(function() {
                            e3.animate()
                        })
                    }
                },
                positionSlider: function() {
                    var t4 = this.x;
                    this.options.wrapAround && this.cells.length > 1 && (t4 = e2.modulo(t4, this.slideableWidth),
                    t4 -= this.slideableWidth,
                    this.shiftWrapCells(t4)),
                    this.setTranslateX(t4, this.isAnimating),
                    this.dispatchScrollEvent()
                },
                setTranslateX: function(t4, e3) {
                    t4 += this.cursorPosition,
                    t4 = this.options.rightToLeft ? -t4 : t4;
                    var n3 = this.getPositionValue(t4);
                    this.slider.style.transform = e3 ? "translate3d(" + n3 + ",0,0)" : "translateX(" + n3 + ")"
                },
                dispatchScrollEvent: function() {
                    var t4 = this.slides[0];
                    if (t4) {
                        var e3 = -this.x - t4.target
                          , n3 = e3 / this.slidesWidth;
                        this.dispatchEvent("scroll", null, [n3, e3])
                    }
                },
                positionSliderAtSelected: function() {
                    this.cells.length && (this.x = -this.selectedSlide.target,
                    this.velocity = 0,
                    this.positionSlider())
                },
                getPositionValue: function(t4) {
                    return this.options.percentPosition ? .01 * Math.round(t4 / this.size.innerWidth * 1e4) + "%" : Math.round(t4) + "px"
                },
                settle: function(t4) {
                    this.isPointerDown || Math.round(100 * this.x) != Math.round(100 * t4) || this.restingFrames++,
                    this.restingFrames > 2 && (this.isAnimating = !1,
                    delete this.isFreeScrolling,
                    this.positionSlider(),
                    this.dispatchEvent("settle", null, [this.selectedIndex]))
                },
                shiftWrapCells: function(t4) {
                    var e3 = this.cursorPosition + t4;
                    this._shiftCells(this.beforeShiftCells, e3, -1);
                    var n3 = this.size.innerWidth - (t4 + this.slideableWidth + this.cursorPosition);
                    this._shiftCells(this.afterShiftCells, n3, 1)
                },
                _shiftCells: function(t4, e3, n3) {
                    for (var r2 = 0; r2 < t4.length; r2++) {
                        var i2 = t4[r2]
                          , o = e3 > 0 ? n3 : 0;
                        i2.wrapShift(o),
                        e3 -= i2.size.outerWidth
                    }
                },
                _unshiftCells: function(t4) {
                    if (t4 && t4.length)
                        for (var e3 = 0; e3 < t4.length; e3++)
                            t4[e3].wrapShift(0)
                },
                integratePhysics: function() {
                    this.x += this.velocity,
                    this.velocity *= this.getFrictionFactor()
                },
                applyForce: function(t4) {
                    this.velocity += t4
                },
                getFrictionFactor: function() {
                    return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
                },
                getRestingPosition: function() {
                    return this.x + this.velocity / (1 - this.getFrictionFactor())
                },
                applyDragForce: function() {
                    if (this.isDraggable && this.isPointerDown) {
                        var t4 = this.dragX - this.x - this.velocity;
                        this.applyForce(t4)
                    }
                },
                applySelectedAttraction: function() {
                    if ((!this.isDraggable || !this.isPointerDown) && !this.isFreeScrolling && this.slides.length) {
                        var t4 = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction;
                        this.applyForce(t4)
                    }
                }
            };
            return n2
        }(0, t2)
    }
    .apply(e, r)) === void 0 || (t.exports = i)
}
, function(t, e, n) {
    var r, i;
    (function(o, a) {
        r = [n(7), n(41), n(4)],
        (i = function(t2, e2, n2) {
            return function(t3, e3, n3, r2) {
                "use strict";
                r2.extend(e3.defaults, {
                    draggable: ">1",
                    dragThreshold: 3
                }),
                e3.createMethods.push("_createDrag");
                var i2 = e3.prototype;
                r2.extend(i2, n3.prototype),
                i2._touchActionValue = "pan-y";
                var o2 = "createTouch"in document
                  , a2 = !1;
                i2._createDrag = function() {
                    this.on("activate", this.onActivateDrag),
                    this.on("uiChange", this._uiChangeDrag),
                    this.on("deactivate", this.onDeactivateDrag),
                    this.on("cellChange", this.updateDraggable),
                    o2 && !a2 && (t3.addEventListener("touchmove", function() {}),
                    a2 = !0)
                }
                ,
                i2.onActivateDrag = function() {
                    this.handles = [this.viewport],
                    this.bindHandles(),
                    this.updateDraggable()
                }
                ,
                i2.onDeactivateDrag = function() {
                    this.unbindHandles(),
                    this.element.classList.remove("is-draggable")
                }
                ,
                i2.updateDraggable = function() {
                    this.options.draggable == ">1" ? this.isDraggable = this.slides.length > 1 : this.isDraggable = this.options.draggable,
                    this.isDraggable ? this.element.classList.add("is-draggable") : this.element.classList.remove("is-draggable")
                }
                ,
                i2.bindDrag = function() {
                    this.options.draggable = !0,
                    this.updateDraggable()
                }
                ,
                i2.unbindDrag = function() {
                    this.options.draggable = !1,
                    this.updateDraggable()
                }
                ,
                i2._uiChangeDrag = function() {
                    delete this.isFreeScrolling
                }
                ,
                i2.pointerDown = function(e4, n4) {
                    this.isDraggable ? this.okayPointerDown(e4) && (this._pointerDownPreventDefault(e4),
                    this.pointerDownFocus(e4),
                    document.activeElement != this.element && this.pointerDownBlur(),
                    this.dragX = this.x,
                    this.viewport.classList.add("is-pointer-down"),
                    this.pointerDownScroll = c(),
                    t3.addEventListener("scroll", this),
                    this._pointerDownDefault(e4, n4)) : this._pointerDownDefault(e4, n4)
                }
                ,
                i2._pointerDownDefault = function(t4, e4) {
                    this.pointerDownPointer = {
                        pageX: e4.pageX,
                        pageY: e4.pageY
                    },
                    this._bindPostStartEvents(t4),
                    this.dispatchEvent("pointerDown", t4, [e4])
                }
                ;
                var s = {
                    INPUT: !0,
                    TEXTAREA: !0,
                    SELECT: !0
                };
                function c() {
                    return {
                        x: t3.pageXOffset,
                        y: t3.pageYOffset
                    }
                }
                return i2.pointerDownFocus = function(t4) {
                    s[t4.target.nodeName] || this.focus()
                }
                ,
                i2._pointerDownPreventDefault = function(t4) {
                    var e4 = t4.type == "touchstart"
                      , n4 = t4.pointerType == "touch"
                      , r3 = s[t4.target.nodeName];
                    e4 || n4 || r3 || t4.preventDefault()
                }
                ,
                i2.hasDragStarted = function(t4) {
                    return Math.abs(t4.x) > this.options.dragThreshold
                }
                ,
                i2.pointerUp = function(t4, e4) {
                    delete this.isTouchScrolling,
                    this.viewport.classList.remove("is-pointer-down"),
                    this.dispatchEvent("pointerUp", t4, [e4]),
                    this._dragPointerUp(t4, e4)
                }
                ,
                i2.pointerDone = function() {
                    t3.removeEventListener("scroll", this),
                    delete this.pointerDownScroll
                }
                ,
                i2.dragStart = function(e4, n4) {
                    this.isDraggable && (this.dragStartPosition = this.x,
                    this.startAnimation(),
                    t3.removeEventListener("scroll", this),
                    this.dispatchEvent("dragStart", e4, [n4]))
                }
                ,
                i2.pointerMove = function(t4, e4) {
                    var n4 = this._dragPointerMove(t4, e4);
                    this.dispatchEvent("pointerMove", t4, [e4, n4]),
                    this._dragMove(t4, e4, n4)
                }
                ,
                i2.dragMove = function(t4, e4, n4) {
                    if (this.isDraggable) {
                        t4.preventDefault(),
                        this.previousDragX = this.dragX;
                        var r3 = this.options.rightToLeft ? -1 : 1;
                        this.options.wrapAround && (n4.x = n4.x % this.slideableWidth);
                        var i3 = this.dragStartPosition + n4.x * r3;
                        if (!this.options.wrapAround && this.slides.length) {
                            var o3 = Math.max(-this.slides[0].target, this.dragStartPosition);
                            i3 = i3 > o3 ? .5 * (i3 + o3) : i3;
                            var a3 = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                            i3 = i3 < a3 ? .5 * (i3 + a3) : i3
                        }
                        this.dragX = i3,
                        this.dragMoveTime = new Date,
                        this.dispatchEvent("dragMove", t4, [e4, n4])
                    }
                }
                ,
                i2.dragEnd = function(t4, e4) {
                    if (this.isDraggable) {
                        this.options.freeScroll && (this.isFreeScrolling = !0);
                        var n4 = this.dragEndRestingSelect();
                        if (this.options.freeScroll && !this.options.wrapAround) {
                            var r3 = this.getRestingPosition();
                            this.isFreeScrolling = -r3 > this.slides[0].target && -r3 < this.getLastSlide().target
                        } else
                            this.options.freeScroll || n4 != this.selectedIndex || (n4 += this.dragEndBoostSelect());
                        delete this.previousDragX,
                        this.isDragSelect = this.options.wrapAround,
                        this.select(n4),
                        delete this.isDragSelect,
                        this.dispatchEvent("dragEnd", t4, [e4])
                    }
                }
                ,
                i2.dragEndRestingSelect = function() {
                    var t4 = this.getRestingPosition()
                      , e4 = Math.abs(this.getSlideDistance(-t4, this.selectedIndex))
                      , n4 = this._getClosestResting(t4, e4, 1)
                      , r3 = this._getClosestResting(t4, e4, -1);
                    return n4.distance < r3.distance ? n4.index : r3.index
                }
                ,
                i2._getClosestResting = function(t4, e4, n4) {
                    for (var r3 = this.selectedIndex, i3 = 1 / 0, o3 = this.options.contain && !this.options.wrapAround ? function(t5, e5) {
                        return t5 <= e5
                    }
                    : function(t5, e5) {
                        return t5 < e5
                    }
                    ; o3(e4, i3) && (r3 += n4,
                    i3 = e4,
                    (e4 = this.getSlideDistance(-t4, r3)) !== null); )
                        e4 = Math.abs(e4);
                    return {
                        distance: i3,
                        index: r3 - n4
                    }
                }
                ,
                i2.getSlideDistance = function(t4, e4) {
                    var n4 = this.slides.length
                      , i3 = this.options.wrapAround && n4 > 1
                      , o3 = i3 ? r2.modulo(e4, n4) : e4
                      , a3 = this.slides[o3];
                    if (!a3)
                        return null;
                    var s2 = i3 ? this.slideableWidth * Math.floor(e4 / n4) : 0;
                    return t4 - (a3.target + s2)
                }
                ,
                i2.dragEndBoostSelect = function() {
                    if (this.previousDragX === void 0 || !this.dragMoveTime || new Date - this.dragMoveTime > 100)
                        return 0;
                    var t4 = this.getSlideDistance(-this.dragX, this.selectedIndex)
                      , e4 = this.previousDragX - this.dragX;
                    return t4 > 0 && e4 > 0 ? 1 : t4 < 0 && e4 < 0 ? -1 : 0
                }
                ,
                i2.staticClick = function(t4, e4) {
                    var n4 = this.getParentCell(t4.target)
                      , r3 = n4 && n4.element
                      , i3 = n4 && this.cells.indexOf(n4);
                    this.dispatchEvent("staticClick", t4, [e4, r3, i3])
                }
                ,
                i2.onscroll = function() {
                    var t4 = c()
                      , e4 = this.pointerDownScroll.x - t4.x
                      , n4 = this.pointerDownScroll.y - t4.y;
                    (Math.abs(e4) > 3 || Math.abs(n4) > 3) && this._pointerDone()
                }
                ,
                e3
            }(o, t2, e2, n2)
        }
        .apply(e, r)) === void 0 || (t.exports = i)
    }
    )(window)
}
, function(t, e, n) {
    var r, i;
    /*!
* Unidragger v2.3.1
* Draggable base class
* MIT license
*/
    (function(o, a) {
        r = [n(13)],
        (i = function(t2) {
            return function(t3, e2) {
                "use strict";
                function n2() {}
                var r2 = n2.prototype = Object.create(e2.prototype);
                r2.bindHandles = function() {
                    this._bindHandles(!0)
                }
                ,
                r2.unbindHandles = function() {
                    this._bindHandles(!1)
                }
                ,
                r2._bindHandles = function(e3) {
                    for (var n3 = (e3 = e3 === void 0 || e3) ? "addEventListener" : "removeEventListener", r3 = e3 ? this._touchActionValue : "", i3 = 0; i3 < this.handles.length; i3++) {
                        var o3 = this.handles[i3];
                        this._bindStartEvent(o3, e3),
                        o3[n3]("click", this),
                        t3.PointerEvent && (o3.style.touchAction = r3)
                    }
                }
                ,
                r2._touchActionValue = "none",
                r2.pointerDown = function(t4, e3) {
                    this.okayPointerDown(t4) && (this.pointerDownPointer = {
                        pageX: e3.pageX,
                        pageY: e3.pageY
                    },
                    t4.preventDefault(),
                    this.pointerDownBlur(),
                    this._bindPostStartEvents(t4),
                    this.emitEvent("pointerDown", [t4, e3]))
                }
                ;
                var i2 = {
                    TEXTAREA: !0,
                    INPUT: !0,
                    SELECT: !0,
                    OPTION: !0
                }
                  , o2 = {
                    radio: !0,
                    checkbox: !0,
                    button: !0,
                    submit: !0,
                    image: !0,
                    file: !0
                };
                return r2.okayPointerDown = function(t4) {
                    var e3 = i2[t4.target.nodeName]
                      , n3 = o2[t4.target.type]
                      , r3 = !e3 || n3;
                    return r3 || this._pointerReset(),
                    r3
                }
                ,
                r2.pointerDownBlur = function() {
                    var t4 = document.activeElement;
                    t4 && t4.blur && t4 != document.body && t4.blur()
                }
                ,
                r2.pointerMove = function(t4, e3) {
                    var n3 = this._dragPointerMove(t4, e3);
                    this.emitEvent("pointerMove", [t4, e3, n3]),
                    this._dragMove(t4, e3, n3)
                }
                ,
                r2._dragPointerMove = function(t4, e3) {
                    var n3 = {
                        x: e3.pageX - this.pointerDownPointer.pageX,
                        y: e3.pageY - this.pointerDownPointer.pageY
                    };
                    return !this.isDragging && this.hasDragStarted(n3) && this._dragStart(t4, e3),
                    n3
                }
                ,
                r2.hasDragStarted = function(t4) {
                    return Math.abs(t4.x) > 3 || Math.abs(t4.y) > 3
                }
                ,
                r2.pointerUp = function(t4, e3) {
                    this.emitEvent("pointerUp", [t4, e3]),
                    this._dragPointerUp(t4, e3)
                }
                ,
                r2._dragPointerUp = function(t4, e3) {
                    this.isDragging ? this._dragEnd(t4, e3) : this._staticClick(t4, e3)
                }
                ,
                r2._dragStart = function(t4, e3) {
                    this.isDragging = !0,
                    this.isPreventingClicks = !0,
                    this.dragStart(t4, e3)
                }
                ,
                r2.dragStart = function(t4, e3) {
                    this.emitEvent("dragStart", [t4, e3])
                }
                ,
                r2._dragMove = function(t4, e3, n3) {
                    this.isDragging && this.dragMove(t4, e3, n3)
                }
                ,
                r2.dragMove = function(t4, e3, n3) {
                    t4.preventDefault(),
                    this.emitEvent("dragMove", [t4, e3, n3])
                }
                ,
                r2._dragEnd = function(t4, e3) {
                    this.isDragging = !1,
                    setTimeout(function() {
                        delete this.isPreventingClicks
                    }
                    .bind(this)),
                    this.dragEnd(t4, e3)
                }
                ,
                r2.dragEnd = function(t4, e3) {
                    this.emitEvent("dragEnd", [t4, e3])
                }
                ,
                r2.onclick = function(t4) {
                    this.isPreventingClicks && t4.preventDefault()
                }
                ,
                r2._staticClick = function(t4, e3) {
                    this.isIgnoringMouseUp && t4.type == "mouseup" || (this.staticClick(t4, e3),
                    t4.type != "mouseup" && (this.isIgnoringMouseUp = !0,
                    setTimeout(function() {
                        delete this.isIgnoringMouseUp
                    }
                    .bind(this), 400)))
                }
                ,
                r2.staticClick = function(t4, e3) {
                    this.emitEvent("staticClick", [t4, e3])
                }
                ,
                n2.getPointerPoint = e2.getPointerPoint,
                n2
            }(o, t2)
        }
        .apply(e, r)) === void 0 || (t.exports = i)
    }
    )(window)
}
, function(t, e, n) {
    var r, i;
    r = [n(7), n(13), n(4)],
    (i = function(t2, e2, n2) {
        return function(t3, e3, n3, r2) {
            "use strict";
            var i2 = "http://www.w3.org/2000/svg";
            function o(t4, e4) {
                this.direction = t4,
                this.parent = e4,
                this._create()
            }
            o.prototype = Object.create(n3.prototype),
            o.prototype._create = function() {
                this.isEnabled = !0,
                this.isPrevious = this.direction == -1;
                var t4 = this.parent.options.rightToLeft ? 1 : -1;
                this.isLeft = this.direction == t4;
                var e4 = this.element = document.createElement("button");
                e4.className = "flickity-button flickity-prev-next-button",
                e4.className += this.isPrevious ? " previous" : " next",
                e4.setAttribute("type", "button"),
                this.disable(),
                e4.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
                var n4 = this.createSVG();
                e4.appendChild(n4),
                this.parent.on("select", this.update.bind(this)),
                this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
            }
            ,
            o.prototype.activate = function() {
                this.bindStartEvent(this.element),
                this.element.addEventListener("click", this),
                this.parent.element.appendChild(this.element)
            }
            ,
            o.prototype.deactivate = function() {
                this.parent.element.removeChild(this.element),
                this.unbindStartEvent(this.element),
                this.element.removeEventListener("click", this)
            }
            ,
            o.prototype.createSVG = function() {
                var t4 = document.createElementNS(i2, "svg");
                t4.setAttribute("class", "flickity-button-icon"),
                t4.setAttribute("viewBox", "0 0 100 100");
                var e4, n4 = document.createElementNS(i2, "path"), r3 = typeof (e4 = this.parent.options.arrowShape) == "string" ? e4 : "M " + e4.x0 + ",50 L " + e4.x1 + "," + (e4.y1 + 50) + " L " + e4.x2 + "," + (e4.y2 + 50) + " L " + e4.x3 + ",50  L " + e4.x2 + "," + (50 - e4.y2) + " L " + e4.x1 + "," + (50 - e4.y1) + " Z";
                return n4.setAttribute("d", r3),
                n4.setAttribute("class", "arrow"),
                this.isLeft || n4.setAttribute("transform", "translate(100, 100) rotate(180) "),
                t4.appendChild(n4),
                t4
            }
            ,
            o.prototype.handleEvent = r2.handleEvent,
            o.prototype.onclick = function() {
                if (this.isEnabled) {
                    this.parent.uiChange();
                    var t4 = this.isPrevious ? "previous" : "next";
                    this.parent[t4]()
                }
            }
            ,
            o.prototype.enable = function() {
                this.isEnabled || (this.element.disabled = !1,
                this.isEnabled = !0)
            }
            ,
            o.prototype.disable = function() {
                this.isEnabled && (this.element.disabled = !0,
                this.isEnabled = !1)
            }
            ,
            o.prototype.update = function() {
                var t4 = this.parent.slides;
                if (this.parent.options.wrapAround && t4.length > 1)
                    this.enable();
                else {
                    var e4 = t4.length ? t4.length - 1 : 0
                      , n4 = this.isPrevious ? 0 : e4;
                    this[this.parent.selectedIndex == n4 ? "disable" : "enable"]()
                }
            }
            ,
            o.prototype.destroy = function() {
                this.deactivate(),
                this.allOff()
            }
            ,
            r2.extend(e3.defaults, {
                prevNextButtons: !0,
                arrowShape: {
                    x0: 10,
                    x1: 60,
                    y1: 50,
                    x2: 70,
                    y2: 40,
                    x3: 30
                }
            }),
            e3.createMethods.push("_createPrevNextButtons");
            var a = e3.prototype;
            return a._createPrevNextButtons = function() {
                this.options.prevNextButtons && (this.prevButton = new o(-1,this),
                this.nextButton = new o(1,this),
                this.on("activate", this.activatePrevNextButtons))
            }
            ,
            a.activatePrevNextButtons = function() {
                this.prevButton.activate(),
                this.nextButton.activate(),
                this.on("deactivate", this.deactivatePrevNextButtons)
            }
            ,
            a.deactivatePrevNextButtons = function() {
                this.prevButton.deactivate(),
                this.nextButton.deactivate(),
                this.off("deactivate", this.deactivatePrevNextButtons)
            }
            ,
            e3.PrevNextButton = o,
            e3
        }(0, t2, e2, n2)
    }
    .apply(e, r)) === void 0 || (t.exports = i)
}
, function(t, e, n) {
    var r, i;
    r = [n(7), n(13), n(4)],
    (i = function(t2, e2, n2) {
        return function(t3, e3, n3, r2) {
            "use strict";
            function i2(t4) {
                this.parent = t4,
                this._create()
            }
            i2.prototype = Object.create(n3.prototype),
            i2.prototype._create = function() {
                this.holder = document.createElement("ol"),
                this.holder.className = "flickity-page-dots",
                this.dots = [],
                this.handleClick = this.onClick.bind(this),
                this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
            }
            ,
            i2.prototype.activate = function() {
                this.setDots(),
                this.holder.addEventListener("click", this.handleClick),
                this.bindStartEvent(this.holder),
                this.parent.element.appendChild(this.holder)
            }
            ,
            i2.prototype.deactivate = function() {
                this.holder.removeEventListener("click", this.handleClick),
                this.unbindStartEvent(this.holder),
                this.parent.element.removeChild(this.holder)
            }
            ,
            i2.prototype.setDots = function() {
                var t4 = this.parent.slides.length - this.dots.length;
                t4 > 0 ? this.addDots(t4) : t4 < 0 && this.removeDots(-t4)
            }
            ,
            i2.prototype.addDots = function(t4) {
                for (var e4 = document.createDocumentFragment(), n4 = [], r3 = this.dots.length, i3 = r3 + t4, o2 = r3; o2 < i3; o2++) {
                    var a = document.createElement("li");
                    a.className = "dot",
                    a.setAttribute("aria-label", "Page dot " + (o2 + 1)),
                    e4.appendChild(a),
                    n4.push(a)
                }
                this.holder.appendChild(e4),
                this.dots = this.dots.concat(n4)
            }
            ,
            i2.prototype.removeDots = function(t4) {
                this.dots.splice(this.dots.length - t4, t4).forEach(function(t5) {
                    this.holder.removeChild(t5)
                }, this)
            }
            ,
            i2.prototype.updateSelected = function() {
                this.selectedDot && (this.selectedDot.className = "dot",
                this.selectedDot.removeAttribute("aria-current")),
                this.dots.length && (this.selectedDot = this.dots[this.parent.selectedIndex],
                this.selectedDot.className = "dot is-selected",
                this.selectedDot.setAttribute("aria-current", "step"))
            }
            ,
            i2.prototype.onTap = i2.prototype.onClick = function(t4) {
                var e4 = t4.target;
                if (e4.nodeName == "LI") {
                    this.parent.uiChange();
                    var n4 = this.dots.indexOf(e4);
                    this.parent.select(n4)
                }
            }
            ,
            i2.prototype.destroy = function() {
                this.deactivate(),
                this.allOff()
            }
            ,
            e3.PageDots = i2,
            r2.extend(e3.defaults, {
                pageDots: !0
            }),
            e3.createMethods.push("_createPageDots");
            var o = e3.prototype;
            return o._createPageDots = function() {
                this.options.pageDots && (this.pageDots = new i2(this),
                this.on("activate", this.activatePageDots),
                this.on("select", this.updateSelectedPageDots),
                this.on("cellChange", this.updatePageDots),
                this.on("resize", this.updatePageDots),
                this.on("deactivate", this.deactivatePageDots))
            }
            ,
            o.activatePageDots = function() {
                this.pageDots.activate()
            }
            ,
            o.updateSelectedPageDots = function() {
                this.pageDots.updateSelected()
            }
            ,
            o.updatePageDots = function() {
                this.pageDots.setDots()
            }
            ,
            o.deactivatePageDots = function() {
                this.pageDots.deactivate()
            }
            ,
            e3.PageDots = i2,
            e3
        }(0, t2, e2, n2)
    }
    .apply(e, r)) === void 0 || (t.exports = i)
}
, function(t, e, n) {
    var r, i;
    r = [n(12), n(4), n(7)],
    (i = function(t2, e2, n2) {
        return function(t3, e3, n3) {
            "use strict";
            function r2(t4) {
                this.parent = t4,
                this.state = "stopped",
                this.onVisibilityChange = this.visibilityChange.bind(this),
                this.onVisibilityPlay = this.visibilityPlay.bind(this)
            }
            r2.prototype = Object.create(t3.prototype),
            r2.prototype.play = function() {
                this.state != "playing" && (document.hidden ? document.addEventListener("visibilitychange", this.onVisibilityPlay) : (this.state = "playing",
                document.addEventListener("visibilitychange", this.onVisibilityChange),
                this.tick()))
            }
            ,
            r2.prototype.tick = function() {
                if (this.state == "playing") {
                    var t4 = this.parent.options.autoPlay;
                    t4 = typeof t4 == "number" ? t4 : 3e3;
                    var e4 = this;
                    this.clear(),
                    this.timeout = setTimeout(function() {
                        e4.parent.next(!0),
                        e4.tick()
                    }, t4)
                }
            }
            ,
            r2.prototype.stop = function() {
                this.state = "stopped",
                this.clear(),
                document.removeEventListener("visibilitychange", this.onVisibilityChange)
            }
            ,
            r2.prototype.clear = function() {
                clearTimeout(this.timeout)
            }
            ,
            r2.prototype.pause = function() {
                this.state == "playing" && (this.state = "paused",
                this.clear())
            }
            ,
            r2.prototype.unpause = function() {
                this.state == "paused" && this.play()
            }
            ,
            r2.prototype.visibilityChange = function() {
                this[document.hidden ? "pause" : "unpause"]()
            }
            ,
            r2.prototype.visibilityPlay = function() {
                this.play(),
                document.removeEventListener("visibilitychange", this.onVisibilityPlay)
            }
            ,
            e3.extend(n3.defaults, {
                pauseAutoPlayOnHover: !0
            }),
            n3.createMethods.push("_createPlayer");
            var i2 = n3.prototype;
            return i2._createPlayer = function() {
                this.player = new r2(this),
                this.on("activate", this.activatePlayer),
                this.on("uiChange", this.stopPlayer),
                this.on("pointerDown", this.stopPlayer),
                this.on("deactivate", this.deactivatePlayer)
            }
            ,
            i2.activatePlayer = function() {
                this.options.autoPlay && (this.player.play(),
                this.element.addEventListener("mouseenter", this))
            }
            ,
            i2.playPlayer = function() {
                this.player.play()
            }
            ,
            i2.stopPlayer = function() {
                this.player.stop()
            }
            ,
            i2.pausePlayer = function() {
                this.player.pause()
            }
            ,
            i2.unpausePlayer = function() {
                this.player.unpause()
            }
            ,
            i2.deactivatePlayer = function() {
                this.player.stop(),
                this.element.removeEventListener("mouseenter", this)
            }
            ,
            i2.onmouseenter = function() {
                this.options.pauseAutoPlayOnHover && (this.player.pause(),
                this.element.addEventListener("mouseleave", this))
            }
            ,
            i2.onmouseleave = function() {
                this.player.unpause(),
                this.element.removeEventListener("mouseleave", this)
            }
            ,
            n3.Player = r2,
            n3
        }(t2, e2, n2)
    }
    .apply(e, r)) === void 0 || (t.exports = i)
}
, function(t, e, n) {
    var r, i;
    r = [n(7), n(4)],
    (i = function(t2, e2) {
        return function(t3, e3, n2) {
            "use strict";
            var r2 = e3.prototype;
            return r2.insert = function(t4, e4) {
                var n3 = this._makeCells(t4);
                if (n3 && n3.length) {
                    var r3 = this.cells.length;
                    e4 = e4 === void 0 ? r3 : e4;
                    var i2 = function(t5) {
                        var e5 = document.createDocumentFragment();
                        return t5.forEach(function(t6) {
                            e5.appendChild(t6.element)
                        }),
                        e5
                    }(n3)
                      , o = e4 == r3;
                    if (o)
                        this.slider.appendChild(i2);
                    else {
                        var a = this.cells[e4].element;
                        this.slider.insertBefore(i2, a)
                    }
                    if (e4 === 0)
                        this.cells = n3.concat(this.cells);
                    else if (o)
                        this.cells = this.cells.concat(n3);
                    else {
                        var s = this.cells.splice(e4, r3 - e4);
                        this.cells = this.cells.concat(n3).concat(s)
                    }
                    this._sizeCells(n3),
                    this.cellChange(e4, !0)
                }
            }
            ,
            r2.append = function(t4) {
                this.insert(t4, this.cells.length)
            }
            ,
            r2.prepend = function(t4) {
                this.insert(t4, 0)
            }
            ,
            r2.remove = function(t4) {
                var e4 = this.getCells(t4);
                if (e4 && e4.length) {
                    var r3 = this.cells.length - 1;
                    e4.forEach(function(t5) {
                        t5.remove();
                        var e5 = this.cells.indexOf(t5);
                        r3 = Math.min(e5, r3),
                        n2.removeFrom(this.cells, t5)
                    }, this),
                    this.cellChange(r3, !0)
                }
            }
            ,
            r2.cellSizeChange = function(t4) {
                var e4 = this.getCell(t4);
                if (e4) {
                    e4.getSize();
                    var n3 = this.cells.indexOf(e4);
                    this.cellChange(n3)
                }
            }
            ,
            r2.cellChange = function(t4, e4) {
                var n3 = this.selectedElement;
                this._positionCells(t4),
                this._getWrapShiftCells(),
                this.setGallerySize();
                var r3 = this.getCell(n3);
                r3 && (this.selectedIndex = this.getCellSlideIndex(r3)),
                this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex),
                this.emitEvent("cellChange", [t4]),
                this.select(this.selectedIndex),
                e4 && this.positionSliderAtSelected()
            }
            ,
            e3
        }(0, t2, e2)
    }
    .apply(e, r)) === void 0 || (t.exports = i)
}
, function(t, e, n) {
    var r, i;
    r = [n(7), n(4)],
    (i = function(t2, e2) {
        return function(t3, e3, n2) {
            "use strict";
            e3.createMethods.push("_createLazyload");
            var r2 = e3.prototype;
            function i2(t4, e4) {
                this.img = t4,
                this.flickity = e4,
                this.load()
            }
            return r2._createLazyload = function() {
                this.on("select", this.lazyLoad)
            }
            ,
            r2.lazyLoad = function() {
                var t4 = this.options.lazyLoad;
                if (t4) {
                    var e4 = typeof t4 == "number" ? t4 : 0
                      , r3 = this.getAdjacentCellElements(e4)
                      , o = [];
                    r3.forEach(function(t5) {
                        var e5 = function(t6) {
                            if (t6.nodeName == "IMG") {
                                var e6 = t6.getAttribute("data-flickity-lazyload")
                                  , r4 = t6.getAttribute("data-flickity-lazyload-src")
                                  , i3 = t6.getAttribute("data-flickity-lazyload-srcset");
                                if (e6 || r4 || i3)
                                    return [t6]
                            }
                            var o2 = t6.querySelectorAll("img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]");
                            return n2.makeArray(o2)
                        }(t5);
                        o = o.concat(e5)
                    }),
                    o.forEach(function(t5) {
                        new i2(t5,this)
                    }, this)
                }
            }
            ,
            i2.prototype.handleEvent = n2.handleEvent,
            i2.prototype.load = function() {
                this.img.addEventListener("load", this),
                this.img.addEventListener("error", this);
                var t4 = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src")
                  , e4 = this.img.getAttribute("data-flickity-lazyload-srcset");
                this.img.src = t4,
                e4 && this.img.setAttribute("srcset", e4),
                this.img.removeAttribute("data-flickity-lazyload"),
                this.img.removeAttribute("data-flickity-lazyload-src"),
                this.img.removeAttribute("data-flickity-lazyload-srcset")
            }
            ,
            i2.prototype.onload = function(t4) {
                this.complete(t4, "flickity-lazyloaded")
            }
            ,
            i2.prototype.onerror = function(t4) {
                this.complete(t4, "flickity-lazyerror")
            }
            ,
            i2.prototype.complete = function(t4, e4) {
                this.img.removeEventListener("load", this),
                this.img.removeEventListener("error", this);
                var n3 = this.flickity.getParentCell(this.img)
                  , r3 = n3 && n3.element;
                this.flickity.cellSizeChange(r3),
                this.img.classList.add(e4),
                this.flickity.dispatchEvent("lazyLoad", t4, r3)
            }
            ,
            e3.LazyLoader = i2,
            e3
        }(0, t2, e2)
    }
    .apply(e, r)) === void 0 || (t.exports = i)
}
, function(t, e) {
    t.exports = function(t2) {
        if (Array.isArray(t2))
            return t2
    }
}
, function(t, e) {
    t.exports = function(t2, e2) {
        if (typeof Symbol < "u" && Symbol.iterator in Object(t2)) {
            var n = []
              , r = !0
              , i = !1
              , o = void 0;
            try {
                for (var a, s = t2[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value),
                !e2 || n.length !== e2); r = !0)
                    ;
            } catch (t3) {
                i = !0,
                o = t3
            } finally {
                try {
                    r || s.return == null || s.return()
                } finally {
                    if (i)
                        throw o
                }
            }
            return n
        }
    }
}
, function(t, e) {
    t.exports = function() {
        throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`)
    }
}
, function(t, e) {
    t.exports = function(t2, e2) {
        if (t2 == null)
            return {};
        var n, r, i = {}, o = Object.keys(t2);
        for (r = 0; r < o.length; r++)
            n = o[r],
            e2.indexOf(n) >= 0 || (i[n] = t2[n]);
        return i
    }
}
, function(t, e, n) {
    "use strict";
    var r;
    /**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/
    r = function() {
        var t2 = {}
          , e2 = {};
        return t2.on = function(t3, n2) {
            var r2 = {
                name: t3,
                handler: n2
            };
            return e2[t3] = e2[t3] || [],
            e2[t3].unshift(r2),
            r2
        }
        ,
        t2.off = function(t3) {
            var n2 = e2[t3.name].indexOf(t3);
            n2 !== -1 && e2[t3.name].splice(n2, 1)
        }
        ,
        t2.trigger = function(t3, n2) {
            var r2, i = e2[t3];
            if (i)
                for (r2 = i.length; r2--; )
                    i[r2].handler(n2)
        }
        ,
        t2
    }
    ,
    t.exports = r
}
, function(t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", {
        value: !0
    });
    var r, i = n(53), o = (r = i) && r.__esModule ? r : {
        default: r
    };
    e.default = function(t2) {
        return new Promise(function(e2) {
            if (window.YT && window.YT.Player && window.YT.Player instanceof Function)
                e2(window.YT);
            else {
                var n2 = window.location.protocol === "http:" ? "http:" : "https:";
                (0,
                o.default)(n2 + "//www.youtube.com/iframe_api", function(e3) {
                    e3 && t2.trigger("error", e3)
                });
                var r2 = window.onYouTubeIframeAPIReady;
                window.onYouTubeIframeAPIReady = function() {
                    r2 && r2(),
                    e2(window.YT)
                }
            }
        }
        )
    }
    ,
    t.exports = e.default
}
, function(t, e) {
    function n(t2, e2) {
        t2.onload = function() {
            this.onerror = this.onload = null,
            e2(null, t2)
        }
        ,
        t2.onerror = function() {
            this.onerror = this.onload = null,
            e2(new Error("Failed to load " + this.src), t2)
        }
    }
    function r(t2, e2) {
        t2.onreadystatechange = function() {
            this.readyState != "complete" && this.readyState != "loaded" || (this.onreadystatechange = null,
            e2(null, t2))
        }
    }
    t.exports = function(t2, e2, i) {
        var o = document.head || document.getElementsByTagName("head")[0]
          , a = document.createElement("script");
        typeof e2 == "function" && (i = e2,
        e2 = {}),
        e2 = e2 || {},
        i = i || function() {}
        ,
        a.type = e2.type || "text/javascript",
        a.charset = e2.charset || "utf8",
        a.async = !("async"in e2) || !!e2.async,
        a.src = t2,
        e2.attrs && function(t3, e3) {
            for (var n2 in e3)
                t3.setAttribute(n2, e3[n2])
        }(a, e2.attrs),
        e2.text && (a.text = "" + e2.text),
        ("onload"in a ? n : r)(a, i),
        a.onload || n(a, i),
        o.appendChild(a)
    }
}
, function(t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", {
        value: !0
    });
    var r = s(n(55))
      , i = s(n(58))
      , o = s(n(59))
      , a = s(n(60));
    function s(t2) {
        return t2 && t2.__esModule ? t2 : {
            default: t2
        }
    }
    var c = (0,
    r.default)("youtube-player")
      , l = {
        proxyEvents: function(t2) {
            var e2 = {}
              , n2 = function(n3) {
                var r3 = "on" + n3.slice(0, 1).toUpperCase() + n3.slice(1);
                e2[r3] = function(e3) {
                    c('event "%s"', r3, e3),
                    t2.trigger(n3, e3)
                }
            }
              , r2 = !0
              , i2 = !1
              , a2 = void 0;
            try {
                for (var s2, l2 = o.default[Symbol.iterator](); !(r2 = (s2 = l2.next()).done); r2 = !0)
                    n2(s2.value)
            } catch (t3) {
                i2 = !0,
                a2 = t3
            } finally {
                try {
                    !r2 && l2.return && l2.return()
                } finally {
                    if (i2)
                        throw a2
                }
            }
            return e2
        },
        promisifyPlayer: function(t2) {
            var e2 = arguments.length > 1 && arguments[1] !== void 0 && arguments[1]
              , n2 = {}
              , r2 = function(r3) {
                e2 && a.default[r3] ? n2[r3] = function() {
                    for (var e3 = arguments.length, n3 = Array(e3), i2 = 0; i2 < e3; i2++)
                        n3[i2] = arguments[i2];
                    return t2.then(function(t3) {
                        var e4 = a.default[r3]
                          , i3 = t3.getPlayerState()
                          , o3 = t3[r3].apply(t3, n3);
                        return e4.stateChangeRequired || Array.isArray(e4.acceptableStates) && e4.acceptableStates.indexOf(i3) === -1 ? new Promise(function(n4) {
                            t3.addEventListener("onStateChange", function r4() {
                                var i4 = t3.getPlayerState()
                                  , o4 = void 0;
                                typeof e4.timeout == "number" && (o4 = setTimeout(function() {
                                    t3.removeEventListener("onStateChange", r4),
                                    n4()
                                }, e4.timeout)),
                                Array.isArray(e4.acceptableStates) && e4.acceptableStates.indexOf(i4) !== -1 && (t3.removeEventListener("onStateChange", r4),
                                clearTimeout(o4),
                                n4())
                            })
                        }
                        ).then(function() {
                            return o3
                        }) : o3
                    })
                }
                : n2[r3] = function() {
                    for (var e3 = arguments.length, n3 = Array(e3), i2 = 0; i2 < e3; i2++)
                        n3[i2] = arguments[i2];
                    return t2.then(function(t3) {
                        return t3[r3].apply(t3, n3)
                    })
                }
            }
              , o2 = !0
              , s2 = !1
              , c2 = void 0;
            try {
                for (var l2, u = i.default[Symbol.iterator](); !(o2 = (l2 = u.next()).done); o2 = !0) {
                    var d = l2.value;
                    r2(d)
                }
            } catch (t3) {
                s2 = !0,
                c2 = t3
            } finally {
                try {
                    !o2 && u.return && u.return()
                } finally {
                    if (s2)
                        throw c2
                }
            }
            return n2
        }
    };
    e.default = l,
    t.exports = e.default
}
, function(t, e, n) {
    (function(r) {
        function i() {
            var t2;
            try {
                t2 = e.storage.debug
            } catch {}
            return !t2 && r !== void 0 && "env"in r && (t2 = r.env.DEBUG),
            t2
        }
        (e = t.exports = n(56)).log = function() {
            return typeof console == "object" && console.log && Function.prototype.apply.call(console.log, console, arguments)
        }
        ,
        e.formatArgs = function(t2) {
            var n2 = this.useColors;
            if (t2[0] = (n2 ? "%c" : "") + this.namespace + (n2 ? " %c" : " ") + t2[0] + (n2 ? "%c " : " ") + "+" + e.humanize(this.diff),
            !!n2) {
                var r2 = "color: " + this.color;
                t2.splice(1, 0, r2, "color: inherit");
                var i2 = 0
                  , o = 0;
                t2[0].replace(/%[a-zA-Z%]/g, function(t3) {
                    t3 !== "%%" && (i2++,
                    t3 === "%c" && (o = i2))
                }),
                t2.splice(o, 0, r2)
            }
        }
        ,
        e.save = function(t2) {
            try {
                t2 == null ? e.storage.removeItem("debug") : e.storage.debug = t2
            } catch {}
        }
        ,
        e.load = i,
        e.useColors = function() {
            return typeof window < "u" && window.process && window.process.type === "renderer" ? !0 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/)
        }
        ,
        e.storage = typeof chrome < "u" && chrome.storage !== void 0 ? chrome.storage.local : function() {
            try {
                return window.localStorage
            } catch {}
        }(),
        e.colors = ["lightseagreen", "forestgreen", "goldenrod", "dodgerblue", "darkorchid", "crimson"],
        e.formatters.j = function(t2) {
            try {
                return JSON.stringify(t2)
            } catch (t3) {
                return "[UnexpectedJSONParseError]: " + t3.message
            }
        }
        ,
        e.enable(i())
    }
    ).call(this, n(14))
}
, function(t, e, n) {
    var r;
    function i(t2) {
        function n2() {
            if (n2.enabled) {
                var t3 = n2
                  , i2 = +new Date
                  , o = i2 - (r || i2);
                t3.diff = o,
                t3.prev = r,
                t3.curr = i2,
                r = i2;
                for (var a = new Array(arguments.length), s = 0; s < a.length; s++)
                    a[s] = arguments[s];
                a[0] = e.coerce(a[0]),
                typeof a[0] != "string" && a.unshift("%O");
                var c = 0;
                a[0] = a[0].replace(/%([a-zA-Z%])/g, function(n3, r2) {
                    if (n3 === "%%")
                        return n3;
                    c++;
                    var i3 = e.formatters[r2];
                    if (typeof i3 == "function") {
                        var o2 = a[c];
                        n3 = i3.call(t3, o2),
                        a.splice(c, 1),
                        c--
                    }
                    return n3
                }),
                e.formatArgs.call(t3, a);
                var l = n2.log || e.log || console.log.bind(console);
                l.apply(t3, a)
            }
        }
        return n2.namespace = t2,
        n2.enabled = e.enabled(t2),
        n2.useColors = e.useColors(),
        n2.color = function(t3) {
            var n3, r2 = 0;
            for (n3 in t3)
                r2 = (r2 << 5) - r2 + t3.charCodeAt(n3),
                r2 |= 0;
            return e.colors[Math.abs(r2) % e.colors.length]
        }(t2),
        typeof e.init == "function" && e.init(n2),
        n2
    }
    (e = t.exports = i.debug = i.default = i).coerce = function(t2) {
        return t2 instanceof Error ? t2.stack || t2.message : t2
    }
    ,
    e.disable = function() {
        e.enable("")
    }
    ,
    e.enable = function(t2) {
        e.save(t2),
        e.names = [],
        e.skips = [];
        for (var n2 = (typeof t2 == "string" ? t2 : "").split(/[\s,]+/), r2 = n2.length, i2 = 0; i2 < r2; i2++)
            n2[i2] && ((t2 = n2[i2].replace(/\*/g, ".*?"))[0] === "-" ? e.skips.push(new RegExp("^" + t2.substr(1) + "$")) : e.names.push(new RegExp("^" + t2 + "$")))
    }
    ,
    e.enabled = function(t2) {
        var n2, r2;
        for (n2 = 0,
        r2 = e.skips.length; n2 < r2; n2++)
            if (e.skips[n2].test(t2))
                return !1;
        for (n2 = 0,
        r2 = e.names.length; n2 < r2; n2++)
            if (e.names[n2].test(t2))
                return !0;
        return !1
    }
    ,
    e.humanize = n(57),
    e.names = [],
    e.skips = [],
    e.formatters = {}
}
, function(t, e) {
    var n = 1e3
      , r = 6e4
      , i = 60 * r
      , o = 24 * i;
    function a(t2, e2, n2) {
        if (!(t2 < e2))
            return t2 < 1.5 * e2 ? Math.floor(t2 / e2) + " " + n2 : Math.ceil(t2 / e2) + " " + n2 + "s"
    }
    t.exports = function(t2, e2) {
        e2 = e2 || {};
        var s, c = typeof t2;
        if (c === "string" && t2.length > 0)
            return function(t3) {
                if (!((t3 = String(t3)).length > 100)) {
                    var e3 = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(t3);
                    if (e3) {
                        var a2 = parseFloat(e3[1]);
                        switch ((e3[2] || "ms").toLowerCase()) {
                        case "years":
                        case "year":
                        case "yrs":
                        case "yr":
                        case "y":
                            return 315576e5 * a2;
                        case "days":
                        case "day":
                        case "d":
                            return a2 * o;
                        case "hours":
                        case "hour":
                        case "hrs":
                        case "hr":
                        case "h":
                            return a2 * i;
                        case "minutes":
                        case "minute":
                        case "mins":
                        case "min":
                        case "m":
                            return a2 * r;
                        case "seconds":
                        case "second":
                        case "secs":
                        case "sec":
                        case "s":
                            return a2 * n;
                        case "milliseconds":
                        case "millisecond":
                        case "msecs":
                        case "msec":
                        case "ms":
                            return a2;
                        default:
                            return
                        }
                    }
                }
            }(t2);
        if (c === "number" && isNaN(t2) === !1)
            return e2.long ? a(s = t2, o, "day") || a(s, i, "hour") || a(s, r, "minute") || a(s, n, "second") || s + " ms" : function(t3) {
                return t3 >= o ? Math.round(t3 / o) + "d" : t3 >= i ? Math.round(t3 / i) + "h" : t3 >= r ? Math.round(t3 / r) + "m" : t3 >= n ? Math.round(t3 / n) + "s" : t3 + "ms"
            }(t2);
        throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(t2))
    }
}
, function(t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", {
        value: !0
    }),
    e.default = ["cueVideoById", "loadVideoById", "cueVideoByUrl", "loadVideoByUrl", "playVideo", "pauseVideo", "stopVideo", "getVideoLoadedFraction", "cuePlaylist", "loadPlaylist", "nextVideo", "previousVideo", "playVideoAt", "setShuffle", "setLoop", "getPlaylist", "getPlaylistIndex", "setOption", "mute", "unMute", "isMuted", "setVolume", "getVolume", "seekTo", "getPlayerState", "getPlaybackRate", "setPlaybackRate", "getAvailablePlaybackRates", "getPlaybackQuality", "setPlaybackQuality", "getAvailableQualityLevels", "getCurrentTime", "getDuration", "removeEventListener", "getVideoUrl", "getVideoEmbedCode", "getOptions", "getOption", "addEventListener", "destroy", "setSize", "getIframe"],
    t.exports = e.default
}
, function(t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", {
        value: !0
    }),
    e.default = ["ready", "stateChange", "playbackQualityChange", "playbackRateChange", "error", "apiChange", "volumeChange"],
    t.exports = e.default
}
, function(t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", {
        value: !0
    });
    var r, i = n(61), o = (r = i) && r.__esModule ? r : {
        default: r
    };
    e.default = {
        pauseVideo: {
            acceptableStates: [o.default.ENDED, o.default.PAUSED],
            stateChangeRequired: !1
        },
        playVideo: {
            acceptableStates: [o.default.ENDED, o.default.PLAYING],
            stateChangeRequired: !1
        },
        seekTo: {
            acceptableStates: [o.default.ENDED, o.default.PLAYING, o.default.PAUSED],
            stateChangeRequired: !0,
            timeout: 3e3
        }
    },
    t.exports = e.default
}
, function(t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", {
        value: !0
    }),
    e.default = {
        BUFFERING: 3,
        ENDED: 0,
        PAUSED: 2,
        PLAYING: 1,
        UNSTARTED: -1,
        VIDEO_CUED: 5
    },
    t.exports = e.default
}
, function(t, e, n) {
    (function(t2) {
        var r = t2 !== void 0 && t2 || typeof self < "u" && self || window
          , i = Function.prototype.apply;
        function o(t3, e2) {
            this._id = t3,
            this._clearFn = e2
        }
        e.setTimeout = function() {
            return new o(i.call(setTimeout, r, arguments),clearTimeout)
        }
        ,
        e.setInterval = function() {
            return new o(i.call(setInterval, r, arguments),clearInterval)
        }
        ,
        e.clearTimeout = e.clearInterval = function(t3) {
            t3 && t3.close()
        }
        ,
        o.prototype.unref = o.prototype.ref = function() {}
        ,
        o.prototype.close = function() {
            this._clearFn.call(r, this._id)
        }
        ,
        e.enroll = function(t3, e2) {
            clearTimeout(t3._idleTimeoutId),
            t3._idleTimeout = e2
        }
        ,
        e.unenroll = function(t3) {
            clearTimeout(t3._idleTimeoutId),
            t3._idleTimeout = -1
        }
        ,
        e._unrefActive = e.active = function(t3) {
            clearTimeout(t3._idleTimeoutId);
            var e2 = t3._idleTimeout;
            e2 >= 0 && (t3._idleTimeoutId = setTimeout(function() {
                t3._onTimeout && t3._onTimeout()
            }, e2))
        }
        ,
        n(63),
        e.setImmediate = typeof self < "u" && self.setImmediate || t2 !== void 0 && t2.setImmediate || this && this.setImmediate,
        e.clearImmediate = typeof self < "u" && self.clearImmediate || t2 !== void 0 && t2.clearImmediate || this && this.clearImmediate
    }
    ).call(this, n(8))
}
, function(t, e, n) {
    (function(t2, e2) {
        (function(t3, n2) {
            "use strict";
            if (!t3.setImmediate) {
                var r, i, o, a, s, c = 1, l = {}, u = !1, d = t3.document, f = Object.getPrototypeOf && Object.getPrototypeOf(t3);
                f = f && f.setTimeout ? f : t3,
                {}.toString.call(t3.process) === "[object process]" ? r = function(t4) {
                    e2.nextTick(function() {
                        p(t4)
                    })
                }
                : function() {
                    if (t3.postMessage && !t3.importScripts) {
                        var e3 = !0
                          , n3 = t3.onmessage;
                        return t3.onmessage = function() {
                            e3 = !1
                        }
                        ,
                        t3.postMessage("", "*"),
                        t3.onmessage = n3,
                        e3
                    }
                }() ? (a = "setImmediate$" + Math.random() + "$",
                s = function(e3) {
                    e3.source === t3 && typeof e3.data == "string" && e3.data.indexOf(a) === 0 && p(+e3.data.slice(a.length))
                }
                ,
                t3.addEventListener ? t3.addEventListener("message", s, !1) : t3.attachEvent("onmessage", s),
                r = function(e3) {
                    t3.postMessage(a + e3, "*")
                }
                ) : t3.MessageChannel ? ((o = new MessageChannel).port1.onmessage = function(t4) {
                    p(t4.data)
                }
                ,
                r = function(t4) {
                    o.port2.postMessage(t4)
                }
                ) : d && "onreadystatechange"in d.createElement("script") ? (i = d.documentElement,
                r = function(t4) {
                    var e3 = d.createElement("script");
                    e3.onreadystatechange = function() {
                        p(t4),
                        e3.onreadystatechange = null,
                        i.removeChild(e3),
                        e3 = null
                    }
                    ,
                    i.appendChild(e3)
                }
                ) : r = function(t4) {
                    setTimeout(p, 0, t4)
                }
                ,
                f.setImmediate = function(t4) {
                    typeof t4 != "function" && (t4 = new Function("" + t4));
                    for (var e3 = new Array(arguments.length - 1), n3 = 0; n3 < e3.length; n3++)
                        e3[n3] = arguments[n3 + 1];
                    var i2 = {
                        callback: t4,
                        args: e3
                    };
                    return l[c] = i2,
                    r(c),
                    c++
                }
                ,
                f.clearImmediate = h
            }
            function h(t4) {
                delete l[t4]
            }
            function p(t4) {
                if (u)
                    setTimeout(p, 0, t4);
                else {
                    var e3 = l[t4];
                    if (e3) {
                        u = !0;
                        try {
                            (function(t5) {
                                var e4 = t5.callback
                                  , n3 = t5.args;
                                switch (n3.length) {
                                case 0:
                                    e4();
                                    break;
                                case 1:
                                    e4(n3[0]);
                                    break;
                                case 2:
                                    e4(n3[0], n3[1]);
                                    break;
                                case 3:
                                    e4(n3[0], n3[1], n3[2]);
                                    break;
                                default:
                                    e4.apply(void 0, n3)
                                }
                            }
                            )(e3)
                        } finally {
                            h(t4),
                            u = !1
                        }
                    }
                }
            }
        }
        )(typeof self > "u" ? t2 === void 0 ? this : t2 : self)
    }
    ).call(this, n(8), n(14))
}
, function(t, e) {
    t.exports = function(t2) {
        return t2.webpackPolyfill || (t2.deprecate = function() {}
        ,
        t2.paths = [],
        t2.children || (t2.children = []),
        Object.defineProperty(t2, "loaded", {
            enumerable: !0,
            get: function() {
                return t2.l
            }
        }),
        Object.defineProperty(t2, "id", {
            enumerable: !0,
            get: function() {
                return t2.i
            }
        }),
        t2.webpackPolyfill = 1),
        t2
    }
}
, function(t, e, n) {
    "use strict";
    n.r(e);
    function r(t2, e2) {
        this.container = function(t3) {
            if (!(t3 instanceof Element))
                throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
            if (t3.getAttribute("data-section-id") === null)
                throw new Error("Theme Sections: The section container provided does not have an id assigned to the data-section-id attribute.");
            return t3
        }(t2),
        this.id = t2.getAttribute("data-section-id"),
        this.extensions = [],
        Object.assign(this, function(t3) {
            if (t3 !== void 0 && typeof t3 != "object" || t3 === null)
                throw new TypeError("Theme Sections: The properties object provided is not a valid");
            return t3
        }(e2)),
        this.onLoad()
    }
    r.prototype = {
        onLoad: Function.prototype,
        onUnload: Function.prototype,
        onSelect: Function.prototype,
        onDeselect: Function.prototype,
        onBlockSelect: Function.prototype,
        onBlockDeselect: Function.prototype,
        extend: function(t2) {
            this.extensions.push(t2);
            var e2 = Object.assign({}, t2);
            delete e2.init,
            Object.assign(this, e2),
            typeof t2.init == "function" && t2.init.apply(this)
        }
    },
    typeof Object.assign != "function" && Object.defineProperty(Object, "assign", {
        value: function(t2) {
            if (t2 == null)
                throw new TypeError("Cannot convert undefined or null to object");
            for (var e2 = Object(t2), n2 = 1; n2 < arguments.length; n2++) {
                var r2 = arguments[n2];
                if (r2 != null)
                    for (var i2 in r2)
                        Object.prototype.hasOwnProperty.call(r2, i2) && (e2[i2] = r2[i2])
            }
            return e2
        },
        writable: !0,
        configurable: !0
    }),
    window.Shopify = window.Shopify || {},
    window.Shopify.theme = window.Shopify.theme || {},
    window.Shopify.theme.sections = window.Shopify.theme.sections || {};
    var i = window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}
      , o = window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
    function a(t2, e2) {
        t2 = l(t2),
        e2 === void 0 && (e2 = document.querySelectorAll("[data-section-type]")),
        e2 = u(e2),
        t2.forEach(function(t3) {
            var n2 = i[t3];
            n2 !== void 0 && (e2 = e2.filter(function(e3) {
                return !(s(e3).length > 0) && e3.getAttribute("data-section-type") !== null && (e3.getAttribute("data-section-type") !== t3 || (o.push(new n2(e3)),
                !1))
            }))
        })
    }
    function s(t2) {
        var e2 = [];
        if (NodeList.prototype.isPrototypeOf(t2) || Array.isArray(t2))
            var n2 = t2[0];
        return t2 instanceof Element || n2 instanceof Element ? u(t2).forEach(function(t3) {
            e2 = e2.concat(o.filter(function(e3) {
                return e3.container === t3
            }))
        }) : (typeof t2 == "string" || typeof n2 == "string") && l(t2).forEach(function(t3) {
            e2 = e2.concat(o.filter(function(e3) {
                return e3.type === t3
            }))
        }),
        e2
    }
    function c(t2) {
        for (var e2, n2 = 0; n2 < o.length; n2++)
            if (o[n2].id === t2) {
                e2 = o[n2];
                break
            }
        return e2
    }
    function l(t2) {
        return t2 === "*" ? t2 = Object.keys(i) : typeof t2 == "string" ? t2 = [t2] : t2.constructor === r ? t2 = [t2.prototype.type] : Array.isArray(t2) && t2[0].constructor === r && (t2 = t2.map(function(t3) {
            return t3.prototype.type
        })),
        t2 = t2.map(function(t3) {
            return t3.toLowerCase()
        })
    }
    function u(t2) {
        return NodeList.prototype.isPrototypeOf(t2) && t2.length > 0 ? t2 = Array.prototype.slice.call(t2) : NodeList.prototype.isPrototypeOf(t2) && t2.length === 0 || t2 === null ? t2 = [] : !Array.isArray(t2) && t2 instanceof Element && (t2 = [t2]),
        t2
    }
    window.Shopify.designMode && (document.addEventListener("shopify:section:load", function(t2) {
        var e2 = t2.detail.sectionId
          , n2 = t2.target.querySelector('[data-section-id="' + e2 + '"]');
        n2 !== null && a(n2.getAttribute("data-section-type"), n2)
    }),
    document.addEventListener("shopify:section:unload", function(t2) {
        var e2 = t2.detail.sectionId
          , n2 = t2.target.querySelector('[data-section-id="' + e2 + '"]');
        typeof s(n2)[0] == "object" && s(n2).forEach(function(t3) {
            var e3 = o.map(function(t4) {
                return t4.id
            }).indexOf(t3.id);
            o.splice(e3, 1),
            t3.onUnload()
        })
    }),
    document.addEventListener("shopify:section:select", function(t2) {
        var e2 = c(t2.detail.sectionId);
        typeof e2 == "object" && e2.onSelect(t2)
    }),
    document.addEventListener("shopify:section:deselect", function(t2) {
        var e2 = c(t2.detail.sectionId);
        typeof e2 == "object" && e2.onDeselect(t2)
    }),
    document.addEventListener("shopify:block:select", function(t2) {
        var e2 = c(t2.detail.sectionId);
        typeof e2 == "object" && e2.onBlockSelect(t2)
    }),
    document.addEventListener("shopify:block:deselect", function(t2) {
        var e2 = c(t2.detail.sectionId);
        typeof e2 == "object" && e2.onBlockDeselect(t2)
    }));
    var d = n(3)
      , f = n.n(d);
    function h(t2, e2) {
        return e2 === void 0 && (e2 = document),
        e2.querySelector(t2)
    }
    function p(t2, e2) {
        return e2 === void 0 && (e2 = document),
        [].slice.call(e2.querySelectorAll(t2))
    }
    function g(t2, e2) {
        return Array.isArray(t2) ? t2.forEach(e2) : e2(t2)
    }
    function v(t2) {
        return function(e2, n2, r2) {
            return g(e2, function(e3) {
                return e3[t2 + "EventListener"](n2, r2)
            })
        }
    }
    function m(t2, e2, n2) {
        return v("add")(t2, e2, n2),
        function() {
            return v("remove")(t2, e2, n2)
        }
    }
    function y(t2) {
        return function(e2) {
            var n2 = arguments;
            return g(e2, function(e3) {
                var r2;
                return (r2 = e3.classList)[t2].apply(r2, [].slice.call(n2, 1))
            })
        }
    }
    function b(t2) {
        y("add").apply(void 0, [t2].concat([].slice.call(arguments, 1)))
    }
    function w(t2) {
        y("remove").apply(void 0, [t2].concat([].slice.call(arguments, 1)))
    }
    function E(t2) {
        y("toggle").apply(void 0, [t2].concat([].slice.call(arguments, 1)))
    }
    function _(t2, e2) {
        return t2.classList.contains(e2)
    }
    function A() {
        this.entries = []
    }
    function k(t2, e2) {
        T(t2);
        var n2 = function(t3, e3) {
            T(t3),
            function(t4) {
                if (!Array.isArray(t4))
                    throw new TypeError(t4 + " is not an array.");
                if (t4.length === 0)
                    return [];
                if (!t4[0].hasOwnProperty("name"))
                    throw new Error(t4[0] + "does not contain name key.");
                if (typeof t4[0].name != "string")
                    throw new TypeError("Invalid value type passed for name of option " + t4[0].name + ". Value should be string.")
            }(e3);
            var n3 = [];
            return e3.forEach(function(e4) {
                for (var r2 = 0; r2 < t3.options.length; r2++)
                    if (t3.options[r2].name.toLowerCase() === e4.name.toLowerCase()) {
                        n3[r2] = e4.value;
                        break
                    }
            }),
            n3
        }(t2, e2);
        return function(t3, e3) {
            return T(t3),
            function(t4) {
                if (Array.isArray(t4) && typeof t4[0] == "object")
                    throw new Error(t4 + "is not a valid array of options.")
            }(e3),
            t3.variants.filter(function(t4) {
                return e3.every(function(e4, n3) {
                    return t4.options[n3] === e4
                })
            })[0] || null
        }(t2, n2)
    }
    function T(t2) {
        if (typeof t2 != "object")
            throw new TypeError(t2 + " is not an object.");
        if (Object.keys(t2).length === 0 && t2.constructor === Object)
            throw new Error(t2 + " is empty.")
    }
    A.prototype.add = function(t2, e2, n2) {
        this.entries.push({
            element: t2,
            event: e2,
            fn: n2
        }),
        t2.addEventListener(e2, n2)
    }
    ,
    A.prototype.removeAll = function() {
        this.entries = this.entries.filter(function(t2) {
            return t2.element.removeEventListener(t2.event, t2.fn),
            !1
        })
    }
    ;
    var S = '[name="id"]'
      , x = '[name^="options"]'
      , C = '[name="quantity"]'
      , O = '[name^="properties"]';
    function L(t2, e2, n2) {
        this.element = t2,
        this.product = function(t3) {
            if (typeof t3 != "object")
                throw new TypeError(t3 + " is not an object.");
            if (t3.variants[0].options === void 0)
                throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
            return t3
        }(e2),
        n2 = n2 || {},
        this._listeners = new A,
        this._listeners.add(this.element, "submit", this._onSubmit.bind(this, n2)),
        this.optionInputs = this._initInputs(x, n2.onOptionChange),
        this.quantityInputs = this._initInputs(C, n2.onQuantityChange),
        this.propertyInputs = this._initInputs(O, n2.onPropertyChange)
    }
    L.prototype.destroy = function() {
        this._listeners.removeAll()
    }
    ,
    L.prototype.options = function() {
        return t2 = this.optionInputs,
        e2 = function(t3) {
            return t3.name = /(?:^(options\[))(.*?)(?:\])/.exec(t3.name)[2],
            t3
        }
        ,
        t2.reduce(function(t3, n2) {
            return (n2.checked || n2.type !== "radio" && n2.type !== "checkbox") && t3.push(e2({
                name: n2.name,
                value: n2.value
            })),
            t3
        }, []);
        var t2, e2
    }
    ,
    L.prototype.variant = function() {
        return k(this.product, this.options())
    }
    ,
    L.prototype.properties = function() {
        var t2, e2, n2 = (t2 = this.propertyInputs,
        e2 = function(t3) {
            return /(?:^(properties\[))(.*?)(?:\])/.exec(t3)[2]
        }
        ,
        t2.reduce(function(t3, n3) {
            return (n3.checked || n3.type !== "radio" && n3.type !== "checkbox") && (t3[e2(n3.name)] = n3.value),
            t3
        }, {}));
        return Object.entries(n2).length === 0 ? null : n2
    }
    ,
    L.prototype.quantity = function() {
        return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1
    }
    ,
    L.prototype._setIdInputValue = function(t2) {
        var e2 = this.element.querySelector(S);
        e2 || ((e2 = document.createElement("input")).type = "hidden",
        e2.name = "id",
        this.element.appendChild(e2)),
        e2.value = t2.toString()
    }
    ,
    L.prototype._onSubmit = function(t2, e2) {
        e2.dataset = this._getProductFormEventData(),
        this._setIdInputValue(e2.dataset.variant.id),
        t2.onFormSubmit && t2.onFormSubmit(e2)
    }
    ,
    L.prototype._onFormEvent = function(t2) {
        return t2 === void 0 ? Function.prototype : function(e2) {
            e2.dataset = this._getProductFormEventData(),
            t2(e2)
        }
        .bind(this)
    }
    ,
    L.prototype._initInputs = function(t2, e2) {
        const colors_swatches = document.querySelectorAll(".quick-cart .product-form__color-swatches a")
          , color_name = document.querySelector(".quick-cart .color_swatch_slider label span");
        colors_swatches.forEach(el => {
            el.classList.contains("selected") && (color_name.innerHTML = el.dataset.tooltip)
        }
        );
        function optionsChange() {
            document.querySelectorAll(".quick-cart__configure .product-form__chips").forEach(function(options) {
                options.querySelectorAll("[data-button]").forEach(function(e3) {
                    e3.addEventListener("click", event2 => {
                        event2.preventDefault();
                        let option_val = event2.target.dataset.button
                          , option_size = event2.currentTarget.dataset.optionSize
                          , pfContainer = event2.target.closest(".pf-container").querySelector(".product-form__chips")
                          , selectElMain = event2.target.closest("form").querySelectorAll("select#variant-selector option");
                        const selectDropdown = event2.target.closest(".product-form__chips").querySelector("select");
                        selectDropdown.value = option_val,
                        selectDropdown.dispatchEvent(new Event("change"));
                        const isActive = event2.currentTarget.classList.contains("selected");
                        options.querySelectorAll(".selected").forEach(el => el.classList.remove("selected")),
                        event2.currentTarget.classList.add("selected"),
                        option_size > 1 && pfContainer.dataset.optionName == "size" && optionSoldoutCheck(option_val, selectElMain, !1, !0)
                    }
                    )
                })
            })
        }
        return optionsChange(),
        Array.prototype.slice.call(this.element.querySelectorAll(t2)).map(function(t3) {
            return this._listeners.add(t3, "change", this._onFormEvent(e2)),
            t3
        }
        .bind(this))
    }
    ,
    L.prototype._getProductFormEventData = function() {
        return {
            options: this.options(),
            variant: this.variant(),
            properties: this.properties(),
            quantity: this.quantity()
        }
    }
    ;
    var q = n(0)
      , D = n.n(q);
    function P() {
        try {
            return localStorage.setItem("test", "test"),
            localStorage.removeItem("test"),
            !0
        } catch {
            return !1
        }
    }
    function j(t2) {
        if (P())
            return JSON.parse(localStorage.getItem("neon_" + t2))
    }
    function I(t2, e2) {
        if (P())
            return localStorage.setItem("neon_" + t2, e2)
    }
    var N = function(t2) {
        if (typeof (e2 = t2) != "object" || Array.isArray(e2))
            throw "state should be an object";
        var e2
    }
      , M = function(t2, e2, n2, r2) {
        return (i2 = t2,
        i2.reduce(function(t3, e3, n3) {
            return t3.indexOf(e3) > -1 ? t3 : t3.concat(e3)
        }, [])).reduce(function(t3, n3) {
            return t3.concat(e2[n3] || [])
        }, []).map(function(t3) {
            return t3(n2, r2)
        });
        var i2
    }
      , z = V()
      , R = z.on
      , B = z.emit
      , F = z.hydrate
      , H = z.getState;
    function V(t2) {
        t2 === void 0 && (t2 = {});
        var e2 = {};
        return {
            getState: function() {
                return Object.assign({}, t2)
            },
            hydrate: function(n2) {
                return N(n2),
                Object.assign(t2, n2),
                function() {
                    var r2 = ["*"].concat(Object.keys(n2));
                    M(r2, e2, t2)
                }
            },
            on: function(t3, n2) {
                return (t3 = [].concat(t3)).map(function(t4) {
                    return e2[t4] = (e2[t4] || []).concat(n2)
                }),
                function() {
                    return t3.map(function(t4) {
                        return e2[t4].splice(e2[t4].indexOf(n2), 1)
                    })
                }
            },
            emit: function(n2, r2, i2) {
                var o2 = (n2 === "*" ? [] : ["*"]).concat(n2);
                (r2 = typeof r2 == "function" ? r2(t2) : r2) && (N(r2),
                Object.assign(t2, r2),
                o2 = o2.concat(Object.keys(r2))),
                M(o2, e2, t2, i2)
            }
        }
    }
    var U = window.theme.routes.cart || {}
      , W = {
        base: "".concat(U.base || "/cart", ".js"),
        add: "".concat(U.add || "/cart/add", ".js"),
        change: "".concat(U.change || "/cart/change", ".js"),
        clear: "".concat(U.clear || "/cart/clear", ".js")
    };
    function G(t2) {
        var e2 = j("cart_order") || [];
        return e2.length ? (t2.sorted = D()(t2.items).sort(function(t3, n2) {
            return e2.indexOf(t3.variant_id) - e2.indexOf(n2.variant_id)
        }),
        t2) : (t2.sorted = t2.items,
        t2)
    }
    function $(t2, e2, prop, action, thisElem) {
        if (prop)
            var updatedBody = JSON.stringify({
                line: t2,
                quantity: e2,
                properties: {
                    "": ""
                }
            });
        else
            var updatedBody = JSON.stringify({
                line: t2,
                quantity: e2
            });
        return fetch(W.change, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: updatedBody
        }).then(function(t3) {
            return t3.text()
        }).then(function(t3) {
            const parsedState = JSON.parse(t3);
            if (parsedState.message) {
                let selectedElement = thisElem.querySelector(".quick-cart__item-right");
                if (!selectedElement.querySelector(".quick-cart__item-error")) {
                    const errorMsg = `<div class="quick-cart__item-error">${parsedState.message}</div>`;
                    selectedElement.insertAdjacentHTML("beforeend", errorMsg)
                }
                return document.querySelector(".quick-cart__items").classList.remove("updating"),
                B("cart:updated", {
                    cart: G(parsedState)
                }),
                G(parsedState)
            } else if (window.protectioncharges)
                Q.protectionCheck(parsedState, null, action).then(function(t4) {
                    return document.querySelector(".quick-cart__items").classList.remove("updating"),
                    B("cart:updated", {
                        cart: G(t4)
                    }),
                    G(t4)
                });
            else
                return document.querySelector(".quick-cart__items").classList.remove("updating"),
                B("cart:updated", {
                    cart: G(t3)
                }),
                G(t3)
        })
    }
    function J(t2, e2, prop) {
        var propJSON = JSON.parse(prop);
        return B("cart:updating"),
        fetch(W.add, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id: t2,
                quantity: e2,
                properties: propJSON
            })
        }).then(function(t3) {
            return t3.json()
        }).then(function(t3) {
            return Y().then(function(e3) {
                var n2 = j("cart_order") || []
                  , r2 = [t3.variant_id].concat(D()(n2.filter(function(e4) {
                    return e4 !== t3.variant_id
                })));
                return I("cart_order", JSON.stringify(r2)),
                B("cart:updated", {
                    cart: G(e3)
                }),
                {
                    item: t3,
                    cart: G(e3)
                }
            })
        })
    }
    function addVO(varid, qty) {
        return B("cart:updating"),
        fetch(W.add, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id: varid,
                quantity: qty
            })
        }).then(function(t2) {
            return t2.json()
        }).then(function(t2) {
            return Y().then(function(e2) {
                var n2 = j("cart_order") || []
                  , r2 = [t2.variant_id].concat(D()(n2.filter(function(e3) {
                    return e3 !== t2.variant_id
                })));
                return I("cart_order", JSON.stringify(r2)),
                B("cart:updated", {
                    cart: G(e2)
                }),
                {
                    item: t2,
                    cart: G(e2)
                }
            })
        })
    }
    function Y() {
        return fetch(W.base, {
            method: "GET",
            credentials: "include"
        }).then(function(t2) {
            return t2.json()
        }).then(function(t2) {
            return G(t2)
        })
    }
    function X(t2) {
        var e2 = []
          , hasEmbroidery = t2.getAttribute("data-hasembroidery") === "true";
        return Array.prototype.slice.call(t2.elements).forEach(function(t3) {
            if (!(!t3.name || t3.disabled || ["file", "reset", "submit", "button"].indexOf(t3.type) > -1))
                if (t3.type !== "select-multiple") {
                    if (hasEmbroidery && t3.type === "select-one")
                        return;
                    if (!hasEmbroidery && t3.name.startsWith("items[0]"))
                        return;
                    if (["checkbox", "radio"].indexOf(t3.type) > -1 && !t3.checked)
                        return;
                    e2.push(encodeURIComponent(t3.name) + "=" + encodeURIComponent(t3.value))
                } else
                    Array.prototype.slice.call(t3.options).forEach(function(n2) {
                        n2.selected && e2.push(encodeURIComponent(t3.name) + "=" + encodeURIComponent(n2.value))
                    })
        }),
        e2.join("&")
    }
    var Q = {
        addItem: function(t2) {
            return B("cart:updating"),
            fetch(W.add, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "X-Requested-With": "XMLHttpRequest"
                },
                body: X(t2)
            }).then(function(t3) {
                return t3.json()
            }).then(function(t3) {
                function insertAfter(newNode, referenceNode) {
                    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling)
                }
                if (t3.status == "422") {
                    var newErrorElem = document.createElement("div");
                    newErrorElem.setAttribute("style", "font-size: 12px;margin: 7px 0;color: red;"),
                    newErrorElem.innerHTML = t3.description;
                    var targetNode = document.querySelector("button[data-add-to-cart]");
                    return insertAfter(newErrorElem, targetNode),
                    setTimeout( () => {
                        newErrorElem.remove()
                    }
                    , 2e3),
                    !1
                }
                return Y().then(function(e2) {
                    var n2 = j("cart_order") || []
                      , r2 = [t3.variant_id].concat(D()(n2.filter(function(e3) {
                        return e3 !== t3.variant_id
                    })));
                    return I("cart_order", JSON.stringify(r2)),
                    B("cart:updated", {
                        cart: G(e2)
                    }),
                    {
                        item: t3,
                        cart: G(e2)
                    }
                })
            })
        },
        addItemById: J,
        addVariantOnly: addVO,
        addVariant: function(t2, e2) {
            var n2 = t2.inventory_policy === "deny" && t2.inventory_management === "shopify" ? t2.inventory_quantity : null;
            return Y().then(function(r2) {
                var i2 = ((r2.items.filter(function(e3) {
                    return e3.id === t2.id
                })[0] || {}).quantity || 0) + e2;
                if (n2 !== null && i2 > n2) {
                    var o2 = "There are only ".concat(n2, " of that product available, requested ").concat(i2, ".");
                    throw new Error(o2)
                }
                return J(t2.id, e2)
            })
        },
        get: Y,
        updateItem: function(t2, e2, p2, action) {
            return Y().then(function(n2) {
                var cartKey = t2.dataset.cartKey;
                n2.items.forEach(function(item, index) {
                    if (item.key == cartKey)
                        return $(parseInt(index + 1), e2, p2, action, t2)
                })
            })
        },
        protectionCheck: function(cart, toggleValue, action) {
            const minicartFooterSubtotal = document.querySelector("[data-subtotal]")
              , minicartProtectionToggleBtn = document.querySelector(".quick-cart input[data-protectiontoggle]");
            let cartSubTotalExl = 0
              , cartItemCount = 0
              , cartLineItemCount = cart.item_count
              , isFirstItem = !1
              , protectionProductFound = !1
              , cartAttributeInsurance = cart.attributes._insurance
              , cartTotalOrg = cart.total_price;
            cart.items.forEach(item => {
                var productTypeHandlize = item.product_type.trim().toLowerCase().replace(/\s/g, "");
                if (productTypeHandlize.indexOf("giftcard") !== -1)
                    cartLineItemCount = cartLineItemCount - item.quantity;
                else if (productTypeHandlize.indexOf("insurance") !== -1)
                    cartLineItemCount = cartLineItemCount - item.quantity,
                    protectionProductFound = !0;
                else {
                    cartSubTotalExl = cartSubTotalExl + item.final_line_price;
                    var productTitleHandlize = item.title.trim().toLowerCase().replace(/\s/g, "");
                    productTitleHandlize.indexOf("icon") !== -1 || productTitleHandlize.indexOf("embroidery") !== -1 ? cartLineItemCount = cartLineItemCount - item.quantity : cartItemCount++
                }
            }
            ),
            cartItemCount == 1 && cartLineItemCount == 1 && action != "minus" && (isFirstItem = !0,
            cartAttributeInsurance = "true"),
            isFirstItem == !1 && cartSubTotalExl == 0 && (cartAttributeInsurance = "false"),
            (toggleValue != null || toggleValue != null) && (localStorage.setItem("changedPMO", !0),
            toggleValue == !0 ? cartAttributeInsurance = "true" : toggleValue == !1 && (cartAttributeInsurance = "false")),
            cartItemCount == 0 && localStorage.removeItem("changedPMO");
            var toggleChanged = localStorage.getItem("changedPMO");
            cartItemCount == 1 && cartLineItemCount == 1 && action != "minus" && toggleChanged && (toggleValue == null || toggleValue == null) && (cartAttributeInsurance = cart.attributes._insurance),
            cartSubTotalExl == 0 ? (minicartProtectionToggleBtn.checked && (minicartProtectionToggleBtn.checked = !1),
            minicartProtectionToggleBtn.disabled = !0) : minicartProtectionToggleBtn.disabled = !1,
            cartAttributeInsurance == "true" ? minicartProtectionToggleBtn.checked || (minicartProtectionToggleBtn.checked = !0) : cartAttributeInsurance == "false" && minicartProtectionToggleBtn.checked && (minicartProtectionToggleBtn.checked = !1);
            let hasOnlyInsurace = !1;
            if (cart.items.length == 1) {
                var only1ItemProductType = cart.items[0].product_type.trim().toLowerCase().replace(/\s/g, "");
                only1ItemProductType.indexOf("insurance") !== -1 && (hasOnlyInsurace = !0)
            }
            if (hasOnlyInsurace)
                return fetch("/cart/clear.js", {
                    body: "",
                    credentials: "same-origin",
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Requested-With": "XMLHttpRequest"
                    }
                }).then(function(cart2) {
                    return cart2.json()
                }).then(function(r2) {
                    return r2
                });
            {
                const cartTotal = parseFloat(cartSubTotalExl) / 100;
                for (var protection_range_data, i2 = 0; i2 < window.protectioncharges.length; i2++) {
                    var range_split = window.protectioncharges.charges[i2].range.split("-")
                      , range_min = parseInt(range_split[0])
                      , range_max = parseInt(range_split[1]);
                    if (cartTotal >= range_min && cartTotal <= range_max) {
                        protection_range_data = window.protectioncharges.charges[i2];
                        break
                    }
                }
                protection_range_data || (protection_range_data = window.protectioncharges.charges[parseInt(window.protectioncharges.length - 1)]),
                document.querySelectorAll("[data-protectioncharge]").forEach(element => {
                    element.innerHTML = K(protection_range_data.price),
                    element.dataset.protectioncharge = protection_range_data.price
                }
                );
                var insuranceCharge = document.querySelector("[data-protectioncharge]").dataset.protectioncharge
                  , cartSubTotalNoInsurance = cart.total_price;
                return cart.items.forEach(item => {
                    item.product_type == "Insurance" && (cartSubTotalNoInsurance -= item.line_price)
                }
                ),
                protectionProductFound && (cartTotalOrg = parseFloat(parseFloat(cartSubTotalNoInsurance))),
                minicartProtectionToggleBtn.checked && (cartTotalOrg = parseFloat(parseFloat(cartSubTotalNoInsurance) + parseFloat(insuranceCharge))),
                minicartFooterSubtotal.innerHTML = K(cartTotalOrg),
                fetch("/cart/update.js", {
                    body: JSON.stringify({
                        attributes: {
                            _insurance: cartAttributeInsurance
                        }
                    }),
                    credentials: "same-origin",
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Requested-With": "XMLHttpRequest"
                    }
                }).then(function(cart2) {
                    return cart2.json()
                }).then(function(t2) {
                    return t2
                })
            }
        },
        giftBoxAddOn: function() {
            var giftBoxElem = document.querySelector("[data-giftbox]");
            if (giftBoxElem) {
                var checkbox = giftBoxElem.querySelector('input[type="checkbox"]')
                  , giftbox = giftBoxElem.querySelector(".giftbox_image")
                  , parentNode = document.querySelector(".quick-cart__items");
                checkbox.addEventListener("change", function(input) {
                    var productId = this.getAttribute("data-variant-id");
                    parentNode.classList.add("updating"),
                    Q.addGiftBoxAddOn(giftBoxElem, productId)
                }),
                giftbox.addEventListener("click", function(input) {
                    var productId = checkbox.getAttribute("data-variant-id");
                    parentNode.classList.add("updating"),
                    Q.addGiftBoxAddOn(giftBoxElem, productId)
                })
            }
        },
        addGiftBoxAddOn: function(giftBoxElem, productId) {
            if (!(!giftBoxElem || giftBoxElem == null || giftBoxElem == null)) {
                var checkbox = giftBoxElem.querySelector('input[type="checkbox"]')
                  , parentNode = document.querySelector(".quick-cart__items");
                fetch(window.Shopify.routes.root + "cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Requested-With": "XMLHttpRequest"
                    },
                    body: JSON.stringify({
                        id: productId,
                        quantity: 1
                    })
                }).then(response => {
                    if (response.status == 200)
                        return console.log("addGiftBoxAddOn"),
                        Y().then(function(e2) {
                            var n2 = j("cart_order") || []
                              , r2 = [t.variant_id].concat(D()(n2.filter(function(e3) {
                                return e3 !== t.variant_id
                            })));
                            return giftBoxElem.classList.remove("active"),
                            parentNode.classList.remove("updating"),
                            checkbox.checked = !1,
                            I("cart_order", JSON.stringify(r2)),
                            B("cart:updated", {
                                cart: G(e2)
                            }),
                            {
                                item: t,
                                cart: G(e2)
                            }
                        });
                    parentNode.classList.remove("updating"),
                    console.error("Request returned an error", response)
                }
                ).catch(error => {
                    parentNode.classList.remove("updating"),
                    console.error("Error:", error)
                }
                )
            }
        }
    }
      , Z = n(18)
      , K = function(t2) {
        return Object(Z.formatMoney)(t2, window.theme.moneyFormat || "${{amount}}")
    }
      , tt = function(t2) {
        return function(e2) {
            return fetch("".concat(window.theme.routes.products, "/").concat(t2, ".js")).then(function(t3) {
                return t3.json()
            }).then(function(t3) {
                return e2(t3)
            }).catch(function(t3) {
                return console.log(t3.message)
            })
        }
    }
      , et = function(t2, e2) {
        if (typeof t2 != "string")
            throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (i[t2] !== void 0)
            throw new Error('Theme Sections: A section of type "' + t2 + '" has already been registered. You cannot register the same section type twice');
        function n2(t3) {
            r.call(this, t3, e2)
        }
        return n2.constructor = r,
        n2.prototype = Object.create(r.prototype),
        n2.prototype.type = t2,
        i[t2] = n2
    }
      , nt = "[data-price]"
      , rt = "[data-compare-price]";
    function it() {
        var t2 = window.SPR;
        t2 && (t2.registerCallbacks(),
        t2.initRatingHandler(),
        t2.initDomEls(),
        t2.loadProducts(),
        t2.loadBadges())
    }
    var ot = "full-width"
      , at = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"]
      , st = at.join(",")
      , ct = typeof Element > "u" ? function() {}
    : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    function lt(t2, e2, n2) {
        var r2 = Array.prototype.slice.apply(t2.querySelectorAll(st));
        return e2 && ct.call(t2, st) && r2.unshift(t2),
        r2 = r2.filter(n2)
    }
    function ut(t2) {
        return !(!dt(t2) || function(t3) {
            return function(t4) {
                return mt(t4) && t4.type === "radio"
            }(t3) && !function(t4) {
                if (!t4.name)
                    return !0;
                var e2 = function(t5, e3) {
                    for (var n2 = 0; n2 < t5.length; n2++)
                        if (t5[n2].checked && t5[n2].form === e3)
                            return t5[n2]
                }((t4.form || t4.ownerDocument).querySelectorAll('input[type="radio"][name="' + t4.name + '"]'), t4.form);
                return !e2 || e2 === t4
            }(t3)
        }(t2) || gt(t2) < 0)
    }
    function dt(t2) {
        return !(t2.disabled || function(t3) {
            return mt(t3) && t3.type === "hidden"
        }(t2) || function(t3) {
            if (getComputedStyle(t3).visibility === "hidden" || (t3.matches("details>summary:first-of-type") ? t3.parentElement : t3).matches("details:not([open]) *"))
                return !0;
            for (; t3; ) {
                if (getComputedStyle(t3).display === "none")
                    return !0;
                t3 = t3.parentElement
            }
            return !1
        }(t2) || function(t3) {
            return t3.tagName === "DETAILS" && Array.prototype.slice.apply(t3.children).some(function(t4) {
                return t4.tagName === "SUMMARY"
            })
        }(t2))
    }
    var ft, ht = at.concat("iframe").join(",");
    function pt(t2) {
        if (!t2)
            throw new Error("No node provided");
        return ct.call(t2, ht) !== !1 && dt(t2)
    }
    function gt(t2) {
        var e2 = parseInt(t2.getAttribute("tabindex"), 10);
        return isNaN(e2) ? function(t3) {
            return t3.contentEditable === "true"
        }(t2) ? 0 : t2.nodeName !== "AUDIO" && t2.nodeName !== "VIDEO" && t2.nodeName !== "DETAILS" || t2.getAttribute("tabindex") !== null ? t2.tabIndex : 0 : e2
    }
    function vt(t2, e2) {
        return t2.tabIndex === e2.tabIndex ? t2.documentOrder - e2.documentOrder : t2.tabIndex - e2.tabIndex
    }
    function mt(t2) {
        return t2.tagName === "INPUT"
    }
    function yt(t2, e2, n2) {
        return e2 in t2 ? Object.defineProperty(t2, e2, {
            value: n2,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t2[e2] = n2,
        t2
    }
    function bt(t2, e2) {
        var n2 = Object.keys(t2);
        if (Object.getOwnPropertySymbols) {
            var r2 = Object.getOwnPropertySymbols(t2);
            e2 && (r2 = r2.filter(function(e3) {
                return Object.getOwnPropertyDescriptor(t2, e3).enumerable
            })),
            n2.push.apply(n2, r2)
        }
        return n2
    }
    var wt, Et = (wt = [],
    {
        activateTrap: function(t2) {
            if (wt.length > 0) {
                var e2 = wt[wt.length - 1];
                e2 !== t2 && e2.pause()
            }
            var n2 = wt.indexOf(t2);
            n2 === -1 || wt.splice(n2, 1),
            wt.push(t2)
        },
        deactivateTrap: function(t2) {
            var e2 = wt.indexOf(t2);
            e2 !== -1 && wt.splice(e2, 1),
            wt.length > 0 && wt[wt.length - 1].unpause()
        }
    });
    function _t(t2, e2) {
        var n2 = document
          , r2 = typeof t2 == "string" ? n2.querySelector(t2) : t2
          , i2 = function(t3) {
            for (var e3 = 1; e3 < arguments.length; e3++) {
                var n3 = arguments[e3] != null ? arguments[e3] : {};
                e3 % 2 ? bt(Object(n3), !0).forEach(function(e4) {
                    yt(t3, e4, n3[e4])
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t3, Object.getOwnPropertyDescriptors(n3)) : bt(Object(n3)).forEach(function(e4) {
                    Object.defineProperty(t3, e4, Object.getOwnPropertyDescriptor(n3, e4))
                })
            }
            return t3
        }({
            returnFocusOnDeactivate: !0,
            escapeDeactivates: !0,
            delayInitialFocus: !0
        }, e2)
          , o2 = {
            firstTabbableNode: null,
            lastTabbableNode: null,
            nodeFocusedBeforeActivation: null,
            mostRecentlyFocusedNode: null,
            active: !1,
            paused: !1
        }
          , a2 = {
            activate: function(t3) {
                if (!o2.active) {
                    v2(),
                    o2.active = !0,
                    o2.paused = !1,
                    o2.nodeFocusedBeforeActivation = n2.activeElement;
                    var e3 = t3 && t3.onActivate ? t3.onActivate : i2.onActivate;
                    return e3 && e3(),
                    c2(),
                    a2
                }
            },
            deactivate: s2,
            pause: function() {
                o2.paused || !o2.active || (o2.paused = !0,
                l2())
            },
            unpause: function() {
                !o2.paused || !o2.active || (o2.paused = !1,
                v2(),
                c2())
            }
        };
        return a2;
        function s2(t3) {
            if (o2.active) {
                clearTimeout(ft),
                l2(),
                o2.active = !1,
                o2.paused = !1,
                Et.deactivateTrap(a2);
                var e3 = t3 && t3.onDeactivate !== void 0 ? t3.onDeactivate : i2.onDeactivate;
                return e3 && e3(),
                (t3 && t3.returnFocus !== void 0 ? t3.returnFocus : i2.returnFocusOnDeactivate) && At(function() {
                    var t4;
                    m2((t4 = o2.nodeFocusedBeforeActivation,
                    u2("setReturnFocus") || t4))
                }),
                a2
            }
        }
        function c2() {
            if (o2.active)
                return Et.activateTrap(a2),
                ft = i2.delayInitialFocus ? At(function() {
                    m2(d2())
                }) : m2(d2()),
                n2.addEventListener("focusin", h2, !0),
                n2.addEventListener("mousedown", f2, {
                    capture: !0,
                    passive: !1
                }),
                n2.addEventListener("touchstart", f2, {
                    capture: !0,
                    passive: !1
                }),
                n2.addEventListener("click", g2, {
                    capture: !0,
                    passive: !1
                }),
                n2.addEventListener("keydown", p2, {
                    capture: !0,
                    passive: !1
                }),
                a2
        }
        function l2() {
            if (o2.active)
                return n2.removeEventListener("focusin", h2, !0),
                n2.removeEventListener("mousedown", f2, !0),
                n2.removeEventListener("touchstart", f2, !0),
                n2.removeEventListener("click", g2, !0),
                n2.removeEventListener("keydown", p2, !0),
                a2
        }
        function u2(t3) {
            var e3 = i2[t3]
              , r3 = e3;
            if (!e3)
                return null;
            if (typeof e3 == "string" && !(r3 = n2.querySelector(e3)))
                throw new Error("`" + t3 + "` refers to no known node");
            if (typeof e3 == "function" && !(r3 = e3()))
                throw new Error("`" + t3 + "` did not return a node");
            return r3
        }
        function d2() {
            var t3;
            if (!(t3 = u2("initialFocus") !== null ? u2("initialFocus") : r2.contains(n2.activeElement) ? n2.activeElement : o2.firstTabbableNode || u2("fallbackFocus")))
                throw new Error("Your focus-trap needs to have at least one focusable element");
            return t3
        }
        function f2(t3) {
            r2.contains(t3.target) || (i2.clickOutsideDeactivates ? s2({
                returnFocus: i2.returnFocusOnDeactivate && !pt(t3.target)
            }) : i2.allowOutsideClick && (typeof i2.allowOutsideClick == "boolean" ? i2.allowOutsideClick : i2.allowOutsideClick(t3)) || t3.preventDefault())
        }
        function h2(t3) {
            r2.contains(t3.target) || t3.target instanceof Document || (t3.stopImmediatePropagation(),
            m2(o2.mostRecentlyFocusedNode || d2()))
        }
        function p2(t3) {
            if (i2.escapeDeactivates !== !1 && function(t4) {
                return t4.key === "Escape" || t4.key === "Esc" || t4.keyCode === 27
            }(t3))
                return t3.preventDefault(),
                void s2();
            (function(t4) {
                return t4.key === "Tab" || t4.keyCode === 9
            }
            )(t3) && function(t4) {
                if (v2(),
                t4.shiftKey && t4.target === o2.firstTabbableNode)
                    return t4.preventDefault(),
                    void m2(o2.lastTabbableNode);
                !t4.shiftKey && t4.target === o2.lastTabbableNode && (t4.preventDefault(),
                m2(o2.firstTabbableNode))
            }(t3)
        }
        function g2(t3) {
            i2.clickOutsideDeactivates || r2.contains(t3.target) || i2.allowOutsideClick && (typeof i2.allowOutsideClick == "boolean" ? i2.allowOutsideClick : i2.allowOutsideClick(t3)) || (t3.preventDefault(),
            t3.stopImmediatePropagation())
        }
        function v2() {
            var t3, e3, n3, i3 = (e3 = [],
            n3 = [],
            lt(r2, (t3 = t3 || {}).includeContainer, ut).forEach(function(t4, r3) {
                var i4 = gt(t4);
                i4 === 0 ? e3.push(t4) : n3.push({
                    documentOrder: r3,
                    tabIndex: i4,
                    node: t4
                })
            }),
            n3.sort(vt).map(function(t4) {
                return t4.node
            }).concat(e3));
            o2.firstTabbableNode = i3[0] || d2(),
            o2.lastTabbableNode = i3[i3.length - 1] || d2()
        }
        function m2(t3) {
            t3 !== n2.activeElement && (t3 && t3.focus ? (t3.focus({
                preventScroll: !!i2.preventScroll
            }),
            o2.mostRecentlyFocusedNode = t3,
            function(t4) {
                return t4.tagName && t4.tagName.toLowerCase() === "input" && typeof t4.select == "function"
            }(t3) && t3.select()) : m2(d2()))
        }
    }
    function At(t2) {
        return setTimeout(t2, 0)
    }
    function kt(t2) {
        if (Array.isArray(t2)) {
            for (var e2 = 0, n2 = Array(t2.length); e2 < t2.length; e2++)
                n2[e2] = t2[e2];
            return n2
        }
        return Array.from(t2)
    }
    var Tt = !1;
    if (typeof window < "u") {
        var St = {
            get passive() {
                Tt = !0
            }
        };
        window.addEventListener("testPassive", null, St),
        window.removeEventListener("testPassive", null, St)
    }
    var xt = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1)
      , Ct = []
      , Ot = !1
      , Lt = -1
      , qt = void 0
      , Dt = void 0
      , Pt = function(t2) {
        return Ct.some(function(e2) {
            return !(!e2.options.allowTouchMove || !e2.options.allowTouchMove(t2))
        })
    }
      , jt = function(t2) {
        var e2 = t2 || window.event;
        return !!Pt(e2.target) || e2.touches.length > 1 || (e2.preventDefault && e2.preventDefault(),
        !1)
    }
      , It = function() {
        setTimeout(function() {
            Dt !== void 0 && (document.body.style.paddingRight = Dt,
            Dt = void 0),
            qt !== void 0 && (document.body.style.overflow = qt,
            qt = void 0)
        })
    }
      , Nt = function(t2, e2) {
        if (xt) {
            if (!t2)
                return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
            if (t2 && !Ct.some(function(e3) {
                return e3.targetElement === t2
            })) {
                var n2 = {
                    targetElement: t2,
                    options: e2 || {}
                };
                Ct = [].concat(kt(Ct), [n2]),
                t2.ontouchstart = function(t3) {
                    t3.targetTouches.length === 1 && (Lt = t3.targetTouches[0].clientY)
                }
                ,
                t2.ontouchmove = function(e3) {
                    e3.targetTouches.length === 1 && function(t3, e4) {
                        var n3 = t3.targetTouches[0].clientY - Lt;
                        !Pt(t3.target) && (e4 && e4.scrollTop === 0 && n3 > 0 || function(t4) {
                            return !!t4 && t4.scrollHeight - t4.scrollTop <= t4.clientHeight
                        }(e4) && n3 < 0 ? jt(t3) : t3.stopPropagation())
                    }(e3, t2)
                }
                ,
                Ot || (document.addEventListener("touchmove", jt, Tt ? {
                    passive: !1
                } : void 0),
                Ot = !0)
            }
        } else {
            (function(t3) {
                if (Dt === void 0) {
                    var e3 = !!t3 && t3.reserveScrollBarGap === !0
                      , n3 = window.innerWidth - document.documentElement.clientWidth;
                    e3 && n3 > 0 && (Dt = document.body.style.paddingRight,
                    document.body.style.paddingRight = n3 + "px")
                }
                qt === void 0 && (qt = document.body.style.overflow,
                setTimeout(function() {
                    document.body.style.overflow = "hidden"
                }))
            }
            )(e2);
            var r2 = {
                targetElement: t2,
                options: e2 || {}
            };
            Ct = [].concat(kt(Ct), [r2])
        }
    }
      , Mt = function(t2) {
        if (xt) {
            if (!t2)
                return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
            t2.ontouchstart = null,
            t2.ontouchmove = null,
            Ct = Ct.filter(function(e2) {
                return e2.targetElement !== t2
            }),
            Ot && Ct.length === 0 && (document.removeEventListener("touchmove", jt, Tt ? {
                passive: !1
            } : void 0),
            Ot = !1)
        } else
            (Ct = Ct.filter(function(e2) {
                return e2.targetElement !== t2
            })).length || It()
    }
      , zt = n(5)
      , Rt = window.theme.strings.products
      , Bt = "[data-unit-price-container]"
      , Ft = "[data-unit-price]"
      , Ht = "[data-unit-base]"
      , Vt = "unit-price--available"
      , Ut = function(t2, e2) {
        var n2 = p(Bt, t2)
          , r2 = p(Ft, t2)
          , i2 = p(Ht, t2)
          , o2 = !e2 || !e2.unit_price;
        E(n2, Vt, !o2),
        e2 && e2.unit_price && ($t(r2, K(e2.unit_price)),
        $t(i2, Gt(e2.unit_price_measurement)))
    }
      , Wt = function(t2, e2) {
        if (t2 && e2) {
            var n2 = Rt.product.unitPrice;
            return `
      <div class="unit-price `.concat(Vt, `">
        <dt>
          <span class="visually-hidden visually-hidden--inline">`).concat(n2, `</span>
        </dt>
        <dd class="unit-price__price">
          <span data-unit-price>`).concat(K(t2), '</span><span aria-hidden="true">/</span><span class="visually-hidden">').concat(Rt.product.unitPriceSeparator, "&nbsp;</span><span data-unit-base>").concat(Gt(e2), `</span>
        </dd>
      </div>
    `)
        }
        return ""
    }
      , Gt = function(t2) {
        return t2.reference_value === 1 ? t2.reference_unit : t2.reference_value + t2.reference_unit
    }
      , $t = function(t2, e2) {
        t2.forEach(function(t3) {
            return t3.innerText = e2
        })
    }
      , Jt = "is-visible"
      , Yt = "active"
      , Xt = "is-fixed"
      , Qt = "[data-store-availability-product]"
      , Zt = "[data-store-list-container]"
      , Kt = "[data-store-availability-modal-wash]"
      , te = function(t2) {
        var e2 = _t(t2, {
            allowOutsideClick: !0
        })
          , n2 = h(Kt, t2.parentNode)
          , r2 = h(Qt, t2)
          , i2 = h(Zt, t2)
          , o2 = [m(n2, "click", function(t3) {
            t3.preventDefault(),
            d2()
        }), m(t2, "keydown", function(t3) {
            t3.keyCode === 27 && d2()
        }), R("availability:showMore", function(t3) {
            var e3 = t3.product
              , n3 = t3.variant
              , i3 = t3.storeList
              , o3 = t3.options;
            r2.innerHTML = s2(e3, n3, o3),
            a2(i3),
            u2()
        })]
          , a2 = function(t3) {
            i2.innerHTML = "",
            i2.appendChild(t3)
        }
          , s2 = function(t3, e3, n3) {
            var r3 = t3.featured_image
              , i3 = t3.title
              , o3 = e3.title
              , a3 = e3.featured_image
              , s3 = e3.price
              , l3 = e3.unit_price
              , u3 = e3.unit_price_measurement
              , d3 = n3.hideVariantTitle
              , f2 = c2(r3, a3);
            return `
      <div class="store-availbility-modal__product-card">
        `.concat(f2 ? `
            <div class='store-availbility-modal__product-card-image'>
              <img src='`.concat(f2, "' alt='").concat(i3, `'/>
            </div>
          `) : "", `
        <div class='store-availbility-modal__product-card-details'>
          <div>
            <h4>
              <span>`).concat(i3, `</span>
            </h4>
            <div class="store-availbility-modal__product-price-wrapper">
              <span class="store-availbility-modal__product-price">`).concat(K(s3), `</span>
              `).concat(Wt(l3, u3), `
            </div>
            <div class="store-availbility-modal__product-card-variant`).concat(d3 ? " hidden" : "", `">
              `).concat(o3, `
            </div>
          </div>
        </div>
      </div>
    `)
        }
          , c2 = function(t3, e3) {
            return t3 || e3 ? l2(e3 ? e3.src : t3) : ""
        }
          , l2 = function(t3) {
            return Object(zt.getSizedImageUrl)(t3, "200x")
        }
          , u2 = function() {
            b(t2, Xt),
            setTimeout(function() {
                b(t2, Jt),
                b(t2, Yt)
            }, 50),
            t2.setAttribute("aria-hidden", "false"),
            e2.activate(),
            Nt(t2, {
                allowTouchMove: function(t3) {
                    for (; t3 && t3 !== document.body; ) {
                        if (t3.getAttribute("data-scroll-lock-ignore") !== null)
                            return !0;
                        t3 = t3.parentNode
                    }
                },
                reserveScrollBarGap: !0
            })
        }
          , d2 = function() {
            e2.deactivate(),
            w(t2, Yt),
            w(t2, Jt),
            t2.setAttribute("aria-hidden", "true"),
            Mt(t2),
            setTimeout(function() {
                w(t2, Xt)
            }, 300)
        };
        return {
            unload: function() {
                o2.forEach(function(t3) {
                    return t3()
                })
            }
        }
    }
      , ee = "(max-width: 40em)"
      , ne = "(min-width: 40em) and (max-width: 60em)"
      , re = "(min-width: 60em)"
      , ie = (n(30),
    n(31),
    n(32),
    n(33),
    n(34),
    n(2),
    n(35),
    n(9))
      , oe = n.n(ie)
      , ae = n(1)
      , se = n.n(ae);
    function ce(t2, e2) {
        var n2 = Object.keys(t2);
        if (Object.getOwnPropertySymbols) {
            var r2 = Object.getOwnPropertySymbols(t2);
            e2 && (r2 = r2.filter(function(e3) {
                return Object.getOwnPropertyDescriptor(t2, e3).enumerable
            })),
            n2.push.apply(n2, r2)
        }
        return n2
    }
    function le(t2) {
        for (var e2 = 1; e2 < arguments.length; e2++) {
            var n2 = arguments[e2] != null ? arguments[e2] : {};
            e2 % 2 ? ce(Object(n2), !0).forEach(function(e3) {
                oe()(t2, e3, n2[e3])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t2, Object.getOwnPropertyDescriptors(n2)) : ce(Object(n2)).forEach(function(e3) {
                Object.defineProperty(t2, e3, Object.getOwnPropertyDescriptor(n2, e3))
            })
        }
        return t2
    }
    var ue = {
        adaptiveHeight: !1,
        draggable: !1,
        fade: !0,
        pageDots: !1,
        prevNextButtons: !1,
        wrapAround: !0
    }
      , de = "is-active";
    et("announcement-bar", {
        timer: null,
        onLoad: function() {
            var t2 = this
              , e2 = parseInt(this.container.dataset.timing)
              , n2 = p("[data-single-announcement]", this.container);
            this.slideshow = new se.a(this.container,le(le({}, ue), {}, {
                autoPlay: e2,
                on: {
                    change: function(t3) {
                        n2.forEach(function(e3, n3) {
                            return E(e3, de, t3 === n3)
                        })
                    }
                }
            })),
            this.slideshow.on("pointerUp", function() {
                return t2.handleRestart()
            }),
            this.listeners = [m(this.container, "touchend", function() {
                return t2.handleRestart()
            })]
        },
        handleRestart: function() {
            var t2 = this;
            clearTimeout(this.timer),
            this.timer = setTimeout(function() {
                return t2.slideshow.playPlayer()
            }, 3500)
        },
        onBlockSelect: function(t2) {
            var e2 = t2.target;
            this.slideshow.pausePlayer(),
            this.slideshow.select(e2.dataset.index)
        },
        onBlockDeselect: function() {
            this.slideshow.unpausePlayer()
        },
        onUnload: function() {
            this.slideshow.destroy(),
            this.listeners.forEach(function(t2) {
                return t2()
            })
        }
    });
    var fe = n(11)
      , he = n.n(fe);
    function pe(t2, e2) {
        var n2 = Object.keys(t2);
        if (Object.getOwnPropertySymbols) {
            var r2 = Object.getOwnPropertySymbols(t2);
            e2 && (r2 = r2.filter(function(e3) {
                return Object.getOwnPropertyDescriptor(t2, e3).enumerable
            })),
            n2.push.apply(n2, r2)
        }
        return n2
    }
    function ge(t2) {
        for (var e2 = 1; e2 < arguments.length; e2++) {
            var n2 = arguments[e2] != null ? arguments[e2] : {};
            e2 % 2 ? pe(Object(n2), !0).forEach(function(e3) {
                oe()(t2, e3, n2[e3])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t2, Object.getOwnPropertyDescriptors(n2)) : pe(Object(n2)).forEach(function(e3) {
                Object.defineProperty(t2, e3, Object.getOwnPropertyDescriptor(n2, e3))
            })
        }
        return t2
    }
    var ve = function(t2) {
        var e2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}
          , n2 = h("[data-prev]", t2)
          , r2 = h("[data-next]", t2)
          , i2 = new se.a(t2,ge({
            adaptiveHeight: !0,
            cellAlign: "left",
            cellSelector: "[data-slide]",
            pageDots: !1,
            prevNextButtons: !1,
            watchCSS: !0,
            wrapAround: !0
        }, e2))
          , o2 = new IntersectionObserver(function(e3) {
            he()(e3, 1)[0].isIntersecting && (i2.slides || {}).length > 1 && (b(r2, "visible"),
            o2.unobserve(t2))
        }
        ,{
            threshold: .75
        });
        function a2() {
            b(n2, "visible"),
            i2.off("change", a2)
        }
        o2.observe(t2);
        var s2 = m(n2, "click", function() {
            return i2.previous()
        })
          , c2 = m(r2, "click", function() {
            return i2.next()
        });
        return i2.on("change", a2),
        {
            destroy: function() {
                (i2.slides || {}).length > 1 && (s2(),
                c2()),
                o2.disconnect(),
                i2.destroy()
            },
            select: function(t3) {
                return i2.select(t3)
            }
        }
    }
      , me = "[data-slider]";
    et("blog-posts", {
        onLoad: function() {
            var t2 = this.container.querySelector(me);
            this.mobileCarousel = ve(t2)
        },
        onUnload: function() {
            this.mobileCarousel.destroy()
        }
    });
    var ye = ".mobile-carousel__pagination-arrow"
      , be = "[data-js-slide]"
      , we = "[data-js-slider]";
    et("carousel", {
        onLoad: function() {
            var t2 = this
              , e2 = h(we, this.container)
              , n2 = p(ye, this.container)
              , r2 = h("[data-prev]", this.container)
              , i2 = h("[data-next]", this.container);
            b(n2, "visible");
            var o2 = function() {
                var e3 = h(".carousel__slide .carousel__image", t2.container);
                e3 && t2.container.style.setProperty("--height-carousel", e3.offsetHeight + "px")
            };
            this.flkty = new se.a(e2,{
                adaptiveHeight: !1,
                cellSelector: be,
                pageDots: !1,
                prevNextButtons: !1,
                setGallerySize: !1,
                wrapAround: !0,
                on: {
                    ready: function() {
                        return o2()
                    }
                }
            }),
            this.flkty.on("resize", function() {
                return o2()
            }),
            this.prevClick = m(r2, "click", function() {
                return t2.flkty.previous()
            }),
            this.nextClick = m(i2, "click", function() {
                return t2.flkty.next()
            })
        },
        onUnload: function() {
            this.flkty.destroy(),
            (this.flkty.slides || {}).length > 1 && (this.prevClick(),
            this.nextClick())
        },
        onBlockSelect: function(t2) {
            var e2 = t2.target;
            this.flkty.select(e2.dataset.index)
        }
    });
    var Ee = "[data-slider]";
    et("collection-list", {
        onLoad: function() {
            var t2 = this.container.querySelector(Ee);
            this.mobileCarousel = ve(t2, {
                groupCells: 2
            })
        },
        onUnload: function() {
            this.mobileCarousel.destroy()
        },
        onBlockSelect: function(t2) {
            var e2 = t2.target;
            this.mobileCarousel.select(e2.dataset.index)
        }
    }),
    et("custom-content", {
        onLoad: function() {},
        onUnload: function() {}
    });
    var _e = "[data-slider]";
    et("featured-collection", {
        onLoad: function() {
            var t2 = this.container.querySelector(_e);
            this.mobileCarousel = ve(t2, {
                groupCells: 2
            })
        },
        onUnload: function() {
            this.mobileCarousel.destroy()
        }
    });
    /*!
* slide-anim
* https://github.com/yomotsu/slide-anim
* (c) 2017 @yomotsu
* Released under the MIT License.
*/
    var Ae = window
      , ke = typeof Ae.Promise == "function" ? Ae.Promise : function(t2) {
        var e2 = function() {};
        return t2(function() {
            e2()
        }),
        {
            then: function(t3) {
                e2 = t3
            }
        }
    }
      , Te = []
      , Se = {
        add: function(t2, e2, n2, r2) {
            var i2 = {
                el: t2,
                defaultStyle: e2,
                timeoutId: n2,
                onCancelled: r2
            };
            this.remove(t2),
            Te.push(i2)
        },
        remove: function(t2) {
            var e2 = Se.findIndex(t2);
            if (e2 !== -1) {
                var n2 = Te[e2];
                clearTimeout(n2.timeoutId),
                n2.onCancelled(),
                Te.splice(e2, 1)
            }
        },
        find: function(t2) {
            return Te[Se.findIndex(t2)]
        },
        findIndex: function(t2) {
            var e2 = -1;
            return Te.some(function(n2, r2) {
                return n2.el === t2 && (e2 = r2,
                !0)
            }),
            e2
        }
    };
    function xe(t2, e2) {
        return e2 === void 0 && (e2 = {}),
        new ke(function(n2) {
            if (Se.findIndex(t2) === -1) {
                var r2 = Le(t2)
                  , i2 = typeof e2.endHeight == "number"
                  , o2 = e2.display || "block"
                  , a2 = e2.duration || 400
                  , s2 = e2.onCancelled || function() {}
                  , c2 = t2.getAttribute("style") || ""
                  , l2 = window.getComputedStyle(t2)
                  , u2 = function(t3, e3) {
                    e3 === void 0 && (e3 = "block");
                    var n3 = t3.getAttribute("style") || ""
                      , r3 = window.getComputedStyle(t3);
                    t3.style.visibility = "hidden",
                    t3.style.display = e3;
                    var i3 = De(r3.getPropertyValue("width"));
                    t3.style.position = "absolute",
                    t3.style.width = i3 + "px",
                    t3.style.height = "",
                    t3.style.minHeight = "",
                    t3.style.paddingTop = "",
                    t3.style.paddingBottom = "",
                    t3.style.borderTopWidth = "",
                    t3.style.borderBottomWidth = "";
                    var o3 = De(r3.getPropertyValue("min-height"))
                      , a3 = De(r3.getPropertyValue("padding-top"))
                      , s3 = De(r3.getPropertyValue("padding-bottom"))
                      , c3 = De(r3.getPropertyValue("border-top-width"))
                      , l3 = De(r3.getPropertyValue("border-bottom-width"))
                      , u3 = t3.scrollHeight;
                    return t3.setAttribute("style", n3),
                    {
                        height: u3,
                        minHeight: o3,
                        paddingTop: a3,
                        paddingBottom: s3,
                        borderTop: c3,
                        borderBottom: l3
                    }
                }(t2, o2)
                  , d2 = /border-box/.test(l2.getPropertyValue("box-sizing"))
                  , f2 = u2.height
                  , h2 = u2.minHeight
                  , p2 = u2.paddingTop
                  , g2 = u2.paddingBottom
                  , v2 = u2.borderTop
                  , m2 = u2.borderBottom
                  , y2 = a2 + "ms"
                  , b2 = "cubic-bezier( 0.19, 1, 0.22, 1 )"
                  , w2 = ["height " + y2 + " " + b2, "min-height " + y2 + " " + b2, "padding " + y2 + " " + b2, "border-width " + y2 + " " + b2].join()
                  , E2 = r2 ? l2.height : "0px"
                  , _2 = r2 ? l2.minHeight : "0px"
                  , A2 = r2 ? l2.paddingTop : "0px"
                  , k2 = r2 ? l2.paddingBottom : "0px"
                  , T2 = r2 ? l2.borderTopWidth : "0px"
                  , S2 = r2 ? l2.borderBottomWidth : "0px"
                  , x2 = i2 ? e2.endHeight + "px" : d2 ? f2 + v2 + m2 + "px" : f2 - p2 - g2 + "px"
                  , C2 = h2 + "px"
                  , O2 = p2 + "px"
                  , L2 = g2 + "px"
                  , q2 = v2 + "px"
                  , D2 = m2 + "px";
                if (E2 !== x2 || A2 !== O2 || k2 !== L2 || T2 !== q2 || S2 !== D2) {
                    requestAnimationFrame(function() {
                        t2.style.height = E2,
                        t2.style.minHeight = _2,
                        t2.style.paddingTop = A2,
                        t2.style.paddingBottom = k2,
                        t2.style.borderTopWidth = T2,
                        t2.style.borderBottomWidth = S2,
                        t2.style.display = o2,
                        t2.style.overflow = "hidden",
                        t2.style.visibility = "visible",
                        t2.style.transition = w2,
                        t2.style.webkitTransition = w2,
                        requestAnimationFrame(function() {
                            t2.style.height = x2,
                            t2.style.minHeight = C2,
                            t2.style.paddingTop = O2,
                            t2.style.paddingBottom = L2,
                            t2.style.borderTopWidth = q2,
                            t2.style.borderBottomWidth = D2
                        })
                    });
                    var P2 = setTimeout(function() {
                        qe(t2),
                        t2.style.display = o2,
                        i2 && (t2.style.height = e2.endHeight + "px",
                        t2.style.overflow = "hidden"),
                        Se.remove(t2),
                        n2()
                    }, a2);
                    Se.add(t2, c2, P2, s2)
                } else
                    n2()
            }
        }
        )
    }
    function Ce(t2, e2) {
        return e2 === void 0 && (e2 = {}),
        new ke(function(n2) {
            if (Se.findIndex(t2) === -1) {
                var r2 = Le(t2)
                  , i2 = e2.display || "block"
                  , o2 = e2.duration || 400
                  , a2 = e2.onCancelled || function() {}
                ;
                if (r2) {
                    var s2 = t2.getAttribute("style") || ""
                      , c2 = window.getComputedStyle(t2)
                      , l2 = /border-box/.test(c2.getPropertyValue("box-sizing"))
                      , u2 = De(c2.getPropertyValue("min-height"))
                      , d2 = De(c2.getPropertyValue("padding-top"))
                      , f2 = De(c2.getPropertyValue("padding-bottom"))
                      , h2 = De(c2.getPropertyValue("border-top-width"))
                      , p2 = De(c2.getPropertyValue("border-bottom-width"))
                      , g2 = t2.scrollHeight
                      , v2 = o2 + "ms"
                      , m2 = "cubic-bezier( 0.19, 1, 0.22, 1 )"
                      , y2 = ["height " + v2 + " " + m2, "padding " + v2 + " " + m2, "border-width " + v2 + " " + m2].join()
                      , b2 = l2 ? g2 + h2 + p2 + "px" : g2 - d2 - f2 + "px"
                      , w2 = u2 + "px"
                      , E2 = d2 + "px"
                      , _2 = f2 + "px"
                      , A2 = h2 + "px"
                      , k2 = p2 + "px";
                    requestAnimationFrame(function() {
                        t2.style.height = b2,
                        t2.style.minHeight = w2,
                        t2.style.paddingTop = E2,
                        t2.style.paddingBottom = _2,
                        t2.style.borderTopWidth = A2,
                        t2.style.borderBottomWidth = k2,
                        t2.style.display = i2,
                        t2.style.overflow = "hidden",
                        t2.style.transition = y2,
                        t2.style.webkitTransition = y2,
                        requestAnimationFrame(function() {
                            t2.style.height = "0",
                            t2.style.minHeight = "0",
                            t2.style.paddingTop = "0",
                            t2.style.paddingBottom = "0",
                            t2.style.borderTopWidth = "0",
                            t2.style.borderBottomWidth = "0"
                        })
                    });
                    var T2 = setTimeout(function() {
                        qe(t2),
                        t2.style.display = "none",
                        Se.remove(t2),
                        n2()
                    }, o2);
                    Se.add(t2, s2, T2, a2)
                } else
                    n2()
            }
        }
        )
    }
    function Oe(t2) {
        if (Se.find(t2)) {
            var e2 = window.getComputedStyle(t2)
              , n2 = e2.height
              , r2 = e2.paddingTop
              , i2 = e2.paddingBottom
              , o2 = e2.borderTopWidth
              , a2 = e2.borderBottomWidth;
            qe(t2),
            t2.style.height = n2,
            t2.style.paddingTop = r2,
            t2.style.paddingBottom = i2,
            t2.style.borderTopWidth = o2,
            t2.style.borderBottomWidth = a2,
            t2.style.overflow = "hidden",
            Se.remove(t2)
        }
    }
    function Le(t2) {
        return t2.offsetHeight !== 0
    }
    function qe(t2) {
        t2.style.visibility = "",
        t2.style.height = "",
        t2.style.minHeight = "",
        t2.style.paddingTop = "",
        t2.style.paddingBottom = "",
        t2.style.borderTopWidth = "",
        t2.style.borderBottomWidth = "",
        t2.style.overflow = "",
        t2.style.transition = "",
        t2.style.webkitTransition = ""
    }
    function De(t2) {
        return +t2.replace(/px/, "")
    }
    function Pe(t2) {
        var e2 = p(".accordion__label", t2);
        e2.forEach(function(t3) {
            t3.href = "#";
            var existingIcon = t3.querySelector(".icon");
            if (!existingIcon) {
                var icon = document.createElement("div");
                icon.classList.add("icon"),
                icon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 24 24"><path d="M7 10L12 15L17 10H7Z" fill="currentColor"/></svg>',
                t3.append(icon)
            }
        });
        var n2 = m(e2, "click", function(t3) {
            var e3 = t3.currentTarget
              , n3 = e3.parentNode
              , r2 = e3.nextElementSibling;
            t3.preventDefault(),
            Oe(r2),
            Le(r2) ? (Ce(r2),
            n3.setAttribute("data-open", !1)) : (xe(r2),
            n3.setAttribute("data-open", !0))
        });
        return {
            destroy: function() {
                return function() {
                    return n2()
                }
            }
        }
    }
    function je(t2) {
        var e2 = t2.map(Pe);
        return {
            accordions: e2,
            destroy: function() {
                e2.forEach(function(t3) {
                    return t3.destroy()
                })
            }
        }
    }
    function Ie(t2) {
        var e2 = window
          , n2 = e2.Shopify
          , r2 = e2.YT
          , i2 = p("[data-interactive]", t2);
        if (i2.length) {
            var o2 = ["video", "model", "external_video"]
              , a2 = null
              , s2 = !1
              , c2 = {};
            return s2 && i2.forEach(l2),
            window.Shopify.loadFeatures([{
                name: "model-viewer-ui",
                version: "1.0"
            }, {
                name: "shopify-xr",
                version: "1.0"
            }, {
                name: "video-ui",
                version: "1.0"
            }], function() {
                s2 = !0,
                "YT"in window && r2.loaded ? i2.forEach(l2) : window.onYouTubeIframeAPIReady = function() {
                    i2.forEach(l2)
                }
            }),
            {
                pauseActiveMedia: u2
            }
        }
        function l2(t3) {
            var e3 = t3.dataset
              , i3 = e3.mediaId
              , s3 = e3.mediaType;
            if (s3 && o2.includes(s3) && !Object.keys(c2).includes(i3)) {
                var l3 = {
                    id: i3,
                    type: s3,
                    container: t3,
                    media: t3.children[0]
                };
                switch (l3.type) {
                case "video":
                    l3.player = new n2.Plyr(l3.media,{
                        loop: {
                            active: t3.dataset.loop == "true"
                        }
                    });
                    break;
                case "external_video":
                    l3.player = new r2.Player(l3.media);
                    break;
                case "model":
                    l3.viewer = new n2.ModelViewerUI(h("model-viewer", t3)),
                    m(h(".model-poster", t3), "click", function(t4) {
                        t4.preventDefault(),
                        function(t5) {
                            u2(t5),
                            t5.viewer.play(),
                            b(t5.container, "model-active"),
                            a2 = t5,
                            setTimeout(function() {
                                h("model-viewer", t5.container).focus()
                            }, 300)
                        }(l3)
                    })
                }
                c2[i3] = l3,
                l3.player && (l3.type === "video" ? l3.player.on("playing", function() {
                    u2(l3),
                    a2 = l3
                }) : l3.type === "external_video" && l3.player.addEventListener("onStateChange", function(t4) {
                    t4.data === 1 && (u2(l3),
                    a2 = l3)
                }))
            }
        }
        function u2(t3) {
            if (a2 && t3 != a2)
                return a2.player ? (a2.type === "video" ? a2.player.pause() : a2.type === "external_video" && a2.player.pauseVideo(),
                void (a2 = null)) : void (a2.viewer && (w(a2.container, "model-active"),
                a2.viewer.pause(),
                a2 = null))
        }
    }
    function Ne(t2) {
        var e2 = t2.map(Me);
        return {
            groups: e2,
            destroy: function() {
                e2 && e2.forEach(function(t3) {
                    return t3()
                })
            }
        }
    }
    function Me(t2) {
        var e2 = h("select", t2)
          , n2 = p("[data-button]", t2)
          , r2 = m(n2, "click", function(t3) {
            t3.preventDefault();
            var r3 = t3.currentTarget.dataset.button;
            let option_size = t3.currentTarget.dataset.optionSize
              , selectElMain = t3.target.closest("form").querySelectorAll("select#variant-selector option")
              , pfContainer = t3.target.closest(".pf-container").querySelector(".product-form__chips");
            n2.forEach(function(t4) {
                return E(t4, "selected", t4.dataset.button === r3)
            }),
            h('[value="'.concat(r3, '"]'), e2).selected = !0,
            e2.dispatchEvent(new Event("change")),
            option_size > 1 && pfContainer.dataset.optionName == "size" && optionSoldoutCheck(r3, selectElMain, !1, !1)
        });
        return function() {
            return r2()
        }
    }
    var ze = n(19)
      , Re = n.n(ze)
      , Be = '[name="id"]'
      , Fe = '[name^="options"]'
      , He = '[name="quantity"]'
      , Ve = '[name^="properties"]';
    function Ue(t2, e2) {
        var n2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}
          , r2 = We(e2)
          , i2 = []
          , o2 = function() {
            return Ge(p2, function(t3) {
                return t3.name = /(?:^(options\[))(.*?)(?:\])/.exec(t3.name)[2],
                t3
            })
        }
          , a2 = function() {
            return k(r2, o2())
        }
          , s2 = function() {
            var t3 = $e(v2, function(t4) {
                return /(?:^(properties\[))(.*?)(?:\])/.exec(t4)[2]
            });
            return Object.entries(t3).length === 0 ? null : t3
        }
          , c2 = function() {
            return g2[0] ? Number.parseInt(g2[0].value, 10) : 1
        }
          , l2 = function() {
            return {
                options: o2(),
                variant: a2(),
                properties: s2(),
                quantity: c2()
            }
        }
          , u2 = function(t3) {
            if (t3 !== void 0)
                return function(e3) {
                    e3.dataset = l2(),
                    t3(e3)
                }
        }
          , d2 = function(e3) {
            var n3 = t2.querySelector(Be);
            n3 || (n3 = document.createElement("input"),
            n3.type = "hidden",
            n3.name = "id",
            t2.dataset.form !== "bundle" && t2.appendChild(n3)),
            n3.value = e3.toString()
        }
          , f2 = function(t3) {
            t3.dataset = l2(),
            d2(t3.dataset.variant.id),
            n2.onFormSubmit && n2.onFormSubmit(t3)
        }
          , h2 = function(e3, n3) {
            return D()(t2.querySelectorAll(e3)).map(function(t3) {
                return i2.push(m(t3, "change", u2(n3))),
                t3
            })
        };
        i2.push(m(t2, "submit", f2));
        var p2 = h2(Fe, n2.onOptionChange)
          , g2 = h2(He, n2.onQuantityChange)
          , v2 = h2(Ve, n2.onPropertyChange)
          , y2 = function() {
            i2.forEach(function(t3) {
                return t3()
            })
        };
        return {
            getVariant: a2,
            destroy: y2
        }
    }
    function We(t2) {
        if (Re()(t2) !== "object")
            throw new TypeError(t2 + " is not an object.");
        if (t2.variants[0].options === void 0)
            throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
        return t2
    }
    function Ge(t2, e2) {
        return t2.reduce(function(t3, n2) {
            return (n2.checked || n2.type !== "radio" && n2.type !== "checkbox") && t3.push(e2({
                name: n2.name,
                value: n2.value
            })),
            t3
        }, [])
    }
    function $e(t2, e2) {
        return t2.reduce(function(t3, n2) {
            return (n2.checked || n2.type !== "radio" && n2.type !== "checkbox") && (t3[e2(n2.name)] = n2.value),
            t3
        }, {})
    }
    var Je = "[data-store-availability-modal-trigger]"
      , Ye = "[data-store-availability-list-content]"
      , Xe = function(t2, e2, n2, r2) {
        var i2 = null
          , o2 = n2
          , a2 = new f.a(t2)
          , s2 = function(e3) {
            o2 = e3;
            var n3 = "".concat(t2.dataset.baseUrl, "/variants/").concat(e3.id, "/?section_id=store-availability");
            t2.innerHTML = "",
            fetch(n3).then(function(t3) {
                return t3.text()
            }).then(function(e4) {
                e4.trim() !== "" && (t2.innerHTML = e4.trim(),
                t2.innerHTML = t2.firstElementChild.innerHTML,
                i2 = h(Ye, t2))
            })
        };
        return s2(n2),
        a2.on("click", Je, function(t3) {
            t3.preventDefault(),
            B("availability:showMore", function() {
                return {
                    product: e2,
                    variant: o2,
                    storeList: i2,
                    options: r2
                }
            })
        }),
        {
            unload: function() {
                t2.innerHTML = ""
            },
            update: s2
        }
    }
      , Qe = "[data-product-form]"
      , Ze = "[data-add-to-cart]"
      , Ke = "[data-price]"
      , tn = "[data-compare-price]"
      , en = "[data-variant-select]"
      , nn = function(t2) {
        return "[value='".concat(t2, "']")
    }
      , rn = "[data-store-availability-container]";
    function on(t2, e2) {
        var n2 = h("[data-add-to-cart-text]", t2)
          , r2 = t2.dataset
          , i2 = r2.langAvailable
          , o2 = r2.langUnavailable
          , a2 = r2.langSoldOut;
        e2 ? e2.available ? (t2.removeAttribute("disabled"),
        n2.textContent = i2) : (t2.setAttribute("disabled", "disabled"),
        n2.textContent = a2) : (t2.setAttribute("disabled", "disabled"),
        n2.textContent = o2)
    }
    et("featured-product", {
        productForm: null,
        onLoad: function() {
            var t2 = this
              , e2 = this.container.dataset.productHasOnlyDefaultVariant;
            if (this.formElement = h(Qe, this.container),
            this.formElement) {
                var n2 = this.formElement.dataset.productHandle;
                this.storeAvailabilityContainer = this.formElement.querySelector(rn),
                this.availability = null,
                tt(n2)(function(n3) {
                    t2.productForm = Ue(t2.formElement, n3, {
                        onOptionChange: function(e3) {
                            return t2.onOptionChange(e3)
                        },
                        onFormSubmit: t2.onFormSubmit
                    });
                    var r3 = t2.productForm.getVariant();
                    t2.storeAvailabilityContainer && r3 && (t2.availability = Xe(t2.storeAvailabilityContainer, n3, r3, {
                        hideVariantTitle: e2 === "true"
                    }))
                }),
                this.images = p("[data-media]", this.container),
                this.media = Ie(h(".featured-product__media-container", this.container)),
                this.optionButtons = Ne(p("[data-option-buttons]", this.container));
                var r2 = h("[data-share]", this.container);
                if (r2) {
                    var i2 = h("[data-description]", this.container).childNodes || null
                      , o2 = i2 ? i2[i2.length - 1] : null;
                    if (o2 && o2.nodeName === "DIV" && o2.classList.contains("accordion")) {
                        var a2 = `
            <div class="accordion__group">
              <a class="accordion__label">`.concat(r2.dataset.share, `</a>
              <div class="accordion__text">`).concat(r2.innerHTML, `</div>
            </div>
          `);
                        o2.insertAdjacentHTML("beforeend", a2),
                        r2.style.display = "none"
                    }
                }
                this.accordions = je(p(".accordion", this.container)),
                it();
                var s2 = h(".product-form", this.container);
                this.observer = new MutationObserver(function(e3) {
                    e3.forEach(function(e4) {
                        if (D()(e4.removedNodes).find(function(t3) {
                            return t3.classList.contains("shopify-product-reviews-badge")
                        })) {
                            t2.observer.disconnect();
                            var n3 = h(".spr-badge", t2.container)
                              , r3 = document.createElement("label");
                            r3.classList.add("pf-review-label"),
                            r3.textContent = window.theme.strings.product.reviews || "Reviews",
                            n3.prepend(r3)
                        }
                    })
                }
                ),
                this.observer.observe(s2, {
                    childList: !0
                })
            }
        },
        onUnload: function() {
            this.productForm && (this.optionButtons.destroy(),
            this.productForm.destroy(),
            this.accordions.destroy(),
            this.observer.disconnect())
        },
        onOptionChange: function(t2) {
            var e2 = t2.dataset.variant;
            if (Ut(this.container, e2),
            !e2)
                return on(h("[data-add-to-cart]", this.container), !1),
                void (this.availability && this.availability.unload());
            (e2.featured_media || {}).id && (this.media && this.media.pauseActiveMedia(),
            this.images.forEach(function(t3) {
                E(t3, "visible", t3.dataset.media === String(e2.featured_media.id))
            })),
            this.updatePrices(e2),
            h("".concat(en, " ").concat(nn(e2.id)), this.container).selected = !0,
            this.availability && this.availability.update(e2),
            this.formElement.dispatchEvent(new Event("change"))
        },
        onFormSubmit: function(t2) {
            if (document.body.dataset.enableCartAjax) {
                t2.preventDefault();
                var e2 = t2.dataset
                  , n2 = e2.variant
                  , r2 = e2.quantity
                  , i2 = h(Ze, this.container);
                b(i2, "loading"),
                Q.addVariant(n2, r2).then(function() {
                    w(i2, "loading"),
                    B("cart:open", null, {
                        flash: n2.id
                    })
                })
            }
        },
        updatePrices: function(t2) {
            var e2 = p(Ke, this.container)
              , n2 = p(tn, this.container)
              , r2 = h("[data-add-to-cart]", this.container);
            e2.forEach(function(e3) {
                return e3.innerHTML = K(t2.price)
            }),
            n2.forEach(function(e3) {
                return e3.innerHTML = t2.compare_at_price > t2.price ? K(t2.compare_at_price) : ""
            }),
            on(r2, t2)
        }
    });
    var an = "[data-slider]";
    et("featured-products", {
        onLoad: function() {
            var t2 = h(an, this.container);
            t2 && (this.mobileCarousel = ve(t2, {
                adaptiveHeight: !1,
                groupCells: 2
            }))
        },
        onUnload: function() {
            this.mobileCarousel.destroy()
        }
    });
    var sn = ".selectors-form"
      , cn = "[data-disclosure-list]"
      , ln = "[data-disclosure-toggle]"
      , un = "[data-disclosure-input]"
      , dn = "[data-disclosure-option]"
      , fn = "disclosure-list--visible";
    function hn(t2, e2) {
        return t2.map(function(t3) {
            return t3.contains(e2)
        }).filter(Boolean)
    }
    var pn = "[data-disclosure]"
      , gn = "[data-header]";
    et("footer", {
        crossBorder: {},
        onLoad: function() {
            var t2 = this
              , e2 = p(gn, this.container);
            this.headerClick = m(e2, "click", function(t3) {
                var e3 = t3.currentTarget
                  , n3 = e3.nextElementSibling;
                E(e3, "open", !Le(n3)),
                Oe(n3),
                Le(n3) ? Ce(n3) : xe(n3)
            });
            var n2 = p(pn, this.container);
            n2 && n2.forEach(function(e3) {
                var n3 = e3.dataset.disclosure;
                t2.crossBorder[n3] = function(t3) {
                    var e4 = t3.closest(sn)
                      , n4 = h(cn, t3)
                      , r2 = h(ln, t3)
                      , i2 = h(un, t3)
                      , o2 = p(dn, t3)
                      , a2 = [m(r2, "click", function(t4) {
                        var e5 = t4.currentTarget.getAttribute("aria-expanded") === !0;
                        t4.currentTarget.setAttribute("aria-expanded", !e5),
                        n4.classList.toggle(fn)
                    }), m(o2, "click", function(t4) {
                        t4.preventDefault();
                        var n5 = t4.currentTarget.dataset.value;
                        i2.value = n5,
                        e4.submit()
                    }), m(document, "click", function(e5) {
                        var r3 = hn([t3], e5.target).length > 0;
                        n4.classList.contains(fn) && !r3 && s2()
                    }), m(r2, "focusout", function(e5) {
                        hn([t3], e5.relatedTarget).length === 0 && s2()
                    }), m(n4, "focusout", function(e5) {
                        var r3 = hn([t3], e5.relatedTarget).length > 0;
                        n4.classList.contains(fn) && !r3 && s2()
                    }), m(t3, "keyup", function(t4) {
                        t4.which === 27 && (s2(),
                        r2.focus())
                    })];
                    function s2() {
                        r2.setAttribute("aria-expanded", !1),
                        n4.classList.remove(fn)
                    }
                    return {
                        unload: function() {
                            a2.forEach(function(t4) {
                                return t4()
                            })
                        }
                    }
                }(e3)
            }),
            Q.giftBoxAddOn()
        },
        onUnload: function() {
            var t2 = this;
            this.headerClick(),
            Object.keys(this.crossBorder).forEach(function(e2) {
                return t2.crossBorder[e2].unload()
            })
        }
    });
    var vn = "[data-slider]";
    et("gallery", {
        onLoad: function() {
            var t2 = this.container.querySelector(vn);
            this.mobileCarousel = ve(t2)
        },
        onUnload: function() {
            this.mobileCarousel.destroy()
        },
        onBlockSelect: function(t2) {
            var e2 = t2.target;
            this.mobileCarousel.select(e2.dataset.index)
        }
    });
    var mn = n(20)
      , yn = function(t2) {
        return function(e2) {
            e2.preventDefault(),
            t2()
        }
    }
      , bn = n(21)
      , wn = n.n(bn)
      , En = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="currentColor" />
    </svg>
  `
      , _n = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19 13H5v-2h14v2z" fill="currentColor" />
    </svg>
  `;
    function An(t2) {
        var e2 = new f.a(t2)
          , n2 = h("[data-overlay]", t2)
          , r2 = h("[data-cart]", t2)
          , i2 = h("[data-configure]", t2)
          , o2 = h("[data-items]", t2)
          , a2 = h("[data-empty]", t2)
          , s2 = h("[data-footer]", t2)
          , c2 = h("[data-discounts]", s2)
          , l2 = h("[data-subtotal]", s2)
          , u2 = h("[data-add]", i2)
          , d2 = h("[data-contents]", u2)
          , minicart_protection = h(".quick-cart__protection", t2);
        const dadaNode = document.querySelector(".quick-cart__items");
        function updateMiniCartEmroidery(parentLine, parentQty, embroideryKey, embroideryQty, identicalIconKey, times, action, thisElem) {
            const refreshMiniCart = () => fetch("/cart.js", {
                credentials: "same-origin",
                method: "GET",
                headers: {
                    "X-Requested-With": "XMLHttpRequest"
                }
            }).then(response => response.json()).then(cartData => {
                dadaNode.classList.remove("updating"),
                B("cart:updated", {
                    cart: G(cartData)
                });
                return G(cartData)
            }).catch(() => {
                dadaNode.classList.remove("updating")
            });
            let bodyData = {
                line: parentLine,
                quantity: parentQty
            };
            action == "removeEmbroidery" && (bodyData = {
                line: parentLine,
                quantity: parentQty,
                properties: {
                    "": ""
                }
            }),
            fetch("/cart/change.js", {
                body: JSON.stringify(bodyData),
                credentials: "same-origin",
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }).then(response => response.text()).then(state => {
                const parsedState = JSON.parse(state);
                if (parsedState.message) {
                    let selectedElement = thisElem.querySelector(".quick-cart__item-right");
                    if (!selectedElement.querySelector(".quick-cart__item-error")) {
                        const errorMsg = `<div class="quick-cart__item-error">${parsedState.message}</div>`;
                        selectedElement.insertAdjacentHTML("beforeend", errorMsg)
                    }
                    return refreshMiniCart()
                } else if (embroideryKey && parentQty > 0 && action != "remove") {
                    let updateData = {
                        updates: embroideryKey.reduce( (acc, key) => (acc[key] = identicalIconKey && key === identicalIconKey ? embroideryQty * times : embroideryQty,
                        acc), {})
                    };
                    fetch("/cart/update.js", {
                        body: JSON.stringify(updateData),
                        credentials: "same-origin",
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    }).then(function(cart) {
                        cart.json().then(function(content2) {
                            if (content2.status == 422)
                                return console.log(content2.description),
                                refreshMiniCart();
                            if (window.protectioncharges)
                                Q.protectionCheck(content2, null, action).then(function(t3) {
                                    return dadaNode.classList.remove("updating"),
                                    B("cart:updated", {
                                        cart: G(t3)
                                    }),
                                    G(t3)
                                });
                            else
                                return dadaNode.classList.remove("updating"),
                                B("cart:updated", {
                                    cart: G(content2)
                                }),
                                G(content2)
                        })
                    })
                } else {
                    if (parsedState.status == 422)
                        return console.log(parsedState.description),
                        refreshMiniCart();
                    if (window.protectioncharges)
                        Q.protectionCheck(parsedState, null, action).then(function(t3) {
                            return dadaNode.classList.remove("updating"),
                            B("cart:updated", {
                                cart: G(t3)
                            }),
                            G(t3)
                        });
                    else {
                        if (parsedState.items.length > 0) {
                            var cartSubTotalNoInsurance = parsedState.total_price
                              , minicartFooterSubtotal = document.querySelector("[data-subtotal]");
                            parsedState.items.forEach(item => {
                                item.product_type == "Insurance" && (cartSubTotalNoInsurance -= item.line_price)
                            }
                            ),
                            minicartFooterSubtotal.innerHTML = K(cartSubTotalNoInsurance)
                        }
                        return dadaNode.classList.remove("updating"),
                        B("cart:updated", {
                            cart: G(parsedState)
                        }),
                        G(parsedState)
                    }
                }
            }
            )
        }
        function updateMiniCartGiftBoxAddOn(key, itemCount) {
            fetch("/cart/update.js", {
                body: JSON.stringify({}),
                credentials: "same-origin",
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }).then(function(response) {
                if (window.giftboxAddOn.enable && response.ok) {
                    var giftBoxElem = document.querySelector(".quick-cart__giftbox-addon")
                      , giftBoxProductId = giftBoxElem.querySelector("#toggleGiftBox")
                      , totalCartDrawerItem = document.querySelectorAll(".quick-cart__item");
                    if (itemCount == 0 && totalCartDrawerItem.length == 1 && (console.log("cart none gifbox product"),
                    giftBoxElem.classList.remove("active")),
                    giftBoxProductId) {
                        var gbProdId = giftBoxProductId.getAttribute("data-variant-id")
                          , currentProductId = key.split(":");
                        gbProdId == currentProductId[0] && itemCount == 0 && totalCartDrawerItem.length > 1 && (giftBoxElem.classList.add("active"),
                        console.log("cart gifbox product"))
                    }
                }
            }).catch(error => {
                console.error("Error:", error)
            }
            )
        }
        e2.on("click", "button[data-decrease]", function(t3, e3) {
            dadaNode.classList.add("updating");
            var parentNode = e3.closest(".quick-cart__item")
              , parentQty = parseInt(h("[data-qty]", e3.parentNode).innerHTML) - 1
              , removeEmbBtn = parentNode.querySelector("[data-remove-emb]")
              , hasEmbroidery = parentNode.classList.contains("embroidery-false")
              , parentProdKey = parentNode.dataset.cartKey
              , parentCartKey = parentNode.dataset.cartKey
              , parentProdLine = parentNode.dataset.line
              , childIdenticalIconsVarId_x = parentNode.dataset.identicalembroideryiconsvarid.split(":")
              , childIdenticalIconsVarId = childIdenticalIconsVarId_x[0] || null
              , childIdenticalIconsNum = parseInt(childIdenticalIconsVarId_x[1]) || null;
            if (hasEmbroidery && removeEmbBtn) {
                var embRefItems = document.querySelectorAll('div[data-parent-id="' + parentProdKey + '"]')
                  , embroideryProdKeyList = []
                  , embroideryProdLineList = [];
                let identicalIconKey = null;
                embRefItems.length && embRefItems.forEach(function(embRefItem) {
                    childIdenticalIconsVarId && embRefItem.dataset.id == childIdenticalIconsVarId && (identicalIconKey = embRefItem.dataset.cartKey),
                    embroideryProdKeyList.push(embRefItem.dataset.cartKey),
                    embroideryProdLineList.push(embRefItem.dataset.line)
                }),
                embroideryProdKeyList && updateMiniCartEmroidery(parentProdLine, parentQty, embroideryProdKeyList, parentQty, identicalIconKey, childIdenticalIconsNum, "minus", parentNode)
            } else
                updateMiniCartEmroidery(parentProdLine, parentQty, null, null, null, null, "minus", parentNode)
        }),
        e2.on("click", "button[data-increase]", function(t3, e3) {
            dadaNode.classList.add("updating");
            var parentNode = e3.closest(".quick-cart__item")
              , parentQty = parseInt(h("[data-qty]", e3.parentNode).innerHTML) + 1
              , removeEmbBtn = parentNode.querySelector("[data-remove-emb]")
              , hasEmbroidery = parentNode.classList.contains("embroidery-false")
              , parentProdKey = parentNode.dataset.cartKey
              , parentCartKey = parentNode.dataset.cartKey
              , parentProdLine = parentNode.dataset.line
              , childIdenticalIconsVarId_x = parentNode.dataset.identicalembroideryiconsvarid.split(":")
              , childIdenticalIconsVarId = childIdenticalIconsVarId_x[0] || null
              , childIdenticalIconsNum = parseInt(childIdenticalIconsVarId_x[1]) || null;
            if (hasEmbroidery && removeEmbBtn) {
                var embRefItems = document.querySelectorAll('div[data-parent-id="' + parentProdKey + '"]')
                  , embroideryProdKeyList = []
                  , embroideryProdLineList = [];
                let identicalIconKey = null;
                embRefItems.length && embRefItems.forEach(function(embRefItem) {
                    childIdenticalIconsVarId && embRefItem.dataset.id == childIdenticalIconsVarId && (identicalIconKey = embRefItem.dataset.cartKey),
                    embroideryProdKeyList.push(embRefItem.dataset.cartKey),
                    embroideryProdLineList.push(embRefItem.dataset.line)
                }),
                embroideryProdKeyList && updateMiniCartEmroidery(parentProdLine, parentQty, embroideryProdKeyList, parentQty, identicalIconKey, childIdenticalIconsNum, "plus", parentNode)
            } else
                updateMiniCartEmroidery(parentProdLine, parentQty, null, null, null, null, "plus", parentNode)
        }),
        e2.on("click", "[data-remove-emb]", function(t3, e3) {
            var dadaNode2 = e3.closest(".quick-cart__items");
            dadaNode2.classList.add("updating");
            var parentNode = e3.closest(".quick-cart__item")
              , parentProdLine = parentNode.dataset.line;
            updateMiniCartEmroidery(parentProdLine, 0, null, 0, null, null, "remove", parentNode)
        }),
        e2.on("change", ".quick-cart input[data-protectiontoggle]", function(event2, elem) {
            var dadaNode2 = elem.closest(".quick-cart__items");
            let PMOToggleValue;
            dadaNode2.classList.add("updating"),
            event2.target.checked ? (elem.closest(".quick-cart__protection").dataset.protectionactive = "true",
            PMOToggleValue = !0) : (elem.closest(".quick-cart__protection").dataset.protectionactive = "false",
            PMOToggleValue = !1),
            Q.get().then(function(cartdata) {
                Q.protectionCheck(cartdata, PMOToggleValue).then(function(response) {
                    dadaNode2.classList.remove("updating")
                })
            })
        });
        var g2 = _t(r2, {
            allowOutsideClick: !0,
            escapeDeactivates: !1
        })
          , v2 = _t(i2, {
            allowOutsideClick: !0,
            escapeDeactivates: !1
        });
        Q.get().then(T2),
        R("cart:updated", function(t3) {
            return T2(t3.cart)
        });
        var y2 = m(n2, "click", k2)
          , _2 = m(t2, "keydown", function(t3) {
            t3.keyCode === 27 && k2()
        });
        function A2(e3, n3) {
            b(t2, "active"),
            setTimeout(function() {
                Nt(t2, {
                    allowTouchMove: function(t3) {
                        for (; t3 && t3 !== document.body; ) {
                            if (t3.getAttribute("data-scroll-lock-ignore") !== null)
                                return !0;
                            t3 = t3.parentNode
                        }
                    },
                    reserveScrollBarGap: !0
                }),
                b(t2, "visible"),
                E(i2, "visible", n3 === !0),
                E(r2, "visible", !n3),
                !n3 && g2.activate(),
                e3 && (b(h('[data-id="'.concat(e3, '"]'), t2), "flash"),
                setTimeout(function() {
                    w(h('[data-id="'.concat(e3, '"]'), t2), "flash")
                }, 2e3))
            }, 50)
        }
        function k2() {
            w(t2, "visible"),
            setTimeout(function() {
                w(t2, "active"),
                Mt(t2),
                w(i2, "visible"),
                b(u2, "loading"),
                b(r2, "visible"),
                g2.deactivate(),
                v2.deactivate()
            }, 350)
        }
        function T2(t3) {
            var e3, n3 = t3.cart_level_discount_applications, protectionProductFound = !1;
            var parentKeys = {};
            t3.items.forEach(function(item) {
                var parentRelationship = item.parent_relationship || {};
                if (parentRelationship.parent_key)
                    parentKeys[parentRelationship.parent_key] = !0;
            });
            o2.innerHTML = kn((e3 = t3.items).length > 0, e3.reduce(function(t4, e4, index) {
                return t4 + function(t5) {
                    var e5, n4, r3, i3 = t5.line_level_discount_allocations, o3 = wn()(t5, ["line_level_discount_allocations"]), a3 = kn(o3.image, '<img class="image__img lazyload" data-src="'.concat(Object(zt.getSizedImageUrl)(o3.image, "120x"), '" />')), s3 = o3.selling_plan_allocation ? '<p class="fs-body-small c-subdued">'.concat(o3.selling_plan_allocation.selling_plan.name, "</p>") : "", isProtectionProd = !1;
                    o3.product_type == "Insurance" && (isProtectionProd = !0,
                    protectionProductFound = !0);
                    var propsHTML = ""
                      , isEmbProd = !1
                      , isParentProd = !1
                      , embProdKey = ""
                      , parentProdKey = ""
                      , identicalEmbroideryIconsVarId = ""
                      , embroideryItemPrice = "";
                    if (parentKeys[o3.key])
                        isParentProd = !0,
                        parentProdKey = o3.key;
                    if ((o3.parent_relationship || {}).parent_key)
                        isEmbProd = !0,
                        embProdKey = o3.parent_relationship.parent_key;
                    o3.properties && Object.keys(o3.properties).map(function(key) {
                        if (o3.properties[key] != "")
                            if (key == "_embroiderycost")
                                embroideryItemPrice = o3.properties[key];
                            else if (key == "_embroideryiconid") {
                                if (o3.properties[key]) {
                                    var values = o3.properties[key].split(",")
                                      , valuesLength = values.length;
                                    values.length > 1 && values.every( (val, i4, arr) => val === arr[0]) && (identicalEmbroideryIconsVarId = values[0] + ":" + valuesLength)
                                }
                            } else
                                key.startsWith("_") || (propsHTML += key + ": " + o3.properties[key] + "<br/>")
                    });
                    var deleteIcon = '<svg height="20px" width="20px" viewBox="0 0 20 20" class="BaseIcon-sc-8v47i9-0 ktEixi"><g fill-rule="evenodd" fill="#8f8f8f"><path d="M12.527 4.01c0-.244.007-.458 0-.671-.015-.382-.228-.587-.6-.59a148.54 148.54 0 00-3.04.003c-.35.004-.554.206-.572.562-.011.226-.002.453-.002.696h4.214zM5.645 5.265c-.014.112-.026.16-.025.21.102 3.16.196 6.32.314 9.48.034.91.765 1.615 1.703 1.628 1.847.026 3.695.026 5.542.002.973-.013 1.697-.742 1.732-1.713.112-3.077.207-6.154.306-9.23.004-.126-.02-.253-.03-.377H5.645zm8.08-1.224h2.132c.566 0 1.132.004 1.697-.001.41-.004.74.096.765.58.02.403-.246.61-.785.619-.347.006-.695.001-1.191.001 0 .865.02 1.691-.004 2.517-.064 2.329-.15 4.656-.22 6.985-.052 1.791-1.275 3.029-3.073 3.05-1.763.019-3.527.02-5.29-.002-1.781-.022-2.985-1.226-3.047-3.016-.102-2.976-.198-5.953-.297-8.93-.006-.179-.02-.358-.035-.604-.36 0-.688.002-1.015 0-.593-.005-.854-.186-.862-.593-.008-.419.241-.603.837-.605 1.065-.003 2.13-.001 3.195-.001h.582c0-.315-.01-.561.002-.807.043-.897.715-1.635 1.608-1.668 1.13-.04 2.264-.04 3.393 0 .892.033 1.563.773 1.606 1.671.012.245.002.492.002.804z"></path><path d="M8.622 10.868c0 .93.002 1.861-.002 2.792-.002.517-.233.82-.619.783-.457-.045-.583-.353-.582-.774.008-1.878.002-3.757.005-5.635.001-.494.214-.755.593-.758.381-.003.6.26.603.75.005.947.001 1.894.002 2.842m2.398-.023c0 .948.003 1.895-.002 2.843-.002.486-.224.758-.597.76-.374 0-.598-.271-.599-.757-.003-1.895-.004-3.79 0-5.685.002-.477.241-.759.62-.726.434.037.581.319.58.723-.006.948-.002 1.895-.002 2.842m2.398.017c0 .931.002 1.862-.001 2.793-.002.52-.228.822-.614.788-.457-.04-.59-.346-.587-.769.007-1.878.006-3.756 0-5.635 0-.42.126-.728.592-.76.381-.024.605.253.608.74.006.948.002 1.896.002 2.843"></path></g></svg>'
                      , embroideryHTML = `
                <div class="properties">
                    <div class="properties_action">
                        <span class="properties_title">Embroidery</span>
                        <span>` + embroideryItemPrice + `</span>
                        <span data-remove-emb data-key="` + o3.key + '">' + deleteIcon + `</span>
                    </div>
                    <div class="properties_list">` + propsHTML + `</div>
                </div>`;
                    return `
    <div class="quick-cart__item ff-body fs-body-base embroidery-` + isEmbProd + " protection-" + isProtectionProd + '" data-line="' + (index + 1) + '" data-parent-id="' + embProdKey + '" data-self-key="' + (isParentProd ? parentProdKey : "") + '" data-cart-key="' + o3.key + '" data-identicalEmbroideryIconsVarId="' + identicalEmbroideryIconsVarId + '" data-id="'.concat(o3.variant_id, `">
      <div class="quick-cart__item-left">
        <a href="`).concat(o3.url, `">
          <div class="quick-cart__image">`).concat(a3, `</div>
        </a>
        <div class="quick-cart__control">
          <button class="quick-cart__button" data-decrease="`).concat(o3.variant_id, `" href="#">
            `).concat(_n, `
          </button>
          <div class="quick-cart__qty ff-body fs-body-base ta-c" data-qty>`).concat(o3.quantity, `</div>
          <button class="quick-cart__button" data-increase="`).concat(o3.variant_id, `" href="#">
            `).concat(En, `
          </button>
        </div>
      </div>
      <div class="quick-cart__item-right">
        <h4><a href="`).concat(o3.url, '">').concat(o3.product_title, `</a></h4>
        <div>
          `).concat(kn(o3.original_price > o3.final_price, '<s class="qty">'.concat(K(o3.original_price), "</s>")), `
          `).concat(K(o3.final_price), `
          `).concat(kn(o3.quantity > 1, '<span class="c-subdued">x '.concat(o3.quantity, "</span>")), `
        </div>
        `).concat((e5 = o3,
                    n4 = e5.options_with_values,
                    r3 = e5.variant_title,
                    kn(n4.length > 0 && r3, n4.reduce(function(t6, e6) {
                        var n5 = e6.name
                          , r4 = e6.value;
                        return t6 + "<div>".concat(n5, ": ").concat(r4, "</div>")
                    }, ""))), `
`.concat(kn(propsHTML != "", embroideryHTML)), `
        `).concat(function(t6) {
                        var e6 = t6.map(function(t7) {
                            var e7 = t7.amount
                              , n5 = t7.discount_application.title;
                            return "<li>".concat(n5, " (-").concat(K(e7), ")</li>")
                        });
                        return kn(!!t6.length, '<ul class="quick-cart__item-discounts fs-body-small c-subdued">'.concat(e6.join(""), "</ul>"))
                    }(i3), `
        `).concat(Wt(o3.unit_price, o3.unit_price_measurement), `
        `).concat(s3, `
      </div>
    </div>
  `)
                }(e4)
            }, "")),
            c2.innerHTML = function(t4) {
                return kn(!!t4.length, `
      <ul>
        `.concat(t4.map(function(t5) {
                    t5.discount_application?t5 = t5.discount_application:'';
                    var e4 = t5.title
                      , n4 = t5.total_allocated_amount;
                    return "<div>".concat(e4, " (-").concat(K(n4), ")</div>")
                }), `
      </ul>
    `))
            }(n3),
            E(s2, "visible", t3.sorted.length),
            E(a2, "visible", !t3.sorted.length),
            E(minicart_protection, "visible", t3.sorted.length),
            E(c2, "visible", n3.length);
            var cartTotalPrice = t3.total_price
              , insuranceCharge = document.querySelector("[data-protectioncharge]").dataset.protectioncharge
              , cartSubTotalNoInsurance = cartTotalPrice
              , minicartProtectionToggleBtn = document.querySelector(".quick-cart input[data-protectiontoggle]");
            t3.items.forEach(item => {
                item.product_type == "Insurance" && (cartSubTotalNoInsurance -= item.line_price)
            }
            ),
            protectionProductFound && (cartTotalPrice = parseFloat(parseFloat(cartSubTotalNoInsurance))),
            minicartProtectionToggleBtn.checked && (cartTotalPrice = parseFloat(parseFloat(cartSubTotalNoInsurance) + parseFloat(insuranceCharge))),
            l2 && (l2.innerHTML = K(cartTotalPrice))
        }
        return R("cart:open", function(t3, e3) {
            return A2(e3.flash)
        }),
        R("cart:configureLoading", function() {
            A2(!1, !0),
            w(r2, "visible"),
            b(i2, "visible")
        }),
        R("cart:configureReady", function(t3, e3) {
            var n3 = e3.html
              , r3 = e3.handle;
            tt(r3)(function(t4) {
                w(u2, "loading"),
                d2.innerHTML = n3,
                function(t5, e4) {
                    checkSoldoutFromParams(!0);
                    var n4 = h("[data-add-to-cart]", e4)
                      , r4 = h("[data-error-message]", e4)
                      , thisBIS = h(".product-form__cart-BIS_trigger", e4)
                      , thisUnvail = h("[data-button-unavailable]", e4)
                      , i3 = new L(h("[data-product-form]", e4),t5,{
                        onOptionChange: function(t6) {
                            var r5 = t6.dataset.variant
                              , i4 = p(nt, e4)
                              , o3 = p(rt, e4);
                            i4.forEach(function(t7) {
                                if (r5)
                                    return t7.innerHTML = K(r5.price)
                            }),
                            o3.forEach(function(t7) {
                                if (r5)
                                    return t7.innerHTML = r5.compare_at_price > r5.price ? K(r5.compare_at_price) : ""
                            });
                            var a3 = h("[data-add-to-cart-text]", n4)
                              , s3 = n4.dataset
                              , c3 = s3.langAvailable
                              , l3 = s3.langSoldOut;
                            r5 && (r5.available ? (n4.removeAttribute("disabled"),
                            a3.textContent = c3) : (n4.setAttribute("disabled", "disabled"),
                            a3.textContent = l3)),
                            r5 ? (thisUnvail.style.display = "none",
                            r5.available ? (n4.style.display = "flex",
                            thisBIS.style.display = "none",
                            n4.classList.remove("bis_hide_unavail")) : (n4.style.display = "none",
                            thisBIS.style.display = "flex",
                            n4.classList.remove("bis_hide_unavail"))) : (thisUnvail.style.display = "block",
                            thisBIS.style.display = "none",
                            n4.classList.add("bis_hide_unavail")),
                            m(thisBIS, "click", function(t7) {
                                t7.preventDefault();
                                var productData = JSON.parse(this.dataset.productData)
                                  , BISTriggerElem = document.querySelector(`[data-productid="${productData.id}"]`);
                                BISTriggerElem.click()
                            })
                        },
                        onFormSubmit: function(t6) {
                            t6.preventDefault(),
                            b(n4, "loading"),
                            w(r4, "visible"),
                            Q.addItem(i3.element).then(function(t7) {
                                if (window.protectioncharges)
                                    Q.protectionCheck(t7.cart).then(function(r5) {
                                        var e6 = t7.item;
                                        w(n4, "loading"),
                                        B("cart:open", null, {
                                            flash: e6.variant_id
                                        })
                                    });
                                else {
                                    var e5 = t7.item;
                                    w(n4, "loading"),
                                    B("cart:open", null, {
                                        flash: e5.variant_id
                                    })
                                }
                            }).catch(function(t7) {
                                w(n4, "loading"),
                                b(r4, "visible"),
                                r4.innerText = t7.message
                            })
                        }
                    })
                }(t4, i2),
                v2.activate()
            })
        }),
        {
            open: A2,
            close: k2,
            destroy: function() {
                y2(),
                _2()
            }
        }
    }
    function kn(t2, e2) {
        return t2 ? e2 : ""
    }
    function Tn() {
        var t2 = Error.call(this);
        return t2.name = "Server error",
        t2.message = "Something went wrong on the server",
        t2.status = 500,
        t2
    }
    function Sn(t2) {
        var e2 = Error.call(this);
        return e2.name = "Not found",
        e2.message = "Not found",
        e2.status = t2,
        e2
    }
    function xn() {
        var t2 = Error.call(this);
        return t2.name = "Server error",
        t2.message = "Something went wrong on the server",
        t2.status = 500,
        t2
    }
    function Cn(t2) {
        var e2 = Error.call(this);
        return e2.name = "Content-Type error",
        e2.message = "Content-Type was not provided or is of wrong type",
        e2.status = t2,
        e2
    }
    function On(t2) {
        var e2 = Error.call(this);
        return e2.name = "JSON parse error",
        e2.message = "JSON syntax error",
        e2.status = t2,
        e2
    }
    function Ln(t2, e2, n2, r2) {
        var i2 = Error.call(this);
        return i2.name = e2,
        i2.message = n2,
        i2.status = t2,
        i2.retryAfter = r2,
        i2
    }
    function qn(t2, e2, n2) {
        var r2 = Error.call(this);
        return r2.name = e2,
        r2.message = n2,
        r2.status = t2,
        r2
    }
    function Dn(t2, e2, n2) {
        var r2 = Error.call(this);
        return r2.name = e2,
        r2.message = n2,
        r2.status = t2,
        r2
    }
    function Pn() {
        this.events = {}
    }
    function jn(t2) {
        this.eventName = t2,
        this.callbacks = []
    }
    function In(t2) {
        this._store = {},
        this._keys = [],
        t2 && t2.bucketSize ? this.bucketSize = t2.bucketSize : this.bucketSize = 20
    }
    function Nn(t2, e2) {
        var n2 = "";
        return e2 = e2 || null,
        Object.keys(t2).forEach(function(r2) {
            var i2 = r2 + "=";
            switch (e2 && (i2 = e2 + "[" + r2 + "]"),
            function(t3) {
                return Object.prototype.toString.call(t3).slice(8, -1).toLowerCase()
            }(t2[r2])) {
            case "object":
                n2 += Nn(t2[r2], e2 ? i2 : r2);
                break;
            case "array":
                n2 += i2 + "=" + t2[r2].join(",") + "&";
                break;
            default:
                e2 && (i2 += "="),
                n2 += i2 + encodeURIComponent(t2[r2]) + "&"
            }
        }),
        n2
    }
    Pn.prototype.on = function(t2, e2) {
        var n2 = this.events[t2];
        n2 || (n2 = new jn(t2),
        this.events[t2] = n2),
        n2.registerCallback(e2)
    }
    ,
    Pn.prototype.off = function(t2, e2) {
        var n2 = this.events[t2];
        n2 && n2.callbacks.indexOf(e2) > -1 && (n2.unregisterCallback(e2),
        n2.callbacks.length === 0 && delete this.events[t2])
    }
    ,
    Pn.prototype.dispatch = function(t2, e2) {
        var n2 = this.events[t2];
        n2 && n2.fire(e2)
    }
    ,
    jn.prototype.registerCallback = function(t2) {
        this.callbacks.push(t2)
    }
    ,
    jn.prototype.unregisterCallback = function(t2) {
        var e2 = this.callbacks.indexOf(t2);
        e2 > -1 && this.callbacks.splice(e2, 1)
    }
    ,
    jn.prototype.fire = function(t2) {
        this.callbacks.slice(0).forEach(function(e2) {
            e2(t2)
        })
    }
    ,
    In.prototype.set = function(t2, e2) {
        if (this.count() >= this.bucketSize) {
            var n2 = this._keys.splice(0, 1);
            this.delete(n2)
        }
        return this._keys.push(t2),
        this._store[t2] = e2,
        this._store
    }
    ,
    In.prototype.get = function(t2) {
        return this._store[t2]
    }
    ,
    In.prototype.has = function(t2) {
        return !!this._store[t2]
    }
    ,
    In.prototype.count = function() {
        return Object.keys(this._store).length
    }
    ,
    In.prototype.delete = function(t2) {
        var e2 = !!this._store[t2];
        return delete this._store[t2],
        e2 && !this._store[t2]
    }
    ;
    var Mn, zn, Rn, Bn = (Mn = function(t2, e2, n2, r2) {
        var i2 = new XMLHttpRequest;
        i2.onreadystatechange = function() {
            if (i2.readyState === XMLHttpRequest.DONE) {
                var t3 = i2.getResponseHeader("Content-Type");
                if (i2.status >= 500)
                    return void r2(new xn);
                if (i2.status === 404)
                    return void r2(new Sn(i2.status));
                if (typeof t3 != "string" || t3.toLowerCase().match("application/json") === null)
                    return void r2(new Cn(i2.status));
                if (i2.status === 417) {
                    try {
                        var o2 = JSON.parse(i2.responseText);
                        r2(new qn(i2.status,o2.message,o2.description))
                    } catch {
                        r2(new On(i2.status))
                    }
                    return
                }
                if (i2.status === 422) {
                    try {
                        var a2 = JSON.parse(i2.responseText);
                        r2(new Dn(i2.status,a2.message,a2.description))
                    } catch {
                        r2(new On(i2.status))
                    }
                    return
                }
                if (i2.status === 429) {
                    try {
                        var s2 = JSON.parse(i2.responseText);
                        r2(new Ln(i2.status,s2.message,s2.description,i2.getResponseHeader("Retry-After")))
                    } catch {
                        r2(new On(i2.status))
                    }
                    return
                }
                if (i2.status === 200) {
                    try {
                        var c2 = JSON.parse(i2.responseText);
                        c2.query = e2,
                        n2(c2)
                    } catch {
                        r2(new On(i2.status))
                    }
                    return
                }
                try {
                    var l2 = JSON.parse(i2.responseText);
                    r2(new Tn(i2.status,l2.message,l2.description))
                } catch {
                    r2(new On(i2.status))
                }
            }
        }
        ,
        i2.open("get", "/search/suggest.json?q=" + encodeURIComponent(e2) + "&" + t2),
        i2.setRequestHeader("Content-Type", "application/json"),
        i2.send()
    }
    ,
    zn = 10,
    Rn = null,
    function() {
        var t2 = this
          , e2 = arguments;
        clearTimeout(Rn),
        Rn = setTimeout(function() {
            Rn = null,
            Mn.apply(t2, e2)
        }, zn || 0)
    }
    );
    function Fn(t2) {
        if (!t2)
            throw new TypeError("No config object was specified");
        this._retryAfter = null,
        this._currentQuery = null,
        this.dispatcher = new Pn,
        this.cache = new In({
            bucketSize: 40
        }),
        this.configParams = Nn(t2)
    }
    function Hn(t2) {
        return typeof t2 != "string" ? null : t2.trim().replace(" ", "-").toLowerCase()
    }
    Fn.TYPES = {
        PRODUCT: "product",
        PAGE: "page",
        ARTICLE: "article"
    },
    Fn.FIELDS = {
        AUTHOR: "author",
        BODY: "body",
        PRODUCT_TYPE: "product_type",
        TAG: "tag",
        TITLE: "title",
        VARIANTS_BARCODE: "variants.barcode",
        VARIANTS_SKU: "variants.sku",
        VARIANTS_TITLE: "variants.title",
        VENDOR: "vendor"
    },
    Fn.UNAVAILABLE_PRODUCTS = {
        SHOW: "show",
        HIDE: "hide",
        LAST: "last"
    },
    Fn.prototype.query = function(t2) {
        try {
            (function(t3) {
                var e3;
                if (t3 == null)
                    throw (e3 = new TypeError("'query' is missing")).type = "argument",
                    e3;
                if (typeof t3 != "string")
                    throw (e3 = new TypeError("'query' is not a string")).type = "argument",
                    e3
            }
            )(t2)
        } catch (t3) {
            return void this.dispatcher.dispatch("error", t3)
        }
        if (t2 === "")
            return this;
        this._currentQuery = Hn(t2);
        var e2 = this.cache.get(this._currentQuery);
        return e2 ? (this.dispatcher.dispatch("success", e2),
        this) : (Bn(this.configParams, t2, function(t3) {
            this.cache.set(Hn(t3.query), t3),
            Hn(t3.query) === this._currentQuery && (this._retryAfter = null,
            this.dispatcher.dispatch("success", t3))
        }
        .bind(this), function(t3) {
            t3.retryAfter && (this._retryAfter = t3.retryAfter),
            this.dispatcher.dispatch("error", t3)
        }
        .bind(this)),
        this)
    }
    ,
    Fn.prototype.on = function(t2, e2) {
        return this.dispatcher.on(t2, e2),
        this
    }
    ,
    Fn.prototype.off = function(t2, e2) {
        return this.dispatcher.off(t2, e2),
        this
    }
    ;
    var Vn = n(6)
      , Un = n.n(Vn)
      , Wn = n(22)
      , Gn = n.n(Wn);
    function $n(t2) {
        var e2 = t2.onfocus
          , n2 = document.createElement("div");
        return n2.style.cssText = `
    width: 1px;
    height: 0px;
    padding: 0px;
    overflow: hidden;
    position: fixed;
    top: 1px;
    left: 1px;
  `,
        n2.onfocus = e2,
        n2.setAttribute("tabindex", "0"),
        n2.setAttribute("aria-hidden", "true"),
        n2.setAttribute("data-lockbox", ""),
        n2
    }
    function Jn(t2) {
        if (t2) {
            var e2, n2, r2 = document.activeElement, i2 = Gn()(t2);
            if (!t2.querySelector("[data-lockbox]")) {
                e2 = $n({
                    onfocus: function() {
                        var t3 = i2[i2.length - 1];
                        t3 && t3.focus()
                    }
                }),
                n2 = $n({
                    onfocus: function() {
                        var t3 = i2[0];
                        t3 && t3.focus()
                    }
                }),
                t2.insertBefore(e2, t2.children[0]),
                t2.appendChild(n2);
                var o2 = i2[0];
                o2 && o2.focus()
            }
            return function() {
                t2.removeChild(e2),
                t2.removeChild(n2),
                r2.focus()
            }
        }
    }
    var Yn = window.theme.strings
      , Xn = "active"
      , Qn = "visible"
      , Zn = function(t2) {
        var e2 = h("[data-overlay]", t2)
          , n2 = h("form", t2)
          , r2 = h("[data-input]", t2)
          , i2 = h("[data-clear]", t2)
          , o2 = h("[data-results]", t2)
          , a2 = h("[data-settings]", t2)
          , s2 = JSON.parse(a2.innerHTML)
          , c2 = s2.limit
          , l2 = s2.show_articles
          , u2 = s2.show_pages
          , d2 = s2.show_price
          , f2 = s2.show_vendor
          , p2 = ""
          , g2 = function() {}
          , v2 = m(e2, "click", C2)
          , y2 = m(i2, "click", function(t3) {
            t3.preventDefault(),
            r2.value = "",
            w([o2, i2], Qn),
            r2.focus()
        })
          , _2 = m(t2, "keydown", function(t3) {
            t3.keyCode === 27 && C2()
        })
          , A2 = m(r2, "input", function(t3) {
            t3.target.value === "" && w(o2, Qn),
            E(i2, Qn, t3.target.value !== ""),
            E(o2, Qn, t3.target.value !== ""),
            T2.query(t3.target.value)
        })
          , k2 = [l2 && Fn.TYPES.ARTICLE, u2 && Fn.TYPES.PAGE, Fn.TYPES.PRODUCT].filter(Boolean)
          , T2 = new Fn({
            resources: {
                type: k2,
                limit: c2,
                options: {
                    unavailable_products: "last",
                    fields: [Fn.FIELDS.TITLE, Fn.FIELDS.PRODUCT_TYPE, Fn.FIELDS.VARIANTS_TITLE, Fn.FIELDS.VENDOR]
                }
            }
        });
        function S2(t3, e3, n3) {
            return t3.length < 1 ? "" : '<div class="quick-search__header ff-meta fs-meta">'.concat(e3, "</div>") + t3.map(n3).join("")
        }
        function x2(t3) {
            var e3 = t3.url
              , n3 = t3.image
              , r3 = t3.heading
              , i3 = t3.subheading
              , o3 = new RegExp("(" + p2 + ")","gi")
              , a3 = r3.replace(o3, '<span class="hl">$1</span>')
              , s3 = i3.replace(o3, '<span class="hl">$1</span>')
              , c3 = n3 ? '<img class="image__img lazyload" data-src="'.concat(Object(zt.getSizedImageUrl)(n3, "120x"), '" />') : `
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M3 7A2 2 0 0 0 1 9V17H3V13H5V17H7V9A2 2 0 0 0 5 7H3M3 9H5V11H3M15 10.5V9A2 2 0 0 0 13 7H9V17H13A2 2 0 0 0 15 15V13.5A1.54 1.54 0 0 0 13.5 12A1.54 1.54 0 0 0 15 10.5M13 15H11V13H13V15M13 11H11V9H13M19 7A2 2 0 0 0 17 9V15A2 2 0 0 0 19 17H21A2 2 0 0 0 23 15V14H21V15H19V9H21V10H23V9A2 2 0 0 0 21 7Z" fill="currentColor" />
  </svg>
`;
            return `
      <a class="quick-search__result" href="`.concat(e3, `">
        <div class="quick-search__result-image">`).concat(c3, `</div>
        <div class="quick-search__result-details ff-body fs-body-base">
          <div class="quick-search__result-heading">`).concat(a3, `</div>
          <div class="quick-search__result-subheading">`).concat(s3, `</div>
        </div>
      </a>
  `)
        }
        function C2() {
            w(t2, Qn),
            setTimeout(function() {
                w(t2, Xn),
                Mt(t2),
                g2()
            }, 350)
        }
        return T2.on("success", function(t3) {
            var e3 = t3.query
              , n3 = t3.resources.results;
            p2 = e3,
            function(t4) {
                var e4 = t4.articles
                  , n4 = t4.pages
                  , r3 = t4.products
                  , i3 = "";
                r3.length && (i3 = S2(r3, Yn.search.headings.products, function(t5) {
                    var e5 = t5.url
                      , n5 = t5.image
                      , r4 = t5.title
                      , i4 = t5.price
                      , o3 = t5.vendor
                      , a4 = K(i4 * window.Shopify.currency.rate * 100);
                    if (!t5.tags.includes("meta-hide"))
                        return x2({
                            url: e5,
                            image: n5,
                            heading: r4,
                            subheading: [f2 && o3, d2 && Un()(a4)].filter(Boolean).join(" \u2022 ")
                        })
                })),
                n4 && (i3 += S2(n4, Yn.search.headings.pages, function(t5) {
                    var e5 = t5.url
                      , n5 = t5.image
                      , r4 = t5.title
                      , i4 = t5.body;
                    return x2({
                        url: e5,
                        image: n5,
                        heading: r4,
                        subheading: Un()(i4)
                    })
                })),
                e4 && (i3 += S2(e4, Yn.search.headings.articles, function(t5) {
                    var e5 = t5.url
                      , n5 = t5.image
                      , r4 = t5.title
                      , i4 = t5.body;
                    return x2({
                        url: e5,
                        image: n5,
                        heading: r4,
                        subheading: Un()(i4)
                    })
                }));
                var a3 = i3 ? `
      <div class="quick-search__view-all ff-body fs-body-base">
        <button type="submit">`.concat(Yn.search.view_all, `</button>
      </div>
    `) : "";
                i3 || (i3 = `
          <div class="quick-search__no-results">
            `.concat(Yn.search.no_results, `
          </div>
        `)),
                o2.innerHTML = i3 + a3
            }(n3)
        }),
        T2.on("error", function(t3) {
            console.log("Predictive Search Error:", t3.message)
        }),
        {
            open: function() {
                b(t2, Xn),
                setTimeout(function() {
                    g2 = Jn(n2),
                    r2.focus(),
                    Nt(t2, {
                        reserveScrollBarGap: !0
                    }),
                    b(t2, Qn)
                }, 50)
            },
            close: C2,
            destroy: function() {
                C2(),
                v2(),
                y2(),
                _2(),
                A2()
            }
        }
    }
      , Kn = "[data-collection]"
      , tr = "[data-image]"
      , er = "[data-overlay]"
      , nr = "[data-trigger]"
      , rr = "[data-submenu]";
    function ir(t2) {
        var e2, n2 = h(tr, t2), r2 = p(nr, t2), i2 = p(rr, t2), o2 = p(Kn, t2), a2 = p(".image", t2), s2 = h(".image--mega-nav-image", t2), c2 = !!t2.dataset.showImages, l2 = c2, u2 = [m(h(er, t2), "click", d2), m(r2, "click", function(t3) {
            t3.preventDefault();
            var e3 = t3.currentTarget.dataset.trigger;
            c2 && (w(n2, "visible"),
            w(s2, "active"),
            l2 = !1),
            i2.forEach(function(t4) {
                E(t4, "visible", t4.dataset.submenu === e3)
            })
        }), c2 && m(o2, "mouseover", function(t3) {
            var e3 = t3.currentTarget.dataset.collection;
            a2.forEach(function(t4) {
                E(t4, "active", t4.classList.contains("image--".concat(e3)))
            }),
            l2 || b(n2, "visible")
        }), c2 && m(o2, "mouseout", function() {
            w(a2, "active"),
            s2 && E(s2, "active", l2),
            E(n2, "visible", l2)
        }), m(t2, "keydown", function(t3) {
            t3.keyCode === 27 && d2()
        })].filter(Boolean);
        function d2() {
            w(t2, "visible"),
            setTimeout(function() {
                w(t2, "active"),
                Mt(t2),
                e2(),
                u2.forEach(function(t3) {
                    return t3()
                })
            }, 350)
        }
        return {
            open: function() {
                b(t2, "active"),
                setTimeout(function() {
                    e2 = Jn(t2),
                    Nt(t2, {
                        reserveScrollBarGap: !0
                    }),
                    b(t2, "visible"),
                    c2 && b(s2, "active"),
                    h("a", t2).focus()
                }, 50)
            },
            close: d2
        }
    }
    var or = {
        update: null,
        begin: null,
        loopBegin: null,
        changeBegin: null,
        change: null,
        changeComplete: null,
        loopComplete: null,
        complete: null,
        loop: 1,
        direction: "normal",
        autoplay: !0,
        timelineOffset: 0
    }
      , ar = {
        duration: 1e3,
        delay: 0,
        endDelay: 0,
        easing: "easeOutElastic(1, .5)",
        round: 0
    }
      , sr = ["translateX", "translateY", "translateZ", "rotate", "rotateX", "rotateY", "rotateZ", "scale", "scaleX", "scaleY", "scaleZ", "skew", "skewX", "skewY", "perspective", "matrix", "matrix3d"]
      , cr = {
        CSS: {},
        springs: {}
    };
    function lr(t2, e2, n2) {
        return Math.min(Math.max(t2, e2), n2)
    }
    function ur(t2, e2) {
        return t2.indexOf(e2) > -1
    }
    function dr(t2, e2) {
        return t2.apply(null, e2)
    }
    var fr = {
        arr: function(t2) {
            return Array.isArray(t2)
        },
        obj: function(t2) {
            return ur(Object.prototype.toString.call(t2), "Object")
        },
        pth: function(t2) {
            return fr.obj(t2) && t2.hasOwnProperty("totalLength")
        },
        svg: function(t2) {
            return t2 instanceof SVGElement
        },
        inp: function(t2) {
            return t2 instanceof HTMLInputElement
        },
        dom: function(t2) {
            return t2.nodeType || fr.svg(t2)
        },
        str: function(t2) {
            return typeof t2 == "string"
        },
        fnc: function(t2) {
            return typeof t2 == "function"
        },
        und: function(t2) {
            return t2 === void 0
        },
        hex: function(t2) {
            return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t2)
        },
        rgb: function(t2) {
            return /^rgb/.test(t2)
        },
        hsl: function(t2) {
            return /^hsl/.test(t2)
        },
        col: function(t2) {
            return fr.hex(t2) || fr.rgb(t2) || fr.hsl(t2)
        },
        key: function(t2) {
            return !or.hasOwnProperty(t2) && !ar.hasOwnProperty(t2) && t2 !== "targets" && t2 !== "keyframes"
        }
    };
    function hr(t2) {
        var e2 = /\(([^)]+)\)/.exec(t2);
        return e2 ? e2[1].split(",").map(function(t3) {
            return parseFloat(t3)
        }) : []
    }
    function pr(t2, e2) {
        var n2 = hr(t2)
          , r2 = lr(fr.und(n2[0]) ? 1 : n2[0], .1, 100)
          , i2 = lr(fr.und(n2[1]) ? 100 : n2[1], .1, 100)
          , o2 = lr(fr.und(n2[2]) ? 10 : n2[2], .1, 100)
          , a2 = lr(fr.und(n2[3]) ? 0 : n2[3], .1, 100)
          , s2 = Math.sqrt(i2 / r2)
          , c2 = o2 / (2 * Math.sqrt(i2 * r2))
          , l2 = c2 < 1 ? s2 * Math.sqrt(1 - c2 * c2) : 0
          , u2 = c2 < 1 ? (c2 * s2 - a2) / l2 : -a2 + s2;
        function d2(t3) {
            var n3 = e2 ? e2 * t3 / 1e3 : t3;
            return n3 = c2 < 1 ? Math.exp(-n3 * c2 * s2) * (1 * Math.cos(l2 * n3) + u2 * Math.sin(l2 * n3)) : (1 + u2 * n3) * Math.exp(-n3 * s2),
            t3 === 0 || t3 === 1 ? t3 : 1 - n3
        }
        return e2 ? d2 : function() {
            var e3 = cr.springs[t2];
            if (e3)
                return e3;
            for (var n3 = 0, r3 = 0; ; )
                if (d2(n3 += 1 / 6) === 1) {
                    if (++r3 >= 16)
                        break
                } else
                    r3 = 0;
            var i3 = n3 * (1 / 6) * 1e3;
            return cr.springs[t2] = i3,
            i3
        }
    }
    function gr(t2) {
        return t2 === void 0 && (t2 = 10),
        function(e2) {
            return Math.ceil(lr(e2, 1e-6, 1) * t2) * (1 / t2)
        }
    }
    var vr, mr, yr = function() {
        function t2(t3, e3) {
            return 1 - 3 * e3 + 3 * t3
        }
        function e2(t3, e3) {
            return 3 * e3 - 6 * t3
        }
        function n2(t3) {
            return 3 * t3
        }
        function r2(r3, i3, o2) {
            return ((t2(i3, o2) * r3 + e2(i3, o2)) * r3 + n2(i3)) * r3
        }
        function i2(r3, i3, o2) {
            return 3 * t2(i3, o2) * r3 * r3 + 2 * e2(i3, o2) * r3 + n2(i3)
        }
        return function(t3, e3, n3, o2) {
            if (0 <= t3 && t3 <= 1 && 0 <= n3 && n3 <= 1) {
                var a2 = new Float32Array(11);
                if (t3 !== e3 || n3 !== o2)
                    for (var s2 = 0; s2 < 11; ++s2)
                        a2[s2] = r2(.1 * s2, t3, n3);
                return function(i3) {
                    return t3 === e3 && n3 === o2 || i3 === 0 || i3 === 1 ? i3 : r2(c2(i3), e3, o2)
                }
            }
            function c2(e4) {
                for (var o3 = 0, s3 = 1; s3 !== 10 && a2[s3] <= e4; ++s3)
                    o3 += .1;
                --s3;
                var c3 = o3 + .1 * ((e4 - a2[s3]) / (a2[s3 + 1] - a2[s3]))
                  , l2 = i2(c3, t3, n3);
                return l2 >= .001 ? function(t4, e5, n4, o4) {
                    for (var a3 = 0; a3 < 4; ++a3) {
                        var s4 = i2(e5, n4, o4);
                        if (s4 === 0)
                            return e5;
                        e5 -= (r2(e5, n4, o4) - t4) / s4
                    }
                    return e5
                }(e4, c3, t3, n3) : l2 === 0 ? c3 : function(t4, e5, n4, i3, o4) {
                    var a3, s4, c4 = 0;
                    do
                        (a3 = r2(s4 = e5 + (n4 - e5) / 2, i3, o4) - t4) > 0 ? n4 = s4 : e5 = s4;
                    while (Math.abs(a3) > 1e-7 && ++c4 < 10);
                    return s4
                }(e4, o3, o3 + .1, t3, n3)
            }
        }
    }(), br = (vr = {
        linear: function() {
            return function(t2) {
                return t2
            }
        }
    },
    mr = {
        Sine: function() {
            return function(t2) {
                return 1 - Math.cos(t2 * Math.PI / 2)
            }
        },
        Circ: function() {
            return function(t2) {
                return 1 - Math.sqrt(1 - t2 * t2)
            }
        },
        Back: function() {
            return function(t2) {
                return t2 * t2 * (3 * t2 - 2)
            }
        },
        Bounce: function() {
            return function(t2) {
                for (var e2, n2 = 4; t2 < ((e2 = Math.pow(2, --n2)) - 1) / 11; )
                    ;
                return 1 / Math.pow(4, 3 - n2) - 7.5625 * Math.pow((3 * e2 - 2) / 22 - t2, 2)
            }
        },
        Elastic: function(t2, e2) {
            t2 === void 0 && (t2 = 1),
            e2 === void 0 && (e2 = .5);
            var n2 = lr(t2, 1, 10)
              , r2 = lr(e2, .1, 2);
            return function(t3) {
                return t3 === 0 || t3 === 1 ? t3 : -n2 * Math.pow(2, 10 * (t3 - 1)) * Math.sin((t3 - 1 - r2 / (2 * Math.PI) * Math.asin(1 / n2)) * (2 * Math.PI) / r2)
            }
        }
    },
    ["Quad", "Cubic", "Quart", "Quint", "Expo"].forEach(function(t2, e2) {
        mr[t2] = function() {
            return function(t3) {
                return Math.pow(t3, e2 + 2)
            }
        }
    }),
    Object.keys(mr).forEach(function(t2) {
        var e2 = mr[t2];
        vr["easeIn" + t2] = e2,
        vr["easeOut" + t2] = function(t3, n2) {
            return function(r2) {
                return 1 - e2(t3, n2)(1 - r2)
            }
        }
        ,
        vr["easeInOut" + t2] = function(t3, n2) {
            return function(r2) {
                return r2 < .5 ? e2(t3, n2)(2 * r2) / 2 : 1 - e2(t3, n2)(-2 * r2 + 2) / 2
            }
        }
    }),
    vr);
    function wr(t2, e2) {
        if (fr.fnc(t2))
            return t2;
        var n2 = t2.split("(")[0]
          , r2 = br[n2]
          , i2 = hr(t2);
        switch (n2) {
        case "spring":
            return pr(t2, e2);
        case "cubicBezier":
            return dr(yr, i2);
        case "steps":
            return dr(gr, i2);
        default:
            return dr(r2, i2)
        }
    }
    function Er(t2) {
        try {
            return document.querySelectorAll(t2)
        } catch {
            return
        }
    }
    function _r(t2, e2) {
        for (var n2 = t2.length, r2 = arguments.length >= 2 ? arguments[1] : void 0, i2 = [], o2 = 0; o2 < n2; o2++)
            if (o2 in t2) {
                var a2 = t2[o2];
                e2.call(r2, a2, o2, t2) && i2.push(a2)
            }
        return i2
    }
    function Ar(t2) {
        return t2.reduce(function(t3, e2) {
            return t3.concat(fr.arr(e2) ? Ar(e2) : e2)
        }, [])
    }
    function kr(t2) {
        return fr.arr(t2) ? t2 : (fr.str(t2) && (t2 = Er(t2) || t2),
        t2 instanceof NodeList || t2 instanceof HTMLCollection ? [].slice.call(t2) : [t2])
    }
    function Tr(t2, e2) {
        return t2.some(function(t3) {
            return t3 === e2
        })
    }
    function Sr(t2) {
        var e2 = {};
        for (var n2 in t2)
            e2[n2] = t2[n2];
        return e2
    }
    function xr(t2, e2) {
        var n2 = Sr(t2);
        for (var r2 in t2)
            n2[r2] = e2.hasOwnProperty(r2) ? e2[r2] : t2[r2];
        return n2
    }
    function Cr(t2, e2) {
        var n2 = Sr(t2);
        for (var r2 in e2)
            n2[r2] = fr.und(t2[r2]) ? e2[r2] : t2[r2];
        return n2
    }
    function Or(t2) {
        return fr.rgb(t2) ? (n2 = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(e2 = t2)) ? "rgba(" + n2[1] + ",1)" : e2 : fr.hex(t2) ? function(t3) {
            var e3 = t3.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(t4, e4, n4, r2) {
                return e4 + e4 + n4 + n4 + r2 + r2
            })
              , n3 = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e3);
            return "rgba(" + parseInt(n3[1], 16) + "," + parseInt(n3[2], 16) + "," + parseInt(n3[3], 16) + ",1)"
        }(t2) : fr.hsl(t2) ? function(t3) {
            var e3, n3, r2, i2 = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(t3) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(t3), o2 = parseInt(i2[1], 10) / 360, a2 = parseInt(i2[2], 10) / 100, s2 = parseInt(i2[3], 10) / 100, c2 = i2[4] || 1;
            function l2(t4, e4, n4) {
                return n4 < 0 && (n4 += 1),
                n4 > 1 && (n4 -= 1),
                n4 < 1 / 6 ? t4 + 6 * (e4 - t4) * n4 : n4 < .5 ? e4 : n4 < 2 / 3 ? t4 + (e4 - t4) * (2 / 3 - n4) * 6 : t4
            }
            if (a2 == 0)
                e3 = n3 = r2 = s2;
            else {
                var u2 = s2 < .5 ? s2 * (1 + a2) : s2 + a2 - s2 * a2
                  , d2 = 2 * s2 - u2;
                e3 = l2(d2, u2, o2 + 1 / 3),
                n3 = l2(d2, u2, o2),
                r2 = l2(d2, u2, o2 - 1 / 3)
            }
            return "rgba(" + 255 * e3 + "," + 255 * n3 + "," + 255 * r2 + "," + c2 + ")"
        }(t2) : void 0;
        var e2, n2
    }
    function Lr(t2) {
        var e2 = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(t2);
        if (e2)
            return e2[1]
    }
    function qr(t2, e2) {
        return fr.fnc(t2) ? t2(e2.target, e2.id, e2.total) : t2
    }
    function Dr(t2, e2) {
        return t2.getAttribute(e2)
    }
    function Pr(t2, e2, n2) {
        if (Tr([n2, "deg", "rad", "turn"], Lr(e2)))
            return e2;
        var r2 = cr.CSS[e2 + n2];
        if (!fr.und(r2))
            return r2;
        var i2 = document.createElement(t2.tagName)
          , o2 = t2.parentNode && t2.parentNode !== document ? t2.parentNode : document.body;
        o2.appendChild(i2),
        i2.style.position = "absolute",
        i2.style.width = 100 + n2;
        var a2 = 100 / i2.offsetWidth;
        o2.removeChild(i2);
        var s2 = a2 * parseFloat(e2);
        return cr.CSS[e2 + n2] = s2,
        s2
    }
    function jr(t2, e2, n2) {
        if (e2 in t2.style) {
            var r2 = e2.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()
              , i2 = t2.style[e2] || getComputedStyle(t2).getPropertyValue(r2) || "0";
            return n2 ? Pr(t2, i2, n2) : i2
        }
    }
    function Ir(t2, e2) {
        return fr.dom(t2) && !fr.inp(t2) && (Dr(t2, e2) || fr.svg(t2) && t2[e2]) ? "attribute" : fr.dom(t2) && Tr(sr, e2) ? "transform" : fr.dom(t2) && e2 !== "transform" && jr(t2, e2) ? "css" : t2[e2] != null ? "object" : void 0
    }
    function Nr(t2) {
        if (fr.dom(t2)) {
            for (var e2, n2 = t2.style.transform || "", r2 = /(\w+)\(([^)]*)\)/g, i2 = new Map; e2 = r2.exec(n2); )
                i2.set(e2[1], e2[2]);
            return i2
        }
    }
    function Mr(t2, e2, n2, r2) {
        var i2 = ur(e2, "scale") ? 1 : 0 + function(t3) {
            return ur(t3, "translate") || t3 === "perspective" ? "px" : ur(t3, "rotate") || ur(t3, "skew") ? "deg" : void 0
        }(e2)
          , o2 = Nr(t2).get(e2) || i2;
        return n2 && (n2.transforms.list.set(e2, o2),
        n2.transforms.last = e2),
        r2 ? Pr(t2, o2, r2) : o2
    }
    function zr(t2, e2, n2, r2) {
        switch (Ir(t2, e2)) {
        case "transform":
            return Mr(t2, e2, r2, n2);
        case "css":
            return jr(t2, e2, n2);
        case "attribute":
            return Dr(t2, e2);
        default:
            return t2[e2] || 0
        }
    }
    function Rr(t2, e2) {
        var n2 = /^(\*=|\+=|-=)/.exec(t2);
        if (!n2)
            return t2;
        var r2 = Lr(t2) || 0
          , i2 = parseFloat(e2)
          , o2 = parseFloat(t2.replace(n2[0], ""));
        switch (n2[0][0]) {
        case "+":
            return i2 + o2 + r2;
        case "-":
            return i2 - o2 + r2;
        case "*":
            return i2 * o2 + r2
        }
    }
    function Br(t2, e2) {
        if (fr.col(t2))
            return Or(t2);
        if (/\s/g.test(t2))
            return t2;
        var n2 = Lr(t2)
          , r2 = n2 ? t2.substr(0, t2.length - n2.length) : t2;
        return e2 ? r2 + e2 : r2
    }
    function Fr(t2, e2) {
        return Math.sqrt(Math.pow(e2.x - t2.x, 2) + Math.pow(e2.y - t2.y, 2))
    }
    function Hr(t2) {
        for (var e2, n2 = t2.points, r2 = 0, i2 = 0; i2 < n2.numberOfItems; i2++) {
            var o2 = n2.getItem(i2);
            i2 > 0 && (r2 += Fr(e2, o2)),
            e2 = o2
        }
        return r2
    }
    function Vr(t2) {
        if (t2.getTotalLength)
            return t2.getTotalLength();
        switch (t2.tagName.toLowerCase()) {
        case "circle":
            return function(t3) {
                return 2 * Math.PI * Dr(t3, "r")
            }(t2);
        case "rect":
            return function(t3) {
                return 2 * Dr(t3, "width") + 2 * Dr(t3, "height")
            }(t2);
        case "line":
            return function(t3) {
                return Fr({
                    x: Dr(t3, "x1"),
                    y: Dr(t3, "y1")
                }, {
                    x: Dr(t3, "x2"),
                    y: Dr(t3, "y2")
                })
            }(t2);
        case "polyline":
            return Hr(t2);
        case "polygon":
            return function(t3) {
                var e2 = t3.points;
                return Hr(t3) + Fr(e2.getItem(e2.numberOfItems - 1), e2.getItem(0))
            }(t2)
        }
    }
    function Ur(t2, e2) {
        var n2 = e2 || {}
          , r2 = n2.el || function(t3) {
            for (var e3 = t3.parentNode; fr.svg(e3) && fr.svg(e3.parentNode); )
                e3 = e3.parentNode;
            return e3
        }(t2)
          , i2 = r2.getBoundingClientRect()
          , o2 = Dr(r2, "viewBox")
          , a2 = i2.width
          , s2 = i2.height
          , c2 = n2.viewBox || (o2 ? o2.split(" ") : [0, 0, a2, s2]);
        return {
            el: r2,
            viewBox: c2,
            x: c2[0] / 1,
            y: c2[1] / 1,
            w: a2 / c2[2],
            h: s2 / c2[3]
        }
    }
    function Wr(t2, e2) {
        function n2(n3) {
            n3 === void 0 && (n3 = 0);
            var r3 = e2 + n3 >= 1 ? e2 + n3 : 0;
            return t2.el.getPointAtLength(r3)
        }
        var r2 = Ur(t2.el, t2.svg)
          , i2 = n2()
          , o2 = n2(-1)
          , a2 = n2(1);
        switch (t2.property) {
        case "x":
            return (i2.x - r2.x) * r2.w;
        case "y":
            return (i2.y - r2.y) * r2.h;
        case "angle":
            return 180 * Math.atan2(a2.y - o2.y, a2.x - o2.x) / Math.PI
        }
    }
    function Gr(t2, e2) {
        var n2 = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g
          , r2 = Br(fr.pth(t2) ? t2.totalLength : t2, e2) + "";
        return {
            original: r2,
            numbers: r2.match(n2) ? r2.match(n2).map(Number) : [0],
            strings: fr.str(t2) || e2 ? r2.split(n2) : []
        }
    }
    function $r(t2) {
        return _r(t2 ? Ar(fr.arr(t2) ? t2.map(kr) : kr(t2)) : [], function(t3, e2, n2) {
            return n2.indexOf(t3) === e2
        })
    }
    function Jr(t2) {
        var e2 = $r(t2);
        return e2.map(function(t3, n2) {
            return {
                target: t3,
                id: n2,
                total: e2.length,
                transforms: {
                    list: Nr(t3)
                }
            }
        })
    }
    function Yr(t2, e2) {
        var n2 = Sr(e2);
        if (/^spring/.test(n2.easing) && (n2.duration = pr(n2.easing)),
        fr.arr(t2)) {
            var r2 = t2.length;
            r2 === 2 && !fr.obj(t2[0]) ? t2 = {
                value: t2
            } : fr.fnc(e2.duration) || (n2.duration = e2.duration / r2)
        }
        var i2 = fr.arr(t2) ? t2 : [t2];
        return i2.map(function(t3, n3) {
            var r3 = fr.obj(t3) && !fr.pth(t3) ? t3 : {
                value: t3
            };
            return fr.und(r3.delay) && (r3.delay = n3 ? 0 : e2.delay),
            fr.und(r3.endDelay) && (r3.endDelay = n3 === i2.length - 1 ? e2.endDelay : 0),
            r3
        }).map(function(t3) {
            return Cr(t3, n2)
        })
    }
    function Xr(t2, e2) {
        var n2 = []
          , r2 = e2.keyframes;
        for (var i2 in r2 && (e2 = Cr(function(t3) {
            for (var e3 = _r(Ar(t3.map(function(t4) {
                return Object.keys(t4)
            })), function(t4) {
                return fr.key(t4)
            }).reduce(function(t4, e4) {
                return t4.indexOf(e4) < 0 && t4.push(e4),
                t4
            }, []), n3 = {}, r3 = function(r4) {
                var i4 = e3[r4];
                n3[i4] = t3.map(function(t4) {
                    var e4 = {};
                    for (var n4 in t4)
                        fr.key(n4) ? n4 == i4 && (e4.value = t4[n4]) : e4[n4] = t4[n4];
                    return e4
                })
            }, i3 = 0; i3 < e3.length; i3++)
                r3(i3);
            return n3
        }(r2), e2)),
        e2)
            fr.key(i2) && n2.push({
                name: i2,
                tweens: Yr(e2[i2], t2)
            });
        return n2
    }
    function Qr(t2, e2) {
        var n2;
        return t2.tweens.map(function(r2) {
            var i2 = function(t3, e3) {
                var n3 = {};
                for (var r3 in t3) {
                    var i3 = qr(t3[r3], e3);
                    fr.arr(i3) && (i3 = i3.map(function(t4) {
                        return qr(t4, e3)
                    })).length === 1 && (i3 = i3[0]),
                    n3[r3] = i3
                }
                return n3.duration = parseFloat(n3.duration),
                n3.delay = parseFloat(n3.delay),
                n3
            }(r2, e2)
              , o2 = i2.value
              , a2 = fr.arr(o2) ? o2[1] : o2
              , s2 = Lr(a2)
              , c2 = zr(e2.target, t2.name, s2, e2)
              , l2 = n2 ? n2.to.original : c2
              , u2 = fr.arr(o2) ? o2[0] : l2
              , d2 = Lr(u2) || Lr(c2)
              , f2 = s2 || d2;
            return fr.und(a2) && (a2 = l2),
            i2.from = Gr(u2, f2),
            i2.to = Gr(Rr(a2, u2), f2),
            i2.start = n2 ? n2.end : 0,
            i2.end = i2.start + i2.delay + i2.duration + i2.endDelay,
            i2.easing = wr(i2.easing, i2.duration),
            i2.isPath = fr.pth(o2),
            i2.isColor = fr.col(i2.from.original),
            i2.isColor && (i2.round = 1),
            n2 = i2,
            i2
        })
    }
    var Zr = {
        css: function(t2, e2, n2) {
            return t2.style[e2] = n2
        },
        attribute: function(t2, e2, n2) {
            return t2.setAttribute(e2, n2)
        },
        object: function(t2, e2, n2) {
            return t2[e2] = n2
        },
        transform: function(t2, e2, n2, r2, i2) {
            if (r2.list.set(e2, n2),
            e2 === r2.last || i2) {
                var o2 = "";
                r2.list.forEach(function(t3, e3) {
                    o2 += e3 + "(" + t3 + ") "
                }),
                t2.style.transform = o2
            }
        }
    };
    function Kr(t2, e2) {
        Jr(t2).forEach(function(t3) {
            for (var n2 in e2) {
                var r2 = qr(e2[n2], t3)
                  , i2 = t3.target
                  , o2 = Lr(r2)
                  , a2 = zr(i2, n2, o2, t3)
                  , s2 = Rr(Br(r2, o2 || Lr(a2)), a2)
                  , c2 = Ir(i2, n2);
                Zr[c2](i2, n2, s2, t3.transforms, !0)
            }
        })
    }
    function ti(t2, e2) {
        return _r(Ar(t2.map(function(t3) {
            return e2.map(function(e3) {
                return function(t4, e4) {
                    var n2 = Ir(t4.target, e4.name);
                    if (n2) {
                        var r2 = Qr(e4, t4)
                          , i2 = r2[r2.length - 1];
                        return {
                            type: n2,
                            property: e4.name,
                            animatable: t4,
                            tweens: r2,
                            duration: i2.end,
                            delay: r2[0].delay,
                            endDelay: i2.endDelay
                        }
                    }
                }(t3, e3)
            })
        })), function(t3) {
            return !fr.und(t3)
        })
    }
    function ei(t2, e2) {
        var n2 = t2.length
          , r2 = function(t3) {
            return t3.timelineOffset ? t3.timelineOffset : 0
        }
          , i2 = {};
        return i2.duration = n2 ? Math.max.apply(Math, t2.map(function(t3) {
            return r2(t3) + t3.duration
        })) : e2.duration,
        i2.delay = n2 ? Math.min.apply(Math, t2.map(function(t3) {
            return r2(t3) + t3.delay
        })) : e2.delay,
        i2.endDelay = n2 ? i2.duration - Math.max.apply(Math, t2.map(function(t3) {
            return r2(t3) + t3.duration - t3.endDelay
        })) : e2.endDelay,
        i2
    }
    var ni = 0, ri, ii = [], oi = [], ai = function() {
        function t2() {
            ri = requestAnimationFrame(e2)
        }
        function e2(e3) {
            var n2 = ii.length;
            if (n2) {
                for (var r2 = 0; r2 < n2; ) {
                    var i2 = ii[r2];
                    if (i2.paused) {
                        var o2 = ii.indexOf(i2);
                        o2 > -1 && (ii.splice(o2, 1),
                        n2 = ii.length)
                    } else
                        i2.tick(e3);
                    r2++
                }
                t2()
            } else
                ri = cancelAnimationFrame(ri)
        }
        return t2
    }();
    function si(t2) {
        t2 === void 0 && (t2 = {});
        var e2, n2 = 0, r2 = 0, i2 = 0, o2 = 0, a2 = null;
        function s2(t3) {
            var e3 = window.Promise && new Promise(function(t4) {
                return a2 = t4
            }
            );
            return t3.finished = e3,
            e3
        }
        var c2 = function(t3) {
            var e3 = xr(or, t3)
              , n3 = xr(ar, t3)
              , r3 = Xr(n3, t3)
              , i3 = Jr(t3.targets)
              , o3 = ti(i3, r3)
              , a3 = ei(o3, n3)
              , s3 = ni;
            return ni++,
            Cr(e3, {
                id: s3,
                children: [],
                animatables: i3,
                animations: o3,
                duration: a3.duration,
                delay: a3.delay,
                endDelay: a3.endDelay
            })
        }(t2);
        s2(c2);
        function l2() {
            var t3 = c2.direction;
            t3 !== "alternate" && (c2.direction = t3 !== "normal" ? "normal" : "reverse"),
            c2.reversed = !c2.reversed,
            e2.forEach(function(t4) {
                return t4.reversed = c2.reversed
            })
        }
        function u2(t3) {
            return c2.reversed ? c2.duration - t3 : t3
        }
        function d2() {
            n2 = 0,
            r2 = u2(c2.currentTime) * (1 / si.speed)
        }
        function f2(t3, e3) {
            e3 && e3.seek(t3 - e3.timelineOffset)
        }
        function h2(t3) {
            for (var e3 = 0, n3 = c2.animations, r3 = n3.length; e3 < r3; ) {
                var i3 = n3[e3]
                  , o3 = i3.animatable
                  , a3 = i3.tweens
                  , s3 = a3.length - 1
                  , l3 = a3[s3];
                s3 && (l3 = _r(a3, function(e4) {
                    return t3 < e4.end
                })[0] || l3);
                for (var u3 = lr(t3 - l3.start - l3.delay, 0, l3.duration) / l3.duration, d3 = isNaN(u3) ? 1 : l3.easing(u3), f3 = l3.to.strings, h3 = l3.round, p3 = [], g3 = l3.to.numbers.length, v2 = void 0, m2 = 0; m2 < g3; m2++) {
                    var y2 = void 0
                      , b2 = l3.to.numbers[m2]
                      , w2 = l3.from.numbers[m2] || 0;
                    y2 = l3.isPath ? Wr(l3.value, d3 * b2) : w2 + d3 * (b2 - w2),
                    h3 && (l3.isColor && m2 > 2 || (y2 = Math.round(y2 * h3) / h3)),
                    p3.push(y2)
                }
                var E2 = f3.length;
                if (E2) {
                    v2 = f3[0];
                    for (var _2 = 0; _2 < E2; _2++) {
                        f3[_2];
                        var A2 = f3[_2 + 1]
                          , k2 = p3[_2];
                        isNaN(k2) || (v2 += A2 ? k2 + A2 : k2 + " ")
                    }
                } else
                    v2 = p3[0];
                Zr[i3.type](o3.target, i3.property, v2, o3.transforms),
                i3.currentValue = v2,
                e3++
            }
        }
        function p2(t3) {
            c2[t3] && !c2.passThrough && c2[t3](c2)
        }
        function g2(t3) {
            var d3 = c2.duration
              , g3 = c2.delay
              , v2 = d3 - c2.endDelay
              , m2 = u2(t3);
            c2.progress = lr(m2 / d3 * 100, 0, 100),
            c2.reversePlayback = m2 < c2.currentTime,
            e2 && function(t4) {
                if (c2.reversePlayback)
                    for (var n3 = o2; n3--; )
                        f2(t4, e2[n3]);
                else
                    for (var r3 = 0; r3 < o2; r3++)
                        f2(t4, e2[r3])
            }(m2),
            !c2.began && c2.currentTime > 0 && (c2.began = !0,
            p2("begin")),
            !c2.loopBegan && c2.currentTime > 0 && (c2.loopBegan = !0,
            p2("loopBegin")),
            m2 <= g3 && c2.currentTime !== 0 && h2(0),
            (m2 >= v2 && c2.currentTime !== d3 || !d3) && h2(d3),
            m2 > g3 && m2 < v2 ? (c2.changeBegan || (c2.changeBegan = !0,
            c2.changeCompleted = !1,
            p2("changeBegin")),
            p2("change"),
            h2(m2)) : c2.changeBegan && (c2.changeCompleted = !0,
            c2.changeBegan = !1,
            p2("changeComplete")),
            c2.currentTime = lr(m2, 0, d3),
            c2.began && p2("update"),
            t3 >= d3 && (r2 = 0,
            c2.remaining && c2.remaining !== !0 && c2.remaining--,
            c2.remaining ? (n2 = i2,
            p2("loopComplete"),
            c2.loopBegan = !1,
            c2.direction === "alternate" && l2()) : (c2.paused = !0,
            c2.completed || (c2.completed = !0,
            p2("loopComplete"),
            p2("complete"),
            !c2.passThrough && "Promise"in window && (a2(),
            s2(c2)))))
        }
        return c2.reset = function() {
            var t3 = c2.direction;
            c2.passThrough = !1,
            c2.currentTime = 0,
            c2.progress = 0,
            c2.paused = !0,
            c2.began = !1,
            c2.loopBegan = !1,
            c2.changeBegan = !1,
            c2.completed = !1,
            c2.changeCompleted = !1,
            c2.reversePlayback = !1,
            c2.reversed = t3 === "reverse",
            c2.remaining = c2.loop,
            e2 = c2.children;
            for (var n3 = o2 = e2.length; n3--; )
                c2.children[n3].reset();
            (c2.reversed && c2.loop !== !0 || t3 === "alternate" && c2.loop === 1) && c2.remaining++,
            h2(c2.reversed ? c2.duration : 0)
        }
        ,
        c2.set = function(t3, e3) {
            return Kr(t3, e3),
            c2
        }
        ,
        c2.tick = function(t3) {
            i2 = t3,
            n2 || (n2 = i2),
            g2((i2 + (r2 - n2)) * si.speed)
        }
        ,
        c2.seek = function(t3) {
            g2(u2(t3))
        }
        ,
        c2.pause = function() {
            c2.paused = !0,
            d2()
        }
        ,
        c2.play = function() {
            c2.paused && (c2.completed && c2.reset(),
            c2.paused = !1,
            ii.push(c2),
            d2(),
            ri || ai())
        }
        ,
        c2.reverse = function() {
            l2(),
            c2.completed = !c2.reversed,
            d2()
        }
        ,
        c2.restart = function() {
            c2.reset(),
            c2.play()
        }
        ,
        c2.reset(),
        c2.autoplay && c2.play(),
        c2
    }
    function ci(t2, e2) {
        for (var n2 = e2.length; n2--; )
            Tr(t2, e2[n2].animatable.target) && e2.splice(n2, 1)
    }
    typeof document < "u" && document.addEventListener("visibilitychange", function() {
        document.hidden ? (ii.forEach(function(t2) {
            return t2.pause()
        }),
        oi = ii.slice(0),
        si.running = ii = []) : oi.forEach(function(t2) {
            return t2.play()
        })
    }),
    si.version = "3.2.0",
    si.speed = 1,
    si.running = ii,
    si.remove = function(t2) {
        for (var e2 = $r(t2), n2 = ii.length; n2--; ) {
            var r2 = ii[n2]
              , i2 = r2.animations
              , o2 = r2.children;
            ci(e2, i2);
            for (var a2 = o2.length; a2--; ) {
                var s2 = o2[a2]
                  , c2 = s2.animations;
                ci(e2, c2),
                c2.length || s2.children.length || o2.splice(a2, 1)
            }
            i2.length || o2.length || r2.pause()
        }
    }
    ,
    si.get = zr,
    si.set = Kr,
    si.convertPx = Pr,
    si.path = function(t2, e2) {
        var n2 = fr.str(t2) ? Er(t2)[0] : t2
          , r2 = e2 || 100;
        return function(t3) {
            return {
                property: t3,
                el: n2,
                svg: Ur(n2),
                totalLength: Vr(n2) * (r2 / 100)
            }
        }
    }
    ,
    si.setDashoffset = function(t2) {
        var e2 = Vr(t2);
        return t2.setAttribute("stroke-dasharray", e2),
        e2
    }
    ,
    si.stagger = function(t2, e2) {
        e2 === void 0 && (e2 = {});
        var n2 = e2.direction || "normal"
          , r2 = e2.easing ? wr(e2.easing) : null
          , i2 = e2.grid
          , o2 = e2.axis
          , a2 = e2.from || 0
          , s2 = a2 === "first"
          , c2 = a2 === "center"
          , l2 = a2 === "last"
          , u2 = fr.arr(t2)
          , d2 = parseFloat(u2 ? t2[0] : t2)
          , f2 = u2 ? parseFloat(t2[1]) : 0
          , h2 = Lr(u2 ? t2[1] : t2) || 0
          , p2 = e2.start || 0 + (u2 ? d2 : 0)
          , g2 = []
          , v2 = 0;
        return function(t3, e3, m2) {
            if (s2 && (a2 = 0),
            c2 && (a2 = (m2 - 1) / 2),
            l2 && (a2 = m2 - 1),
            !g2.length) {
                for (var y2 = 0; y2 < m2; y2++) {
                    if (i2) {
                        var b2 = c2 ? (i2[0] - 1) / 2 : a2 % i2[0]
                          , w2 = c2 ? (i2[1] - 1) / 2 : Math.floor(a2 / i2[0])
                          , E2 = b2 - y2 % i2[0]
                          , _2 = w2 - Math.floor(y2 / i2[0])
                          , A2 = Math.sqrt(E2 * E2 + _2 * _2);
                        o2 === "x" && (A2 = -E2),
                        o2 === "y" && (A2 = -_2),
                        g2.push(A2)
                    } else
                        g2.push(Math.abs(a2 - y2));
                    v2 = Math.max.apply(Math, g2)
                }
                r2 && (g2 = g2.map(function(t4) {
                    return r2(t4 / v2) * v2
                })),
                n2 === "reverse" && (g2 = g2.map(function(t4) {
                    return o2 ? t4 < 0 ? -1 * t4 : -t4 : Math.abs(v2 - t4)
                }))
            }
            return p2 + (u2 ? (f2 - d2) / v2 : d2) * (Math.round(100 * g2[e3]) / 100) + h2
        }
    }
    ,
    si.timeline = function(t2) {
        t2 === void 0 && (t2 = {});
        var e2 = si(t2);
        return e2.duration = 0,
        e2.add = function(n2, r2) {
            var i2 = ii.indexOf(e2)
              , o2 = e2.children;
            function a2(t3) {
                t3.passThrough = !0
            }
            i2 > -1 && ii.splice(i2, 1);
            for (var s2 = 0; s2 < o2.length; s2++)
                a2(o2[s2]);
            var c2 = Cr(n2, xr(ar, t2));
            c2.targets = c2.targets || t2.targets;
            var l2 = e2.duration;
            c2.autoplay = !1,
            c2.direction = e2.direction,
            c2.timelineOffset = fr.und(r2) ? l2 : Rr(r2, l2),
            a2(e2),
            e2.seek(c2.timelineOffset);
            var u2 = si(c2);
            a2(u2),
            o2.push(u2);
            var d2 = ei(o2, t2);
            return e2.delay = d2.delay,
            e2.endDelay = d2.endDelay,
            e2.duration = d2.duration,
            e2.seek(0),
            e2.reset(),
            e2.autoplay && e2.play(),
            e2
        }
        ,
        e2
    }
    ,
    si.easing = wr,
    si.penner = br,
    si.random = function(t2, e2) {
        return Math.floor(Math.random() * (e2 - t2 + 1)) + t2
    }
    ;
    var li = si
      , ui = `
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M3 7A2 2 0 0 0 1 9V17H3V13H5V17H7V9A2 2 0 0 0 5 7H3M3 9H5V11H3M15 10.5V9A2 2 0 0 0 13 7H9V17H13A2 2 0 0 0 15 15V13.5A1.54 1.54 0 0 0 13.5 12A1.54 1.54 0 0 0 15 10.5M13 15H11V13H13V15M13 11H11V9H13M19 7A2 2 0 0 0 17 9V15A2 2 0 0 0 19 17H21A2 2 0 0 0 23 15V14H21V15H19V9H21V10H23V9A2 2 0 0 0 21 7Z" fill="currentColor" />
  </svg>
`
      , di = {
        el: {
            clear: "[data-search-clear]",
            input: "[data-input]",
            results: "[data-search-results]",
            search: "[data-search-submit]"
        },
        strings: {
            articles: "Articles",
            pages: "Pages",
            products: "Products",
            view_all: "View all"
        },
        show_articles: !0,
        show_pages: !0,
        show_products: !0,
        show_vendor: !1,
        show_price: !0,
        limit: 4,
        headingMarkup: function(t2) {
            return '<div class="quick-search__header ff-meta fs-meta c-meta">'.concat(t2, "</div>")
        },
        resultMarkup: function(t2) {
            var e2 = t2.url
              , n2 = t2.img
              , r2 = t2.heading
              , i2 = t2.subheading;
            return `
  <a class="quick-search__result" href="`.concat(e2, `">
    <div class="quick-search__result-image">`).concat(n2, `</div>
    <div class="quick-search__result-details ff-body fs-body-base">
      <div class="quick-search__result-heading">`).concat(r2, `</div>
      <div class="quick-search__result-subheading">`).concat(i2, `</div>
    </div>
  </a>
`)
        },
        viewAllMarkup: function(t2) {
            return `
  <div class="quick-search__view-all ff-body fs-body-base">
    <button type="submit">`.concat(t2, `</button>
  </div>
`)
        }
    };
    function fi(t2, e2) {
        var n2 = Object.keys(t2);
        if (Object.getOwnPropertySymbols) {
            var r2 = Object.getOwnPropertySymbols(t2);
            e2 && (r2 = r2.filter(function(e3) {
                return Object.getOwnPropertyDescriptor(t2, e3).enumerable
            })),
            n2.push.apply(n2, r2)
        }
        return n2
    }
    function hi(t2) {
        for (var e2 = 1; e2 < arguments.length; e2++) {
            var n2 = arguments[e2] != null ? arguments[e2] : {};
            e2 % 2 ? fi(Object(n2), !0).forEach(function(e3) {
                oe()(t2, e3, n2[e3])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t2, Object.getOwnPropertyDescriptors(n2)) : fi(Object(n2)).forEach(function(e3) {
                Object.defineProperty(t2, e3, Object.getOwnPropertyDescriptor(n2, e3))
            })
        }
        return t2
    }
    var pi = "[data-overlay]"
      , gi = "[data-list-item]"
      , vi = "[data-all-links]"
      , mi = "[data-main]"
      , yi = "[data-primary-container]"
      , bi = "[data-footer]"
      , wi = "[data-search-settings]"
      , Ei = ".drawer-menu__form"
      , _i = "[data-locale-input]"
      , Ai = "[data-currency-input]"
      , ki = "active"
      , Ti = "visible"
      , Si = function(t2) {
        return li({
            targets: t2,
            translateX: [40, 0],
            opacity: [0, 1],
            easing: "cubicBezier(.5, .05, .1, .3)",
            duration: 180,
            delay: li.stagger(80, {
                start: 250
            }),
            complete: function() {
                t2.forEach(function(t3) {
                    return t3.style.removeProperty("transform")
                })
            }
        })
    }
      , xi = function(t2) {
        return t2 + 8 + "px"
    }
      , Ci = function(t2) {
        var e2 = window.theme
          , n2 = 0
          , r2 = 0
          , i2 = h(vi, t2)
          , o2 = h(mi, t2)
          , a2 = h(yi, t2)
          , s2 = h(Ei, t2)
          , c2 = h(_i, t2)
          , l2 = h(Ai, t2)
          , u2 = h(wi, t2)
          , d2 = function(t3) {
            var e3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}
              , n3 = Object.assign(di, e3)
              , r3 = ""
              , i3 = h("form", t3)
              , o3 = h(n3.el.input, t3)
              , a3 = h(n3.el.results, t3)
              , s3 = h(n3.el.clear, t3)
              , c3 = h(n3.el.search, t3)
              , l3 = m(o3, "input", b2)
              , u3 = m(s3, "click", _3)
              , d3 = function() {}
              , f3 = [n3.show_articles && Fn.TYPES.ARTICLE, n3.show_pages && Fn.TYPES.PAGE, Fn.TYPES.PRODUCT].filter(Boolean)
              , p2 = new Fn({
                resources: {
                    type: f3,
                    limit: n3.limit,
                    options: {
                        unavailable_products: "last",
                        fields: [Fn.FIELDS.TITLE, Fn.FIELDS.PRODUCT_TYPE, Fn.FIELDS.VARIANTS_TITLE]
                    }
                }
            });
            function g3(t4, e4, r4) {
                return t4.length < 1 ? "" : n3.headingMarkup(e4) + t4.map(r4).join("")
            }
            function v3(t4) {
                var e4 = t4.url
                  , i4 = t4.image
                  , o4 = t4.heading
                  , a4 = t4.subheading
                  , s4 = new RegExp("(" + r3 + ")","gi")
                  , c4 = o4.replace(s4, '<span class="hl">$1</span>')
                  , l4 = a4.replace(s4, '<span class="hl">$1</span>')
                  , u4 = i4 ? '<img class="image__img lazyload" data-src="'.concat(Object(zt.getSizedImageUrl)(i4, "120x"), '" />') : ui;
                return n3.resultMarkup({
                    url: e4,
                    img: u4,
                    heading: c4,
                    subheading: l4
                })
            }
            function y3(t4) {
                var e4 = t4.articles
                  , r4 = t4.pages
                  , i4 = g3(t4.products, n3.strings.products, function(t5) {
                    var e5 = t5.url
                      , r5 = t5.image
                      , i5 = t5.title
                      , o5 = t5.price
                      , a4 = t5.vendor
                      , s4 = K(o5 * window.Shopify.currency.rate * 100);
                    if (!(t5.handle.includes("icon-") || t5.handle.includes("embroidery")))
                        return v3({
                            url: e5,
                            image: r5,
                            heading: i5,
                            subheading: [n3.show_vendor && a4, n3.show_price && Un()(s4)].filter(Boolean).join(" \u2022 ")
                        })
                });
                r4 && (i4 += g3(r4, n3.strings.pages, function(t5) {
                    var e5 = t5.url
                      , n4 = t5.image
                      , r5 = t5.title
                      , i5 = t5.body;
                    return v3({
                        url: e5,
                        image: n4,
                        heading: r5,
                        subheading: Un()(i5)
                    })
                })),
                e4 && (i4 += g3(e4, n3.strings.articles, function(t5) {
                    var e5 = t5.url
                      , n4 = t5.image
                      , r5 = t5.title
                      , i5 = t5.body;
                    return v3({
                        url: e5,
                        image: n4,
                        heading: r5,
                        subheading: Un()(i5)
                    })
                }));
                var o4 = n3.viewAllMarkup(n3.strings.view_all);
                a3.innerHTML = i4 + o4
            }
            function b2(t4) {
                var e4 = t4.target.value;
                e4 === "" && w(a3, "visible"),
                E([s3, c3], "visible", e4 !== ""),
                p2.query(e4)
            }
            function _3(t4) {
                t4.preventDefault(),
                o3.value = "",
                w([a3, s3, c3], "visible"),
                a3.innerHTML = "",
                o3.focus(),
                d3()
            }
            function A3() {
                l3(),
                u3()
            }
            return p2.on("success", function(t4) {
                var e4 = t4.query
                  , n4 = t4.resources.results
                  , o4 = Object.keys(n4).reduce(function(t5, e5) {
                    return t5 + n4[e5].length
                }, 0);
                r3 = e4,
                E(a3, "visible", o4),
                o4 && (y3(n4),
                d3(),
                d3 = Jn(i3))
            }),
            p2.on("error", function(t4) {
                console.log("Search error:", t4.message)
            }),
            {
                destroy: A3
            }
        }(t2, hi(hi({}, JSON.parse(u2.innerHTML)), {}, {
            strings: {
                articles: e2.strings.search.headings.articles,
                pages: e2.strings.search.headings.pages,
                products: e2.strings.search.headings.products,
                view_all: e2.strings.search.view_all
            }
        }))
          , f2 = h(pi, t2)
          , g2 = p('[data-item="parent"]', t2)
          , v2 = p('[data-item="back"]', t2)
          , y2 = p('[data-item="secondary"]', t2)
          , _2 = p('[data-item="secondaryHeading"]', t2)
          , A2 = p('[data-item="locale"]', t2)
          , k2 = p('[data-item="currency"]', t2)
          , T2 = [m(f2, "click", S2), m(g2, "click", function(t3) {
            t3.preventDefault();
            var e3 = t3.currentTarget.nextElementSibling;
            b(e3, Ti),
            o2.style.height = xi(e3.offsetHeight);
            var n3 = p(":scope > ".concat(gi), e3);
            Si(n3),
            x2(r2 += 1)
        }), m(v2, "click", function(t3) {
            t3.preventDefault();
            var e3 = t3.currentTarget.closest(gi).closest("ul");
            o2.style.height = xi(e3.offsetHeight),
            w(t3.currentTarget.closest("ul"), Ti),
            x2(r2 -= 1)
        }), m(y2, "click", function(t3) {
            t3.preventDefault(),
            C2(1);
            var e3 = t3.currentTarget.nextElementSibling;
            b(e3, Ti);
            var n3 = p(":scope > ".concat(gi), e3);
            Si(n3)
        }), m(_2, "click", function(t3) {
            t3.preventDefault(),
            C2(0),
            w(t3.currentTarget.closest("ul"), Ti)
        }), m(A2, "click", function(t3) {
            return O2(t3, c2)
        }), m(k2, "click", function(t3) {
            return O2(t3, l2)
        })];
        function S2() {
            w(t2, Ti),
            setTimeout(function() {
                w(t2, ki),
                Mt(t2)
            }, 350)
        }
        function x2(t3) {
            r2 = t3,
            a2.setAttribute("data-depth", t3)
        }
        function C2(t3) {
            n2 = t3,
            i2.setAttribute("data-depth", t3)
        }
        function O2(t3, e3) {
            var n3 = t3.currentTarget.dataset.value;
            e3.value = n3,
            S2(),
            s2.submit()
        }
        return {
            close: S2,
            destroy: function() {
                T2.forEach(function(t3) {
                    return t3()
                }),
                Mt(t2),
                d2.destroy()
            },
            open: function() {
                b(t2, ki),
                setTimeout(function() {
                    b(t2, Ti),
                    Nt(t2, {
                        allowTouchMove: function(t3) {
                            for (; t3 && t3 !== document.body; ) {
                                if (t3.getAttribute("data-scroll-lock-ignore") !== null)
                                    return !0;
                                t3 = t3.parentNode
                            }
                        },
                        reserveScrollBarGap: !0
                    });
                    var e3 = p("".concat(yi, " > ").concat(gi, ", ").concat(bi, " > li, ").concat(bi, " > form > li"), t2);
                    n2 === 0 && r2 === 0 && (o2.style.height = xi(a2.offsetHeight),
                    Si(e3))
                }, 50)
            }
        }
    };
    et("header", {
        onLoad: function() {
            var t2 = this
              , e2 = h("[data-js-cart-icon]", this.container)
              , n2 = h("[data-js-cart-indicator]", e2)
              , r2 = h("[data-js-cart-count]", this.container)
              , i2 = h("[data-js-menu-button]", this.container)
              , o2 = h("[data-search]", this.container)
              , a2 = h("[data-header-space]", document)
              , s2 = Ci(h("[data-drawer-menu]"))
              , c2 = Zn(h("[data-quick-search]", this.container))
              , l2 = An(h("[data-quick-cart]", this.container))
              , u2 = function(t3) {
                if (t3) {
                    var e3 = p("[data-parent]", t3)
                      , n3 = p("[data-mega]", t3);
                    if (e3 || n3) {
                        var r3 = null
                          , i3 = [m([].concat(D()(e3), D()(n3)), "mouseup", function(t4) {
                            return t4.preventDefault()
                        }), m(e3, "click", function(t4) {
                            return t4.preventDefault()
                        }), m(e3, "mousedown", function(t4) {
                            t4.preventDefault(),
                            D()(t4.currentTarget.parentNode.parentNode.children).filter(function(e4) {
                                return !e4.contains(t4.currentTarget)
                            }).forEach(function(t5) {
                                return w(p("[data-submenu]", t5), "active")
                            }),
                            o3(t4.currentTarget.parentNode)
                        }), m(n3, "click", function(t4) {
                            t4.preventDefault(),
                            ir(h("[data-mega-nav]", t4.currentTarget.parentNode)).open()
                        }), m(p(".header__links-list > li > a", t3), "focus", a3), m(p("[data-link]", t3), "focus", function(t4) {
                            t4.preventDefault();
                            var e4 = t4.currentTarget;
                            e4.hasAttribute("data-parent") && o3(e4.parentNode),
                            p("[data-link]", e4.parentNode.parentNode).forEach(function(t5) {
                                return E(p("[data-submenu]", t5.parentNode), "active", t5 === e4)
                            })
                        }), m(p("[data-link]", t3), "focusout", function(t4) {
                            t4.relatedTarget && !t4.relatedTarget.hasAttribute("data-link") && a3()
                        }), R("megaNav:open", function(e4, n4) {
                            var i4 = n4.id;
                            (r3 = ir(h('[data-id="'.concat(i4, '"]'), t3))).open()
                        }), R("megaNav:close", function() {
                            r3 && r3.close()
                        })];
                        return {
                            destroy: function() {
                                i3.forEach(function(t4) {
                                    return t4()
                                })
                            }
                        }
                    }
                }
                function o3(t4) {
                    var e4 = h("[data-submenu]", t4);
                    E(e4, "active", !e4.offsetWidth > 0 && !e4.offsetHeight > 0)
                }
                function a3() {
                    w(p("[data-submenu]", t3), "active")
                }
            }(h("[data-navigation]", this.container));
            this.listeners = [R("cart:updated", function(t3) {
                var e3 = t3.cart;
                w(n2, "visible"),
                setTimeout(function() {
                    return b(n2, "visible")
                }, 500),
                r2.innerHTML = e3.item_count
            }), m(i2, "click", yn(s2.open)), m(o2, "click", yn(c2.open)), m(e2, "click", yn(l2.open))],
            this.components = [s2, c2, l2, u2],
            this.io = new IntersectionObserver(function(e3) {
                var n3 = he()(e3, 1)[0].isIntersecting;
                E(t2.container, "is-sticky", !n3)
            }
            ),
            this.io.observe(a2),
            this.ro = new mn.a(function(t3) {
                var e3, n3 = he()(t3, 1)[0].target;
                _(n3, "is-sticky") || (e3 = n3.offsetHeight,
                document.documentElement.style.setProperty("--height-header", e3 + "px"))
            }
            ),
            this.ro.observe(this.container)
        },
        onUnload: function() {
            this.listeners.forEach(function(t2) {
                return t2()
            }),
            this.components.forEach(function(t2) {
                return t2.destroy()
            }),
            this.io.disconnect(),
            this.ro.disconnect()
        },
        onBlockSelect: function(t2) {
            var e2 = t2.target;
            B("megaNav:open", null, {
                id: e2.dataset.id
            })
        },
        onBlockDeselect: function() {
            B("megaNav:close")
        }
    }),
    et("image-with-text", {
        onLoad: function() {},
        onUnload: function() {}
    }),
    et("newsletter", {
        onLoad: function() {},
        onUnload: function() {}
    });
    var Oi = n(10)
      , Li = n.n(Oi)
      , qi = function() {
        return j("exit_intent")
    }
      , Di = function(t2) {
        return I("exit_intent", t2)
    };
    et("popup", {
        onLoad: function() {
            var t2 = this
              , e2 = h("[data-close]", this.container)
              , n2 = h("[data-overlay]", this.container);
            this.closeClick = m([e2, n2], "click", function(e3) {
                e3.preventDefault(),
                t2.close()
            }),
            this.bodyLeave = function() {}
            ;
            var r2 = this.container.dataset.timeout;
            !qi() && Li()() ? setTimeout(function() {
                return t2.open()
            }, parseInt(r2)) : qi() || (this.bodyLeave = m(document.body, "mouseout", function(e3) {
                e3.relatedTarget || e3.toElement || (t2.open(),
                t2.bodyLeave())
            }))
        },
        open: function() {
            b(this.container, "visible")
        },
        close: function() {
            Di(!0),
            w(this.container, "visible")
        },
        onSelect: function() {
            this.open()
        },
        onDeselect: function() {
            this.close()
        },
        onUnload: function() {
            this.closeClick(),
            this.bodyLeave()
        }
    });
    var Pi = "[data-recommendations]"
      , ji = "[data-slider]";
    et("recommended-products", {
        onLoad: function() {
            var t2 = this
              , e2 = this.container.dataset
              , n2 = e2.limit
              , r2 = e2.productId
              , i2 = h(Pi, this.container);
            if (i2) {
                var o2 = "".concat(window.theme.routes.productRecommendations, "?section_id=recommended-products--static&limit=").concat(n2, "&product_id=").concat(r2)
                  , a2 = new XMLHttpRequest;
                a2.open("GET", o2, !0),
                a2.onload = function() {
                    if (a2.status >= 200 && a2.status < 300) {
                        var e3 = document.createElement("div");
                        if (e3.innerHTML = a2.response,
                        !h(".product-item", e3))
                            return void t2.container.parentNode.removeChild(t2.container);
                        i2.innerHTML = h(Pi, e3).innerHTML;
                        var n3 = h(ji, i2);
                        n3 && (t2.mobileCarousel = ve(n3)),
                        countHiddenColor()
                    } else
                        t2.container.parentNode.removeChild(t2.container);
                    quickAddonOptionsChange()
                }
                ,
                a2.send()
            }
        },
        onUnload: function() {
            this.mobileCarousel && this.mobileCarousel.destroy()
        }
    }),
    et("rich-text", {
        onLoad: function() {},
        onUnload: function() {}
    });
    var Ii = n(23)
      , Ni = n.n(Ii)
      , Mi = function(t2) {
        if (t2.length)
            var e2 = [m(window, "click", function() {
                return n2()
            }), m(window, "touchstart", function() {
                return n2()
            })];
        function n2() {
            t2.forEach(function(t3) {
                t3.playing || t3.play()
            }),
            e2.forEach(function(t3) {
                return t3()
            })
        }
    }
      , zi = "[data-slider]";
    et("slideshow", {
        onLoad: function() {
            var t2 = this
              , e2 = h(zi, this.container)
              , n2 = this.container.dataset
              , r2 = n2.autoplay
              , i2 = n2.parallax;
            if (Mi(p(".slideshow__video", this.container)),
            w(e2, "is-hidden"),
            e2.offsetHeight,
            this.flkty = new se.a(e2,{
                adaptiveHeight: !0,
                autoPlay: Number(r2),
                draggable: !0,
                prevNextButtons: !1,
                wrapAround: !0,
                on: {
                    ready: function() {
                        var e3 = h("[data-slide]", t2.container);
                        li({
                            targets: p(".animate", e3),
                            easing: "easeOutQuart",
                            translateY: [{
                                value: 40,
                                duration: 0
                            }, {
                                value: 0,
                                duration: 500
                            }],
                            opacity: [{
                                value: 0,
                                duration: 0
                            }, {
                                value: 1,
                                duration: 500
                            }],
                            delay: li.stagger(150, {
                                start: 800
                            })
                        })
                    }
                }
            }),
            this.flkty.on("change", function(e3) {
                var n3 = t2.flkty.cells[e3].element;
                li({
                    targets: p(".animate", n3),
                    easing: "easeOutQuart",
                    translateY: [{
                        value: 40,
                        duration: 0
                    }, {
                        value: 0,
                        duration: 500
                    }],
                    opacity: [{
                        value: 0,
                        duration: 0
                    }, {
                        value: 1,
                        duration: 500
                    }],
                    delay: li.stagger(150, {
                        start: 200
                    })
                })
            }),
            i2 == "true") {
                var o2 = this.container.querySelectorAll(".image__img");
                this.parallax = new Ni.a(o2,{
                    customWrapper: ".slideshow__parallax-wrapper",
                    scale: 1.5
                })
            }
        },
        onBlockSelect: function(t2) {
            var e2 = t2.target;
            this.flkty.select(e2.dataset.index),
            this.flkty.pausePlayer()
        },
        onBlockDeselect: function() {
            this.flkty.unpausePlayer(),
            this.parallax && this.parallax.destroy()
        },
        onUnload: function() {
            this.flkty.destroy()
        }
    });
    var Ri = "img"
      , Bi = "[data-slider]"
      , Fi = "[data-slide]";
    et("testimonials", {
        onLoad: function() {
            var t2 = h(Bi, this.container)
              , e2 = p(Fi, this.container);
            p(Ri, this.container).length === e2.length ? this.mobileCarousel = ve(t2) : b(this.container, "testimonials--vertical")
        },
        onUnload: function() {
            this.mobileCarousel && this.mobileCarousel.destroy()
        },
        onBlockSelect: function(t2) {
            var e2 = t2.target;
            this.mobileCarousel && this.mobileCarousel.select(e2.dataset.index)
        }
    });
    var Hi = "[data-slider]";
    et("text-columns-with-images", {
        onLoad: function() {
            var t2 = this.container.querySelector(Hi);
            this.mobileCarousel = ve(t2)
        },
        onUnload: function() {
            this.mobileCarousel.destroy()
        },
        onBlockSelect: function(t2) {
            var e2 = t2.target;
            this.mobileCarousel.select(e2.dataset.index)
        }
    });
    var Vi = n(24)
      , Ui = n.n(Vi)
      , Wi = n(25);
    et("video", {
        onLoad: function() {
            var t2 = this
              , e2 = this.container.dataset
              , n2 = e2.videoId
              , r2 = e2.videoType;
            if (n2 && r2) {
                var i2 = h("[data-video-player]", this.container)
                  , o2 = h("[data-play-button]", this.container)
                  , a2 = h("[data-overlay]", this.container)
                  , s2 = h(".video__image", this.container);
                this.video = function(t3, e3) {
                    e3 === void 0 && (e3 = {});
                    var n3, r3 = e3.id, i3 = e3.playerEl, o3 = e3.type;
                    if (r3 && o3) {
                        var a3 = V()
                          , s3 = a3.on
                          , c2 = a3.emit;
                        return o3 === "youtube" ? ((n3 = Ui()(i3)).loadVideoById({
                            videoId: r3,
                            suggestedQuality: "large"
                        }),
                        n3.stopVideo(),
                        n3.on("stateChange", function(t4) {
                            t4.data === 1 ? c2("play") : t4.data === 2 && c2("pause")
                        }),
                        n3.on("ready", function() {
                            c2("ready"),
                            l2()
                        })) : o3 === "vimeo" && ((n3 = new Wi.a(i3,{
                            id: r3
                        })).on("play", function() {
                            return c2("play")
                        }),
                        n3.on("pause", function() {
                            return c2("pause")
                        }),
                        n3.ready().then(function() {
                            c2("ready"),
                            l2()
                        })),
                        {
                            destroy: function() {},
                            on: s3,
                            pause: function() {
                                o3 === "youtube" ? n3.pauseVideo() : o3 === "vimeo" && n3.pause()
                            },
                            play: function() {
                                o3 === "youtube" ? n3.playVideo() : o3 === "vimeo" && n3.play()
                            }
                        }
                    }
                    function l2() {
                        var e4 = h("iframe", t3)
                          , n4 = e4.height / e4.width * 100
                          , r4 = e4.parentNode;
                        e4.height = "100%",
                        e4.width = "100%",
                        o3 === "youtube" ? r4.style.paddingTop = n4 + "%" : o3 === "vimeo" && (r4.parentNode.style.paddingTop = n4 + "%"),
                        c2("resized")
                    }
                }(this.container, {
                    id: n2,
                    type: r2,
                    playerEl: i2
                }),
                this.video.on("play", function() {
                    var e3 = h("iframe", t2.container);
                    e3.taxindex = 0,
                    e3.focus(),
                    w(a2, "visible"),
                    s2 && w(s2, "visible")
                }),
                this.video.on("pause", function() {
                    h("iframe", t2.container).tabindex = -1,
                    b(a2, "visible"),
                    s2 && b(s2, "visible"),
                    o2.focus()
                }),
                this.buttonClick = m(o2, "click", function() {
                    t2.video.play()
                })
            }
        },
        onUnload: function() {
            this.video && this.video.destroy(),
            this.buttonClick()
        }
    }),
    et("collage", {
        onLoad: function() {
            Mi(p(".collage__block-video", this.container))
        },
        onUnload: function() {}
    }),
    et("cart", {
        onLoad: function() {
            var t2, e2 = h("[data-form]", this.container), n2 = p("[data-change]", this.container);
            this.buttonClick = m(n2, "click", function(n3) {
                n3.preventDefault();
                var r2 = n3.currentTarget.dataset.change
                  , i2 = h("input", n3.currentTarget.parentNode);
                r2 === "increment" ? i2.value >= 0 && i2.value++ : r2 === "decrement" && i2.value > 0 && i2.value--,
                clearTimeout(t2),
                t2 = setTimeout(function() {
                    e2.submit()
                }, 1e3)
            })
        },
        onUnload: function() {
            this.buttonClick()
        }
    });
    var Gi = n(26)
      , $i = n.n(Gi)
      , Ji = function(t2) {
        return window.Shopify.designMode !== !0 && li({
            targets: t2,
            translateY: [60, 0],
            opacity: 1,
            easing: "cubicBezier(.5, .05, .1, .3)",
            duration: 400,
            delay: li.stagger(200)
        })
    }
      , Yi = function(t2) {
        return B("collection:filters:add", null, {
            tags: t2
        })
    }
      , Xi = function(t2) {
        var e2 = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
        return B("collection:filters:remove", null, {
            tags: t2,
            fetch: e2
        })
    }
      , Qi = function(t2) {
        return B("collection:sort:set", null, {
            method: t2
        })
    }
      , Zi = function() {
        return B("collection:sort:clear", null)
    }
      , Ki = function(t2) {
        return R("collection:filters:remove", t2)
    }
      , to = function(t2) {
        return R("collection:sort:set", t2)
    }
      , eo = function(t2) {
        return R("collection:sort:clear", t2)
    }
      , no = function(t2) {
        return R("collection:clear", t2)
    }
      , ro = "active"
      , io = "closed"
      , oo = function() {
        return j("closed_sidebar_groups") || []
    }
      , ao = function(t2) {
        return I("closed_sidebar_groups", JSON.stringify(t2))
    }
      , so = "[data-heading]"
      , co = "[data-tag]"
      , lo = "[data-sort]"
      , uo = function(t2) {
        return '[data-group="'.concat(t2, '"]')
    }
      , fo = "[data-mobile-filter]"
      , ho = "[data-mobile-modal]"
      , po = "[data-button]"
      , go = "[data-mobile-wash]"
      , vo = "[data-tag]"
      , mo = "[data-sort]"
      , yo = "[data-close-icon]"
      , bo = "active"
      , wo = "[data-js-partial]"
      , Eo = "[data-js-sidebar]"
      , subCollectionSlider = "[data-slider]";
    et("collection", {
        onLoad: function() {
            var t2, e2 = this, scSlider = h(subCollectionSlider, this.container);
            this.flkty = new se.a(scSlider,{
                cellAlign: "left",
                contain: !0,
                prevNextButtons: !1,
                pageDots: !1
            }),
            this.collection = function(t3) {
                var e3 = new $i.a(t3 || window.location.href)
                  , n2 = e3.paths().indexOf("collections") > 0 ? 3 : 2;
                function r2(t4) {
                    var r3 = e3.paths().slice(0, n2);
                    e3.paths([].concat(r3, [t4]))
                }
                function i2() {
                    var t4 = e3.paths().filter(Boolean);
                    return t4[n2] ? t4[n2].split(" ") : []
                }
                return {
                    getState: function() {
                        return {
                            handle: e3.paths()[1],
                            page: Number(e3.query.page) || 1,
                            sort_by: e3.query.sort_by || null,
                            tags: i2(),
                            url: e3.toString().replace(/%20/g, "+")
                        }
                    },
                    addTags: function(t4, n3) {
                        return r2([].concat(i2(), t4).filter(function(t5, e4, n4) {
                            return n4.indexOf(t5) == e4
                        }).join(" ")),
                        delete e3.query.page,
                        n3(this.getState())
                    },
                    removeTags: function(t4, n3) {
                        return r2(i2().filter(function(e4) {
                            return !t4.includes(e4)
                        }).join(" ")),
                        delete e3.query.page,
                        n3(this.getState())
                    },
                    setSort: function(t4, n3) {
                        return e3.query.sort_by = t4,
                        n3(this.getState())
                    },
                    clearSort: function(t4) {
                        return delete e3.query.sort_by,
                        t4(this.getState())
                    },
                    clearAll: function(t4) {
                        return delete e3.query.sort_by,
                        r2(""),
                        t4(this.getState())
                    }
                }
            }(window.location.href),
            this.sidebar = function(t3) {
                if (!t3)
                    return Function();
                document.addEventListener("click", e4 => {
                    if (!t3.contains(event.target)) {
                        var filterItems = document.querySelectorAll(".collection-sidebar .collection-sidebar__group");
                        filterItems.forEach(item => {
                            item.querySelector(".collection-sidebar__heading").classList.add("closed"),
                            item.querySelector("ul").style.display = "none"
                        }
                        )
                    }
                }
                );
                var e3 = p(co, t3)
                  , n2 = p(lo, t3)
                  , r2 = m(t3, "click", function(t4) {
                    var filterItems = t4.target.closest(".collection-sidebar").querySelectorAll(".collection-sidebar__group");
                    filterItems.forEach(item => {
                        item.querySelector(".collection-sidebar__heading").classList.add("closed"),
                        item.querySelector("ul").style.display = "none"
                    }
                    ),
                    t4.preventDefault();
                    var e4 = t4.target.dataset
                      , n3 = e4.heading
                      , r3 = e4.tag
                      , i3 = e4.sort;
                    if (r3 && (H().tags.includes(r3) ? Xi([r3]) : Yi([r3])),
                    i3 && (H().sort_by === i3 ? Zi() : Qi(i3)),
                    n3) {
                        var o3 = t4.target.nextElementSibling;
                        Oe(o3);
                        var a2 = oo();
                        Le(o3) ? (b(t4.target, io),
                        Ce(o3),
                        ao([].concat(D()(a2), [n3]))) : (w(t4.target, io),
                        xe(o3),
                        ao(a2.filter(function(t5) {
                            return t5 !== n3
                        })))
                    }
                })
                  , i2 = R("tags", function(t4) {
                    var n3 = t4.tags;
                    return e3.forEach(function(t5) {
                        return E(t5.parentElement, ro, n3.includes(t5.dataset.tag))
                    })
                })
                  , o2 = R("sort_by", function(t4) {
                    var e4 = t4.sort_by;
                    return n2.forEach(function(t5) {
                        return E(t5.parentElement, ro, t5.dataset.sort === e4)
                    })
                });
                return oo().forEach(function(e4) {
                    var n3 = h(uo(e4), t3);
                    n3 && (b(h(so, n3), io),
                    Ce(n3.querySelector("ul"), {
                        duration: 1
                    }))
                }),
                function() {
                    r2(),
                    i2(),
                    o2()
                }
            }(h(Eo, this.container)),
            this.mobileFiltering = function(t3) {
                var e3 = p(fo, t3)
                  , n2 = p(ho, t3)
                  , r2 = h(go, t3)
                  , i2 = p(vo, t3)
                  , o2 = p('[data-mobile-modal="__sort"] '.concat(mo))
                  , a2 = p(po, t3)
                  , s2 = p(yo, t3)
                  , c2 = m(e3, "click", function(e4) {
                    e4.preventDefault();
                    var n3 = e4.currentTarget.dataset.mobileFilter;
                    b(r2, bo),
                    b(h('[data-mobile-modal="'.concat(n3, '"]'), t3), bo),
                    Nt(t3, {
                        allowTouchMove: function(t4) {
                            for (; t4 && t4 !== document.body; ) {
                                if (t4.getAttribute("data-scroll-lock-ignore") !== null)
                                    return !0;
                                t4 = t4.parentNode
                            }
                        },
                        reserveScrollBarGap: !0
                    })
                })
                  , l2 = m(i2, "click", function(t4) {
                    t4.preventDefault(),
                    E(t4.target.parentNode, bo)
                })
                  , u2 = m(o2, "click", function(t4) {
                    t4.preventDefault(),
                    !_(t4.currentTarget.parentNode, bo) && o2.forEach(function(e4) {
                        return E(e4.parentNode, bo, e4 === t4.currentTarget)
                    })
                })
                  , d2 = m(r2, "click", A2)
                  , f2 = m(a2, "click", function(t4) {
                    t4.preventDefault();
                    var e4 = t4.currentTarget.dataset.button
                      , n3 = t4.currentTarget.closest(ho)
                      , drawerHeader = t4.target.closest(".drawer-menu__panel")
                      , drawerFilterClose = drawerHeader.querySelector("[data-filter-close-button]")
                      , drawerSortClose = drawerHeader.querySelector("[data-sort-close-button]");
                    if (drawerFilterClose && drawerFilterClose.click(),
                    drawerSortClose && drawerSortClose.click(),
                    n3.dataset.mobileModal === "__sort") {
                        if (e4 === "clear" && w(o2.map(function(t5) {
                            return t5.parentNode
                        }), bo),
                        e4 === "apply") {
                            var r3 = h(".".concat(bo), n3);
                            return r3 ? Qi(r3.firstElementChild.dataset.sort) : Zi(),
                            void A2()
                        }
                    } else {
                        var i3 = p(vo, n3);
                        if (e4 === "clear" && w(i3.map(function(t5) {
                            return t5.parentNode
                        }), bo),
                        e4 === "apply") {
                            var a3 = []
                              , s3 = [];
                            i3.forEach(function(t5) {
                                var e5 = t5.parentNode
                                  , n4 = t5.dataset.tag;
                                _(e5, bo) ? a3.push(n4) : s3.push(n4)
                            }),
                            s3.length > 0 && Xi(s3, a3.length <= 0),
                            a3.length > 0 && Yi(a3),
                            A2()
                        }
                    }
                })
                  , g2 = m(s2, "click", A2)
                  , v2 = R("tags", function(t4) {
                    var e4 = t4.tags;
                    return i2.forEach(function(t5) {
                        return E(t5.parentElement, bo, e4.includes(t5.dataset.tag))
                    })
                })
                  , y2 = R("sort_by", function(t4) {
                    var e4 = t4.sort_by;
                    return o2.forEach(function(t5) {
                        return E(t5.parentElement, bo, t5.dataset.sort === e4)
                    })
                });
                function A2() {
                    w([].concat(D()(n2), [r2]), bo),
                    Mt(t3)
                }
                return function() {
                    v2(),
                    y2(),
                    c2(),
                    l2(),
                    u2(),
                    d2(),
                    f2(),
                    g2()
                }
            }(this.container),
            F(this.collection.getState()),
            this.partial = h(wo, this.container),
            this.subscriptions = [(t2 = function(t3, n2) {
                var r2 = n2.tags;
                return e2.collection.addTags(r2, function(t4) {
                    e2.renderView(t4.url),
                    F(t4)()
                })
            }
            ,
            R("collection:filters:add", t2)), Ki(function(t3, n2) {
                var r2 = n2.tags
                  , i2 = n2.fetch;
                e2.collection.removeTags(r2, function(t4) {
                    i2 && (e2.renderView(t4.url),
                    F(t4)())
                })
            }), to(function(t3, n2) {
                var r2 = n2.method;
                e2.collection.setSort(r2, function(t4) {
                    e2.renderView(t4.url),
                    F(t4)()
                })
            }), eo(function() {
                e2.collection.clearSort(function(t3) {
                    e2.renderView(t3.url),
                    F(t3)()
                })
            }), no(function() {
                e2.collection.clearAll(function(t3) {
                    e2.renderView(t3.url),
                    F(t3)()
                })
            }), m(window, "popstate", function() {
                return location.reload()
            })],
            this.delegate = new f.a(this.partial),
            this.delegate.on("click", '[data-pill="filter"]', function(t3) {
                t3.preventDefault();
                var e3 = t3.target.dataset.tag;
                Xi([e3])
            }),
            this.delegate.on("click", '[data-pill="sort"]', function(t3) {
                t3.preventDefault(),
                Zi()
            }),
            this.delegate.on("click", "[data-clear]", function(t3) {
                t3.preventDefault(),
                B("collection:clear")
            }),
            this.delegate.on("click", "[data-pagination]", function(t3) {
                t3.preventDefault();
                var n2 = t3.target.href || t3.target.closest("a").href;
                e2.renderView(n2)
            }),
            Ji(".animate.animate-up");
            var preventDefault = fn2 => e3 => {
                e3.preventDefault(),
                fn2()
            }
            ;
            const menuButton = h("[data-js-filter-button]", this.container)
              , menuCloseButton = h("[data-filter-close-button]", this.container)
              , menu$1 = Ci(h("[data-filter-menu]"));
            m(menuButton, "click", preventDefault(menu$1.open)),
            m(menuCloseButton, "click", preventDefault(menu$1.close));
            const menuButton2 = h("[data-js-sort-button]", this.container)
              , menuCloseButton2 = h("[data-sort-close-button]", this.container)
              , menu$12 = Ci(h("[data-sort-filter-menu]"));
            m(menuButton2, "click", preventDefault(menu$12.open)),
            m(menuCloseButton2, "click", preventDefault(menu$12.close))
        },
        onUnload: function() {
            this.sidebar(),
            this.mobileFiltering(),
            this.delegate.off(),
            this.subscriptions.forEach(function(t2) {
                return t2()
            })
        },
        renderView: function(t2) {
            window.scrollTo(0, 0);
            var e2 = this
              , n2 = h(".collection__loading", this.container);
            b(n2, "is-active"),
            fetch(t2, {
                credentials: "include"
            }).then(function(t3) {
                return t3.text()
            }).then(function(r2) {
                window.history.pushState({}, "", t2);
                var i2 = new window.DOMParser().parseFromString(r2, "text/html")
                  , o2 = h(wo, i2).innerHTML;
                e2.partial.innerHTML = o2,
                w(n2, "is-active"),
                B("collection:updated"),
                countHiddenColor()
            }).then(function() {
                Ji(".animate.animate-up"),
                quickAddonOptionsChange()
            })
        }
    });
    var _o = function(t2) {
        var e2 = je(p(".accordion", t2));
        return {
            destroy: function() {
                e2.destroy()
            }
        }
    };
    function Ao() {
        var t2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        t2.forEach(function(t3) {
            var e2 = document.createElement("div");
            e2.classList.add("rte__iframe"),
            t3.parentNode.insertBefore(e2, t3),
            e2.appendChild(t3),
            t3.src = t3.src
        })
    }
    et("page", {
        onLoad: function() {
            this.accordions = _o(this.container),
            Ao(p("iframe", this.container))
        },
        onUnload: function() {
            this.accordions.destroy()
        }
    });
    var ko = "[data-js-toggle]";
    et("password", {
        onLoad: function() {
            var t2 = this;
            this.toggleButton = this.container.querySelector(ko),
            this.toggleButton.addEventListener("click", function(e2) {
                return t2.toggleView(e2)
            })
        },
        onUnload: function() {
            var t2 = this;
            this.toggleButton.removeEventListener("click", function(e2) {
                return t2.toggleView(e2)
            })
        },
        toggleView: function() {
            this.container.classList.toggle("welcome")
        }
    });
    var To = "[data-close]"
      , So = "[data-slider]"
      , xo = "[data-slide]"
      , Co = function(t2) {
        return "[data-id='".concat(t2, "']")
    }
      , Oo = "[data-nav-item]"
      , Lo = ".lightbox__images-wrapper"
      , qo = "[data-prev]"
      , Do = "[data-next]"
      , Po = "visible"
      , jo = "active"
      , Io = "zoom";
    function No(t2) {
        var e2 = _t(t2)
          , n2 = p(Oo, t2)
          , r2 = h(Lo, t2)
          , i2 = p(xo, t2)
          , o2 = h(qo, t2)
          , a2 = h(Do, t2)
          , s2 = h(So, t2)
          , c2 = new se.a(s2,{
            adaptiveHeight: !0,
            draggable: Li()({
                tablet: !0,
                featureDetect: !0
            }),
            prevNextButtons: !1,
            wrapAround: !1,
            pageDots: !1
        });
        i2.length > 1 ? (c2.on("scroll", function(t3) {
            u2();
            var e3 = 100 * t3;
            o2.disabled = e3 < 1,
            a2.disabled = e3 > 99
        }),
        c2.on("select", function() {
            n2.forEach(function(t3) {
                return w(t3, jo)
            }),
            b(n2[c2.selectedIndex], jo),
            n2[c2.selectedIndex].scrollIntoView({
                behavior: "smooth",
                inline: "nearest"
            })
        })) : (b(o2, "hidden"),
        b(a2, "hidden"),
        o2.disabled = !0,
        a2.disabled = !0);
        var l2 = [m(h(To, t2), "click", function(t3) {
            t3.preventDefault(),
            d2()
        }), m(t2, "keydown", function(t3) {
            t3.keyCode === 27 && d2()
        }), m(n2, "click", function(t3) {
            t3.preventDefault();
            var e3 = t3.currentTarget.dataset.index;
            c2.select(e3)
        }), m(i2, "click", function(t3) {
            t3.preventDefault(),
            function(t4) {
                var e3 = t4.currentTarget
                  , n3 = e3.classList.contains(Io);
                if (E(e3, Io, !n3),
                n3)
                    return void u2(e3);
                var i3 = t4.clientX
                  , o3 = t4.clientY + r2.scrollTop - s2.offsetTop
                  , a3 = -1 * (i3 - e3.clientWidth / 2)
                  , c3 = -1 * (o3 - e3.clientHeight / 2);
                e3.style.transform = "translate3d(".concat(a3, "px, ").concat(c3, "px, 0) scale(2)")
            }(t3)
        }), m(o2, "click", function() {
            return c2.previous()
        }), m(a2, "click", function() {
            return c2.next()
        })];
        function u2(t3) {
            if (t3)
                return w(t3, Io),
                void (t3.style.transform = "translate3d(0px, 0px, 0) scale(1)");
            i2.forEach(function(t4) {
                w(t4, Io),
                t4.style.transform = "translate3d(0px, 0px, 0) scale(1)"
            })
        }
        function d2() {
            u2(),
            w(t2, Po),
            setTimeout(function() {
                w(t2, jo),
                Mt(t2),
                e2.deactivate()
            }, 300)
        }
        return {
            destroy: function() {
                l2.forEach(function(t3) {
                    return t3()
                }),
                c2.destroy()
            },
            open: function(n3) {
                b(t2, jo),
                setTimeout(function() {
                    b(t2, Po),
                    Nt(t2, {
                        allowTouchMove: function(t3) {
                            for (; t3 && t3 !== document.body; ) {
                                if (t3.getAttribute("data-scroll-lock-ignore") !== null)
                                    return !0;
                                t3 = t3.parentNode
                            }
                        },
                        reserveScrollBarGap: !0
                    }),
                    e2.activate();
                    var r3 = h(Co(n3), t2).dataset.slideIndex;
                    c2.select(r3, !1, !0)
                }, 50)
            }
        }
    }
    var Mo, zo = "[data-product-form]", bundleForm = "[data-form='bundle']", Ro = "[data-add-to-cart]", Bo = "[data-price]", Fo = "[data-compare-price]", Ho = "[data-slide]", Vo = "[data-slider]", Uo = "[data-variant-select]", Wo = function(t2) {
        return "[value='".concat(t2, "']")
    }, Go = "[data-store-availability-container]";
    function $o(t2, e2) {
        var n2 = h("[data-add-to-cart-text]", t2)
          , r2 = t2.dataset
          , i2 = r2.langAvailable
          , o2 = r2.langUnavailable
          , a2 = r2.langSoldOut;
        e2 ? e2.available ? (t2.removeAttribute("disabled"),
        n2.textContent = i2) : (t2.setAttribute("disabled", "disabled"),
        n2.textContent = a2) : (t2.setAttribute("disabled", "disabled"),
        n2.textContent = o2)
    }
    if (et("product", {
        productForm: null,
        onLoad: function() {
            var t2 = this
              , e2 = this.container.dataset.productHasOnlyDefaultVariant;
            this.formElement = h(zo, this.container);
            var n2 = h(Vo, this.container)
              , r2 = this.formElement.dataset.productHandle;
            this.storeAvailabilityContainer = this.formElement.querySelector(Go),
            this.availability = null;
            var i2 = p("[data-open]", this.container)
              , o2 = h("[data-in-your-space]", this.container);
            if (o2 && E(o2, "visible", Li()()),
            tt(r2)(function(n3) {
                t2.productForm = Ue(t2.formElement, n3, {
                    onOptionChange: function(e3) {
                        return t2.onOptionChange(e3)
                    },
                    onFormSubmit: function(e3) {
                        return t2.onFormSubmit(e3)
                    }
                });
                var r3 = t2.productForm.getVariant();
                t2.storeAvailabilityContainer && r3 && (t2.availability = Xe(t2.storeAvailabilityContainer, n3, r3, {
                    hideVariantTitle: e2 === "true"
                }))
            }),
            this.optionButtons = Ne(p("[data-option-buttons]", this.container)),
            this.lightbox = No(h("[data-lightbox]", this.container)),
            this.media = Ie(h(".product__media-container", this.container)),
            this.imageClick = m(i2, "click", function(e3) {
                e3.preventDefault(),
                t2.media && t2.media.pauseActiveMedia(),
                t2.lightbox.open(e3.currentTarget.dataset.open)
            }),
            document.querySelectorAll("[data-embroidery-popup]").length > 0) {
                var p_up = p("[data-embroidery-popup]", this.container);
                this.lightbox2 = No(h("[data-lightbox-2]", this.container)),
                this.imageClicks = m(p_up, "click", function(e3) {
                    e3.preventDefault(),
                    t2.lightbox2.open(e3.currentTarget.dataset.openImage)
                })
            }
            var a2 = h("[data-prev]", this.container)
              , s2 = h("[data-next]", this.container);
            s2 && b(s2, "visible"),
            this.flkty = new se.a(n2,{
                adaptiveHeight: !0,
                cellSelector: Ho,
                initialIndex: ".initial",
                pageDots: !1,
                prevNextButtons: !1,
                watchCSS: !0,
                wrapAround: !0
            }),
            this.flkty.on("change", function() {
                b(a2, "visible"),
                t2.media && t2.media.pauseActiveMedia()
            }),
            this.viewportResizeEvent = R("viewport-resize:small", function() {
                setTimeout(function() {
                    t2.flkty.resize()
                }, 400)
            }),
            this.sliderPaginationClick = s2 ? m([a2, s2], "click", function(e3) {
                return t2.onClickNav(e3)
            }) : function() {}
            ;
            var c2 = h("[data-share]", this.container);
            if (c2) {
                var l2 = h("[data-description]", this.container).childNodes || null
                  , u2 = l2 ? l2[l2.length - 1] : null;
                if (u2 && u2.nodeName === "DIV" && u2.classList.contains("accordion")) {
                    var d2 = `
            <div class="accordion__group">
              <a class="accordion__label">`.concat(c2.dataset.share, `</a>
              <div class="accordion__text">`).concat(c2.innerHTML, `</div>
            </div>
          `);
                    u2.insertAdjacentHTML("beforeend", d2),
                    c2.style.display = "none"
                }
            }
            this.accordions = je(p(".accordion", this.container)),
            it();
            var f2 = h(".product-form", this.container);
            this.observer = new MutationObserver(function(e3) {
                e3.forEach(function(e4) {
                    if (D()(e4.removedNodes).find(function(t3) {
                        return t3.classList.contains("shopify-product-reviews-badge")
                    })) {
                        t2.observer.disconnect();
                        var n3 = h(".spr-badge", t2.container)
                          , r3 = document.createElement("label");
                        r3.classList.add("pf-review-label"),
                        r3.textContent = window.theme.strings.product.reviews || "Reviews",
                        n3.prepend(r3)
                    }
                })
            }
            ),
            this.observer.observe(f2, {
                childList: !0
            })
        },
        onUnload: function() {
            this.optionButtons.destroy(),
            this.productForm.destroy(),
            this.flkty.destroy(),
            this.accordions.destroy(),
            this.lightbox.destroy(),
            this.imageClick(),
            this.sliderPaginationClick(),
            this.viewportResizeEvent(),
            this.observer.disconnect()
        },
        onOptionChange: function(t2) {
            var e2 = t2.dataset.variant
              , main_prod_hidden = this.container.querySelector('div[data-product="main"] [name="items[0][id]"]');
            main_prod_hidden.value = e2.id;
            var thisCTA = this.container.querySelector("[data-add-to-cart]")
              , thisBIS = this.container.querySelector(".product-form__cart-BIS_trigger")
              , thisUnvail = this.container.querySelector("[data-button-unavailable]");
            if (e2 ? (thisUnvail.style.display = "none",
            e2.available ? (thisCTA.style.display = "flex",
            thisBIS.style.display = "none",
            thisCTA.classList.remove("bis_hide_unavail")) : (thisCTA.style.display = "none",
            thisBIS.style.display = "flex",
            thisBIS.classList.remove("bis_hide_unavail"))) : (thisCTA.classList.add("bis_hide_unavail"),
            thisUnvail.style.display = "block",
            thisBIS.style.display = "none",
            thisBIS.classList.add("bis_hide_unavail")),
            Ut(this.container, e2),
            !e2)
                return $o(h("[data-add-to-cart]", this.container), !1),
                void (this.availability && this.availability.unload());
            var n2 = function(t3, e3) {
                return /variant=/.test(t3) ? t3.replace(/(variant=)[^&]+/, "$1" + e3) : /\?/.test(t3) ? t3.concat("&variant=").concat(e3) : t3.concat("?variant=").concat(e3)
            }(window.location.href, e2.id);
            if (window.history.replaceState({
                path: n2
            }, "", n2),
            this.updatePrices(e2),
            h("".concat(Uo, " ").concat(Wo(e2.id)), this.container).selected = !0,
            this.formElement.dispatchEvent(new Event("change")),
            e2.featured_media)
                if (window.matchMedia("(min-width: 40em)").matches) {
                    var r2 = h('[data-media-id="'.concat(e2.featured_media.id, '"]'), this.container);
                    r2 && r2.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    })
                } else
                    this.flkty.select(e2.featured_media.position - 1);
            this.availability && this.availability.update(e2)
        },
        onFormSubmit: function(t2) {
            if (document.body.dataset.enableCartAjax) {
                t2.preventDefault();
                var e2 = h(Ro, this.container);
                b(e2, "loading"),
                Q.addItem(this.formElement).then(function(t3) {
                    if (t3) {
                        let clickRest = !1;
                        const embroideryOptionsReset = document.querySelector(".EmbroiderySummary__Reset");
                        if (embroideryOptionsReset) {
                            const closestElement = embroideryOptionsReset.closest(".pf__embroidery-action-r");
                            (closestElement ? closestElement.classList.contains("hide") : !1) || (clickRest = !0)
                        }
                        if (window.protectioncharges)
                            Q.protectionCheck(t3.cart).then(function(response) {
                                clickRest && embroideryOptionsReset.click();
                                var n3 = t3.item;
                                w(e2, "loading"),
                                B("cart:open", null, {
                                    flash: n3.variant_id
                                })
                            });
                        else {
                            clickRest && embroideryOptionsReset.click();
                            var n2 = t3.item;
                            w(e2, "loading"),
                            B("cart:open", null, {
                                flash: n2.variant_id
                            })
                        }
                    } else
                        w(e2, "loading")
                })
            }
        },
        updatePrices: function(t2) {
            var e2 = p(Bo, this.container)
              , n2 = p(Fo, this.container)
              , r2 = h("[data-add-to-cart]", this.container);
            e2.forEach(function(e3) {
                return e3.innerHTML = K(t2.price)
            }),
            n2.forEach(function(e3) {
                return e3.innerHTML = t2.compare_at_price > t2.price ? K(t2.compare_at_price) : ""
            }),
            $o(r2, t2)
        },
        onClickNav: function(t2) {
            t2.preventDefault(),
            "next"in t2.currentTarget.dataset ? this.flkty.next() : "prev"in t2.currentTarget.dataset && this.flkty.previous()
        }
    }),
    et("product-bundle", {
        productForm: null,
        onLoad: function() {
            var t2 = this
              , e2 = this.container.dataset.productHasOnlyDefaultVariant;
            this.formElement = h(zo, this.container),
            this.bundleButton = h("[data-bundle-cta]", this.container);
            var n2 = h(Vo, this.container)
              , r2 = this.formElement.dataset.productHandle;
            this.storeAvailabilityContainer = this.formElement.querySelector(Go),
            this.availability = null;
            var i2 = p("[data-open]", this.container)
              , o2 = h("[data-in-your-space]", this.container)
              , formElements = this.container.querySelectorAll(zo)
              , r1 = formElements[0].dataset.productHandle
              , r22 = formElements[1].dataset.productHandle;
            o2 && E(o2, "visible", Li()()),
            tt(r1)(function(n3) {
                t2.productForm = Ue(formElements[0], n3, {
                    onOptionChange: function(e3) {
                        return t2.onOptionChange(e3)
                    },
                    onFormSubmit: function(e3) {
                        return t2.onFormSubmit(e3)
                    }
                });
                var r3 = t2.productForm.getVariant();
                t2.storeAvailabilityContainer && r3 && (t2.availability = Xe(t2.storeAvailabilityContainer, n3, r3, {
                    hideVariantTitle: e2 === "true"
                }))
            }),
            o2 && E(o2, "visible", Li()()),
            tt(r22)(function(n3) {
                t2.productForm = Ue(formElements[1], n3, {
                    onOptionChange: function(e3) {
                        return t2.onOptionChange(e3)
                    },
                    onFormSubmit: function(e3) {
                        return t2.onFormSubmit(e3)
                    }
                });
                var r3 = t2.productForm.getVariant();
                t2.storeAvailabilityContainer && r3 && (t2.availability = Xe(t2.storeAvailabilityContainer, n3, r3, {
                    hideVariantTitle: e2 === "true"
                }))
            });
            var bundleFormElement = h(bundleForm, this.container);
            o2 && E(o2, "visible", Li()()),
            tt(r22)(function(n3) {
                t2.productForm = Ue(bundleFormElement, n3, {
                    onOptionChange: function(e3) {
                        return t2.onOptionChange(e3)
                    },
                    onFormSubmit: function(e3) {
                        return t2.onFormSubmit(e3)
                    }
                });
                var r3 = t2.productForm.getVariant();
                t2.storeAvailabilityContainer && r3 && (t2.availability = Xe(t2.storeAvailabilityContainer, n3, r3, {
                    hideVariantTitle: e2 === "true"
                }))
            }),
            this.optionButtons = Ne(p("[data-option-buttons]", this.container)),
            this.lightbox = No(h("[data-lightbox]", this.container)),
            this.media = Ie(h(".product__media-container", this.container)),
            this.imageClick = m(i2, "click", function(e3) {
                e3.preventDefault(),
                t2.media && t2.media.pauseActiveMedia(),
                t2.lightbox.open(e3.currentTarget.dataset.open)
            });
            var thisBundleButton = this.bundleButton;
            this.bundleButton.addEventListener("click", function() {
                if (thisBundleButton.getAttribute("disabled") != "disabled") {
                    var bundleItems = document.querySelectorAll(".product--bundle-item form")
                      , bundleForm2 = document.querySelector('form[data-form="bundle"] [data-bundleItemsData]');
                    bundleForm2.innerHTML = "",
                    bundleItems.forEach( (element, index) => {
                        var x2 = element.querySelector('[data-product="main"]')
                          , y2 = element.querySelector(".hidden-info");
                        if (x2) {
                            let xHTML = x2.innerHTML;
                            if (index > 0 && xHTML.includes("items[0]")) {
                                let numbers = bundleForm2.innerHTML.match(/items\[(\d+)\]/g).map(item => Number(item.match(/\d+/)[0]))
                                  , maxNumber = Math.max(...numbers);
                                xHTML = xHTML.replaceAll("items[0]", `items[${maxNumber + 1}]`)
                            }
                            bundleForm2.innerHTML += xHTML
                        }
                        if (y2) {
                            let yHTML = y2.innerHTML;
                            if (index > 0 && yHTML.includes("items[0]")) {
                                let numbers = bundleForm2.innerHTML.match(/items\[(\d+)\]/g).map(item => Number(item.match(/\d+/)[0]))
                                  , maxNumber = Math.max(...numbers);
                                yHTML = yHTML.replaceAll("items[0]", `items[${maxNumber + 1}]`)
                            }
                            bundleForm2.innerHTML += yHTML
                        }
                    }
                    ),
                    bundleFormElement.querySelector("[data-add-to-cart]").click()
                }
            });
            var a2 = h("[data-prev]", this.container)
              , s2 = h("[data-next]", this.container);
            s2 && b(s2, "visible"),
            this.flkty = new se.a(n2,{
                adaptiveHeight: !0,
                cellSelector: Ho,
                initialIndex: ".initial",
                pageDots: !1,
                prevNextButtons: !1,
                watchCSS: !0,
                wrapAround: !0
            }),
            this.flkty.on("change", function() {
                b(a2, "visible"),
                t2.media && t2.media.pauseActiveMedia()
            }),
            this.viewportResizeEvent = R("viewport-resize:small", function() {
                setTimeout(function() {
                    t2.flkty.resize()
                }, 400)
            }),
            this.sliderPaginationClick = s2 ? m([a2, s2], "click", function(e3) {
                return t2.onClickNav(e3)
            }) : function() {}
            ;
            var c2 = h("[data-share]", this.container);
            if (c2) {
                var l2 = h("[data-description]", this.container).childNodes || null
                  , u2 = l2 ? l2[l2.length - 1] : null;
                if (u2 && u2.nodeName === "DIV" && u2.classList.contains("accordion")) {
                    var d2 = `
            <div class="accordion__group">
              <a class="accordion__label">`.concat(c2.dataset.share, `</a>
              <div class="accordion__text">`).concat(c2.innerHTML, `</div>
            </div>
          `);
                    u2.insertAdjacentHTML("beforeend", d2),
                    c2.style.display = "none"
                }
            }
            this.accordions = je(p(".accordion", this.container)),
            it();
            var f2 = h(".product-form", this.container);
            this.observer = new MutationObserver(function(e3) {
                e3.forEach(function(e4) {
                    if (D()(e4.removedNodes).find(function(t3) {
                        return t3.classList.contains("shopify-product-reviews-badge")
                    })) {
                        t2.observer.disconnect();
                        var n3 = h(".spr-badge", t2.container)
                          , r3 = document.createElement("label");
                        r3.classList.add("pf-review-label"),
                        r3.textContent = window.theme.strings.product.reviews || "Reviews",
                        n3.prepend(r3)
                    }
                })
            }
            ),
            this.observer.observe(f2, {
                childList: !0
            })
        },
        onUnload: function() {
            this.optionButtons.destroy(),
            this.productForm.destroy(),
            this.flkty.destroy(),
            this.accordions.destroy(),
            this.lightbox.destroy(),
            this.imageClick(),
            this.sliderPaginationClick(),
            this.viewportResizeEvent(),
            this.observer.disconnect()
        },
        onOptionChange: function(t2) {
            var thisContainer = t2.srcElement.form
              , e2 = t2.dataset.variant
              , main_prod_hidden = thisContainer.querySelector('div[data-product="main"] [name="items[0][id]"]');
            main_prod_hidden.value = e2.id;
            var thisButton = h("[data-add-to-cart]", thisContainer);
            if (thisButton.dataset.selectedVariantName = e2.name,
            Ut(thisContainer, e2),
            !e2)
                return $o(h("[data-add-to-cart]", thisContainer), !1),
                void (this.availability && this.availability.unload());
            var n2 = function(t3, e3) {
                return /variant=/.test(t3) ? t3.replace(/(variant=)[^&]+/, "$1" + e3) : /\?/.test(t3) ? t3.concat("&variant=").concat(e3) : t3.concat("?variant=").concat(e3)
            }(window.location.href, e2.id);
            window.history.replaceState({
                path: n2
            }, "", n2),
            this.updatePrices(e2, thisContainer),
            h("".concat(Uo, " ").concat(Wo(e2.id)), thisContainer).selected = !0,
            thisContainer.dispatchEvent(new Event("change")),
            e2.featured_media && this.availability && this.availability.update(e2)
        },
        onFormSubmit: function(t2) {
            var bundleFormElement = h(bundleForm, this.container)
              , thisFormElement = bundleFormElement;
            if (document.body.dataset.enableCartAjax) {
                t2.preventDefault();
                var e2 = this.bundleButton;
                b(e2, "loading"),
                Q.addItem(bundleFormElement).then(function(t3) {
                    if (t3) {
                        let clickRest = !1;
                        const embroideryOptionsReset = document.querySelector(".EmbroiderySummary__Reset");
                        if (embroideryOptionsReset) {
                            const closestElement = embroideryOptionsReset.closest(".pf__embroidery-action-r");
                            (closestElement ? closestElement.classList.contains("hide") : !1) || (clickRest = !0)
                        }
                        if (window.protectioncharges)
                            Q.protectionCheck(t3.cart).then(function(response) {
                                clickRest && embroideryOptionsReset.click();
                                var n3 = t3.item;
                                w(e2, "loading"),
                                B("cart:open", null, {
                                    flash: n3.variant_id
                                })
                            });
                        else {
                            clickRest && embroideryOptionsReset.click();
                            var n2 = t3.item;
                            w(e2, "loading"),
                            B("cart:open", null, {
                                flash: n2.variant_id
                            })
                        }
                    } else
                        w(e2, "loading")
                })
            }
        },
        updatePrices: function(t2, thisc) {
            var e2 = p(Bo, this.container)
              , n2 = p(Fo, this.container)
              , r2 = h("[data-add-to-cart]", thisc);
            $o(r2, t2);
            var bundleCTAs = document.querySelectorAll(".product--bundle-item [data-add-to-cart]")
              , bundleErrorMsg = document.querySelector("[data-bundle-soldout-msg]");
            bundleErrorMsg.innerHTML = "";
            var bundleCTAs_disabled = 0
              , bundleErrorMsg_html = "";
            if (bundleCTAs.forEach(element => {
                if (element.disabled) {
                    bundleCTAs_disabled++;
                    var getName = element.dataset.selectedVariantName;
                    bundleErrorMsg_html = `${bundleErrorMsg_html}<span>${getName}</span>`
                }
            }
            ),
            bundleErrorMsg_html ? bundleErrorMsg.innerHTML = bundleErrorMsg_html : bundleErrorMsg.innerHTML = "",
            bundleCTAs_disabled == 0) {
                var t2 = {
                    available: !0
                };
                $o(this.bundleButton, t2)
            } else {
                var t2 = {
                    available: !1
                };
                $o(this.bundleButton, t2)
            }
        },
        onClickNav: function(t2) {
            t2.preventDefault(),
            "next"in t2.currentTarget.dataset ? this.flkty.next() : "prev"in t2.currentTarget.dataset && this.flkty.previous()
        }
    }),
    et("contact", {
        onLoad: function() {
            this.accordions = _o(this.container),
            Ao(p("iframe", this.container))
        },
        onUnload: function() {
            this.accordions.destroy()
        }
    }),
    et("addresses", {
        onLoad: function() {
            var t2 = this;
            this.modals = p("[data-modal]", this.container);
            var e2 = p("[data-overlay]", this.container)
              , n2 = p("[data-open]", this.container)
              , r2 = p("[data-close]", this.container)
              , i2 = p("[data-remove]", this.container)
              , o2 = p("[data-country-option]", this.container) || [];
            this.events = [m(n2, "click", function(e3) {
                return t2.openModal(e3)
            }), m([].concat(D()(r2), D()(e2)), "click", function(e3) {
                return t2.closeModal(e3)
            }), m(i2, "click", function(e3) {
                return t2.removeAddress(e3)
            })],
            o2.forEach(function(t3) {
                var e3 = t3.dataset.formId
                  , n3 = "AddressCountry_" + e3
                  , r3 = "AddressProvince_" + e3
                  , i3 = "AddressProvinceContainer_" + e3;
                new window.Shopify.CountryProvinceSelector(n3,r3,{
                    hideElement: i3
                })
            })
        },
        onUnload: function() {
            this.events.forEach(function(t2) {
                return t2()
            })
        },
        openModal: function(t2) {
            t2.preventDefault();
            var e2 = t2.currentTarget.dataset.open
              , n2 = this.modals.find(function(t3) {
                return t3.dataset.modal == e2
            });
            b(n2, "active"),
            setTimeout(function() {
                b(n2, "visible")
            }, 50)
        },
        closeModal: function(t2) {
            var e2 = this;
            t2.preventDefault(),
            w(this.modals, "visible"),
            setTimeout(function() {
                w(e2.modals, "active")
            }, 350)
        },
        removeAddress: function(t2) {
            var e2 = t2.currentTarget.dataset
              , n2 = e2.confirmMessage
              , r2 = e2.target;
            confirm(n2),
            window.Shopify.postLink(r2, {
                parameters: {
                    _method: "delete"
                }
            })
        }
    }),
    et("login", {
        onLoad: function() {
            var t2 = h('[data-part="login"]', this.container)
              , e2 = h('[data-part="reset"]', this.container)
              , n2 = p("[data-toggle]", this.container)
              , r2 = h("[data-success]", this.container)
              , i2 = h("[data-success-message]", this.container);
            r2 && b(i2, "visible"),
            this.toggleClick = m(n2, "click", function(n3) {
                n3.preventDefault(),
                E([t2, e2], "hide")
            })
        },
        onUnload: function() {
            this.toggleClick()
        }
    }),
    window.Shopify.designMode === !0)
        document.documentElement.classList.add("theme-editor");
    else {
        var Jo = document.querySelector(".theme-editor-scroll-offset");
        Jo && Jo.parentNode.removeChild(Jo)
    }
    (function() {
        function t2() {
            p(".shopify-section").forEach(function(t3) {
                var e2 = t3.firstElementChild;
                e2 && e2.classList.contains(ot) && (w(e2, ot),
                b(t3, ot))
            })
        }
        t2(),
        document.addEventListener("shopify:section:load", t2)
    }
    )(),
    document.addEventListener("DOMContentLoaded", function() {
        a("*")
    }),
    (Mo = document.querySelector(".page-transition")) && (Object.assign(Mo.style, {
        opacity: 0,
        pointerEvents: "none"
    }),
    setTimeout(function() {
        Mo.style.visibility = "hidden"
    }, 300),
    new f.a(document.body).on("click", 'a[href]:not([href^="#"]):not(.no-transition):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])', function(t2, e2) {
        t2.preventDefault(),
        Mo.addEventListener("transitionend", function t3(n2) {
            n2.propertyName === "opacity" && (Mo.removeEventListener("transitionend", t3),
            window.location.href = e2.href)
        }),
        Object.assign(Mo.style, {
            opacity: 1,
            pointerEvents: "all",
            visibility: "visible"
        })
    }),
    window.onpageshow = function(t2) {
        t2.persisted && Object.assign(Mo.style, {
            opacity: 0,
            pointerEvents: "none"
        })
    }
    ),
    new f.a(document.body).on("click", "button[data-quick-add]", function(t2, e2) {
        var n2 = e2.dataset.quickAdd;
        B("cart:configureLoading"),
        function(t3) {
            return function(e3) {
                return fetch("".concat(window.theme.routes.products, "/").concat(t3, "?view=quick")).then(function(t4) {
                    return t4.text()
                }).then(function(t4) {
                    return e3(t4)
                }).catch(function(t4) {
                    return console.log(t4.message)
                })
            }
        }(n2)(function(t3) {
            return B("cart:configureReady", null, {
                html: t3,
                handle: n2
            })
        })
    }),
    R("collection:updated", it),
    function() {
        var t2 = e2();
        function e2() {
            return window.matchMedia(ee).matches ? "small" : window.matchMedia(ne).matches ? "medium" : window.matchMedia(re).matches ? "large" : void 0
        }
        m(window, "resize", function() {
            var n2 = e2();
            t2 !== n2 && B("viewport-resize:".concat(t2 = n2))
        })
    }(),
    te(document.querySelector("[data-store-availability-modal]")),
    window.SHA = "unknown";
    function quickAddonOptionsChange() {
        document.querySelectorAll(".product-item__options").forEach(function(main) {
            let option1, option2, option3, radioOptionFirst = main.querySelectorAll('input[name="option-1"]'), radioOptionSecond = main.querySelectorAll('input[name="option-2"]'), radioOptionThird = main.querySelectorAll('input[name="option-3"]');
            const option_selector = main.querySelectorAll('input[type="radio"]')
              , product_options_size = main.querySelector(".product_options");
            radioOptionFirst && radioOptionFirst.forEach(function(el) {
                el.addEventListener("change", function(e2) {
                    e2.target.checked && (option1 = e2.target.value)
                })
            }),
            radioOptionSecond && radioOptionSecond.forEach(function(el) {
                el.addEventListener("change", function(e2) {
                    e2.target.checked && (option2 = e2.target.value)
                })
            }),
            radioOptionThird && radioOptionThird.forEach(function(el) {
                el.addEventListener("change", function(e2) {
                    e2.target.checked && (option3 = e2.target.value)
                })
            });
            let final_var = "";
            option_selector.forEach(function(els) {
                els.addEventListener("change", function(option) {
                    const optionEl = main.querySelectorAll("select option");
                    let option1_length = option.target.closest(".product_options").querySelectorAll('input[name="option-1"]:checked').length
                      , option2_length = option.target.closest(".product_options").querySelectorAll('input[name="option-2"]:checked').length;
                    const onlySizeElClicked = option.target.closest(".option_wrapper").querySelector(".single_option").dataset.optionSize;
                    let option_size = product_options_size.dataset.productOptions;
                    option_size > 1 && onlySizeElClicked != null && optionSoldoutCheck(option.target.value, optionEl, !0),
                    option1 && option2 == null && option3 == null && option1_length == 1 && option2_length == 0 ? final_var = option1 : option1 && option2 && option3 == null && option1_length == 1 && option2_length == 1 ? final_var = option1 + " / " + option2 : option1 && option2 && option3 && (final_var = option1 + " / " + option2 + " / " + option3),
                    optionEl.forEach(function(e2) {
                        let var_title = e2.dataset.variant
                          , varAvail = e2.dataset.available
                          , mainTitle = e2.dataset.title;
                        if (var_title == final_var) {
                            if (e2.dataset.customoption === "excludeAuto") {
                                let tempTitle = e2.dataset.title
                                  , btn = main.querySelectorAll(`button[data-title="${mainTitle}"]`)
                                  , btnAdd = main.querySelectorAll('button[data-variant-button="custom-add-to-bag"]')
                                  , btnBis = main.querySelectorAll("a.recommended-product__BIS")
                                  , btnLabel = main.querySelectorAll('button[data-variant-button="custom-add-to-bag"] span[data-add-to-cart-text]');
                                varAvail == "true" ? (btnBis[0].style.display = "none",
                                btnAdd[0].style.display = "flex",
                                btnAdd[0].removeAttribute("disabled", !1),
                                btnLabel[0].innerHTML = "Add to Bag") : (btnBis[0].style.display = "flex",
                                btnAdd[0].style.display = "none"),
                                localStorage.setItem(tempTitle, e2.value);
                                return
                            }
                            varAvail == "true" && (ajaxAdd(e2.value, option_size),
                            final_var = "")
                        }
                    })
                })
            }),
            document.querySelectorAll(".single_option li.option_value").forEach(li2 => {
                li2.addEventListener("click", () => {
                    li2.parentNode.childNodes.forEach(sibling => {
                        sibling.nodeType === Node.ELEMENT_NODE && sibling.classList.remove("selected")
                    }
                    ),
                    li2.classList.add("selected")
                }
                )
            }
            ),
            main.querySelectorAll('button[data-variant-button="custom-add-to-bag"]').forEach(function(item) {
                item.addEventListener("click", function() {
                    let tempTitle = item.dataset.title
                      , variantID = localStorage.getItem(tempTitle);
                    variantID !== null && (item.classList.add("loading"),
                    ajaxAdd(variantID, 1, function() {
                        item.classList.remove("loading")
                    }))
                })
            })
        })
    }
    function optionSoldoutCheck(option_name, selectEl, radio, drawer) {
        let product_options_wrap, productOptions;
        radio == !0 ? product_options_wrap = selectEl[0].parentElement.nextElementSibling : drawer == !0 ? productOptions = document.querySelectorAll(".quick-add__form .product-form__chip") : productOptions = document.querySelectorAll(".product-form__chip");
        let soldout_options = []
          , avail_options = [];
        selectEl.forEach(function(select) {
            let option1_name = select.dataset.voption1
              , option2_name = select.dataset.voption2
              , is_variant_avail = select.dataset.available;
            option_name == option1_name ? is_variant_avail == "false" ? soldout_options.push(option2_name) : avail_options.push(option2_name) : option_name == option2_name && (is_variant_avail == "false" ? soldout_options.push(option1_name) : avail_options.push(option1_name))
        }),
        soldout_options.length > 0 ? radio == !0 ? (product_options_wrap.querySelectorAll("input[data-option='variant']").forEach(e2 => {
            soldout_options.includes(e2.value) ? e2.classList.add("disabled") : e2.classList.contains("disabled") || e2.classList.remove("disabled")
        }
        ),
        product_options_wrap.querySelectorAll("input.recommended-product__variant").forEach(e2 => {
            soldout_options.includes(e2.value) ? e2.classList.add("soldout") : e2.classList.remove("soldout")
        }
        )) : productOptions.forEach(e2 => {
            soldout_options.includes(e2.dataset.button) ? e2.classList.add("opt_soldout") : e2.classList.remove("opt_soldout")
        }
        ) : radio == !0 ? (product_options_wrap.querySelectorAll("input[data-option='variant']").forEach(e2 => e2.disabled = !1),
        product_options_wrap.querySelectorAll("input.recommended-product__variant").forEach(e2 => e2.classList.remove("soldout"))) : productOptions.forEach(e2 => e2.classList.remove("opt_soldout"));
        let length_selector;
        drawer == !0 ? length_selector = document.querySelectorAll('.quick-add__form .product-form__chips[data-option-name="length"] a') : length_selector = document.querySelectorAll('.product-form__chips[data-option-name="length"] a'),
        avail_options.length == 0 ? length_selector.forEach(function(e2) {
            e2.classList.add("opt_soldout")
        }) : length_selector.forEach(function(e2) {
            !avail_options.includes(e2.dataset.button) && e2.dataset.status == "soldout"
        }),
        radio == !0 && product_options_wrap.querySelectorAll(".option-length input[type='radio']").forEach(e2 => {
            avail_options.includes(e2.value) ? e2.classList.remove("disabled") : e2.classList.add("disabled")
        }
        )
    }
    function ajaxAdd(variantId, option_size, callback) {
        const option_selector_size = document.querySelectorAll('.product-item__options .option-size input[type="radio"]')
          , option_selector_length = document.querySelectorAll('.product-item__options .option-length input[type="radio"]');
        B("cart:updating"),
        fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
        }).then(function(response) {
            return response.json()
        }).then(function(json) {
            return option_selector_size.forEach(function(el) {
                el.checked = !1
            }),
            option_selector_length.forEach(function(el) {
                el.checked = !1,
                el.classList.remove("disabled")
            }),
            Y().then(function(e2) {
                var n2 = j("cart_order") || []
                  , r2 = [json.variant_id].concat(D()(n2.filter(function(e3) {
                    return e3 !== json.variant_id
                })));
                return I("cart_order", JSON.stringify(r2)),
                B("cart:updated", {
                    cart: G(e2)
                }),
                {
                    item: json,
                    cart: G(e2)
                }
            }).then(function(data) {
                if (window.protectioncharges)
                    Q.protectionCheck(data.cart).then(function(r2) {
                        var e3 = data.item;
                        B("cart:open", null, {
                            flash: e3.variant_id
                        })
                    });
                else {
                    var e2 = data.item;
                    B("cart:open", null, {
                        flash: e2.variant_id
                    })
                }
            })
        }).catch(function(err) {
            console.error(err)
        }).finally(function() {
            callback && callback()
        })
    }
    quickAddonOptionsChange();
    function checkSoldoutFromParams(drawer) {
        let sizeNameDefault, selectEl, productFormChip;
        drawer == !0 ? (sizeNameDefault = document.querySelector(".quick-add__form .pf-container.option-size a.selected"),
        selectEl = document.querySelectorAll(".quick-add__form .product-form__variants select option"),
        productFormChip = document.querySelectorAll(".quick-add__form .pf-container.option-length a.product-form__chip")) : (sizeNameDefault = document.querySelector(".pf-container.option-size a.selected"),
        selectEl = document.querySelectorAll(".product-form__variants select option"),
        productFormChip = document.querySelectorAll(".pf-container.option-length a.product-form__chip"));
        let sold_length_arr = []
          , avail_length_arr = [];
        selectEl.forEach(function(e2) {
            sizeNameDefault && (e2.dataset.voption1 == sizeNameDefault.dataset.button && e2.dataset.available == "false" ? sold_length_arr.push(e2.dataset.voption2) : e2.dataset.voption1 == sizeNameDefault.dataset.button && e2.dataset.available == "true" ? avail_length_arr.push(e2.dataset.voption2) : e2.dataset.voption2 == sizeNameDefault.dataset.button && e2.dataset.available == "false" ? sold_length_arr.push(e2.dataset.voption1) : e2.dataset.voption2 == sizeNameDefault.dataset.button && e2.dataset.available == "true" && avail_length_arr.push(e2.dataset.voption1))
        }),
        productFormChip.forEach(function(el) {
            sold_length_arr.includes(el.dataset.button) && el.classList.add("opt_soldout"),
            avail_length_arr.includes(el.dataset.button)
        })
    }
    checkSoldoutFromParams(!1);
    const cartCloseIcon = document.querySelector("[data-cart-close]")
      , cartOverlay = document.querySelector(".quick-cart__overlay");
    cartCloseIcon.addEventListener("click", function() {
        cartOverlay.click()
    })
}
]);
function countHiddenColor() {
    var colorSwatches = document.querySelectorAll(".product-item .color_swatch_slider");
    for (let i = 0; i < colorSwatches.length; i++) {
        var colorSwatch = colorSwatches[i]
          , colorSwatchWidth = colorSwatch.offsetWidth
          , colorElems = colorSwatch.querySelectorAll(".alternate_product_color")
          , colorElemTotal = colorElems.length
          , hiddenCount = colorSwatch.querySelector("[data-hiddencount]");
        hiddenCountH = colorSwatch.querySelector("[data-hiddencount] a");
        const swatches = document.querySelectorAll(".alternate_product_color.label_coming-soon");
        if (swatches && swatches.forEach(swatch => {
            swatch.addEventListener("mouseover", () => {
                const color = swatch.getAttribute("data-comingsooncolor");
                swatch.style.setProperty("--hover-color", color);
                let left = swatch.offsetLeft + 10 + "px"
                  , mobileLeft = swatch.offsetLeft + 35 + "px";
                swatch.style.setProperty("--position-left", left),
                swatch.style.setProperty("--mobile-position-left", mobileLeft)
            }
            )
        }
        ),
        colorSwatchWidth == 0) {
            var firstVisibleElem = document.querySelectorAll(".collection__grid.updated .grid__item.visible")[0];
            if (firstVisibleElem)
                var firstVisibleColorSwatchWidth = firstVisibleElem.querySelector(".product-item .color_swatch_slider").offsetWidth
                  , firstVisibleColorElmWidth = firstVisibleElem.querySelectorAll(".alternate_product_color")[0].offsetWidth
                  , colorElemItemWidth = parseInt(firstVisibleColorElmWidth + 8)
                  , visibleElm = parseInt(Math.floor(firstVisibleColorSwatchWidth / colorElemItemWidth) - 2)
        }
        for (let j = 0; j < colorElemTotal; j++) {
            var colorElemItem = colorElems[j];
            if (j == 0 && colorSwatchWidth != 0)
                var colorElemItemWidth = parseInt(colorElemItem.offsetWidth + 8)
                  , visibleElm = parseInt(Math.floor(colorSwatchWidth / colorElemItemWidth) - 2);
            if (colorElemTotal >= visibleElm) {
                hiddenCount.style.display = "flex";
                var hiddenElm = colorElemTotal - visibleElm;
                hiddenCountH.innerHTML = "+" + hiddenElm,
                j > parseInt(visibleElm - 1) ? colorElemItem.style.display = "none" : colorElemItem.style.display = "block",
                colorElemTotal == visibleElm && (hiddenCount.style.display = "none")
            } else
                hiddenCount.style.display = "none"
        }
    }
}
(document.querySelectorAll(".product-item").length || document.querySelector("[data-recommendations]")) && (document.addEventListener("DOMContentLoaded", countHiddenColor),
window.onresize = countHiddenColor);
function colorSwatchName() {
    var pdpColorSwatches = document.querySelector(".product__details .pf-element");
    const colorElems = pdpColorSwatches.querySelectorAll(".color_swatch_desktop .alternate_product_color")
      , colorNameElm = pdpColorSwatches.querySelector(".pf-label .pf-label__color-name")
      , comingSoonElem = pdpColorSwatches.querySelector(".pf-label__coming_soon")
      , activeColor = colorNameElm.innerHTML;
    colorElems.forEach(colorElem => {
        colorElem.addEventListener("mouseover", () => {
            const colorName = colorElem.getAttribute("data-tooltip")
              , comingSoonColor = colorElem.getAttribute("data-comingsoon");
            comingSoonElem && (comingSoonColor == null ? pdpColorSwatches.querySelector(".pf-label__coming_soon").classList.add("hidden") : pdpColorSwatches.querySelector(".pf-label__coming_soon").classList.remove("hidden")),
            colorNameElm.innerHTML = colorName
        }
        ),
        colorElem.addEventListener("mouseleave", () => {
            colorNameElm.innerHTML = activeColor,
            comingSoonElem && pdpColorSwatches.querySelector(".pf-label__coming_soon").classList.remove("hidden")
        }
        )
    }
    )
}
function swatchListMobile() {
    const listBtn = document.querySelector(".color_swatch_slider.mobile_only .product-form__color-swatch")
      , closeButton = document.querySelector(".product-form__color-dropdownlist .color_text")
      , dropdown_list = document.querySelector(".color_swatch_slider.mobile_only .product-form__color-dropdownlist");
    if (dropdown_list) {
        const color_count = dropdown_list.querySelectorAll(".product_color").length
          , dropdown_active = document.querySelector(".popup__overlay.dropdown_list")
          , countText = document.querySelector(".pf-label.mobile_only .color_count");
        countText.innerHTML = color_count + " colors",
        listBtn.addEventListener("click", () => {
            dropdown_list.classList.add("active_dropdown"),
            dropdown_active.classList.add("dropdown_list--active"),
            document.body.style.overflow = "hidden"
        }
        ),
        closeButton.querySelector(".icon").addEventListener("click", () => {
            dropdown_list.classList.remove("active_dropdown"),
            dropdown_active.classList.remove("dropdown_list--active"),
            document.body.style.overflow = ""
        }
        ),
        document.addEventListener("click", event2 => {
            !closeButton.contains(event2.target) && !listBtn.contains(event2.target) && (dropdown_list.classList.remove("active_dropdown"),
            dropdown_active.classList.remove("dropdown_list--active"),
            document.body.style.overflow = "")
        }
        )
    }
}
document.querySelectorAll(".product__details").length;
function checkHistoryState() {
    if (history.state?._page) {
        const carItems = document.getElementById("cart-items");
        carItems && carItems.classList.remove("updating");
        const {_page, ...rest} = history.state;
        history.replaceState(rest, null, window.location.href)
    }
}
window.addEventListener("popstate", checkHistoryState),
window.addEventListener("pageshow", checkHistoryState);
var isRunning = !1;
function clickSelectedInputElements() {
    if (!isRunning) {
        isRunning = !0;
        var liElements = document.querySelectorAll(".recommended-product__options li.option_value.selected");
        liElements.forEach(function(liElement) {
            var inputElement = liElement.querySelector("input.recommended-product__variant");
            inputElement.click()
        }),
        setTimeout(function() {
            isRunning = !1
        }, 100)
    }
}
function clickSizeOption() {
    var liSizeElements = document.querySelectorAll(".recommended-product__options[data-option-size] li.option_value.selected");
    liSizeElements.forEach(function(liSizeElement) {
        var inputSizeElement = liSizeElement.querySelector("input.recommended-product__variant");
        inputSizeElement.click()
    })
}
window.addEventListener("load", function() {
    for (var parentSizeElements = document.querySelectorAll(".recommended-product__options[data-option-size] li.option_value"), parentLengthElements = document.querySelectorAll(".recommended-product__options[data-option-length] li.option_value"), i = 0; i < parentSizeElements.length; i++)
        parentSizeElements[i].addEventListener("click", clickSelectedInputElements);
    for (var i = 0; i < parentLengthElements.length; i++)
        parentLengthElements[i].addEventListener("click", clickSelectedInputElements);
    clickSelectedInputElements(),
    clickSizeOption()
});
let intervalId;
function checkForProductElements() {
    if (document.querySelectorAll(".recommended-products__product--slider").length) {
        const productElements2 = document.querySelectorAll(".recommended-products__product--slider");
        let tallestElement = productElements2[0];
        for (let i = 1; i < productElements2.length; i++)
            productElements2[i].offsetHeight > tallestElement.offsetHeight && (tallestElement = productElements2[i]);
        for (let i = 0; i < productElements2.length; i++)
            productElements2[i].style.height = "100%";
        const grid = document.querySelector(".recommended-products__grid");
        grid.style.height = `${tallestElement.offsetHeight}px`,
        clearInterval(intervalId)
    }
}
intervalId = setInterval(checkForProductElements, 100);
function checkAddToCart() {
  // update progress
    fetch(`${window.location.origin}/?sections=quick-cart-template`)
    .then(res => res.clone().json().then(data => {
       if(data['quick-cart-template']){
        const cartProgressEl = new DOMParser()
        .parseFromString(data['quick-cart-template'], 'text/html')
        .querySelector('.shipping-progress-container');
        const containers = document.querySelectorAll('.shipping-progress-container');
        containers.forEach( container => {
            container.innerHTML = cartProgressEl.innerHTML
        }) 
       }
    })) 
    if (window.giftboxAddOn.enable) {
        var giftBoxElem = document.querySelector("[data-giftbox]")
          , checkbox = giftBoxElem.querySelector('input[type="checkbox"]')
          , productId = checkbox.getAttribute("data-variant-id");
        fetch(`${window.location.origin}/cart.js`).then(res => res.clone().json().then(data => {
            giftBoxElem.classList.remove("active"),
            data.item_count >= 1 && (giftBoxElem.classList.add("active"),
            data.items.forEach(item => {
                item.variant_id == productId && giftBoxElem.classList.remove("active")
            }
            ))
        }
        ))
    }
}
(function(ns, fetch2) {
    ns.fetch = function() {
        const response = fetch2.apply(this, arguments);
        return response.then(res => {
            `${window.location.origin}/cart/add.js`.includes(res.url) && checkAddToCart(),
            `${window.location.origin}/cart/update.js`.includes(res.url) && (checkAddToCart(),
            console.log("cart updated"))
        }
        ),
        response
    }
}
)(window, window.fetch);
//# sourceMappingURL=/cdn/shop/t/520/assets/index.js.map?v=51481241707351227201729245509
